export interface ISpecEnums {
    Group?: string;
    Description: string;
    Elaboration?: string;
    Value: string;
    Sort: number;
    Tag: number;
    SymbolicName: string;
    added?: string;
    addedEP?: number;
    updated?: string;
    updatedEP?: number;
    deprecated?: string;
    deprecatedEP?: number;
    issue?: string;
}

const batch1: ISpecEnums[] = [
    {
        Group: '',
        Description: 'Buy',
        added: 'FIX.2.7',
        Value: 'B',
        Sort: 1,
        Tag: 4,
        SymbolicName: 'Buy',
    },
    {
        Group: '',
        Description: 'Sell',
        added: 'FIX.2.7',
        Value: 'S',
        Sort: 2,
        Tag: 4,
        SymbolicName: 'Sell',
    },
    {
        Group: '',
        Description: 'Trade',
        added: 'FIX.2.7',
        Value: 'T',
        Sort: 3,
        Tag: 4,
        SymbolicName: 'Trade',
    },
    {
        Group: '',
        Description: 'Cross',
        added: 'FIX.2.7',
        Value: 'X',
        Sort: 4,
        Tag: 4,
        SymbolicName: 'Cross',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: 'N',
        Sort: 1,
        Tag: 5,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.2.7',
        Value: 'C',
        Sort: 2,
        Tag: 5,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.2.7',
        Value: 'R',
        Sort: 3,
        Tag: 5,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Per Unit (implying shares, par, currency, etc.)',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 13,
        SymbolicName: 'PerUnit',
    },
    {
        Group: '',
        Description: 'Percent',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 13,
        SymbolicName: 'Percent',
    },
    {
        Group: '',
        Description: 'Absolute (total monetary amount)',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 13,
        SymbolicName: 'Absolute',
    },
    {
        Group: '',
        Description: 'Percentage waived - cash discount (for CIV buy orders)',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 13,
        SymbolicName: 'PercentageWaivedCashDiscount',
    },
    {
        Group: '',
        Description: 'Percentage waived -= enhanced units (for CIV buy orders)',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 13,
        SymbolicName: 'PercentageWaivedEnhancedUnits',
    },
    {
        Group: '',
        Description:
            'Points per bond or contract (supply ContractMultiplier (231) in the <Instrument> component block if the object security is denominated in a size other than the industry default - 1000 par for bonds)',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 13,
        SymbolicName: 'PointsPerBondOrContract',
    },
    {
        Group: '',
        Description: 'Stay on offer side',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 18,
        SymbolicName: 'StayOnOfferSide',
    },
    {
        Group: '',
        Description: 'Not held',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 18,
        SymbolicName: 'NotHeld',
    },
    {
        Group: '',
        Description: 'Work',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 18,
        SymbolicName: 'Work',
    },
    {
        Group: '',
        Description: 'Go along',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 18,
        SymbolicName: 'GoAlong',
    },
    {
        Group: '',
        Description: 'Over the day',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 18,
        SymbolicName: 'OverTheDay',
    },
    {
        Group: '',
        Description: 'Held',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 6,
        Tag: 18,
        SymbolicName: 'Held',
    },
    {
        Group: '',
        Description: "Participate don't initiate",
        added: 'FIX.2.7',
        Value: '6',
        Sort: 7,
        Tag: 18,
        SymbolicName: 'ParticipateDoNotInitiate',
    },
    {
        Group: '',
        Description: 'Strict scale',
        added: 'FIX.2.7',
        Value: '7',
        Sort: 8,
        Tag: 18,
        SymbolicName: 'StrictScale',
    },
    {
        Group: '',
        Description: 'Try to scale',
        added: 'FIX.2.7',
        Value: '8',
        Sort: 9,
        Tag: 18,
        SymbolicName: 'TryToScale',
    },
    {
        Group: '',
        Description: 'Stay on bid side',
        added: 'FIX.2.7',
        Value: '9',
        Sort: 10,
        Tag: 18,
        SymbolicName: 'StayOnBidSide',
    },
    {
        Group: '',
        Description: 'No cross (cross is forbidden)',
        added: 'FIX.2.7',
        Value: 'A',
        Sort: 11,
        Tag: 18,
        SymbolicName: 'NoCross',
    },
    {
        Group: '',
        Description: 'OK to cross',
        added: 'FIX.2.7',
        Value: 'B',
        Sort: 12,
        Tag: 18,
        SymbolicName: 'OKToCross',
    },
    {
        Group: '',
        Description: 'Call first',
        added: 'FIX.2.7',
        Value: 'C',
        Sort: 13,
        Tag: 18,
        SymbolicName: 'CallFirst',
    },
    {
        Group: '',
        Description:
            'Percent of volume (indicates that the sender does not want to be all of the volume on the floor vs. a specific percentage)',
        added: 'FIX.2.7',
        Value: 'D',
        Sort: 14,
        Tag: 18,
        SymbolicName: 'PercentOfVolume',
    },
    {
        Group: '',
        Description: 'Do not increase - DNI',
        added: 'FIX.2.7',
        Value: 'E',
        Sort: 15,
        Tag: 18,
        SymbolicName: 'DoNotIncrease',
    },
    {
        Group: '',
        Description: 'Do not reduce - DNR',
        added: 'FIX.2.7',
        Value: 'F',
        Sort: 16,
        Tag: 18,
        SymbolicName: 'DoNotReduce',
    },
    {
        Group: '',
        Description: 'All or none - AON',
        added: 'FIX.2.7',
        Value: 'G',
        Sort: 17,
        Tag: 18,
        SymbolicName: 'AllOrNone',
    },
    {
        Group: '',
        Description: 'Reinstate on system failure (mutually exclusive with Q and l)',
        added: 'FIX.4.3',
        Value: 'H',
        Sort: 18,
        Tag: 18,
        SymbolicName: 'ReinstateOnSystemFailure',
    },
    {
        Group: '',
        Description: 'Institutions only',
        added: 'FIX.3.0',
        Value: 'I',
        Sort: 19,
        Tag: 18,
        SymbolicName: 'InstitutionsOnly',
    },
    {
        Group: '',
        Description: 'Reinstate on Trading Halt (mutually exclusive with K and m)',
        added: 'FIX.4.3',
        Value: 'J',
        Sort: 20,
        Tag: 18,
        SymbolicName: 'ReinstateOnTradingHalt',
    },
    {
        Group: '',
        Description: 'Cancel on Trading Halt (mutually exclusive with J and m)',
        added: 'FIX.4.3',
        Value: 'K',
        Sort: 21,
        Tag: 18,
        SymbolicName: 'CancelOnTradingHalt',
    },
    {
        Group: '',
        Description: 'Last peg (last sale)',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        Value: 'L',
        Sort: 22,
        Tag: 18,
        SymbolicName: 'LastPeg',
    },
    {
        Group: '',
        Description: 'Mid-price peg (midprice of inside quote)',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        Value: 'M',
        Sort: 23,
        Tag: 18,
        SymbolicName: 'MidPricePeg',
    },
    {
        Group: '',
        Description: 'Non-negotiable',
        added: 'FIX.3.0',
        Value: 'N',
        Sort: 24,
        Tag: 18,
        SymbolicName: 'NonNegotiable',
    },
    {
        Group: '',
        Description: 'Opening peg',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        Value: 'O',
        Sort: 25,
        Tag: 18,
        SymbolicName: 'OpeningPeg',
    },
    {
        Group: '',
        Description: 'Market peg',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        Value: 'P',
        Sort: 26,
        Tag: 18,
        SymbolicName: 'MarketPeg',
    },
    {
        Group: '',
        Description: 'Cancel on system failure (mutually exclusive with H and l)',
        added: 'FIX.4.3',
        Value: 'Q',
        Sort: 27,
        Tag: 18,
        SymbolicName: 'CancelOnSystemFailure',
    },
    {
        Group: '',
        Description: 'Primary peg (primary market - buy at bid/sell at offer)',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        Value: 'R',
        Sort: 28,
        Tag: 18,
        SymbolicName: 'PrimaryPeg',
    },
    {
        Group: '',
        Description: 'Suspend',
        added: 'FIX.3.0',
        Value: 'S',
        Sort: 29,
        Tag: 18,
        SymbolicName: 'Suspend',
    },
    {
        Group: '',
        Description: 'Fixed Peg to Local best bid or offer at time of order',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        Value: 'T',
        Sort: 30,
        addedEP: 35,
        Tag: 18,
        SymbolicName: 'FixedPegToLocalBestBidOrOfferAtTimeOfOrder',
    },
    {
        Group: '',
        Description: 'Customer Display Instruction (Rule 11Ac1-1/4)',
        added: 'FIX.4.1',
        Value: 'U',
        Sort: 31,
        Tag: 18,
        SymbolicName: 'CustomerDisplayInstruction',
    },
    {
        Group: '',
        Description: 'Netting (for Forex)',
        added: 'FIX.4.1',
        Value: 'V',
        Sort: 32,
        Tag: 18,
        SymbolicName: 'Netting',
    },
    {
        Group: '',
        Description: 'Peg to VWAP',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        Value: 'W',
        Sort: 33,
        Tag: 18,
        SymbolicName: 'PegToVWAP',
    },
    {
        Group: '',
        Description: 'Trade Along',
        added: 'FIX.4.3',
        Value: 'X',
        Sort: 34,
        Tag: 18,
        SymbolicName: 'TradeAlong',
    },
    {
        Group: '',
        Description: 'Try To Stop',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 35,
        Tag: 18,
        SymbolicName: 'TryToStop',
    },
    {
        Group: '',
        Description: 'Cancel if not best',
        added: 'FIX.4.4',
        Value: 'Z',
        Sort: 36,
        Tag: 18,
        SymbolicName: 'CancelIfNotBest',
    },
    {
        Group: '',
        Description: 'Trailing Stop Peg',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        Value: 'a',
        Sort: 37,
        Tag: 18,
        SymbolicName: 'TrailingStopPeg',
    },
    {
        Group: '',
        Description: 'Strict Limit (No price improvement)',
        added: 'FIX.4.4',
        Value: 'b',
        Sort: 38,
        Tag: 18,
        SymbolicName: 'StrictLimit',
    },
    {
        Group: '',
        Description: 'Ignore Price Validity Checks',
        added: 'FIX.4.4',
        Value: 'c',
        Sort: 39,
        Tag: 18,
        SymbolicName: 'IgnorePriceValidityChecks',
    },
    {
        Group: '',
        Description: 'Peg to Limit Price',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        Value: 'd',
        Sort: 40,
        Tag: 18,
        SymbolicName: 'PegToLimitPrice',
    },
    {
        Group: '',
        Description: 'Work to Target Strategy',
        added: 'FIX.4.4',
        Value: 'e',
        Sort: 41,
        Tag: 18,
        SymbolicName: 'WorkToTargetStrategy',
    },
    {
        Group: '',
        Description: 'Intermarket Sweep',
        added: 'FIX.4.4',
        Value: 'f',
        Sort: 42,
        addedEP: 6,
        Tag: 18,
        SymbolicName: 'IntermarketSweep',
    },
    {
        Group: '',
        Description: 'External Routing Allowed',
        added: 'FIX.4.4',
        Value: 'g',
        Sort: 43,
        addedEP: 14,
        Tag: 18,
        SymbolicName: 'ExternalRoutingAllowed',
    },
    {
        Group: '',
        Description: 'External Routing Not Allowed',
        added: 'FIX.4.4',
        Value: 'h',
        Sort: 44,
        addedEP: 14,
        Tag: 18,
        SymbolicName: 'ExternalRoutingNotAllowed',
    },
    {
        Group: '',
        Description: 'Imbalance Only',
        added: 'FIX.4.4',
        Value: 'i',
        Sort: 45,
        addedEP: 22,
        Tag: 18,
        SymbolicName: 'ImbalanceOnly',
    },
    {
        Group: '',
        Description: 'Single execution requested for block trade',
        added: 'FIX.4.4',
        Value: 'j',
        Sort: 46,
        addedEP: 6,
        Tag: 18,
        SymbolicName: 'SingleExecutionRequestedForBlockTrade',
    },
    {
        Group: '',
        Description: 'Best Execution',
        added: 'FIX.4.4',
        Value: 'k',
        Sort: 47,
        addedEP: 35,
        Tag: 18,
        SymbolicName: 'BestExecution',
    },
    {
        Group: '',
        Description: 'Suspend on system failure (mutually exclusive with H and Q)',
        added: 'FIX.5.0',
        Value: 'l',
        Sort: 48,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'SuspendOnSystemFailure',
    },
    {
        Group: '',
        Description: 'Suspend on Trading Halt (mutually exclusive with J and K)',
        added: 'FIX.5.0',
        Value: 'm',
        Sort: 49,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'SuspendOnTradingHalt',
    },
    {
        Group: '',
        Description: 'Reinstate on connection loss (mutually exclusive with o and p)',
        added: 'FIX.5.0',
        Value: 'n',
        Sort: 50,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'ReinstateOnConnectionLoss',
    },
    {
        Group: '',
        Description: 'Cancel on connection loss (mutually exclusive with n and p)',
        added: 'FIX.5.0',
        Value: 'o',
        Sort: 51,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'CancelOnConnectionLoss',
    },
    {
        Group: '',
        Description: 'Suspend on connection loss (mutually exclusive with n and o)',
        added: 'FIX.5.0',
        Value: 'p',
        Sort: 52,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'SuspendOnConnectionLoss',
    },
    {
        Group: '',
        Description: 'Release from suspension (mutually exclusive with S)',
        added: 'FIX.5.0',
        Value: 'q',
        Sort: 53,
        addedEP: 58,
        Tag: 18,
        SymbolicName: 'ReleaseFromSuspension',
    },
    {
        Group: '',
        Description: 'Execute as delta neutral using volatility provided',
        added: 'FIX.5.0',
        Value: 'r',
        Sort: 54,
        addedEP: 59,
        Tag: 18,
        SymbolicName: 'ExecuteAsDeltaNeutral',
    },
    {
        Group: '',
        Description: 'Execute as duration neutral',
        added: 'FIX.5.0',
        Value: 's',
        Sort: 55,
        addedEP: 59,
        Tag: 18,
        SymbolicName: 'ExecuteAsDurationNeutral',
    },
    {
        Group: '',
        Description: 'Execute as FX neutral',
        added: 'FIX.5.0',
        Value: 't',
        Sort: 56,
        addedEP: 59,
        Tag: 18,
        SymbolicName: 'ExecuteAsFXNeutral',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 20,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 20,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Correct',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 20,
        SymbolicName: 'Correct',
    },
    {
        Group: '',
        Description: 'Status',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 20,
        SymbolicName: 'Status',
    },
    {
        Group: '',
        Description: 'Automated execution order, private, no Broker intervention',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 21,
        SymbolicName: 'AutomatedExecutionNoIntervention',
    },
    {
        Group: '',
        Description: 'Automated execution order, public, Broker intervention OK',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 21,
        SymbolicName: 'AutomatedExecutionInterventionOK',
    },
    {
        Group: '',
        Description: 'Manual order, best execution',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 21,
        SymbolicName: 'ManualOrder',
    },
    {
        Group: '',
        Description: 'CUSIP',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 22,
        SymbolicName: 'CUSIP',
    },
    {
        Group: '',
        Description: 'SEDOL',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 22,
        SymbolicName: 'SEDOL',
    },
    {
        Group: '',
        Description: 'QUIK',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 22,
        SymbolicName: 'QUIK',
    },
    {
        Group: '',
        Description: 'ISIN number',
        added: 'FIX.3.0',
        Value: '4',
        Sort: 4,
        Tag: 22,
        SymbolicName: 'ISINNumber',
    },
    {
        Group: '',
        Description: 'RIC code',
        added: 'FIX.3.0',
        Value: '5',
        Sort: 5,
        Tag: 22,
        SymbolicName: 'RICCode',
    },
    {
        Group: '',
        Description: 'ISO Currency Code',
        added: 'FIX.4.1',
        Value: '6',
        Sort: 6,
        Tag: 22,
        SymbolicName: 'ISOCurrencyCode',
    },
    {
        Group: '',
        Description: 'ISO Country Code',
        added: 'FIX.4.1',
        Value: '7',
        Sort: 7,
        Tag: 22,
        SymbolicName: 'ISOCountryCode',
    },
    {
        Group: '',
        Description: 'Exchange Symbol',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 8,
        Tag: 22,
        SymbolicName: 'ExchangeSymbol',
    },
    {
        Group: '',
        Description: 'Consolidated Tape Association (CTA) Symbol (SIAC CTS/CQS line format)',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 9,
        Tag: 22,
        SymbolicName: 'ConsolidatedTapeAssociation',
    },
    {
        Group: '',
        Description: 'Bloomberg Symbol',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 10,
        Tag: 22,
        SymbolicName: 'BloombergSymbol',
    },
    {
        Group: '',
        Description: 'Wertpapier',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 11,
        Tag: 22,
        SymbolicName: 'Wertpapier',
    },
    {
        Group: '',
        Description: 'Dutch',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 12,
        Tag: 22,
        SymbolicName: 'Dutch',
    },
    {
        Group: '',
        Description: 'Valoren',
        added: 'FIX.4.3',
        Value: 'D',
        Sort: 13,
        Tag: 22,
        SymbolicName: 'Valoren',
    },
    {
        Group: '',
        Description: 'Sicovam',
        added: 'FIX.4.3',
        Value: 'E',
        Sort: 14,
        Tag: 22,
        SymbolicName: 'Sicovam',
    },
    {
        Group: '',
        Description: 'Belgian',
        added: 'FIX.4.3',
        Value: 'F',
        Sort: 15,
        Tag: 22,
        SymbolicName: 'Belgian',
    },
    {
        Group: '',
        Description: '"Common" (Clearstream and Euroclear)',
        added: 'FIX.4.3',
        Value: 'G',
        Sort: 16,
        Tag: 22,
        SymbolicName: 'Common',
    },
    {
        Group: '',
        Description: 'Clearing House / Clearing Organization',
        added: 'FIX.4.4',
        Value: 'H',
        Sort: 17,
        Tag: 22,
        SymbolicName: 'ClearingHouse',
    },
    {
        Group: '',
        Description: 'ISDA/FpML Product Specification (XML in EncodedSecurityDesc)',
        added: 'FIX.4.4',
        Value: 'I',
        Sort: 18,
        Tag: 22,
        SymbolicName: 'ISDAFpMLSpecification',
    },
    {
        Group: '',
        Description: 'Option Price Reporting Authority',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 19,
        Tag: 22,
        SymbolicName: 'OptionPriceReportingAuthority',
    },
    {
        Group: '',
        Description: 'ISDA/FpML Product URL (URL in SecurityID)',
        added: 'FIX.4.4',
        Value: 'K',
        Sort: 20,
        addedEP: 15,
        Tag: 22,
        SymbolicName: 'ISDAFpMLURL',
    },
    {
        Group: '',
        Description: 'Letter of Credit',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 21,
        addedEP: 8,
        Tag: 22,
        SymbolicName: 'LetterOfCredit',
    },
    {
        Group: '',
        Description: 'Marketplace-assigned Identifier',
        added: 'FIX.5.0',
        Value: 'M',
        Sort: 22,
        addedEP: 58,
        Tag: 22,
        SymbolicName: 'MarketplaceAssignedIdentifier',
    },
    {
        Group: '',
        Description: 'High',
        added: 'FIX.2.7',
        Value: 'H',
        Sort: 1,
        Tag: 25,
        SymbolicName: 'High',
    },
    {
        Group: '',
        Description: 'Low',
        added: 'FIX.2.7',
        Value: 'L',
        Sort: 2,
        Tag: 25,
        SymbolicName: 'Low',
    },
    {
        Group: '',
        Description: 'Medium',
        added: 'FIX.2.7',
        Value: 'M',
        Sort: 3,
        Tag: 25,
        SymbolicName: 'Medium',
    },
    {
        Group: '',
        Description: 'Small',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 2,
        addedEP: 25,
        Tag: 27,
        SymbolicName: 'Small',
    },
    {
        Group: '',
        Description: 'Medium',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 3,
        addedEP: 25,
        Tag: 27,
        SymbolicName: 'Medium',
    },
    {
        Group: '',
        Description: 'Large',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 4,
        addedEP: 25,
        Tag: 27,
        SymbolicName: 'Large',
    },
    {
        Group: '',
        Description: 'Undisclosed Quantity',
        added: 'FIX.4.4',
        Value: 'U',
        Sort: 5,
        addedEP: 25,
        Tag: 27,
        SymbolicName: 'UndisclosedQuantity',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: 'N',
        Sort: 1,
        Tag: 28,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.2.7',
        Value: 'C',
        Sort: 2,
        Tag: 28,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.2.7',
        Value: 'R',
        Sort: 3,
        Tag: 28,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Agent',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 29,
        SymbolicName: 'Agent',
    },
    {
        Group: '',
        Description: 'Cross as agent',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 29,
        SymbolicName: 'CrossAsAgent',
    },
    {
        Group: '',
        Description: 'Cross as principal',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 29,
        SymbolicName: 'CrossAsPrincipal',
    },
    {
        Group: '',
        Description: 'Principal',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 4,
        Tag: 29,
        SymbolicName: 'Principal',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 39,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Partially filled',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 39,
        SymbolicName: 'PartiallyFilled',
    },
    {
        Group: '',
        Description: 'Filled',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 39,
        SymbolicName: 'Filled',
    },
    {
        Group: '',
        Description: 'Done for day',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 39,
        SymbolicName: 'DoneForDay',
    },
    {
        Group: '',
        Description: 'Canceled',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 39,
        SymbolicName: 'Canceled',
    },
    {
        Group: '',
        Description: 'Replaced (No longer used)',
        added: 'FIX.4.4',
        deprecated: 'FIX.4.3',
        Value: '5',
        Sort: 6,
        addedEP: 35,
        Tag: 39,
        SymbolicName: 'Replaced',
    },
    {
        Group: '',
        Description: 'Pending Cancel (i.e. result of Order Cancel Request)',
        added: 'FIX.2.7',
        Value: '6',
        Sort: 7,
        Tag: 39,
        SymbolicName: 'PendingCancel',
    },
    {
        Group: '',
        Description: 'Stopped',
        added: 'FIX.2.7',
        Value: '7',
        Sort: 8,
        Tag: 39,
        SymbolicName: 'Stopped',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.2.7',
        Value: '8',
        Sort: 9,
        Tag: 39,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Suspended',
        added: 'FIX.3.0',
        Value: '9',
        Sort: 10,
        Tag: 39,
        SymbolicName: 'Suspended',
    },
    {
        Group: '',
        Description: 'Pending New',
        added: 'FIX.3.0',
        Value: 'A',
        Sort: 11,
        Tag: 39,
        SymbolicName: 'PendingNew',
    },
    {
        Group: '',
        Description: 'Calculated',
        added: 'FIX.4.0',
        Value: 'B',
        Sort: 12,
        Tag: 39,
        SymbolicName: 'Calculated',
    },
    {
        Group: '',
        Description: 'Expired',
        added: 'FIX.4.0',
        Value: 'C',
        Sort: 13,
        Tag: 39,
        SymbolicName: 'Expired',
    },
    {
        Group: '',
        Description: 'Accepted for Bidding',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 14,
        Tag: 39,
        SymbolicName: 'AcceptedForBidding',
    },
    {
        Group: '',
        Description: 'Pending Replace (i.e. result of Order Cancel/Replace Request)',
        added: 'FIX.4.2',
        Value: 'E',
        Sort: 15,
        Tag: 39,
        SymbolicName: 'PendingReplace',
    },
    {
        Group: '',
        Description: 'Market',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 40,
        SymbolicName: 'Market',
    },
    {
        Group: '',
        Description: 'Limit',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 40,
        SymbolicName: 'Limit',
    },
    {
        Group: '',
        Description: 'Stop / Stop Loss',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 40,
        SymbolicName: 'Stop',
    },
    {
        Group: '',
        Description: 'Stop Limit',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 4,
        Tag: 40,
        SymbolicName: 'StopLimit',
    },
    {
        Group: '',
        Description: 'Market On Close (No longer used)',
        added: 'FIX.2.7',
        deprecated: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 40,
        SymbolicName: 'MarketOnClose',
    },
    {
        Group: '',
        Description: 'With Or Without',
        added: 'FIX.2.7',
        Value: '6',
        Sort: 6,
        Tag: 40,
        SymbolicName: 'WithOrWithout',
    },
    {
        Group: '',
        Description: 'Limit Or Better',
        added: 'FIX.2.7',
        deprecated: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        Tag: 40,
        SymbolicName: 'LimitOrBetter',
    },
    {
        Group: '',
        Description: 'Limit With Or Without',
        added: 'FIX.2.7',
        Value: '8',
        Sort: 8,
        Tag: 40,
        SymbolicName: 'LimitWithOrWithout',
    },
    {
        Group: '',
        Description: 'On Basis',
        added: 'FIX.2.7',
        Value: '9',
        Sort: 9,
        Tag: 40,
        SymbolicName: 'OnBasis',
    },
    {
        Group: '',
        Description: 'On Close (No longer used)',
        added: 'FIX.2.7',
        deprecated: 'FIX.4.3',
        Value: 'A',
        Sort: 10,
        Tag: 40,
        SymbolicName: 'OnClose',
    },
    {
        Group: '',
        Description: 'Limit On Close (No longer used)',
        added: 'FIX.2.7',
        deprecated: 'FIX.4.3',
        Value: 'B',
        Sort: 11,
        Tag: 40,
        SymbolicName: 'LimitOnClose',
    },
    {
        Group: '',
        Description: 'Forex Market (No longer used)',
        added: 'FIX.4.0',
        deprecated: 'FIX.4.3',
        Value: 'C',
        Sort: 12,
        Tag: 40,
        SymbolicName: 'ForexMarket',
    },
    {
        Group: '',
        Description: 'Previously Quoted',
        added: 'FIX.4.0',
        Value: 'D',
        Sort: 13,
        Tag: 40,
        SymbolicName: 'PreviouslyQuoted',
    },
    {
        Group: '',
        Description: 'Previously Indicated',
        added: 'FIX.4.0',
        Value: 'E',
        Sort: 14,
        Tag: 40,
        SymbolicName: 'PreviouslyIndicated',
    },
    {
        Group: '',
        Description: 'Forex Limit (No longer used)',
        added: 'FIX.4.1',
        deprecated: 'FIX.4.3',
        Value: 'F',
        Sort: 15,
        Tag: 40,
        SymbolicName: 'ForexLimit',
    },
    {
        Group: '',
        Description: 'Forex Swap',
        added: 'FIX.4.1',
        Value: 'G',
        Sort: 16,
        Tag: 40,
        SymbolicName: 'ForexSwap',
    },
    {
        Group: '',
        Description: 'Forex Previously Quoted (No longer used)',
        added: 'FIX.4.1',
        deprecated: 'FIX.4.3',
        Value: 'H',
        Sort: 17,
        Tag: 40,
        SymbolicName: 'ForexPreviouslyQuoted',
    },
    {
        Group: '',
        Description: 'Funari (Limit day order with unexecuted portion handles as Market On Close. E.g. Japan)',
        added: 'FIX.4.2',
        Value: 'I',
        Sort: 18,
        Tag: 40,
        SymbolicName: 'Funari',
    },
    {
        Group: '',
        Description: 'Market If Touched (MIT)',
        added: 'FIX.4.3',
        Value: 'J',
        Sort: 19,
        Tag: 40,
        SymbolicName: 'MarketIfTouched',
    },
    {
        Group: '',
        Description:
            'Market With Left Over as Limit (market order with unexecuted quantity becoming limit order at last price)',
        added: 'FIX.4.3',
        Value: 'K',
        Sort: 20,
        Tag: 40,
        SymbolicName: 'MarketWithLeftOverAsLimit',
    },
    {
        Group: '',
        Description: 'Previous Fund Valuation Point (Historic pricing; for CIV)',
        added: 'FIX.4.3',
        Value: 'L',
        Sort: 21,
        Tag: 40,
        SymbolicName: 'PreviousFundValuationPoint',
    },
    {
        Group: '',
        Description: 'Next Fund Valuation Point (Forward pricing; for CIV)',
        added: 'FIX.4.3',
        Value: 'M',
        Sort: 22,
        Tag: 40,
        SymbolicName: 'NextFundValuationPoint',
    },
    {
        Group: '',
        Description: 'Pegged',
        added: 'FIX.3.0',
        Value: 'P',
        Sort: 23,
        Tag: 40,
        SymbolicName: 'Pegged',
    },
    {
        Group: '',
        Description: 'Counter-order selection',
        added: 'FIX.4.4',
        Value: 'Q',
        Sort: 24,
        addedEP: 22,
        Tag: 40,
        SymbolicName: 'CounterOrderSelection',
    },
    {
        Group: '',
        Description: 'Original transmission',
        added: 'FIX.2.7',
        Value: 'N',
        Sort: 1,
        Tag: 43,
        SymbolicName: 'OriginalTransmission',
    },
    {
        Group: '',
        Description: 'Possible duplicate',
        added: 'FIX.2.7',
        Value: 'Y',
        Sort: 2,
        Tag: 43,
        SymbolicName: 'PossibleDuplicate',
    },
    {
        Group: '',
        Description: 'Agency single order',
        added: 'FIX.2.7',
        Value: 'A',
        Sort: 1,
        Tag: 47,
        SymbolicName: 'AgencySingleOrder',
    },
    {
        Group: '',
        Description: 'Short exempt transaction (refer to A type)',
        added: 'FIX.4.1',
        Value: 'B',
        Sort: 2,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionAType',
    },
    {
        Group: '',
        Description: 'Proprietary, Non-Algorithmic Program Trade (non-index arbitrage)',
        added: 'FIX.2.7',
        Value: 'C',
        Sort: 3,
        Tag: 47,
        SymbolicName: 'ProprietaryNonAlgo',
    },
    {
        Group: '',
        Description: 'Program order, index arb, for Member firm/org',
        added: 'FIX.2.7',
        Value: 'D',
        Sort: 4,
        Tag: 47,
        SymbolicName: 'ProgramOrderMember',
    },
    {
        Group: '',
        Description:
            'Short Exempt Transaction for Principal (was incorrectly identified in the FIX spec as "Registered Equity Market Maker trades")',
        added: 'FIX.4.1',
        Value: 'E',
        Sort: 5,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionForPrincipal',
    },
    {
        Group: '',
        Description: 'Short exempt transaction (refer to W type)',
        added: 'FIX.4.1',
        Value: 'F',
        Sort: 6,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionWType',
    },
    {
        Group: '',
        Description: 'Short exempt transaction (refer to I type)',
        added: 'FIX.4.1',
        Value: 'H',
        Sort: 7,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionIType',
    },
    {
        Group: '',
        Description: 'Individual Investor, single order',
        added: 'FIX.2.7',
        Value: 'I',
        Sort: 8,
        Tag: 47,
        SymbolicName: 'IndividualInvestor',
    },
    {
        Group: '',
        Description: 'Proprietary, Algorithmic Program Trading (non-index arbitrage)',
        added: 'FIX.2.7',
        Value: 'J',
        Sort: 9,
        Tag: 47,
        SymbolicName: 'ProprietaryAlgo',
    },
    {
        Group: '',
        Description: 'Agency, Algorithmic Program Trading (non-index arbitrage)',
        added: 'FIX.2.7',
        Value: 'K',
        Sort: 10,
        Tag: 47,
        SymbolicName: 'AgencyAlgo',
    },
    {
        Group: '',
        Description:
            'Short exempt transaction for member competing market-maker affliated with the firm clearing the trade (refer to P and O types)',
        added: 'FIX.4.1',
        Value: 'L',
        Sort: 11,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionMemberAffliated',
    },
    {
        Group: '',
        Description: 'Program Order, index arb, for other member',
        added: 'FIX.2.7',
        Value: 'M',
        Sort: 12,
        Tag: 47,
        SymbolicName: 'ProgramOrderOtherMember',
    },
    {
        Group: '',
        Description: 'Agent for other Member, Non-Algorithmic Program Trade (non-index arbitrage)',
        added: 'FIX.2.7',
        Value: 'N',
        Sort: 13,
        Tag: 47,
        SymbolicName: 'AgentForOtherMember',
    },
    {
        Group: '',
        Description:
            'Proprietary transactions for competing market-maker that is affiliated with the clearing member (was incorrectly identified in the FIX spec as "Competing dealer trades")',
        added: 'FIX.4.1',
        Value: 'O',
        Sort: 14,
        Tag: 47,
        SymbolicName: 'ProprietaryTransactionAffiliated',
    },
    {
        Group: '',
        Description: 'Principal',
        added: 'FIX.4.1',
        Value: 'P',
        Sort: 15,
        Tag: 47,
        SymbolicName: 'Principal',
    },
    {
        Group: '',
        Description:
            'Transactions for the account of a non-member compting market-maker (was incorrectly identified in the FIX spec as "Competing dealer trades")',
        added: 'FIX.4.1',
        Value: 'R',
        Sort: 16,
        Tag: 47,
        SymbolicName: 'TransactionNonMember',
    },
    {
        Group: '',
        Description: 'Specialist trades',
        added: 'FIX.4.1',
        Value: 'S',
        Sort: 17,
        Tag: 47,
        SymbolicName: 'SpecialistTrades',
    },
    {
        Group: '',
        Description:
            'Transactions for the account of an unaffiliated member\'s competing market-maker (was incorrectly identified in the FIX spec as "Competing dealer trades")',
        added: 'FIX.4.1',
        Value: 'T',
        Sort: 18,
        Tag: 47,
        SymbolicName: 'TransactionUnaffiliatedMember',
    },
    {
        Group: '',
        Description: 'Agency, Index Arbitrage (includes Individual, Index Arbitrage trades)',
        added: 'FIX.2.7',
        Value: 'U',
        Sort: 19,
        Tag: 47,
        SymbolicName: 'AgencyIndexArb',
    },
    {
        Group: '',
        Description: 'All other orders as agent for other member',
        added: 'FIX.2.7',
        Value: 'W',
        Sort: 20,
        Tag: 47,
        SymbolicName: 'AllOtherOrdersAsAgentForOtherMember',
    },
    {
        Group: '',
        Description:
            'Short exempt transaction for member competing market-maker not affiliated with the firm clearing the trade (refer to W and T types)',
        added: 'FIX.4.1',
        Value: 'X',
        Sort: 21,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionMemberNotAffliated',
    },
    {
        Group: '',
        Description: 'Agency, Non-Algorithmic Program Trade (non-index arbitrage)',
        added: 'FIX.2.7',
        Value: 'Y',
        Sort: 22,
        Tag: 47,
        SymbolicName: 'AgencyNonAlgo',
    },
    {
        Group: '',
        Description: 'Short exempt transaction for non-member competing market-maker (refer to A and R types)',
        added: 'FIX.4.1',
        Value: 'Z',
        Sort: 23,
        Tag: 47,
        SymbolicName: 'ShortExemptTransactionNonMember',
    },
    {
        Group: '',
        Description: 'Buy',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 54,
        SymbolicName: 'Buy',
    },
    {
        Group: '',
        Description: 'Sell',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 54,
        SymbolicName: 'Sell',
    },
    {
        Group: '',
        Description: 'Buy minus',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 54,
        SymbolicName: 'BuyMinus',
    },
    {
        Group: '',
        Description: 'Sell plus',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 4,
        Tag: 54,
        SymbolicName: 'SellPlus',
    },
    {
        Group: '',
        Description: 'Sell short',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 5,
        Tag: 54,
        SymbolicName: 'SellShort',
    },
    {
        Group: '',
        Description: 'Sell short exempt',
        added: 'FIX.2.7',
        Value: '6',
        Sort: 6,
        Tag: 54,
        SymbolicName: 'SellShortExempt',
    },
    {
        Group: '',
        Description: 'Undisclosed (valid for IOI and List Order messages only)',
        added: 'FIX.4.1',
        Value: '7',
        Sort: 7,
        Tag: 54,
        SymbolicName: 'Undisclosed',
    },
    {
        Group: '',
        Description: 'Cross (orders where counterparty is an exchange, valid for all messages except IOIs)',
        added: 'FIX.4.1',
        Value: '8',
        Sort: 8,
        Tag: 54,
        SymbolicName: 'Cross',
    },
    {
        Group: '',
        Description: 'Cross short',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 9,
        Tag: 54,
        SymbolicName: 'CrossShort',
    },
    {
        Group: '',
        Description: 'Cross short exempt',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: 'A',
        Sort: 10,
        Tag: 54,
        SymbolicName: 'CrossShortExempt',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: '"As Defined" (for use with multileg instruments)',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 11,
        Tag: 54,
        SymbolicName: 'AsDefined',
    },
    {
        Group: '',
        Description: '"Opposite" (for use with multileg instruments)',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 12,
        Tag: 54,
        SymbolicName: 'Opposite',
    },
    {
        Group: '',
        Description: 'Subscribe (e.g. CIV)',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 13,
        Tag: 54,
        SymbolicName: 'Subscribe',
    },
    {
        Group: '',
        Description: 'Redeem (e.g. CIV)',
        added: 'FIX.4.4',
        Value: 'E',
        Sort: 14,
        Tag: 54,
        SymbolicName: 'Redeem',
    },
    {
        Group: '',
        Description: 'Lend (FINANCING - identifies direction of collateral)',
        added: 'FIX.4.4',
        Value: 'F',
        Sort: 15,
        Tag: 54,
        SymbolicName: 'Lend',
    },
    {
        Group: '',
        Description: 'Borrow (FINANCING - identifies direction of collateral)',
        added: 'FIX.4.4',
        Value: 'G',
        Sort: 16,
        Tag: 54,
        SymbolicName: 'Borrow',
    },
    {
        Group: '',
        Description: 'Day (or session)',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 59,
        SymbolicName: 'Day',
    },
    {
        Group: '',
        Description: 'Good Till Cancel (GTC)',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 59,
        SymbolicName: 'GoodTillCancel',
    },
    {
        Group: '',
        Description: 'At the Opening (OPG)',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 59,
        SymbolicName: 'AtTheOpening',
    },
    {
        Group: '',
        Description: 'Immediate Or Cancel (IOC)',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 59,
        SymbolicName: 'ImmediateOrCancel',
    },
    {
        Group: '',
        Description: 'Fill Or Kill (FOK)',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 59,
        SymbolicName: 'FillOrKill',
    },
    {
        Group: '',
        Description: 'Good Till Crossing (GTX)',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 6,
        Tag: 59,
        SymbolicName: 'GoodTillCrossing',
    },
    {
        Group: '',
        Description: 'Good Till Date (GTD)',
        added: 'FIX.4.0',
        Value: '6',
        Sort: 7,
        Tag: 59,
        SymbolicName: 'GoodTillDate',
    },
    {
        Group: '',
        Description: 'At the Close',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 8,
        Tag: 59,
        SymbolicName: 'AtTheClose',
    },
    {
        Group: '',
        Description: 'Good Through Crossing',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 61,
        Tag: 59,
        SymbolicName: 'GoodThroughCrossing',
    },
    {
        Group: '',
        Description: 'At Crossing',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 10,
        addedEP: 61,
        Tag: 59,
        SymbolicName: 'AtCrossing',
    },
    {
        Group: '',
        Description: 'Normal',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 61,
        SymbolicName: 'Normal',
    },
    {
        Group: '',
        Description: 'Flash',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 61,
        SymbolicName: 'Flash',
    },
    {
        Group: '',
        Description: 'Background',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 61,
        SymbolicName: 'Background',
    },
    {
        Group: '',
        Description: 'Regular / FX Spot settlement (T+1 or T+2 depending on currency)',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 63,
        SymbolicName: 'Regular',
    },
    {
        Group: '',
        Description: 'Cash (TOD / T+0)',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 63,
        SymbolicName: 'Cash',
    },
    {
        Group: '',
        Description: 'Next Day (TOM / T+1)',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 63,
        SymbolicName: 'NextDay',
    },
    {
        Group: '',
        Description: 'T+2',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 63,
        SymbolicName: 'TPlus2',
    },
    {
        Group: '',
        Description: 'T+3',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 63,
        SymbolicName: 'TPlus3',
    },
    {
        Group: '',
        Description: 'T+4',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 6,
        Tag: 63,
        SymbolicName: 'TPlus4',
    },
    {
        Group: '',
        Description: 'Future',
        added: 'FIX.2.7',
        Value: '6',
        Sort: 7,
        Tag: 63,
        SymbolicName: 'Future',
    },
    {
        Group: '',
        Description: 'When And If Issued',
        added: 'FIX.2.7',
        Value: '7',
        Sort: 8,
        Tag: 63,
        SymbolicName: 'WhenAndIfIssued',
    },
    {
        Group: '',
        Description: 'Sellers Option',
        added: 'FIX.2.7',
        Value: '8',
        Sort: 9,
        Tag: 63,
        SymbolicName: 'SellersOption',
    },
    {
        Group: '',
        Description: 'T+5',
        added: 'FIX.3.0',
        Value: '9',
        Sort: 10,
        Tag: 63,
        SymbolicName: 'TPlus5',
    },
    {
        Group: '',
        Description: 'Broken date - for FX expressing non-standard tenor, SettlDate (64) must be specified',
        added: 'FIX.4.4',
        Value: 'B',
        Sort: 12,
        addedEP: 25,
        Tag: 63,
        SymbolicName: 'BrokenDate',
    },
    {
        Group: '',
        Description: 'FX Spot Next settlement (Spot+1, aka next day)',
        added: 'FIX.4.4',
        Value: 'C',
        Sort: 99,
        addedEP: 21,
        Tag: 63,
        SymbolicName: 'FXSpotNextSettlement',
    },
    {
        Group: 'For Fixed Income',
        Description: 'EUCP with lump-sum interest rather than discount price',
        added: 'FIX.4.4',
        Value: 'CD',
        Sort: 1,
        addedEP: -1,
        Tag: 65,
        SymbolicName: 'EUCPWithLumpSumInterest',
    },
    {
        Group: 'For Fixed Income',
        Description: '"When Issued" for a security to be reissued under an old CUSIP or ISIN',
        added: 'FIX.4.4',
        Value: 'WI',
        Sort: 2,
        addedEP: -1,
        Tag: 65,
        SymbolicName: 'WhenIssued',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 71,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 71,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 71,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Preliminary (without MiscFees and NetMoney) (Removed/Replaced)',
        added: 'FIX.4.1',
        deprecated: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 71,
        SymbolicName: 'Preliminary',
    },
    {
        Group: '',
        Description: 'Calculated (includes MiscFees and NetMoney) (Removed/Replaced)',
        added: 'FIX.4.1',
        deprecated: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 71,
        SymbolicName: 'Calculated',
    },
    {
        Group: '',
        Description:
            'Calculated without Preliminary (sent unsolicited by broker, includes MiscFees and NetMoney) (Removed/Replaced)',
        added: 'FIX.4.2',
        deprecated: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 71,
        SymbolicName: 'CalculatedWithoutPreliminary',
    },
    {
        Group: '',
        Description: 'Reversal',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        addedEP: 5,
        Tag: 71,
        SymbolicName: 'Reversal',
    },
    {
        Group: '',
        Description: 'Close',
        added: 'FIX.4.1',
        Value: 'C',
        Sort: 1,
        Tag: 77,
        SymbolicName: 'Close',
    },
    {
        Group: '',
        Description: 'FIFO',
        added: 'FIX.4.3',
        Value: 'F',
        Sort: 2,
        Tag: 77,
        SymbolicName: 'FIFO',
    },
    {
        Group: '',
        Description: 'Open',
        added: 'FIX.4.1',
        Value: 'O',
        Sort: 3,
        Tag: 77,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Rolled',
        added: 'FIX.4.3',
        Value: 'R',
        Sort: 4,
        Tag: 77,
        SymbolicName: 'Rolled',
    },
    {
        Group: '',
        Description: 'Close but notify on open',
        added: 'FIX.5.0',
        Value: 'N',
        Sort: 5,
        addedEP: 61,
        Tag: 77,
        SymbolicName: 'CloseButNotifyOnOpen',
    },
    {
        Group: '',
        Description: 'Default',
        added: 'FIX.5.0',
        Value: 'D',
        Sort: 6,
        addedEP: 61,
        Tag: 77,
        SymbolicName: 'Default',
    },
    {
        Group: '',
        Description: 'Regular',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 81,
        SymbolicName: 'Regular',
    },
    {
        Group: '',
        Description: 'Soft Dollar',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 81,
        SymbolicName: 'SoftDollar',
    },
    {
        Group: '',
        Description: 'Step-In',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 81,
        SymbolicName: 'StepIn',
    },
    {
        Group: '',
        Description: 'Step-Out',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 81,
        SymbolicName: 'StepOut',
    },
    {
        Group: '',
        Description: 'Soft-dollar Step-In',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 81,
        SymbolicName: 'SoftDollarStepIn',
    },
    {
        Group: '',
        Description: 'Soft-dollar Step-Out',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 6,
        Tag: 81,
        SymbolicName: 'SoftDollarStepOut',
    },
    {
        Group: '',
        Description: 'Plan Sponsor',
        added: 'FIX.4.0',
        Value: '6',
        Sort: 7,
        Tag: 81,
        SymbolicName: 'PlanSponsor',
    },
    {
        Group: '',
        Description: 'accepted (successfully processed)',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 87,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'block level reject',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 87,
        SymbolicName: 'BlockLevelReject',
    },
    {
        Group: '',
        Description: 'account level reject',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 87,
        SymbolicName: 'AccountLevelReject',
    },
    {
        Group: '',
        Description: 'received (received, not yet processed)',
        added: 'FIX.4.0',
        Value: '3',
        Sort: 4,
        Tag: 87,
        SymbolicName: 'Received',
    },
    {
        Group: '',
        Description: 'incomplete',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 87,
        SymbolicName: 'Incomplete',
    },
    {
        Group: '',
        Description: 'rejected by intermediary',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 87,
        SymbolicName: 'RejectedByIntermediary',
    },
    {
        Group: '',
        Description: 'allocation pending',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        addedEP: 5,
        Tag: 87,
        SymbolicName: 'AllocationPending',
    },
    {
        Group: '',
        Description: 'reversed',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        addedEP: 5,
        Tag: 87,
        SymbolicName: 'Reversed',
    },
    {
        Group: '',
        Description: 'Unknown account(s)',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 88,
        SymbolicName: 'UnknownAccount',
    },
    {
        Group: '',
        Description: 'Incorrect quantity',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 88,
        SymbolicName: 'IncorrectQuantity',
    },
    {
        Group: '',
        Description: 'Incorrect averageg price',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 88,
        SymbolicName: 'IncorrectAveragegPrice',
    },
    {
        Group: '',
        Description: 'Unknown executing broker mnemonic',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 88,
        SymbolicName: 'UnknownExecutingBrokerMnemonic',
    },
    {
        Group: '',
        Description: 'Commission difference',
        added: 'FIX.2.7',
        Value: '4',
        Sort: 5,
        Tag: 88,
        SymbolicName: 'CommissionDifference',
    },
    {
        Group: '',
        Description: 'Unknown OrderID (37)',
        added: 'FIX.2.7',
        Value: '5',
        Sort: 6,
        Tag: 88,
        SymbolicName: 'UnknownOrderID',
    },
    {
        Group: '',
        Description: 'Unknown ListID (66)',
        added: 'FIX.2.7',
        Value: '6',
        Sort: 7,
        Tag: 88,
        SymbolicName: 'UnknownListID',
    },
    {
        Group: '',
        Description: 'Other (further in Text (58))',
        added: 'FIX.2.7',
        Value: '7',
        Sort: 8,
        Tag: 88,
        SymbolicName: 'OtherSeeText',
    },
    {
        Group: '',
        Description: 'Incorrect allocated quantity',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 9,
        Tag: 88,
        SymbolicName: 'IncorrectAllocatedQuantity',
    },
    {
        Group: '',
        Description: 'Calculation difference',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 10,
        Tag: 88,
        SymbolicName: 'CalculationDifference',
    },
    {
        Group: '',
        Description: 'Unknown or stale ExecID',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 11,
        Tag: 88,
        SymbolicName: 'UnknownOrStaleExecID',
    },
    {
        Group: '',
        Description: 'Mismatched data',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 12,
        Tag: 88,
        SymbolicName: 'MismatchedData',
    },
    {
        Group: '',
        Description: 'Unknown ClOrdID',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 13,
        Tag: 88,
        SymbolicName: 'UnknownClOrdID',
    },
    {
        Group: '',
        Description: 'Warehouse request rejected',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 14,
        Tag: 88,
        SymbolicName: 'WarehouseRequestRejected',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 94,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Reply',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 94,
        SymbolicName: 'Reply',
    },
    {
        Group: '',
        Description: 'Admin Reply',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 94,
        SymbolicName: 'AdminReply',
    },
    {
        Group: '',
        Description: 'Original Transmission',
        added: 'FIX.4.1',
        Value: 'N',
        Sort: 1,
        Tag: 97,
        SymbolicName: 'OriginalTransmission',
    },
    {
        Group: '',
        Description: 'Possible Resend',
        added: 'FIX.4.1',
        Value: 'Y',
        Sort: 2,
        Tag: 97,
        SymbolicName: 'PossibleResend',
    },
    {
        Group: '',
        Description: 'None / Other',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 98,
        SymbolicName: 'None',
    },
    {
        Group: '',
        Description: 'PKCS (Proprietary)',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 98,
        SymbolicName: 'PKCS',
    },
    {
        Group: '',
        Description: 'DES (ECB Mode)',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 3,
        Tag: 98,
        SymbolicName: 'DES',
    },
    {
        Group: '',
        Description: 'PKCS / DES (Proprietary)',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 4,
        Tag: 98,
        SymbolicName: 'PKCSDES',
    },
    {
        Group: '',
        Description: 'PGP / DES (Defunct)',
        added: 'FIX.3.0',
        Value: '4',
        Sort: 5,
        Tag: 98,
        SymbolicName: 'PGPDES',
    },
    {
        Group: '',
        Description: 'PGP / DES-MD5 (See app note on FIX web site)',
        added: 'FIX.4.0',
        Value: '5',
        Sort: 6,
        Tag: 98,
        SymbolicName: 'PGPDESMD5',
    },
    {
        Group: '',
        Description: 'PEM / DES-MD5 (see app note on FIX web site)',
        added: 'FIX.4.0',
        Value: '6',
        Sort: 7,
        Tag: 98,
        SymbolicName: 'PEM',
    },
    {
        Group: '',
        Description: 'Too late to cancel',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 1,
        Tag: 102,
        SymbolicName: 'TooLateToCancel',
    },
    {
        Group: '',
        Description: 'Unknown order',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 2,
        Tag: 102,
        SymbolicName: 'UnknownOrder',
    },
    {
        Group: '',
        Description: 'Broker / Exchange Option',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 102,
        SymbolicName: 'BrokerCredit',
    },
    {
        Group: '',
        Description: 'Order already in Pending Cancel or Pending Replace status',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 102,
        SymbolicName: 'OrderAlreadyInPendingStatus',
    },
    {
        Group: '',
        Description: 'Unable to process Order Mass Cancel Request',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 5,
        Tag: 102,
        SymbolicName: 'UnableToProcessOrderMassCancelRequest',
    },
    {
        Group: '',
        Description: 'OrigOrdModTime (586) did not match last TransactTime (60) of order',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 6,
        Tag: 102,
        SymbolicName: 'OrigOrdModTime',
    },
    {
        Group: '',
        Description: 'Duplicate ClOrdID (11) received',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 7,
        Tag: 102,
        SymbolicName: 'DuplicateClOrdID',
    },
    {
        Group: '',
        Description: 'Price exceeds current price',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 8,
        addedEP: -1,
        Tag: 102,
        SymbolicName: 'PriceExceedsCurrentPrice',
    },
    {
        Group: '',
        Description: 'Price exceeds current price band',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 43,
        Tag: 102,
        SymbolicName: 'PriceExceedsCurrentPriceBand',
    },
    {
        Group: '',
        Description: 'Invalid price increment',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 18,
        addedEP: 6,
        Tag: 102,
        SymbolicName: 'InvalidPriceIncrement',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 102,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Broker / Exchange option',
        added: 'FIX.2.7',
        Value: '0',
        Sort: 0,
        Tag: 103,
        SymbolicName: 'BrokerCredit',
    },
    {
        Group: '',
        Description: 'Unknown symbol',
        added: 'FIX.2.7',
        Value: '1',
        Sort: 1,
        Tag: 103,
        SymbolicName: 'UnknownSymbol',
    },
    {
        Group: '',
        Description: 'Exchange closed',
        added: 'FIX.2.7',
        Value: '2',
        Sort: 2,
        Tag: 103,
        SymbolicName: 'ExchangeClosed',
    },
    {
        Group: '',
        Description: 'Order exceeds limit',
        added: 'FIX.2.7',
        Value: '3',
        Sort: 3,
        Tag: 103,
        SymbolicName: 'OrderExceedsLimit',
    },
    {
        Group: '',
        Description: 'Too late to enter',
        added: 'FIX.4.0',
        Value: '4',
        Sort: 4,
        Tag: 103,
        SymbolicName: 'TooLateToEnter',
    },
    {
        Group: '',
        Description: 'Unknown order',
        added: 'FIX.4.1',
        Value: '5',
        Sort: 5,
        Tag: 103,
        SymbolicName: 'UnknownOrder',
    },
    {
        Group: '',
        Description: 'Duplicate Order (e.g. dupe ClOrdID)',
        added: 'FIX.4.1',
        Value: '6',
        Sort: 6,
        Tag: 103,
        SymbolicName: 'DuplicateOrder',
    },
    {
        Group: '',
        Description: 'Duplicate of a verbally communicated order',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 7,
        Tag: 103,
        SymbolicName: 'DuplicateOfAVerballyCommunicatedOrder',
    },
    {
        Group: '',
        Description: 'Stale order',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 8,
        Tag: 103,
        SymbolicName: 'StaleOrder',
    },
    {
        Group: '',
        Description: 'Trade along required',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 103,
        SymbolicName: 'TradeAlongRequired',
    },
    {
        Group: '',
        Description: 'Invalid Investor ID',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 103,
        SymbolicName: 'InvalidInvestorID',
    },
    {
        Group: '',
        Description: 'Unsupported order characteristic',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 103,
        SymbolicName: 'UnsupportedOrderCharacteristic',
    },
    {
        Group: '',
        Description: 'Surveillence Option',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 103,
        SymbolicName: 'SurveillenceOption',
    },
    {
        Group: '',
        Description: 'Incorrect quantity',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        Tag: 103,
        SymbolicName: 'IncorrectQuantity',
    },
    {
        Group: '',
        Description: 'Incorrect allocated quantity',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 14,
        Tag: 103,
        SymbolicName: 'IncorrectAllocatedQuantity',
    },
    {
        Group: '',
        Description: 'Unknown account(s)',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 15,
        Tag: 103,
        SymbolicName: 'UnknownAccount',
    },
    {
        Group: '',
        Description: 'Price exceeds current price band',
        added: 'FIX.5.0',
        Value: '16',
        Sort: 16,
        addedEP: -1,
        Tag: 103,
        SymbolicName: 'PriceExceedsCurrentPriceBand',
    },
    {
        Group: '',
        Description: 'Invalid price increment',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 18,
        addedEP: 6,
        Tag: 103,
        SymbolicName: 'InvalidPriceIncrement',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 103,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'All or None (AON)',
        added: 'FIX.3.0',
        Value: 'A',
        Sort: 1,
        Tag: 104,
        SymbolicName: 'AllOrNone',
    },
    {
        Group: '',
        Description: 'Market On Close (MOC) (held to close)',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 2,
        Tag: 104,
        SymbolicName: 'MarketOnClose',
    },
    {
        Group: '',
        Description: 'At the close (around/not held to close)',
        added: 'FIX.3.0',
        Value: 'C',
        Sort: 3,
        Tag: 104,
        SymbolicName: 'AtTheClose',
    },
    {
        Group: '',
        Description: 'VWAP (Volume Weighted Average Price)',
        added: 'FIX.4.3',
        Value: 'D',
        Sort: 4,
        Tag: 104,
        SymbolicName: 'VWAP',
    },
    {
        Group: '',
        Description: 'In touch with',
        added: 'FIX.3.0',
        Value: 'I',
        Sort: 5,
        Tag: 104,
        SymbolicName: 'InTouchWith',
    },
    {
        Group: '',
        Description: 'Limit',
        added: 'FIX.3.0',
        Value: 'L',
        Sort: 6,
        Tag: 104,
        SymbolicName: 'Limit',
    },
    {
        Group: '',
        Description: 'More Behind',
        added: 'FIX.3.0',
        Value: 'M',
        Sort: 7,
        Tag: 104,
        SymbolicName: 'MoreBehind',
    },
    {
        Group: '',
        Description: 'At the Open',
        added: 'FIX.3.0',
        Value: 'O',
        Sort: 8,
        Tag: 104,
        SymbolicName: 'AtTheOpen',
    },
    {
        Group: '',
        Description: 'Taking a Position',
        added: 'FIX.3.0',
        Value: 'P',
        Sort: 9,
        Tag: 104,
        SymbolicName: 'TakingAPosition',
    },
    {
        Group: '',
        Description: 'At the Market (previously called Current Quote)',
        added: 'FIX.3.0',
        Value: 'Q',
        Sort: 10,
        Tag: 104,
        SymbolicName: 'AtTheMarket',
    },
    {
        Group: '',
        Description: 'Ready to Trade',
        added: 'FIX.4.2',
        Value: 'R',
        Sort: 11,
        Tag: 104,
        SymbolicName: 'ReadyToTrade',
    },
    {
        Group: '',
        Description: 'Portfolio Shown',
        added: 'FIX.3.0',
        Value: 'S',
        Sort: 12,
        Tag: 104,
        SymbolicName: 'PortfolioShown',
    },
    {
        Group: '',
        Description: 'Through the Day',
        added: 'FIX.3.0',
        Value: 'T',
        Sort: 13,
        Tag: 104,
        SymbolicName: 'ThroughTheDay',
    },
    {
        Group: '',
        Description: 'Versus',
        added: 'FIX.3.0',
        Value: 'V',
        Sort: 14,
        Tag: 104,
        SymbolicName: 'Versus',
    },
    {
        Group: '',
        Description: 'Indication - Working Away',
        added: 'FIX.3.0',
        updatedEP: 95,
        Value: 'W',
        Sort: 15,
        Tag: 104,
        SymbolicName: 'Indication',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Crossing Opportunity',
        added: 'FIX.3.0',
        Value: 'X',
        Sort: 16,
        Tag: 104,
        SymbolicName: 'CrossingOpportunity',
    },
    {
        Group: '',
        Description: 'At the Midpoint',
        added: 'FIX.4.1',
        Value: 'Y',
        Sort: 17,
        Tag: 104,
        SymbolicName: 'AtTheMidpoint',
    },
    {
        Group: '',
        Description: 'Pre-open',
        added: 'FIX.4.1',
        Value: 'Z',
        Sort: 18,
        Tag: 104,
        SymbolicName: 'PreOpen',
    },
    {
        Group: '',
        Description: 'Indicates the party sending message will report trade',
        added: 'FIX.3.0',
        Value: 'N',
        Sort: 1,
        Tag: 113,
        SymbolicName: 'SenderReports',
    },
    {
        Group: '',
        Description: 'Indicates the party receiving message must report trade',
        added: 'FIX.3.0',
        Value: 'Y',
        Sort: 2,
        Tag: 113,
        SymbolicName: 'ReceiverReports',
    },
    {
        Group: '',
        Description: 'Indicates the broker is not required to locate',
        added: 'FIX.4.0',
        Value: 'N',
        Sort: 1,
        Tag: 114,
        SymbolicName: 'No',
    },
    {
        Group: '',
        Description: 'Indicates the broker is responsible for locating the stock',
        added: 'FIX.4.0',
        Value: 'Y',
        Sort: 2,
        Tag: 114,
        SymbolicName: 'Yes',
    },
    {
        Group: '',
        Description: 'Do Not Execute Forex After Security Trade',
        added: 'FIX.4.0',
        Value: 'N',
        Sort: 1,
        Tag: 121,
        SymbolicName: 'DoNotExecuteForexAfterSecurityTrade',
    },
    {
        Group: '',
        Description: 'Execute Forex After Security Trade',
        added: 'FIX.4.0',
        Value: 'Y',
        Sort: 2,
        Tag: 121,
        SymbolicName: 'ExecuteForexAfterSecurityTrade',
    },
    {
        Group: '',
        Description: 'Sequence Reset, Ignore Msg Seq Num (N/A For FIXML - Not Used)',
        added: 'FIX.4.0',
        Value: 'N',
        Sort: 1,
        Tag: 123,
        SymbolicName: 'SequenceReset',
    },
    {
        Group: '',
        Description: 'Gap Fill Message, Msg Seq Num Field Valid',
        added: 'FIX.4.0',
        Value: 'Y',
        Sort: 2,
        Tag: 123,
        SymbolicName: 'GapFillMessage',
    },
    {
        Group: '',
        Description: 'Unknown Symbol',
        added: 'FIX.4.0',
        Value: 'A',
        Sort: 1,
        Tag: 127,
        SymbolicName: 'UnknownSymbol',
    },
    {
        Group: '',
        Description: 'Wrong Side',
        added: 'FIX.4.0',
        Value: 'B',
        Sort: 2,
        Tag: 127,
        SymbolicName: 'WrongSide',
    },
    {
        Group: '',
        Description: 'Quantity Exceeds Order',
        added: 'FIX.4.0',
        Value: 'C',
        Sort: 3,
        Tag: 127,
        SymbolicName: 'QuantityExceedsOrder',
    },
    {
        Group: '',
        Description: 'No Matching Order',
        added: 'FIX.4.0',
        Value: 'D',
        Sort: 4,
        Tag: 127,
        SymbolicName: 'NoMatchingOrder',
    },
    {
        Group: '',
        Description: 'Price Exceeds Limit',
        added: 'FIX.4.0',
        Value: 'E',
        Sort: 5,
        Tag: 127,
        SymbolicName: 'PriceExceedsLimit',
    },
    {
        Group: '',
        Description: 'Calculation Difference',
        added: 'FIX.4.4',
        Value: 'F',
        Sort: 6,
        Tag: 127,
        SymbolicName: 'CalculationDifference',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.0',
        Value: 'Z',
        Sort: 7,
        Tag: 127,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Not Natural',
        added: 'FIX.4.0',
        Value: 'N',
        Sort: 1,
        Tag: 130,
        SymbolicName: 'NotNatural',
    },
    {
        Group: '',
        Description: 'Natural',
        added: 'FIX.4.0',
        Value: 'Y',
        Sort: 2,
        Tag: 130,
        SymbolicName: 'Natural',
    },
    {
        Group: '',
        Description: 'Regulatory (e.g. SEC)',
        added: 'FIX.4.0',
        Value: '1',
        Sort: 0,
        Tag: 139,
        SymbolicName: 'Regulatory',
    },
    {
        Group: '',
        Description: 'Tax',
        added: 'FIX.4.0',
        Value: '2',
        Sort: 1,
        Tag: 139,
        SymbolicName: 'Tax',
    },
    {
        Group: '',
        Description: 'Local Commission',
        added: 'FIX.4.0',
        Value: '3',
        Sort: 2,
        Tag: 139,
        SymbolicName: 'LocalCommission',
    },
    {
        Group: '',
        Description: 'Exchange Fees',
        added: 'FIX.4.0',
        Value: '4',
        Sort: 3,
        Tag: 139,
        SymbolicName: 'ExchangeFees',
    },
    {
        Group: '',
        Description: 'Stamp',
        added: 'FIX.4.0',
        Value: '5',
        Sort: 4,
        Tag: 139,
        SymbolicName: 'Stamp',
    },
    {
        Group: '',
        Description: 'Levy',
        added: 'FIX.4.0',
        Value: '6',
        Sort: 5,
        Tag: 139,
        SymbolicName: 'Levy',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.0',
        Value: '7',
        Sort: 6,
        Tag: 139,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Markup',
        added: 'FIX.4.1',
        Value: '8',
        Sort: 7,
        Tag: 139,
        SymbolicName: 'Markup',
    },
    {
        Group: '',
        Description: 'Consumption Tax',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 8,
        Tag: 139,
        SymbolicName: 'ConsumptionTax',
    },
    {
        Group: '',
        Description: 'Per transaction',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 139,
        SymbolicName: 'PerTransaction',
    },
    {
        Group: '',
        Description: 'Conversion',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 10,
        Tag: 139,
        SymbolicName: 'Conversion',
    },
    {
        Group: '',
        Description: 'Agent',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 11,
        Tag: 139,
        SymbolicName: 'Agent',
    },
    {
        Group: '',
        Description: 'Transfer Fee',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 15,
        addedEP: 25,
        Tag: 139,
        SymbolicName: 'TransferFee',
    },
    {
        Group: '',
        Description: 'Security Lending',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 16,
        addedEP: 25,
        Tag: 139,
        SymbolicName: 'SecurityLending',
    },
    {
        Group: '',
        Description: 'No',
        added: 'FIX.4.1',
        Value: 'N',
        Sort: 1,
        Tag: 141,
        SymbolicName: 'No',
    },
    {
        Group: '',
        Description: 'Yes, reset sequence numbers',
        added: 'FIX.4.1',
        Value: 'Y',
        Sort: 2,
        Tag: 141,
        SymbolicName: 'Yes',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 150,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Done for day',
        added: 'FIX.4.1',
        Value: '3',
        Sort: 2,
        Tag: 150,
        SymbolicName: 'DoneForDay',
    },
    {
        Group: '',
        Description: 'Canceled',
        added: 'FIX.4.1',
        Value: '4',
        Sort: 3,
        Tag: 150,
        SymbolicName: 'Canceled',
    },
    {
        Group: '',
        Description: 'Replaced',
        added: 'FIX.4.1',
        Value: '5',
        Sort: 4,
        Tag: 150,
        SymbolicName: 'Replaced',
    },
    {
        Group: '',
        Description: 'Pending Cancel (e.g. result of Order Cancel Request)',
        added: 'FIX.4.1',
        Value: '6',
        Sort: 5,
        Tag: 150,
        SymbolicName: 'PendingCancel',
    },
    {
        Group: '',
        Description: 'Stopped',
        added: 'FIX.4.1',
        Value: '7',
        Sort: 6,
        Tag: 150,
        SymbolicName: 'Stopped',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.1',
        Value: '8',
        Sort: 7,
        Tag: 150,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Suspended',
        added: 'FIX.4.1',
        Value: '9',
        Sort: 8,
        Tag: 150,
        SymbolicName: 'Suspended',
    },
    {
        Group: '',
        Description: 'Pending New',
        added: 'FIX.4.1',
        Value: 'A',
        Sort: 9,
        Tag: 150,
        SymbolicName: 'PendingNew',
    },
    {
        Group: '',
        Description: 'Calculated',
        added: 'FIX.4.1',
        Value: 'B',
        Sort: 10,
        Tag: 150,
        SymbolicName: 'Calculated',
    },
    {
        Group: '',
        Description: 'Expired',
        added: 'FIX.4.1',
        Value: 'C',
        Sort: 11,
        Tag: 150,
        SymbolicName: 'Expired',
    },
    {
        Group: '',
        Description: 'Restated (Execution Report sent unsolicited by sellside, with ExecRestatementReason (378) set)',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 12,
        Tag: 150,
        SymbolicName: 'Restated',
    },
    {
        Group: '',
        Description: 'Pending Replace (e.g. result of Order Cancel/Replace Request)',
        added: 'FIX.4.2',
        Value: 'E',
        Sort: 13,
        Tag: 150,
        SymbolicName: 'PendingReplace',
    },
    {
        Group: '',
        Description: 'Trade (partial fill or fill)',
        added: 'FIX.4.3',
        Value: 'F',
        Sort: 14,
        Tag: 150,
        SymbolicName: 'Trade',
    },
    {
        Group: '',
        Description: 'Trade Correct',
        added: 'FIX.4.3',
        Value: 'G',
        Sort: 15,
        Tag: 150,
        SymbolicName: 'TradeCorrect',
    },
    {
        Group: '',
        Description: 'Trade Cancel',
        added: 'FIX.4.3',
        Value: 'H',
        Sort: 16,
        Tag: 150,
        SymbolicName: 'TradeCancel',
    },
    {
        Group: '',
        Description: 'Order Status',
        added: 'FIX.4.3',
        Value: 'I',
        Sort: 17,
        Tag: 150,
        SymbolicName: 'OrderStatus',
    },
    {
        Group: '',
        Description: 'Trade in a Clearing Hold',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 18,
        addedEP: 5,
        Tag: 150,
        SymbolicName: 'TradeInAClearingHold',
    },
    {
        Group: '',
        Description: 'Trade has been released to Clearing',
        added: 'FIX.4.4',
        Value: 'K',
        Sort: 19,
        addedEP: 5,
        Tag: 150,
        SymbolicName: 'TradeHasBeenReleasedToClearing',
    },
    {
        Group: '',
        Description: 'Triggered or Activated by System',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 20,
        addedEP: 22,
        Tag: 150,
        SymbolicName: 'TriggeredOrActivatedBySystem',
    },
    {
        Group: '',
        Description: 'Multiply',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 1,
        addedEP: 38,
        Tag: 156,
        SymbolicName: 'Multiply',
    },
    {
        Group: '',
        Description: 'Divide',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 2,
        addedEP: 38,
        Tag: 156,
        SymbolicName: 'Divide',
    },
    {
        Group: '',
        Description: 'Default (Replaced)',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 160,
        SymbolicName: 'Default',
    },
    {
        Group: '',
        Description: 'Standing Instructions Provided',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 160,
        SymbolicName: 'StandingInstructionsProvided',
    },
    {
        Group: '',
        Description: 'Specific Allocation Account Overriding (Replaced)',
        added: 'FIX.4.1',
        Value: '2',
        Sort: 3,
        Tag: 160,
        SymbolicName: 'SpecificAllocationAccountOverriding',
    },
    {
        Group: '',
        Description: 'Specific Allocation Account Standing (Replaced)',
        added: 'FIX.4.1',
        Value: '3',
        Sort: 4,
        Tag: 160,
        SymbolicName: 'SpecificAllocationAccountStanding',
    },
    {
        Group: '',
        Description: 'Specific Order for a single account (for CIV)',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 5,
        Tag: 160,
        SymbolicName: 'SpecificOrderForASingleAccount',
    },
    {
        Group: '',
        Description: 'Request reject',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 160,
        SymbolicName: 'RequestReject',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.1',
        Value: 'N',
        Sort: 1,
        Tag: 163,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.1',
        Value: 'C',
        Sort: 2,
        Tag: 163,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.4.1',
        Value: 'R',
        Sort: 3,
        Tag: 163,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Restate',
        added: 'FIX.4.4',
        Value: 'T',
        Sort: 4,
        Tag: 163,
        SymbolicName: 'Restate',
    },
    {
        Group: '',
        Description: "Broker's Instructions",
        added: 'FIX.4.1',
        Value: '1',
        Sort: 1,
        Tag: 165,
        SymbolicName: 'BrokerCredit',
    },
    {
        Group: '',
        Description: "Institution's Instructions",
        added: 'FIX.4.1',
        Value: '2',
        Sort: 2,
        Tag: 165,
        SymbolicName: 'Institution',
    },
    {
        Group: '',
        Description: 'Investor (e.g. CIV use)',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 165,
        SymbolicName: 'Investor',
    },
    {
        Group: '',
        Description: 'CEDEL',
        added: 'FIX.4.1',
        Value: 'CED',
        Sort: 1,
        Tag: 166,
        SymbolicName: 'CEDEL',
    },
    {
        Group: '',
        Description: 'Depository Trust Company',
        added: 'FIX.4.1',
        Value: 'DTC',
        Sort: 2,
        Tag: 166,
        SymbolicName: 'DepositoryTrustCompany',
    },
    {
        Group: '',
        Description: 'Euro clear',
        added: 'FIX.4.1',
        Value: 'EUR',
        Sort: 3,
        Tag: 166,
        SymbolicName: 'EuroClear',
    },
    {
        Group: '',
        Description: 'Federal Book Entry',
        added: 'FIX.4.1',
        Value: 'FED',
        Sort: 4,
        Tag: 166,
        SymbolicName: 'FederalBookEntry',
    },
    {
        Group: '',
        Description: 'Local Market Settle Location',
        added: 'FIX.4.4',
        Value: 'ISO_Country_Code',
        Sort: 5,
        addedEP: -1,
        Tag: 166,
        SymbolicName: 'LocalMarketSettleLocation',
    },
    {
        Group: '',
        Description: 'Physical',
        added: 'FIX.4.1',
        Value: 'PNY',
        Sort: 6,
        Tag: 166,
        SymbolicName: 'Physical',
    },
    {
        Group: '',
        Description: 'Participant Trust Company',
        added: 'FIX.4.1',
        Value: 'PTC',
        Sort: 7,
        Tag: 166,
        SymbolicName: 'ParticipantTrustCompany',
    },
    {
        Group: '',
        Description: 'US Treasury Note (Deprecated Value Use TNOTE)',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.4',
        Value: 'UST',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'USTreasuryNoteOld',
    },
    {
        Group: '',
        Description: 'US Treasury Bill (Deprecated Value Use TBILL)',
        added: 'FIX.4.1',
        deprecated: 'FIX.4.4',
        Value: 'USTB',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'USTreasuryBillOld',
    },
    {
        Group: 'Agency',
        Description: 'Euro Supranational Coupons *',
        added: 'FIX.4.4',
        Value: 'EUSUPRA',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'EuroSupranationalCoupons',
    },
    {
        Group: 'Agency',
        Description: 'Federal Agency Coupon',
        added: 'FIX.4.3',
        Value: 'FAC',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'FederalAgencyCoupon',
    },
    {
        Group: 'Agency',
        Description: 'Federal Agency Discount Note',
        added: 'FIX.4.3',
        Value: 'FADN',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'FederalAgencyDiscountNote',
    },
    {
        Group: 'Agency',
        Description: 'Private Export Funding *',
        added: 'FIX.4.3',
        Value: 'PEF',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'PrivateExportFunding',
    },
    {
        Group: 'Agency',
        Description: 'USD Supranational Coupons *',
        added: 'FIX.4.4',
        Value: 'SUPRA',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'USDSupranationalCoupons',
    },
    {
        Group: 'Corporate',
        Description: 'Corporate Bond',
        added: 'FIX.4.1',
        Value: 'CORP',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'CorporateBond',
    },
    {
        Group: 'Corporate',
        Description: 'Corporate Private Placement',
        added: 'FIX.4.1',
        Value: 'CPP',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'CorporatePrivatePlacement',
    },
    {
        Group: 'Corporate',
        Description: 'Convertible Bond',
        added: 'FIX.4.2',
        Value: 'CB',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'ConvertibleBond',
    },
    {
        Group: 'Corporate',
        Description: 'Dual Currency',
        added: 'FIX.4.3',
        Value: 'DUAL',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'DualCurrency',
    },
    {
        Group: 'Corporate',
        Description: 'Euro Corporate Bond',
        added: 'FIX.4.4',
        Value: 'EUCORP',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'EuroCorporateBond',
    },
    {
        Group: 'Corporate',
        Description: 'Euro Corporate Floating Rate Notes',
        added: 'FIX.5.0',
        Value: 'EUFRN',
        Sort: 5,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'EuroCorporateFloatingRateNotes',
    },
    {
        Group: 'Corporate',
        Description: 'US Corporate Floating Rate Notes',
        added: 'FIX.5.0',
        Value: 'FRN',
        Sort: 6,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'USCorporateFloatingRateNotes',
    },
    {
        Group: 'Corporate',
        Description: 'Indexed Linked',
        added: 'FIX.4.3',
        Value: 'XLINKD',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'IndexedLinked',
    },
    {
        Group: 'Corporate',
        Description: 'Structured Notes',
        added: 'FIX.4.3',
        Value: 'STRUCT',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'StructuredNotes',
    },
    {
        Group: 'Corporate',
        Description: 'Yankee Corporate Bond',
        added: 'FIX.4.3',
        Value: 'YANK',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'YankeeCorporateBond',
    },
    {
        Group: 'Currency',
        Description: 'Foreign Exchange Contract',
        added: 'FIX.4.1',
        deprecated: 'FIX.5.0SP1',
        Value: 'FOR',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'ForeignExchangeContract',
        deprecatedEP: 82,
    },
    {
        Group: 'Derivatives',
        Description: 'Credit Default Swap',
        added: 'FIX.5.0',
        Value: 'CDS',
        Sort: 0,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CreditDefaultSwap',
    },
    {
        Group: 'Derivatives',
        Description: 'Future',
        added: 'FIX.4.1',
        Value: 'FUT',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'Future',
    },
    {
        Group: 'Derivatives',
        Description: 'Option',
        added: 'FIX.4.1',
        Value: 'OPT',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'Option',
    },
    {
        Group: 'Derivatives',
        Description: 'Options on Futures',
        added: 'FIX.4.4',
        Value: 'OOF',
        Sort: 3,
        addedEP: 19,
        Tag: 167,
        SymbolicName: 'OptionsOnFutures',
    },
    {
        Group: 'Derivatives',
        Description: 'Options on Physical - use not recommended',
        added: 'FIX.4.4',
        Value: 'OOP',
        Sort: 4,
        addedEP: 19,
        Tag: 167,
        SymbolicName: 'OptionsOnPhysical',
    },
    {
        Group: 'Derivatives',
        Description: 'Interest Rate Swap',
        added: 'FIX.5.0',
        Value: 'IRS',
        Sort: 5,
        addedEP: 54,
        Tag: 167,
        SymbolicName: 'InterestRateSwap',
    },
    {
        Group: 'Derivatives',
        Description: 'Options on Combo',
        added: 'FIX.5.0',
        Value: 'OOC',
        Sort: 6,
        addedEP: -1,
        Tag: 167,
        SymbolicName: 'OptionsOnCombo',
    },
    {
        Group: 'Equity',
        Description: 'Common Stock',
        added: 'FIX.4.1',
        Value: 'CS',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'CommonStock',
    },
    {
        Group: 'Equity',
        Description: 'Preferred Stock',
        added: 'FIX.4.1',
        Value: 'PS',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'PreferredStock',
    },
    {
        Group: 'Financing',
        Description: 'Repurchase',
        added: 'FIX.4.4',
        Value: 'REPO',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'Repurchase',
    },
    {
        Group: 'Financing',
        Description: 'Forward',
        added: 'FIX.4.4',
        Value: 'FORWARD',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'Forward',
    },
    {
        Group: 'Financing',
        Description: 'Buy Sellback',
        added: 'FIX.4.4',
        Value: 'BUYSELL',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'BuySellback',
    },
    {
        Group: 'Financing',
        Description: 'Securities Loan',
        added: 'FIX.4.4',
        Value: 'SECLOAN',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'SecuritiesLoan',
    },
    {
        Group: 'Financing',
        Description: 'Securities Pledge',
        added: 'FIX.4.4',
        Value: 'SECPLEDGE',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'SecuritiesPledge',
    },
    {
        Group: 'Government',
        Description: 'Brady Bond',
        added: 'FIX.4.3',
        Value: 'BRADY',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'BradyBond',
    },
    {
        Group: 'Government',
        Description: 'Canadian Treasury Notes',
        added: 'FIX.5.0',
        Value: 'CAN',
        Sort: 1,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CanadianTreasuryNotes',
    },
    {
        Group: 'Government',
        Description: 'Canadian Treasury Bills',
        added: 'FIX.5.0',
        Value: 'CTB',
        Sort: 2,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CanadianTreasuryBills',
    },
    {
        Group: 'Government',
        Description: 'Euro Sovereigns *',
        added: 'FIX.4.4',
        Value: 'EUSOV',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'EuroSovereigns',
    },
    {
        Group: 'Government',
        Description: 'Canadian Provincial Bonds',
        added: 'FIX.5.0',
        Value: 'PROV',
        Sort: 4,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CanadianProvincialBonds',
    },
    {
        Group: 'Government',
        Description: 'Treasury Bill - non US',
        added: 'FIX.5.0',
        Value: 'TB',
        Sort: 5,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'TreasuryBill',
    },
    {
        Group: 'Government',
        Description: 'US Treasury Bond',
        added: 'FIX.4.3',
        Value: 'TBOND',
        Sort: 6,
        Tag: 167,
        SymbolicName: 'USTreasuryBond',
    },
    {
        Group: 'Government',
        Description: 'Interest Strip From Any Bond Or Note',
        added: 'FIX.4.3',
        Value: 'TINT',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'InterestStripFromAnyBondOrNote',
    },
    {
        Group: 'Government',
        Description: 'US Treasury Bill',
        added: 'FIX.4.4',
        Value: 'TBILL',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'USTreasuryBill',
    },
    {
        Group: 'Government',
        Description: 'Treasury Inflation Protected Securities',
        added: 'FIX.4.3',
        Value: 'TIPS',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'TreasuryInflationProtectedSecurities',
    },
    {
        Group: 'Government',
        Description: 'Principal Strip Of A Callable Bond Or Note',
        added: 'FIX.4.3',
        Value: 'TCAL',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'PrincipalStripOfACallableBondOrNote',
    },
    {
        Group: 'Government',
        Description: 'Principal Strip From A Non-Callable Bond Or Note',
        added: 'FIX.4.3',
        Value: 'TPRN',
        Sort: 10,
        Tag: 167,
        SymbolicName: 'PrincipalStripFromANonCallableBondOrNote',
    },
    {
        Group: 'Government',
        Description: 'US Treasury Note',
        added: 'FIX.4.4',
        Value: 'TNOTE',
        Sort: 11,
        Tag: 167,
        SymbolicName: 'USTreasuryNote',
    },
    {
        Group: 'Loan',
        Description: 'Term Loan',
        added: 'FIX.4.3',
        Value: 'TERM',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'TermLoan',
    },
    {
        Group: 'Loan',
        Description: 'Revolver Loan',
        added: 'FIX.4.3',
        Value: 'RVLV',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'RevolverLoan',
    },
    {
        Group: 'Loan',
        Description: 'Revolver/Term Loan',
        added: 'FIX.4.3',
        Value: 'RVLVTRM',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'Revolver',
    },
    {
        Group: 'Loan',
        Description: 'Bridge Loan',
        added: 'FIX.4.3',
        Value: 'BRIDGE',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'BridgeLoan',
    },
    {
        Group: 'Loan',
        Description: 'Letter Of Credit',
        added: 'FIX.4.3',
        Value: 'LOFC',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'LetterOfCredit',
    },
    {
        Group: 'Loan',
        Description: 'Swing Line Facility',
        added: 'FIX.4.3',
        Value: 'SWING',
        Sort: 5,
        Tag: 167,
        SymbolicName: 'SwingLineFacility',
    },
    {
        Group: 'Loan',
        Description: 'Debtor In Possession',
        added: 'FIX.4.3',
        Value: 'DINP',
        Sort: 6,
        Tag: 167,
        SymbolicName: 'DebtorInPossession',
    },
    {
        Group: 'Loan',
        Description: 'Defaulted',
        added: 'FIX.4.3',
        Value: 'DEFLTED',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'Defaulted',
    },
    {
        Group: 'Loan',
        Description: 'Withdrawn',
        added: 'FIX.4.3',
        Value: 'WITHDRN',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'Withdrawn',
    },
    {
        Group: 'Loan',
        Description: 'Replaced',
        added: 'FIX.4.3',
        Value: 'REPLACD',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'Replaced',
    },
    {
        Group: 'Loan',
        Description: 'Matured',
        added: 'FIX.4.3',
        Value: 'MATURED',
        Sort: 10,
        Tag: 167,
        SymbolicName: 'Matured',
    },
    {
        Group: 'Loan',
        Description: 'Amended & Restated',
        added: 'FIX.4.3',
        Value: 'AMENDED',
        Sort: 11,
        Tag: 167,
        SymbolicName: 'Amended',
    },
    {
        Group: 'Loan',
        Description: 'Retired',
        added: 'FIX.4.3',
        Value: 'RETIRED',
        Sort: 12,
        Tag: 167,
        SymbolicName: 'Retired',
    },
    {
        Group: 'Money Market',
        Description: 'Bankers Acceptance',
        added: 'FIX.4.1',
        Value: 'BA',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'BankersAcceptance',
    },
    {
        Group: 'Money Market',
        Description: 'Bank Depository Note',
        added: 'FIX.5.0',
        Value: 'BDN',
        Sort: 1,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'BankDepositoryNote',
    },
    {
        Group: 'Money Market',
        Description: 'Bank Notes',
        added: 'FIX.4.3',
        Value: 'BN',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'BankNotes',
    },
    {
        Group: 'Money Market',
        Description: 'Bill Of Exchanges',
        added: 'FIX.4.3',
        Value: 'BOX',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'BillOfExchanges',
    },
    {
        Group: 'Money Market',
        Description: 'Canadian Money Markets',
        added: 'FIX.5.0',
        Value: 'CAMM',
        Sort: 4,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CanadianMoneyMarkets',
    },
    {
        Group: 'Money Market',
        Description: 'Certificate Of Deposit',
        added: 'FIX.4.1',
        Value: 'CD',
        Sort: 5,
        Tag: 167,
        SymbolicName: 'CertificateOfDeposit',
    },
    {
        Group: 'Money Market',
        Description: 'Call Loans',
        added: 'FIX.4.3',
        Value: 'CL',
        Sort: 6,
        Tag: 167,
        SymbolicName: 'CallLoans',
    },
    {
        Group: 'Money Market',
        Description: 'Commercial Paper',
        added: 'FIX.4.1',
        Value: 'CP',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'CommercialPaper',
    },
    {
        Group: 'Money Market',
        Description: 'Deposit Notes',
        added: 'FIX.4.3',
        Value: 'DN',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'DepositNotes',
    },
    {
        Group: 'Money Market',
        Description: 'Euro Certificate Of Deposit',
        added: 'FIX.4.4',
        Value: 'EUCD',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'EuroCertificateOfDeposit',
    },
    {
        Group: 'Money Market',
        Description: 'Euro Commercial Paper',
        added: 'FIX.4.4',
        Value: 'EUCP',
        Sort: 10,
        Tag: 167,
        SymbolicName: 'EuroCommercialPaper',
    },
    {
        Group: 'Money Market',
        Description: 'Liquidity Note',
        added: 'FIX.4.3',
        Value: 'LQN',
        Sort: 11,
        Tag: 167,
        SymbolicName: 'LiquidityNote',
    },
    {
        Group: 'Money Market',
        Description: 'Medium Term Notes',
        added: 'FIX.4.3',
        Value: 'MTN',
        Sort: 12,
        Tag: 167,
        SymbolicName: 'MediumTermNotes',
    },
    {
        Group: 'Money Market',
        Description: 'Overnight',
        added: 'FIX.4.3',
        Value: 'ONITE',
        Sort: 13,
        Tag: 167,
        SymbolicName: 'Overnight',
    },
    {
        Group: 'Money Market',
        Description: 'Promissory Note',
        added: 'FIX.4.3',
        Value: 'PN',
        Sort: 14,
        Tag: 167,
        SymbolicName: 'PromissoryNote',
    },
    {
        Group: 'Money Market',
        Description: 'Short Term Loan Note',
        added: 'FIX.4.3',
        Value: 'STN',
        Sort: 14,
        Tag: 167,
        SymbolicName: 'ShortTermLoanNote',
    },
    {
        Group: 'Money Market',
        Description: 'Plazos Fijos',
        added: 'FIX.4.3',
        Value: 'PZFJ',
        Sort: 15,
        Tag: 167,
        SymbolicName: 'PlazosFijos',
    },
    {
        Group: 'Money Market',
        Description: 'Secured Liquidity Note',
        added: 'FIX.5.0',
        Value: 'SLQN',
        Sort: 16,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'SecuredLiquidityNote',
    },
    {
        Group: 'Money Market',
        Description: 'Time Deposit',
        added: 'FIX.4.1',
        Value: 'TD',
        Sort: 17,
        Tag: 167,
        SymbolicName: 'TimeDeposit',
    },
    {
        Group: 'Money Market',
        Description: 'Term Liquidity Note',
        added: 'FIX.5.0',
        Value: 'TLQN',
        Sort: 19,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'TermLiquidityNote',
    },
    {
        Group: 'Money Market',
        Description: 'Extended Comm Note',
        added: 'FIX.4.3',
        Value: 'XCN',
        Sort: 20,
        Tag: 167,
        SymbolicName: 'ExtendedCommNote',
    },
    {
        Group: 'Money Market',
        Description: 'Yankee Certificate Of Deposit',
        added: 'FIX.4.4',
        Value: 'YCD',
        Sort: 21,
        Tag: 167,
        SymbolicName: 'YankeeCertificateOfDeposit',
    },
    {
        Group: 'Mortgage',
        Description: 'Asset-backed Securities',
        added: 'FIX.4.3',
        Value: 'ABS',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'AssetBackedSecurities',
    },
    {
        Group: 'Mortgage',
        Description: 'Canadian Mortgage Bonds',
        added: 'FIX.5.0',
        Value: 'CMB',
        Sort: 1,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'CanadianMortgageBonds',
    },
    {
        Group: 'Mortgage',
        Description: 'Corp. Mortgage-backed Securities',
        added: 'FIX.4.3',
        Value: 'CMBS',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'Corp',
    },
    {
        Group: 'Mortgage',
        Description: 'Collateralized Mortgage Obligation',
        added: 'FIX.4.1',
        Value: 'CMO',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'CollateralizedMortgageObligation',
    },
    {
        Group: 'Mortgage',
        Description: 'IOETTE Mortgage',
        added: 'FIX.4.2',
        Value: 'IET',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'IOETTEMortgage',
    },
    {
        Group: 'Mortgage',
        Description: 'Mortgage-backed Securities',
        added: 'FIX.4.3',
        Value: 'MBS',
        Sort: 5,
        Tag: 167,
        SymbolicName: 'MortgageBackedSecurities',
    },
    {
        Group: 'Mortgage',
        Description: 'Mortgage Interest Only',
        added: 'FIX.4.1',
        Value: 'MIO',
        Sort: 6,
        Tag: 167,
        SymbolicName: 'MortgageInterestOnly',
    },
    {
        Group: 'Mortgage',
        Description: 'Mortgage Principal Only',
        added: 'FIX.4.1',
        Value: 'MPO',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'MortgagePrincipalOnly',
    },
    {
        Group: 'Mortgage',
        Description: 'Mortgage Private Placement',
        added: 'FIX.4.1',
        Value: 'MPP',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'MortgagePrivatePlacement',
    },
    {
        Group: 'Mortgage',
        Description: 'Miscellaneous Pass-through',
        added: 'FIX.4.1',
        Value: 'MPT',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'MiscellaneousPassThrough',
    },
    {
        Group: 'Mortgage',
        Description: 'Pfandbriefe *',
        added: 'FIX.4.4',
        Value: 'PFAND',
        Sort: 10,
        Tag: 167,
        SymbolicName: 'Pfandbriefe',
    },
    {
        Group: 'Mortgage',
        Description: 'To Be Announced',
        added: 'FIX.4.3',
        Value: 'TBA',
        Sort: 11,
        Tag: 167,
        SymbolicName: 'ToBeAnnounced',
    },
    {
        Group: 'Municipal',
        Description: 'Other Anticipation Notes (BAN, GAN, etc.)',
        added: 'FIX.4.3',
        Value: 'AN',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'OtherAnticipationNotes',
    },
    {
        Group: 'Municipal',
        Description: 'Certificate Of Obligation',
        added: 'FIX.4.3',
        Value: 'COFO',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'CertificateOfObligation',
    },
];

const batch2: ISpecEnums[] = [
    {
        Group: 'Municipal',
        Description: 'Certificate Of Participation',
        added: 'FIX.4.3',
        Value: 'COFP',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'CertificateOfParticipation',
    },
    {
        Group: 'Municipal',
        Description: 'General Obligation Bonds',
        added: 'FIX.4.3',
        Value: 'GO',
        Sort: 3,
        Tag: 167,
        SymbolicName: 'GeneralObligationBonds',
    },
    {
        Group: 'Municipal',
        Description: 'Mandatory Tender',
        added: 'FIX.4.3',
        Value: 'MT',
        Sort: 4,
        Tag: 167,
        SymbolicName: 'MandatoryTender',
    },
    {
        Group: 'Municipal',
        Description: 'Revenue Anticipation Note',
        added: 'FIX.4.3',
        Value: 'RAN',
        Sort: 5,
        Tag: 167,
        SymbolicName: 'RevenueAnticipationNote',
    },
    {
        Group: 'Municipal',
        Description: 'Revenue Bonds',
        added: 'FIX.4.3',
        Value: 'REV',
        Sort: 6,
        Tag: 167,
        SymbolicName: 'RevenueBonds',
    },
    {
        Group: 'Municipal',
        Description: 'Special Assessment',
        added: 'FIX.4.3',
        Value: 'SPCLA',
        Sort: 7,
        Tag: 167,
        SymbolicName: 'SpecialAssessment',
    },
    {
        Group: 'Municipal',
        Description: 'Special Obligation',
        added: 'FIX.4.3',
        Value: 'SPCLO',
        Sort: 8,
        Tag: 167,
        SymbolicName: 'SpecialObligation',
    },
    {
        Group: 'Municipal',
        Description: 'Special Tax',
        added: 'FIX.4.3',
        Value: 'SPCLT',
        Sort: 9,
        Tag: 167,
        SymbolicName: 'SpecialTax',
    },
    {
        Group: 'Municipal',
        Description: 'Tax Anticipation Note',
        added: 'FIX.4.3',
        Value: 'TAN',
        Sort: 10,
        Tag: 167,
        SymbolicName: 'TaxAnticipationNote',
    },
    {
        Group: 'Municipal',
        Description: 'Tax Allocation',
        added: 'FIX.4.3',
        Value: 'TAXA',
        Sort: 11,
        Tag: 167,
        SymbolicName: 'TaxAllocation',
    },
    {
        Group: 'Municipal',
        Description: 'Tax Exempt Commercial Paper',
        added: 'FIX.4.3',
        Value: 'TECP',
        Sort: 12,
        Tag: 167,
        SymbolicName: 'TaxExemptCommercialPaper',
    },
    {
        Group: 'Municipal',
        Description: 'Taxable Municipal CP',
        added: 'FIX.5.0',
        Value: 'TMCP',
        Sort: 13,
        addedEP: 68,
        Tag: 167,
        SymbolicName: 'TaxableMunicipalCP',
    },
    {
        Group: 'Municipal',
        Description: 'Tax Revenue Anticipation Note',
        added: 'FIX.4.3',
        Value: 'TRAN',
        Sort: 14,
        Tag: 167,
        SymbolicName: 'TaxRevenueAnticipationNote',
    },
    {
        Group: 'Municipal',
        Description: 'Variable Rate Demand Note',
        added: 'FIX.4.3',
        Value: 'VRDN',
        Sort: 15,
        Tag: 167,
        SymbolicName: 'VariableRateDemandNote',
    },
    {
        Group: 'Municipal',
        Description: 'Warrant',
        added: 'FIX.4.1',
        Value: 'WAR',
        Sort: 16,
        Tag: 167,
        SymbolicName: 'Warrant',
    },
    {
        Group: 'Other',
        Description: 'Mutual Fund',
        added: 'FIX.4.1',
        Value: 'MF',
        Sort: 0,
        Tag: 167,
        SymbolicName: 'MutualFund',
    },
    {
        Group: 'Other',
        Description: 'Multileg Instrument',
        added: 'FIX.4.3',
        Value: 'MLEG',
        Sort: 1,
        Tag: 167,
        SymbolicName: 'MultilegInstrument',
    },
    {
        Group: 'Other',
        Description: 'No Security Type',
        added: 'FIX.4.1',
        Value: 'NONE',
        Sort: 2,
        Tag: 167,
        SymbolicName: 'NoSecurityType',
    },
    {
        Group: 'Other',
        Description: 'Wildcard entry for use on Security Definition Request',
        added: 'FIX.4.2',
        Value: '?',
        Sort: 5,
        Tag: 167,
        SymbolicName: 'Wildcard',
    },
    {
        Group: 'Other',
        Description: 'Cash',
        added: 'FIX.4.4',
        Value: 'CASH',
        Sort: 6,
        addedEP: 28,
        Tag: 167,
        SymbolicName: 'Cash',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 169,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'DTC SID',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 169,
        SymbolicName: 'DTCSID',
    },
    {
        Group: '',
        Description: 'Thomson ALERT',
        added: 'FIX.4.1',
        Value: '2',
        Sort: 3,
        Tag: 169,
        SymbolicName: 'ThomsonALERT',
    },
    {
        Group: '',
        Description: 'A Global Custodian (StandInstDBName (70) must be provided)',
        added: 'FIX.4.1',
        Value: '3',
        Sort: 4,
        Tag: 169,
        SymbolicName: 'AGlobalCustodian',
    },
    {
        Group: '',
        Description: 'AccountNet',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 169,
        SymbolicName: 'AccountNet',
    },
    {
        Group: '',
        Description: '"Versus. Payment": Deliver (if Sell) or Receive (if Buy) vs. (Against) Payment',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: 35,
        Tag: 172,
        SymbolicName: 'Versus',
    },
    {
        Group: '',
        Description: '"Free": Deliver (if Sell) or Receive (if Buy) Free',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: 35,
        Tag: 172,
        SymbolicName: 'Free',
    },
    {
        Group: '',
        Description: 'Tri-Party',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: 35,
        Tag: 172,
        SymbolicName: 'TriParty',
    },
    {
        Group: '',
        Description: 'Hold In Custody',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: 35,
        Tag: 172,
        SymbolicName: 'HoldInCustody',
    },
    {
        Group: '',
        Description: 'FX Netting',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 197,
        SymbolicName: 'FXNetting',
    },
    {
        Group: '',
        Description: 'FX Swap',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 197,
        SymbolicName: 'FXSwap',
    },
    {
        Group: '',
        Description: 'Put',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 201,
        SymbolicName: 'Put',
    },
    {
        Group: '',
        Description: 'Call',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 201,
        SymbolicName: 'Call',
    },
    {
        Group: '',
        Description: 'Covered',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 203,
        SymbolicName: 'Covered',
    },
    {
        Group: '',
        Description: 'Uncovered',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 203,
        SymbolicName: 'Uncovered',
    },
    {
        Group: '',
        Description: 'Customer',
        added: 'FIX.4.1',
        Value: '0',
        Sort: 1,
        Tag: 204,
        SymbolicName: 'Customer',
    },
    {
        Group: '',
        Description: 'Firm',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 2,
        Tag: 204,
        SymbolicName: 'Firm',
    },
    {
        Group: '',
        Description: 'Details should not be communicated',
        added: 'FIX.4.1',
        Value: 'N',
        Sort: 1,
        Tag: 208,
        SymbolicName: 'DetailsShouldNotBeCommunicated',
    },
    {
        Group: '',
        Description: 'Details should be communicated',
        added: 'FIX.4.1',
        Value: 'Y',
        Sort: 2,
        Tag: 208,
        SymbolicName: 'DetailsShouldBeCommunicated',
    },
    {
        Group: '',
        Description: 'Match',
        added: 'FIX.4.1',
        Value: '1',
        Sort: 1,
        Tag: 209,
        SymbolicName: 'Match',
    },
    {
        Group: '',
        Description: 'Forward',
        added: 'FIX.4.1',
        Value: '2',
        Sort: 2,
        Tag: 209,
        SymbolicName: 'Forward',
    },
    {
        Group: '',
        Description: 'Forward and Match',
        added: 'FIX.4.1',
        Value: '3',
        Sort: 3,
        Tag: 209,
        SymbolicName: 'ForwardAndMatch',
    },
    {
        Group: '',
        Description: 'Target Firm',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 216,
        SymbolicName: 'TargetFirm',
    },
    {
        Group: '',
        Description: 'Target List',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 216,
        SymbolicName: 'TargetList',
    },
    {
        Group: '',
        Description: 'Block Firm',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 216,
        SymbolicName: 'BlockFirm',
    },
    {
        Group: '',
        Description: 'Block List',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 216,
        SymbolicName: 'BlockList',
    },
    {
        Group: '',
        Description: 'CURVE',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 219,
        SymbolicName: 'CURVE',
    },
    {
        Group: '',
        Description: '5YR',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 219,
        SymbolicName: 'FiveYR',
    },
    {
        Group: '',
        Description: 'OLD5',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 219,
        SymbolicName: 'OLD5',
    },
    {
        Group: '',
        Description: '10YR',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 219,
        SymbolicName: 'TenYR',
    },
    {
        Group: '',
        Description: 'OLD10',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 219,
        SymbolicName: 'OLD10',
    },
    {
        Group: '',
        Description: '30YR',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 6,
        Tag: 219,
        SymbolicName: 'ThirtyYR',
    },
    {
        Group: '',
        Description: 'OLD30',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 7,
        Tag: 219,
        SymbolicName: 'OLD30',
    },
    {
        Group: '',
        Description: '3MOLIBOR',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 8,
        Tag: 219,
        SymbolicName: 'ThreeMOLIBOR',
    },
    {
        Group: '',
        Description: '6MOLIBOR',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 9,
        Tag: 219,
        SymbolicName: 'SixMOLIBOR',
    },
    {
        Group: '',
        Description: 'EONIA',
        added: 'FIX.4.4',
        Value: 'EONIA',
        Sort: 1,
        addedEP: -1,
        Tag: 221,
        SymbolicName: 'EONIA',
    },
    {
        Group: '',
        Description: 'EUREPO',
        added: 'FIX.4.4',
        Value: 'EUREPO',
        Sort: 2,
        addedEP: -1,
        Tag: 221,
        SymbolicName: 'EUREPO',
    },
    {
        Group: '',
        Description: 'Euribor',
        added: 'FIX.4.3',
        Value: 'Euribor',
        Sort: 3,
        Tag: 221,
        SymbolicName: 'Euribor',
    },
    {
        Group: '',
        Description: 'FutureSWAP',
        added: 'FIX.4.3',
        Value: 'FutureSWAP',
        Sort: 4,
        Tag: 221,
        SymbolicName: 'FutureSWAP',
    },
    {
        Group: '',
        Description: 'LIBID',
        added: 'FIX.4.3',
        Value: 'LIBID',
        Sort: 5,
        Tag: 221,
        SymbolicName: 'LIBID',
    },
    {
        Group: '',
        Description: 'LIBOR (London Inter-Bank Offer)',
        added: 'FIX.4.3',
        Value: 'LIBOR',
        Sort: 6,
        Tag: 221,
        SymbolicName: 'LIBOR',
    },
    {
        Group: '',
        Description: 'MuniAAA',
        added: 'FIX.4.3',
        Value: 'MuniAAA',
        Sort: 7,
        Tag: 221,
        SymbolicName: 'MuniAAA',
    },
    {
        Group: '',
        Description: 'OTHER',
        added: 'FIX.4.3',
        Value: 'OTHER',
        Sort: 8,
        Tag: 221,
        SymbolicName: 'OTHER',
    },
    {
        Group: '',
        Description: 'Pfandbriefe',
        added: 'FIX.4.3',
        Value: 'Pfandbriefe',
        Sort: 9,
        Tag: 221,
        SymbolicName: 'Pfandbriefe',
    },
    {
        Group: '',
        Description: 'SONIA',
        added: 'FIX.4.4',
        Value: 'SONIA',
        Sort: 10,
        addedEP: -1,
        Tag: 221,
        SymbolicName: 'SONIA',
    },
    {
        Group: '',
        Description: 'SWAP',
        added: 'FIX.4.3',
        Value: 'SWAP',
        Sort: 11,
        Tag: 221,
        SymbolicName: 'SWAP',
    },
    {
        Group: '',
        Description: 'Treasury',
        added: 'FIX.4.3',
        Value: 'Treasury',
        Sort: 12,
        Tag: 221,
        SymbolicName: 'Treasury',
    },
    {
        Group: '',
        Description: 'Alternative Minimum Tax (Y/N)',
        added: 'FIX.4.4',
        Value: 'AMT',
        Sort: 1,
        Tag: 233,
        SymbolicName: 'AlternativeMinimumTax',
    },
    {
        Group: '',
        Description: 'Auto Reinvestment at <rate> or better',
        added: 'FIX.4.4',
        Value: 'AUTOREINV',
        Sort: 2,
        Tag: 233,
        SymbolicName: 'AutoReinvestment',
    },
    {
        Group: '',
        Description: 'Bank qualified (Y/N)',
        added: 'FIX.4.4',
        Value: 'BANKQUAL',
        Sort: 3,
        Tag: 233,
        SymbolicName: 'BankQualified',
    },
    {
        Group: '',
        Description: 'Bargain conditions (see StipulationValue (234) for values)',
        added: 'FIX.4.4',
        Value: 'BGNCON',
        Sort: 4,
        Tag: 233,
        SymbolicName: 'BargainConditions',
    },
    {
        Group: '',
        Description: 'Coupon range',
        added: 'FIX.4.4',
        Value: 'COUPON',
        Sort: 5,
        Tag: 233,
        SymbolicName: 'CouponRange',
    },
    {
        Group: '',
        Description: 'ISO Currency Code',
        added: 'FIX.4.4',
        Value: 'CURRENCY',
        Sort: 6,
        Tag: 233,
        SymbolicName: 'ISOCurrencyCode',
    },
    {
        Group: '',
        Description: 'Custom start/end date',
        added: 'FIX.4.4',
        Value: 'CUSTOMDATE',
        Sort: 7,
        Tag: 233,
        SymbolicName: 'CustomStart',
    },
    {
        Group: '',
        Description: 'Geographics and % range (ex. 234=CA 0-80 [minimum of 80% California assets])',
        added: 'FIX.4.3',
        Value: 'GEOG',
        Sort: 8,
        Tag: 233,
        SymbolicName: 'Geographics',
    },
    {
        Group: '',
        Description: 'Valuation Discount',
        added: 'FIX.4.4',
        Value: 'HAIRCUT',
        Sort: 9,
        Tag: 233,
        SymbolicName: 'ValuationDiscount',
    },
    {
        Group: '',
        Description: 'Insured (Y/N)',
        added: 'FIX.4.4',
        Value: 'INSURED',
        Sort: 10,
        Tag: 233,
        SymbolicName: 'Insured',
    },
    {
        Group: '',
        Description: 'Year Or Year/Month of Issue (ex. 234=2002/09)',
        added: 'FIX.4.3',
        Value: 'ISSUE',
        Sort: 11,
        Tag: 233,
        SymbolicName: 'IssueDate',
    },
    {
        Group: '',
        Description: "Issuer's ticker",
        added: 'FIX.4.4',
        Value: 'ISSUER',
        Sort: 12,
        Tag: 233,
        SymbolicName: 'Issuer',
    },
    {
        Group: '',
        Description: 'issue size range',
        added: 'FIX.4.4',
        Value: 'ISSUESIZE',
        Sort: 13,
        Tag: 233,
        SymbolicName: 'IssueSizeRange',
    },
    {
        Group: '',
        Description: 'Lookback Days',
        added: 'FIX.4.4',
        Value: 'LOOKBACK',
        Sort: 14,
        Tag: 233,
        SymbolicName: 'LookbackDays',
    },
    {
        Group: '',
        Description: 'Explicit lot identifier',
        added: 'FIX.4.4',
        Value: 'LOT',
        Sort: 15,
        Tag: 233,
        SymbolicName: 'ExplicitLotIdentifier',
    },
    {
        Group: '',
        Description: 'Lot Variance (value in percent maximum over- or under-allocation allowed)',
        added: 'FIX.4.3',
        Value: 'LOTVAR',
        Sort: 16,
        Tag: 233,
        SymbolicName: 'LotVariance',
    },
    {
        Group: '',
        Description: 'Maturity Year And Month',
        added: 'FIX.4.3',
        Value: 'MAT',
        Sort: 17,
        Tag: 233,
        SymbolicName: 'MaturityYearAndMonth',
    },
    {
        Group: '',
        Description: 'Maturity range',
        added: 'FIX.4.4',
        Value: 'MATURITY',
        Sort: 18,
        Tag: 233,
        SymbolicName: 'MaturityRange',
    },
    {
        Group: '',
        Description: 'Maximum substitutions (Repo)',
        added: 'FIX.4.4',
        Value: 'MAXSUBS',
        Sort: 19,
        Tag: 233,
        SymbolicName: 'MaximumSubstitutions',
    },
    {
        Group: '',
        Description: 'Minimum denomination',
        added: 'FIX.4.4',
        Value: 'MINDNOM',
        Sort: 20,
        Tag: 233,
        SymbolicName: 'MinimumDenomination',
    },
    {
        Group: '',
        Description: 'Minimum increment',
        added: 'FIX.4.4',
        Value: 'MININCR',
        Sort: 21,
        Tag: 233,
        SymbolicName: 'MinimumIncrement',
    },
    {
        Group: '',
        Description: 'Minimum quantity',
        added: 'FIX.4.4',
        Value: 'MINQTY',
        Sort: 22,
        Tag: 233,
        SymbolicName: 'MinimumQuantity',
    },
    {
        Group: '',
        Description: 'Payment frequency, calendar',
        added: 'FIX.4.4',
        Value: 'PAYFREQ',
        Sort: 23,
        Tag: 233,
        SymbolicName: 'PaymentFrequency',
    },
    {
        Group: '',
        Description: 'Number Of Pieces',
        added: 'FIX.4.3',
        Value: 'PIECES',
        Sort: 24,
        Tag: 233,
        SymbolicName: 'NumberOfPieces',
    },
    {
        Group: '',
        Description: 'Pools Maximum',
        added: 'FIX.4.3',
        Value: 'PMAX',
        Sort: 25,
        Tag: 233,
        SymbolicName: 'PoolsMaximum',
    },
    {
        Group: '',
        Description: 'Pools per Lot',
        added: 'FIX.4.3',
        Value: 'PPL',
        Sort: 26,
        Tag: 233,
        SymbolicName: 'PoolsPerLot',
    },
    {
        Group: '',
        Description: 'Pools per Million',
        added: 'FIX.4.3',
        Value: 'PPM',
        Sort: 27,
        Tag: 233,
        SymbolicName: 'PoolsPerMillion',
    },
    {
        Group: '',
        Description: 'Pools per Trade',
        added: 'FIX.4.3',
        Value: 'PPT',
        Sort: 28,
        Tag: 233,
        SymbolicName: 'PoolsPerTrade',
    },
    {
        Group: '',
        Description: 'Price Range',
        added: 'FIX.4.4',
        Value: 'PRICE',
        Sort: 29,
        Tag: 233,
        SymbolicName: 'PriceRange',
    },
    {
        Group: '',
        Description: 'Pricing frequency',
        added: 'FIX.4.4',
        Value: 'PRICEFREQ',
        Sort: 30,
        Tag: 233,
        SymbolicName: 'PricingFrequency',
    },
    {
        Group: '',
        Description: 'Production Year',
        added: 'FIX.4.3',
        Value: 'PROD',
        Sort: 31,
        Tag: 233,
        SymbolicName: 'ProductionYear',
    },
    {
        Group: '',
        Description: 'Call protection',
        added: 'FIX.4.4',
        Value: 'PROTECT',
        Sort: 32,
        Tag: 233,
        SymbolicName: 'CallProtection',
    },
    {
        Group: '',
        Description: 'Purpose',
        added: 'FIX.4.4',
        Value: 'PURPOSE',
        Sort: 33,
        Tag: 233,
        SymbolicName: 'Purpose',
    },
    {
        Group: '',
        Description: 'Benchmark price source',
        added: 'FIX.4.4',
        Value: 'PXSOURCE',
        Sort: 34,
        Tag: 233,
        SymbolicName: 'BenchmarkPriceSource',
    },
    {
        Group: '',
        Description: 'Rating source and range',
        added: 'FIX.4.4',
        Value: 'RATING',
        Sort: 35,
        Tag: 233,
        SymbolicName: 'RatingSourceAndRange',
    },
    {
        Group: '',
        Description:
            'Type Of Redemption - values are: NonCallable, Prefunded, EscrowedToMaturity, Putable, Convertible',
        added: 'FIX.4.4',
        Value: 'REDEMPTION',
        Sort: 36,
        Tag: 233,
        SymbolicName: 'TypeOfRedemption',
    },
    {
        Group: '',
        Description: 'Restricted (Y/N)',
        added: 'FIX.4.4',
        Value: 'RESTRICTED',
        Sort: 37,
        Tag: 233,
        SymbolicName: 'Restricted',
    },
    {
        Group: '',
        Description: 'Market Sector',
        added: 'FIX.4.4',
        Value: 'SECTOR',
        Sort: 38,
        Tag: 233,
        SymbolicName: 'MarketSector',
    },
    {
        Group: '',
        Description: 'Security Type included or excluded',
        added: 'FIX.4.4',
        Value: 'SECTYPE',
        Sort: 39,
        Tag: 233,
        SymbolicName: 'SecurityTypeIncludedOrExcluded',
    },
    {
        Group: '',
        Description: 'Structure',
        added: 'FIX.4.4',
        Value: 'STRUCT',
        Sort: 40,
        Tag: 233,
        SymbolicName: 'Structure',
    },
    {
        Group: '',
        Description: 'Substitutions frequency (Repo)',
        added: 'FIX.4.4',
        Value: 'SUBSFREQ',
        Sort: 41,
        Tag: 233,
        SymbolicName: 'SubstitutionsFrequency',
    },
    {
        Group: '',
        Description: 'Substitutions left (Repo)',
        added: 'FIX.4.4',
        Value: 'SUBSLEFT',
        Sort: 42,
        Tag: 233,
        SymbolicName: 'SubstitutionsLeft',
    },
    {
        Group: '',
        Description: 'Freeform Text',
        added: 'FIX.4.4',
        Value: 'TEXT',
        Sort: 43,
        Tag: 233,
        SymbolicName: 'FreeformText',
    },
    {
        Group: '',
        Description: 'Trade Variance (value in percent maximum over- or under-allocation allowed)',
        added: 'FIX.4.3',
        Value: 'TRDVAR',
        Sort: 44,
        Tag: 233,
        SymbolicName: 'TradeVariance',
    },
    {
        Group: '',
        Description:
            'Weighted Average Coupon - value in percent (exact or range) plus "Gross" or "Net" of servicing spread (the default) (ex. 234=6.5-Net [minimum of 6.5% net of servicing fee])',
        added: 'FIX.4.3',
        Value: 'WAC',
        Sort: 45,
        Tag: 233,
        SymbolicName: 'WeightedAverageCoupon',
    },
    {
        Group: '',
        Description: 'Weighted Average Life Coupon - value in percent (exact or range)',
        added: 'FIX.4.3',
        Value: 'WAL',
        Sort: 46,
        Tag: 233,
        SymbolicName: 'WeightedAverageLifeCoupon',
    },
    {
        Group: '',
        Description: 'Weighted Average Loan Age - value in months (exact or range)',
        added: 'FIX.4.3',
        Value: 'WALA',
        Sort: 47,
        Tag: 233,
        SymbolicName: 'WeightedAverageLoanAge',
    },
    {
        Group: '',
        Description: 'Weighted Average Maturity - value in months (exact or range)',
        added: 'FIX.4.3',
        Value: 'WAM',
        Sort: 48,
        Tag: 233,
        SymbolicName: 'WeightedAverageMaturity',
    },
    {
        Group: '',
        Description: 'Whole Pool (Y/N)',
        added: 'FIX.4.4',
        Value: 'WHOLE',
        Sort: 49,
        Tag: 233,
        SymbolicName: 'WholePool',
    },
    {
        Group: '',
        Description: 'Yield Range',
        added: 'FIX.4.4',
        Value: 'YIELD',
        Sort: 50,
        Tag: 233,
        SymbolicName: 'YieldRange',
    },
    {
        Group: 'Other',
        Description: 'Average FICO Score',
        added: 'FIX.5.0',
        Value: 'AVFICO',
        Sort: 51,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'AverageFICOScore',
    },
    {
        Group: 'Other',
        Description: 'Average Loan Size',
        added: 'FIX.5.0',
        Value: 'AVSIZE',
        Sort: 52,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'AverageLoanSize',
    },
    {
        Group: 'Other',
        Description: 'Maximum Loan Balance',
        added: 'FIX.5.0',
        Value: 'MAXBAL',
        Sort: 53,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'MaximumLoanBalance',
    },
    {
        Group: 'Other',
        Description: 'Pool Identifier',
        added: 'FIX.5.0',
        Value: 'POOL',
        Sort: 54,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'PoolIdentifier',
    },
    {
        Group: 'Other',
        Description: 'Type of Roll trade',
        added: 'FIX.5.0',
        Value: 'ROLLTYPE',
        Sort: 55,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'TypeOfRollTrade',
    },
    {
        Group: 'Other',
        Description: 'reference to rolling or closing trade',
        added: 'FIX.5.0',
        Value: 'REFTRADE',
        Sort: 56,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'ReferenceToRollingOrClosingTrade',
    },
    {
        Group: 'Other',
        Description: 'principal of rolling or closing trade',
        added: 'FIX.5.0',
        Value: 'REFPRIN',
        Sort: 57,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'PrincipalOfRollingOrClosingTrade',
    },
    {
        Group: 'Other',
        Description: 'interest of rolling or closing trade',
        added: 'FIX.5.0',
        Value: 'REFINT',
        Sort: 58,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'InterestOfRollingOrClosingTrade',
    },
    {
        Group: 'Other',
        Description: 'Available offer quantity to be shown to the street',
        added: 'FIX.5.0',
        Value: 'AVAILQTY',
        Sort: 59,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'AvailableOfferQuantityToBeShownToTheStreet',
    },
    {
        Group: 'Other',
        Description: "Broker's sales credit",
        added: 'FIX.5.0',
        Value: 'BROKERCREDIT',
        Sort: 60,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'BrokerCredit',
    },
    {
        Group: 'Other',
        Description: 'Offer price to be shown to internal brokers',
        added: 'FIX.5.0',
        Value: 'INTERNALPX',
        Sort: 61,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'OfferPriceToBeShownToInternalBrokers',
    },
    {
        Group: 'Other',
        Description: 'Offer quantity to be shown to internal brokers',
        added: 'FIX.5.0',
        Value: 'INTERNALQTY',
        Sort: 62,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'OfferQuantityToBeShownToInternalBrokers',
    },
    {
        Group: 'Other',
        Description: 'The minimum residual offer quantity',
        added: 'FIX.5.0',
        Value: 'LEAVEQTY',
        Sort: 63,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'TheMinimumResidualOfferQuantity',
    },
    {
        Group: 'Other',
        Description: 'Maximum order size',
        added: 'FIX.5.0',
        Value: 'MAXORDQTY',
        Sort: 64,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'MaximumOrderSize',
    },
    {
        Group: 'Other',
        Description: 'Order quantity increment',
        added: 'FIX.5.0',
        Value: 'ORDRINCR',
        Sort: 65,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'OrderQuantityIncrement',
    },
    {
        Group: 'Other',
        Description: 'Primary or Secondary market indicator',
        added: 'FIX.5.0',
        Value: 'PRIMARY',
        Sort: 66,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'PrimaryOrSecondaryMarketIndicator',
    },
    {
        Group: 'Other',
        Description: 'Broker sales credit override',
        added: 'FIX.5.0',
        Value: 'SALESCREDITOVR',
        Sort: 67,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'BrokerSalesCreditOverride',
    },
    {
        Group: 'Other',
        Description: "Trader's credit",
        added: 'FIX.5.0',
        Value: 'TRADERCREDIT',
        Sort: 68,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'TraderCredit',
    },
    {
        Group: 'Other',
        Description: 'Discount Rate (when price is denominated in percent of par)',
        added: 'FIX.5.0',
        Value: 'DISCOUNT',
        Sort: 69,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'DiscountRate',
    },
    {
        Group: 'Other',
        Description: 'Yield to Maturity (when YieldType(235) and Yield(236) show a different yield)',
        added: 'FIX.5.0',
        Value: 'YTM',
        Sort: 71,
        addedEP: 68,
        Tag: 233,
        SymbolicName: 'YieldToMaturity',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Absolute Prepayment Speed',
        added: 'FIX.4.3',
        Value: 'ABS',
        Sort: 1,
        Tag: 233,
        SymbolicName: 'AbsolutePrepaymentSpeed',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Constant Prepayment Penalty',
        added: 'FIX.4.3',
        Value: 'CPP',
        Sort: 2,
        Tag: 233,
        SymbolicName: 'ConstantPrepaymentPenalty',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Constant Prepayment Rate',
        added: 'FIX.4.3',
        Value: 'CPR',
        Sort: 3,
        Tag: 233,
        SymbolicName: 'ConstantPrepaymentRate',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Constant Prepayment Yield',
        added: 'FIX.4.3',
        Value: 'CPY',
        Sort: 4,
        Tag: 233,
        SymbolicName: 'ConstantPrepaymentYield',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'final CPR of Home Equity Prepayment Curve',
        added: 'FIX.4.3',
        Value: 'HEP',
        Sort: 5,
        Tag: 233,
        SymbolicName: 'FinalCPROfHomeEquityPrepaymentCurve',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Percent of Manufactured Housing Prepayment Curve',
        added: 'FIX.4.3',
        Value: 'MHP',
        Sort: 6,
        Tag: 233,
        SymbolicName: 'PercentOfManufacturedHousingPrepaymentCurve',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Monthly Prepayment Rate',
        added: 'FIX.4.3',
        Value: 'MPR',
        Sort: 7,
        Tag: 233,
        SymbolicName: 'MonthlyPrepaymentRate',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Percent of Prospectus Prepayment Curve',
        added: 'FIX.4.3',
        Value: 'PPC',
        Sort: 8,
        Tag: 233,
        SymbolicName: 'PercentOfProspectusPrepaymentCurve',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Percent of BMA Prepayment Curve',
        added: 'FIX.4.3',
        Value: 'PSA',
        Sort: 9,
        Tag: 233,
        SymbolicName: 'PercentOfBMAPrepaymentCurve',
    },
    {
        Group: 'Prepayment Speeds',
        Description: 'Single Monthly Mortality',
        added: 'FIX.4.3',
        Value: 'SMM',
        Sort: 10,
        Tag: 233,
        SymbolicName: 'SingleMonthlyMortality',
    },
    {
        Group: '',
        Description: 'After Tax Yield (Municipals)',
        added: 'FIX.4.3',
        Value: 'AFTERTAX',
        Sort: 1,
        Tag: 235,
        SymbolicName: 'AfterTaxYield',
    },
    {
        Group: '',
        Description: 'Annual Yield',
        added: 'FIX.4.3',
        Value: 'ANNUAL',
        Sort: 2,
        Tag: 235,
        SymbolicName: 'AnnualYield',
    },
    {
        Group: '',
        Description: 'Yield At Issue (Municipals)',
        added: 'FIX.4.3',
        Value: 'ATISSUE',
        Sort: 3,
        Tag: 235,
        SymbolicName: 'YieldAtIssue',
    },
    {
        Group: '',
        Description: 'Yield To Avg Maturity',
        added: 'FIX.4.3',
        Value: 'AVGMATURITY',
        Sort: 4,
        Tag: 235,
        SymbolicName: 'YieldToAverageMaturity',
    },
    {
        Group: '',
        Description: 'Book Yield',
        added: 'FIX.4.3',
        Value: 'BOOK',
        Sort: 5,
        Tag: 235,
        SymbolicName: 'BookYield',
    },
    {
        Group: '',
        Description: 'Yield to Next Call',
        added: 'FIX.4.3',
        Value: 'CALL',
        Sort: 6,
        Tag: 235,
        SymbolicName: 'YieldToNextCall',
    },
    {
        Group: '',
        Description: 'Yield Change Since Close',
        added: 'FIX.4.3',
        Value: 'CHANGE',
        Sort: 7,
        Tag: 235,
        SymbolicName: 'YieldChangeSinceClose',
    },
    {
        Group: '',
        Description: 'Closing Yield',
        added: 'FIX.4.3',
        Value: 'CLOSE',
        Sort: 8,
        Tag: 235,
        SymbolicName: 'ClosingYield',
    },
    {
        Group: '',
        Description: 'Compound Yield',
        added: 'FIX.4.3',
        Value: 'COMPOUND',
        Sort: 9,
        Tag: 235,
        SymbolicName: 'CompoundYield',
    },
    {
        Group: '',
        Description: 'Current Yield',
        added: 'FIX.4.3',
        Value: 'CURRENT',
        Sort: 10,
        Tag: 235,
        SymbolicName: 'CurrentYield',
    },
    {
        Group: '',
        Description: 'Gvnt Equivalent Yield',
        added: 'FIX.4.3',
        Value: 'GOVTEQUIV',
        Sort: 11,
        Tag: 235,
        SymbolicName: 'GvntEquivalentYield',
    },
    {
        Group: '',
        Description: 'True Gross Yield',
        added: 'FIX.4.3',
        Value: 'GROSS',
        Sort: 12,
        Tag: 235,
        SymbolicName: 'TrueGrossYield',
    },
    {
        Group: '',
        Description: 'Yield with Inflation Assumption',
        added: 'FIX.4.3',
        Value: 'INFLATION',
        Sort: 13,
        Tag: 235,
        SymbolicName: 'YieldWithInflationAssumption',
    },
    {
        Group: '',
        Description: 'Inverse Floater Bond Yield',
        added: 'FIX.4.3',
        Value: 'INVERSEFLOATER',
        Sort: 14,
        Tag: 235,
        SymbolicName: 'InverseFloaterBondYield',
    },
    {
        Group: '',
        Description: 'Most Recent Closing Yield',
        added: 'FIX.4.3',
        Value: 'LASTCLOSE',
        Sort: 15,
        Tag: 235,
        SymbolicName: 'MostRecentClosingYield',
    },
    {
        Group: '',
        Description: 'Closing Yield Most Recent Month',
        added: 'FIX.4.3',
        Value: 'LASTMONTH',
        Sort: 16,
        Tag: 235,
        SymbolicName: 'ClosingYieldMostRecentMonth',
    },
    {
        Group: '',
        Description: 'Closing Yield Most Recent Quarter',
        added: 'FIX.4.3',
        Value: 'LASTQUARTER',
        Sort: 17,
        Tag: 235,
        SymbolicName: 'ClosingYieldMostRecentQuarter',
    },
    {
        Group: '',
        Description: 'Closing Yield Most Recent Year',
        added: 'FIX.4.3',
        Value: 'LASTYEAR',
        Sort: 18,
        Tag: 235,
        SymbolicName: 'ClosingYieldMostRecentYear',
    },
    {
        Group: '',
        Description: 'Yield to Longest Average Life',
        added: 'FIX.4.3',
        Value: 'LONGAVGLIFE',
        Sort: 19,
        Tag: 235,
        SymbolicName: 'YieldToLongestAverageLife',
    },
    {
        Group: '',
        Description: 'Mark to Market Yield',
        added: 'FIX.4.3',
        Value: 'MARK',
        Sort: 20,
        Tag: 235,
        SymbolicName: 'MarkToMarketYield',
    },
    {
        Group: '',
        Description: 'Yield to Maturity',
        added: 'FIX.4.3',
        Value: 'MATURITY',
        Sort: 21,
        Tag: 235,
        SymbolicName: 'YieldToMaturity',
    },
    {
        Group: '',
        Description: 'Yield to Next Refund (Sinking Fund Bonds)',
        added: 'FIX.4.3',
        Value: 'NEXTREFUND',
        Sort: 22,
        Tag: 235,
        SymbolicName: 'YieldToNextRefund',
    },
    {
        Group: '',
        Description: 'Open Average Yield',
        added: 'FIX.4.3',
        Value: 'OPENAVG',
        Sort: 23,
        Tag: 235,
        SymbolicName: 'OpenAverageYield',
    },
    {
        Group: '',
        Description: 'Previous Close Yield',
        added: 'FIX.4.3',
        Value: 'PREVCLOSE',
        Sort: 24,
        Tag: 235,
        SymbolicName: 'PreviousCloseYield',
    },
    {
        Group: '',
        Description: 'Proceeds Yield',
        added: 'FIX.4.3',
        Value: 'PROCEEDS',
        Sort: 25,
        Tag: 235,
        SymbolicName: 'ProceedsYield',
    },
    {
        Group: '',
        Description: 'Yield to Next Put',
        added: 'FIX.4.3',
        Value: 'PUT',
        Sort: 26,
        Tag: 235,
        SymbolicName: 'YieldToNextPut',
    },
    {
        Group: '',
        Description: 'Semi-annual Yield',
        added: 'FIX.4.3',
        Value: 'SEMIANNUAL',
        Sort: 27,
        Tag: 235,
        SymbolicName: 'SemiAnnualYield',
    },
    {
        Group: '',
        Description: 'Yield to Shortest Average Life',
        added: 'FIX.4.3',
        Value: 'SHORTAVGLIFE',
        Sort: 28,
        Tag: 235,
        SymbolicName: 'YieldToShortestAverageLife',
    },
    {
        Group: '',
        Description: 'Simple Yield',
        added: 'FIX.4.3',
        Value: 'SIMPLE',
        Sort: 29,
        Tag: 235,
        SymbolicName: 'SimpleYield',
    },
    {
        Group: '',
        Description: 'Tax Equivalent Yield',
        added: 'FIX.4.3',
        Value: 'TAXEQUIV',
        Sort: 30,
        Tag: 235,
        SymbolicName: 'TaxEquivalentYield',
    },
    {
        Group: '',
        Description: 'Yield to Tender Date',
        added: 'FIX.4.3',
        Value: 'TENDER',
        Sort: 31,
        Tag: 235,
        SymbolicName: 'YieldToTenderDate',
    },
    {
        Group: '',
        Description: 'True Yield',
        added: 'FIX.4.3',
        Value: 'True',
        Sort: 32,
        Tag: 235,
        SymbolicName: 'TrueYield',
    },
    {
        Group: '',
        Description: 'Yield Value Of 1/32',
        added: 'FIX.4.4',
        Value: 'VALUE1_32',
        Sort: 33,
        addedEP: -1,
        Tag: 235,
        SymbolicName: 'YieldValueOf32nds',
    },
    {
        Group: '',
        Description: 'Yield To Worst',
        added: 'FIX.4.3',
        Value: 'WORST',
        Sort: 34,
        Tag: 235,
        SymbolicName: 'YieldToWorst',
    },
    {
        Group: '',
        Description: 'Not Traded Flat',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 258,
        SymbolicName: 'NotTradedFlat',
    },
    {
        Group: '',
        Description: 'Traded Flat',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 258,
        SymbolicName: 'TradedFlat',
    },
    {
        Group: '',
        Description: 'Snapshot',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 263,
        SymbolicName: 'Snapshot',
    },
    {
        Group: '',
        Description: 'Snapshot + Updates (Subscribe)',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 263,
        SymbolicName: 'SnapshotAndUpdates',
    },
    {
        Group: '',
        Description: 'Disable previous Snapshot + Update Request (Unsubscribe)',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 263,
        SymbolicName: 'DisablePreviousSnapshot',
    },
    {
        Group: '',
        Description: 'Full refresh',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '0',
        Sort: 1,
        Tag: 265,
        SymbolicName: 'FullRefresh',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Incremental refresh',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '1',
        Sort: 2,
        Tag: 265,
        SymbolicName: 'IncrementalRefresh',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'book entries to be aggregated',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 1,
        addedEP: 34,
        Tag: 266,
        SymbolicName: 'BookEntriesToBeAggregated',
    },
    {
        Group: '',
        Description: 'book entries should not be aggregated',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 2,
        addedEP: 34,
        Tag: 266,
        SymbolicName: 'BookEntriesShouldNotBeAggregated',
    },
    {
        Group: '',
        Description: 'Bid',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 269,
        SymbolicName: 'Bid',
    },
    {
        Group: '',
        Description: 'Offer',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 269,
        SymbolicName: 'Offer',
    },
    {
        Group: '',
        Description: 'Trade',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 269,
        SymbolicName: 'Trade',
    },
    {
        Group: '',
        Description: 'Index Value',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 269,
        SymbolicName: 'IndexValue',
    },
    {
        Group: '',
        Description: 'Opening Price',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 269,
        SymbolicName: 'OpeningPrice',
    },
    {
        Group: '',
        Description: 'Closing Price',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 269,
        SymbolicName: 'ClosingPrice',
    },
    {
        Group: '',
        Description: 'Settlement Price',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 7,
        Tag: 269,
        SymbolicName: 'SettlementPrice',
    },
    {
        Group: '',
        Description: 'Trading Session High Price',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 8,
        Tag: 269,
        SymbolicName: 'TradingSessionHighPrice',
    },
    {
        Group: '',
        Description: 'Trading Session Low Price',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 9,
        Tag: 269,
        SymbolicName: 'TradingSessionLowPrice',
    },
    {
        Group: '',
        Description: 'Trading Session VWAP Price',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 10,
        Tag: 269,
        SymbolicName: 'TradingSessionVWAPPrice',
    },
    {
        Group: '',
        Description: 'Imbalance',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 11,
        Tag: 269,
        SymbolicName: 'Imbalance',
    },
    {
        Group: '',
        Description: 'Trade Volume',
        added: 'FIX.4.4',
        Value: 'B',
        Sort: 12,
        Tag: 269,
        SymbolicName: 'TradeVolume',
    },
    {
        Group: '',
        Description: 'Open Interest',
        added: 'FIX.4.4',
        Value: 'C',
        Sort: 13,
        Tag: 269,
        SymbolicName: 'OpenInterest',
    },
    {
        Group: '',
        Description: 'Composite Underlying Price',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 14,
        addedEP: 4,
        Tag: 269,
        SymbolicName: 'CompositeUnderlyingPrice',
    },
    {
        Group: '',
        Description: 'Simulated Sell Price',
        added: 'FIX.4.4',
        Value: 'E',
        Sort: 15,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SimulatedSellPrice',
    },
    {
        Group: '',
        Description: 'Simulated Buy Price',
        added: 'FIX.4.4',
        Value: 'F',
        Sort: 16,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SimulatedBuyPrice',
    },
    {
        Group: '',
        Description: 'Margin Rate',
        added: 'FIX.4.4',
        Value: 'G',
        Sort: 17,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'MarginRate',
    },
    {
        Group: '',
        Description: 'Mid Price',
        added: 'FIX.4.4',
        Value: 'H',
        Sort: 18,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'MidPrice',
    },
    {
        Group: '',
        Description: 'Empty Book',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 19,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'EmptyBook',
    },
    {
        Group: '',
        Description: 'Settle High Price',
        added: 'FIX.4.4',
        Value: 'K',
        Sort: 20,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SettleHighPrice',
    },
    {
        Group: '',
        Description: 'Settle Low Price',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 21,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SettleLowPrice',
    },
    {
        Group: '',
        Description: 'Prior Settle Price',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 22,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'PriorSettlePrice',
    },
    {
        Group: '',
        Description: 'Session High Bid',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 23,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SessionHighBid',
    },
    {
        Group: '',
        Description: 'Session Low Offer',
        added: 'FIX.4.4',
        Value: 'O',
        Sort: 24,
        addedEP: 7,
        Tag: 269,
        SymbolicName: 'SessionLowOffer',
    },
    {
        Group: '',
        Description: 'Early Prices',
        added: 'FIX.4.4',
        Value: 'P',
        Sort: 25,
        addedEP: 8,
        Tag: 269,
        SymbolicName: 'EarlyPrices',
    },
    {
        Group: '',
        Description: 'Auction Clearing Price',
        added: 'FIX.4.4',
        Value: 'Q',
        Sort: 26,
        addedEP: 26,
        Tag: 269,
        SymbolicName: 'AuctionClearingPrice',
    },
    {
        Group: '',
        Description: 'Swap Value Factor (SVP) for swaps cleared through a central counterparty (CCP)',
        added: 'FIX.5.0',
        Value: 'S',
        Sort: 27,
        addedEP: 54,
        Tag: 269,
        SymbolicName: 'SwapValueFactor',
    },
    {
        Group: '',
        Description: 'Daily value adjustment for long positions',
        added: 'FIX.5.0',
        Value: 'R',
        Sort: 28,
        addedEP: 55,
        Tag: 269,
        SymbolicName: 'DailyValueAdjustmentForLongPositions',
    },
    {
        Group: '',
        Description: 'Cumulative Value Adjustment for long positions',
        added: 'FIX.5.0',
        Value: 'T',
        Sort: 29,
        addedEP: 55,
        Tag: 269,
        SymbolicName: 'CumulativeValueAdjustmentForLongPositions',
    },
    {
        Group: '',
        Description: 'Daily Value Adjustment for Short Positions',
        added: 'FIX.5.0',
        Value: 'U',
        Sort: 30,
        addedEP: 55,
        Tag: 269,
        SymbolicName: 'DailyValueAdjustmentForShortPositions',
    },
    {
        Group: '',
        Description: 'Cumulative Value Adjustment for Short Positions',
        added: 'FIX.5.0',
        Value: 'V',
        Sort: 31,
        addedEP: 55,
        Tag: 269,
        SymbolicName: 'CumulativeValueAdjustmentForShortPositions',
    },
    {
        Group: '',
        Description: 'Plus Tick',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 274,
        SymbolicName: 'PlusTick',
    },
    {
        Group: '',
        Description: 'Zero-Plus Tick',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 274,
        SymbolicName: 'ZeroPlusTick',
    },
    {
        Group: '',
        Description: 'Minus Tick',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 274,
        SymbolicName: 'MinusTick',
    },
    {
        Group: '',
        Description: 'Zero-Minus Tick',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 274,
        SymbolicName: 'ZeroMinusTick',
    },
    {
        Group: '',
        Description: 'Open/Active',
        added: 'FIX.4.2',
        Value: 'A',
        Sort: 1,
        Tag: 276,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Closed/Inactive',
        added: 'FIX.4.2',
        Value: 'B',
        Sort: 2,
        Tag: 276,
        SymbolicName: 'Closed',
    },
    {
        Group: '',
        Description: 'Exchange Best',
        added: 'FIX.4.2',
        Value: 'C',
        Sort: 3,
        Tag: 276,
        SymbolicName: 'ExchangeBest',
    },
    {
        Group: '',
        Description: 'Consolidated Best',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 4,
        Tag: 276,
        SymbolicName: 'ConsolidatedBest',
    },
    {
        Group: '',
        Description: 'Locked',
        added: 'FIX.4.2',
        Value: 'E',
        Sort: 5,
        Tag: 276,
        SymbolicName: 'Locked',
    },
    {
        Group: '',
        Description: 'Crossed',
        added: 'FIX.4.2',
        Value: 'F',
        Sort: 6,
        Tag: 276,
        SymbolicName: 'Crossed',
    },
    {
        Group: '',
        Description: 'Depth',
        added: 'FIX.4.2',
        Value: 'G',
        Sort: 7,
        Tag: 276,
        SymbolicName: 'Depth',
    },
    {
        Group: '',
        Description: 'Fast Trading',
        added: 'FIX.4.2',
        Value: 'H',
        Sort: 8,
        Tag: 276,
        SymbolicName: 'FastTrading',
    },
    {
        Group: '',
        Description: 'Non-Firm',
        added: 'FIX.4.2',
        Value: 'I',
        Sort: 9,
        Tag: 276,
        SymbolicName: 'NonFirm',
    },
    {
        Group: '',
        Description: 'Manual/Slow Quote',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 10,
        addedEP: 6,
        Tag: 276,
        SymbolicName: 'Manual',
    },
    {
        Group: '',
        Description: 'Outright Price',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 11,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OutrightPrice',
    },
    {
        Group: '',
        Description: 'Implied Price',
        added: 'FIX.4.4',
        Value: 'K',
        Sort: 12,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'ImpliedPrice',
    },
    {
        Group: '',
        Description: 'Depth on Offer',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 13,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'DepthOnOffer',
    },
    {
        Group: '',
        Description: 'Depth on Bid',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 14,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'DepthOnBid',
    },
    {
        Group: '',
        Description: 'Closing',
        added: 'FIX.4.4',
        Value: 'O',
        Sort: 15,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'Closing',
    },
    {
        Group: '',
        Description: 'News Dissemination',
        added: 'FIX.4.4',
        Value: 'P',
        Sort: 16,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'NewsDissemination',
    },
    {
        Group: '',
        Description: 'Trading Range',
        added: 'FIX.4.4',
        Value: 'Q',
        Sort: 17,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'TradingRange',
    },
    {
        Group: '',
        Description: 'Order Influx',
        added: 'FIX.4.4',
        Value: 'R',
        Sort: 18,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OrderInflux',
    },
    {
        Group: '',
        Description: 'Due to Related',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 19,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'DueToRelated',
    },
    {
        Group: '',
        Description: 'News Pending',
        added: 'FIX.4.4',
        Value: 'T',
        Sort: 20,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'NewsPending',
    },
    {
        Group: '',
        Description: 'Additional Info',
        added: 'FIX.4.4',
        Value: 'U',
        Sort: 21,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'AdditionalInfo',
    },
    {
        Group: '',
        Description: 'Additional Info due to related',
        added: 'FIX.4.4',
        Value: 'V',
        Sort: 22,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'AdditionalInfoDueToRelated',
    },
    {
        Group: '',
        Description: 'Resume',
        added: 'FIX.4.4',
        Value: 'W',
        Sort: 23,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'Resume',
    },
    {
        Group: '',
        Description: 'View of Common',
        added: 'FIX.4.4',
        Value: 'X',
        Sort: 24,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'ViewOfCommon',
    },
    {
        Group: '',
        Description: 'Volume Alert',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 25,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'VolumeAlert',
    },
    {
        Group: '',
        Description: 'Order Imbalance',
        added: 'FIX.4.4',
        Value: 'Z',
        Sort: 26,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OrderImbalance',
    },
    {
        Group: '',
        Description: 'Equipment Changeover',
        added: 'FIX.4.4',
        Value: 'a',
        Sort: 27,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'EquipmentChangeover',
    },
    {
        Group: '',
        Description: 'No Open / No Resume',
        added: 'FIX.4.4',
        Value: 'b',
        Sort: 28,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'NoOpen',
    },
    {
        Group: '',
        Description: 'Regular ETH',
        added: 'FIX.4.4',
        Value: 'c',
        Sort: 29,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'RegularETH',
    },
    {
        Group: '',
        Description: 'Automatic Execution',
        added: 'FIX.4.4',
        Value: 'd',
        Sort: 30,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'AutomaticExecution',
    },
    {
        Group: '',
        Description: 'Automatic Execution ETH',
        added: 'FIX.4.4',
        Value: 'e',
        Sort: 31,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'AutomaticExecutionETH',
    },
    {
        Group: '',
        Description: 'Fast Market ETH',
        added: 'FIX.4.4',
        Value: 'f',
        Sort: 32,
        addedEP: -1,
        Tag: 276,
        SymbolicName: 'FastMarketETH',
    },
    {
        Group: '',
        Description: 'Inactive ETH',
        added: 'FIX.4.4',
        Value: 'g',
        Sort: 33,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'InactiveETH',
    },
    {
        Group: '',
        Description: 'Rotation',
        added: 'FIX.4.4',
        Value: 'h',
        Sort: 34,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'Rotation',
    },
    {
        Group: '',
        Description: 'Rotation ETH',
        added: 'FIX.4.4',
        Value: 'i',
        Sort: 35,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'RotationETH',
    },
    {
        Group: '',
        Description: 'Halt',
        added: 'FIX.4.4',
        Value: 'j',
        Sort: 36,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'Halt',
    },
    {
        Group: '',
        Description: 'Halt ETH',
        added: 'FIX.4.4',
        Value: 'k',
        Sort: 37,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'HaltETH',
    },
    {
        Group: '',
        Description: 'Due to News Dissemination',
        added: 'FIX.4.4',
        Value: 'l',
        Sort: 38,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'DueToNewsDissemination',
    },
    {
        Group: '',
        Description: 'Due to News Pending',
        added: 'FIX.4.4',
        Value: 'm',
        Sort: 39,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'DueToNewsPending',
    },
    {
        Group: '',
        Description: 'Trading Resume',
        added: 'FIX.4.4',
        Value: 'n',
        Sort: 40,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'TradingResume',
    },
    {
        Group: '',
        Description: 'Out of Sequence',
        added: 'FIX.4.4',
        Value: 'o',
        Sort: 41,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OutOfSequence',
    },
    {
        Group: '',
        Description: 'Bid Specialist',
        added: 'FIX.4.4',
        Value: 'p',
        Sort: 42,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'BidSpecialist',
    },
    {
        Group: '',
        Description: 'Offer Specialist',
        added: 'FIX.4.4',
        Value: 'q',
        Sort: 43,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OfferSpecialist',
    },
    {
        Group: '',
        Description: 'Bid Offer Specialist',
        added: 'FIX.4.4',
        Value: 'r',
        Sort: 44,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'BidOfferSpecialist',
    },
    {
        Group: '',
        Description: 'End of Day SAM',
        added: 'FIX.4.4',
        Value: 's',
        Sort: 45,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'EndOfDaySAM',
    },
    {
        Group: '',
        Description: 'Forbidden SAM',
        added: 'FIX.4.4',
        Value: 't',
        Sort: 46,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'ForbiddenSAM',
    },
    {
        Group: '',
        Description: 'Frozen SAM',
        added: 'FIX.4.4',
        Value: 'u',
        Sort: 47,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'FrozenSAM',
    },
    {
        Group: '',
        Description: 'PreOpening SAM',
        added: 'FIX.4.4',
        Value: 'v',
        Sort: 48,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'PreOpeningSAM',
    },
    {
        Group: '',
        Description: 'Opening SAM',
        added: 'FIX.4.4',
        Value: 'w',
        Sort: 49,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OpeningSAM',
    },
    {
        Group: '',
        Description: 'Open SAM',
        added: 'FIX.4.4',
        Value: 'x',
        Sort: 50,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'OpenSAM',
    },
    {
        Group: '',
        Description: 'Surveillance SAM',
        added: 'FIX.4.4',
        Value: 'y',
        Sort: 51,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'SurveillanceSAM',
    },
    {
        Group: '',
        Description: 'Suspended SAM',
        added: 'FIX.4.4',
        Value: 'z',
        Sort: 52,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'SuspendedSAM',
    },
    {
        Group: '',
        Description: 'Reserved SAM',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 53,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'ReservedSAM',
    },
    {
        Group: '',
        Description: 'No Active SAM',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 54,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'NoActiveSAM',
    },
    {
        Group: '',
        Description: 'Restricted',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 55,
        addedEP: 7,
        Tag: 276,
        SymbolicName: 'Restricted',
    },
    {
        Group: '',
        Description: 'Rest of Book VWAP',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 56,
        addedEP: 47,
        Tag: 276,
        SymbolicName: 'RestOfBookVWAP',
    },
    {
        Group: '',
        Description: 'Better Prices in Conditional Orders',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 57,
        addedEP: 47,
        Tag: 276,
        SymbolicName: 'BetterPricesInConditionalOrders',
    },
    {
        Group: '',
        Description: 'Median Price',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 58,
        addedEP: 61,
        Tag: 276,
        SymbolicName: 'MedianPrice',
    },
    {
        Group: '',
        Description: 'Cash (only) Market',
        added: 'FIX.4.2',
        Value: 'A',
        Sort: 0,
        Tag: 277,
        SymbolicName: 'Cash',
    },
    {
        Group: '',
        Description: 'Average Price Trade',
        added: 'FIX.4.2',
        Value: 'B',
        Sort: 1,
        Tag: 277,
        SymbolicName: 'AveragePriceTrade',
    },
    {
        Group: '',
        Description: 'Cash Trade (same day clearing)',
        added: 'FIX.4.2',
        Value: 'C',
        Sort: 2,
        Tag: 277,
        SymbolicName: 'CashTrade',
    },
    {
        Group: '',
        Description: 'Next Day (only)Market',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 3,
        Tag: 277,
        SymbolicName: 'NextDay',
    },
    {
        Group: '',
        Description: 'Opening/Reopening Trade Detail',
        added: 'FIX.4.2',
        Value: 'E',
        Sort: 4,
        Tag: 277,
        SymbolicName: 'Opening',
    },
    {
        Group: '',
        Description: 'Intraday Trade Detail',
        added: 'FIX.4.2',
        Value: 'F',
        Sort: 5,
        Tag: 277,
        SymbolicName: 'IntradayTradeDetail',
    },
    {
        Group: '',
        Description: 'Rule 127 Trade (NYSE)',
        added: 'FIX.4.2',
        Value: 'G',
        Sort: 6,
        Tag: 277,
        SymbolicName: 'Rule127Trade',
    },
    {
        Group: '',
        Description: 'Rule 155 Trade (AMEX)',
        added: 'FIX.4.2',
        Value: 'H',
        Sort: 7,
        Tag: 277,
        SymbolicName: 'Rule155Trade',
    },
    {
        Group: '',
        Description: 'Sold Last (late reporting)',
        added: 'FIX.4.2',
        Value: 'I',
        Sort: 8,
        Tag: 277,
        SymbolicName: 'SoldLast',
    },
    {
        Group: '',
        Description: 'Next Day Trade (next day clearing)',
        added: 'FIX.4.2',
        Value: 'J',
        Sort: 9,
        Tag: 277,
        SymbolicName: 'NextDayTrade',
    },
    {
        Group: '',
        Description: 'Opened (late report of opened trade)',
        added: 'FIX.4.2',
        Value: 'K',
        Sort: 10,
        Tag: 277,
        SymbolicName: 'Opened',
    },
    {
        Group: '',
        Description: 'Seller',
        added: 'FIX.4.2',
        Value: 'L',
        Sort: 11,
        Tag: 277,
        SymbolicName: 'Seller',
    },
    {
        Group: '',
        Description: 'Sold (out of sequence)',
        added: 'FIX.4.2',
        Value: 'M',
        Sort: 12,
        Tag: 277,
        SymbolicName: 'Sold',
    },
    {
        Group: '',
        Description: 'Stopped Stock (guarantee of price but does not execute the order)',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 13,
        Tag: 277,
        SymbolicName: 'StoppedStock',
    },
    {
        Group: '',
        Description: 'Imbalance More Buyers (cannot be used in combination with Q)',
        added: 'FIX.4.3',
        Value: 'P',
        Sort: 14,
        Tag: 277,
        SymbolicName: 'ImbalanceMoreBuyers',
    },
    {
        Group: '',
        Description: 'Imbalance More Sellers (cannot be used in combination with P)',
        added: 'FIX.4.3',
        Value: 'Q',
        Sort: 15,
        Tag: 277,
        SymbolicName: 'ImbalanceMoreSellers',
    },
    {
        Group: '',
        Description: 'Opening Price',
        added: 'FIX.4.3',
        Value: 'R',
        Sort: 16,
        Tag: 277,
        SymbolicName: 'OpeningPrice',
    },
    {
        Group: '',
        Description: 'Bargain Condition (LSE)',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 17,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'BargainCondition',
    },
    {
        Group: '',
        Description: 'Converted Price Indicator',
        added: 'FIX.4.4',
        Value: 'T',
        Sort: 18,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ConvertedPriceIndicator',
    },
    {
        Group: '',
        Description: 'Exchange Last',
        added: 'FIX.4.4',
        Value: 'U',
        Sort: 19,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ExchangeLast',
    },
    {
        Group: '',
        Description: 'Final Price of Session',
        added: 'FIX.4.4',
        Value: 'V',
        Sort: 20,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'FinalPriceOfSession',
    },
    {
        Group: '',
        Description: 'Ex-pit',
        added: 'FIX.4.4',
        Value: 'W',
        Sort: 21,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ExPit',
    },
    {
        Group: '',
        Description: 'Crossed',
        added: 'FIX.4.4',
        Value: 'X',
        Sort: 22,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Crossed',
    },
    {
        Group: '',
        Description: 'Trades resulting from manual/slow quote',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 23,
        addedEP: 6,
        Tag: 277,
        SymbolicName: 'TradesResultingFromManual',
    },
    {
        Group: '',
        Description: 'Trades resulting from intermarket sweep',
        added: 'FIX.4.4',
        Value: 'Z',
        Sort: 24,
        addedEP: 6,
        Tag: 277,
        SymbolicName: 'TradesResultingFromIntermarketSweep',
    },
    {
        Group: '',
        Description: 'Volume Only',
        added: 'FIX.4.4',
        Value: 'a',
        Sort: 25,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'VolumeOnly',
    },
    {
        Group: '',
        Description: 'Direct Plus',
        added: 'FIX.4.4',
        Value: 'b',
        Sort: 26,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'DirectPlus',
    },
    {
        Group: '',
        Description: 'Acquisition',
        added: 'FIX.4.4',
        Value: 'c',
        Sort: 27,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Acquisition',
    },
    {
        Group: '',
        Description: 'Bunched',
        added: 'FIX.4.4',
        Value: 'd',
        Sort: 28,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Bunched',
    },
    {
        Group: '',
        Description: 'Distribution',
        added: 'FIX.4.4',
        Value: 'e',
        Sort: 29,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Distribution',
    },
    {
        Group: '',
        Description: 'Bunched Sale',
        added: 'FIX.4.4',
        Value: 'f',
        Sort: 30,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'BunchedSale',
    },
    {
        Group: '',
        Description: 'Split Trade',
        added: 'FIX.4.4',
        Value: 'g',
        Sort: 31,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'SplitTrade',
    },
    {
        Group: '',
        Description: 'Cancel Stopped',
        added: 'FIX.4.4',
        Value: 'h',
        Sort: 32,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelStopped',
    },
    {
        Group: '',
        Description: 'Cancel ETH',
        added: 'FIX.4.4',
        Value: 'i',
        Sort: 33,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelETH',
    },
    {
        Group: '',
        Description: 'Cancel Stopped ETH',
        added: 'FIX.4.4',
        Value: 'j',
        Sort: 34,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelStoppedETH',
    },
    {
        Group: '',
        Description: 'Out of Sequence ETH',
        added: 'FIX.4.4',
        Value: 'k',
        Sort: 35,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'OutOfSequenceETH',
    },
    {
        Group: '',
        Description: 'Cancel Last ETH',
        added: 'FIX.4.4',
        Value: 'l',
        Sort: 36,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelLastETH',
    },
    {
        Group: '',
        Description: 'Sold Last Sale ETH',
        added: 'FIX.4.4',
        Value: 'm',
        Sort: 37,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'SoldLastSaleETH',
    },
    {
        Group: '',
        Description: 'Cancel Last',
        added: 'FIX.4.4',
        Value: 'n',
        Sort: 38,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelLast',
    },
    {
        Group: '',
        Description: 'Sold Last Sale',
        added: 'FIX.4.4',
        Value: 'o',
        Sort: 39,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'SoldLastSale',
    },
    {
        Group: '',
        Description: 'Cancel Open',
        added: 'FIX.4.4',
        Value: 'p',
        Sort: 40,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelOpen',
    },
    {
        Group: '',
        Description: 'Cancel Open ETH',
        added: 'FIX.4.4',
        Value: 'q',
        Sort: 41,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelOpenETH',
    },
    {
        Group: '',
        Description: 'Opened Sale ETH',
        added: 'FIX.4.4',
        Value: 'r',
        Sort: 42,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'OpenedSaleETH',
    },
    {
        Group: '',
        Description: 'Cancel Only',
        added: 'FIX.4.4',
        Value: 's',
        Sort: 43,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelOnly',
    },
    {
        Group: '',
        Description: 'Cancel Only ETH',
        added: 'FIX.4.4',
        Value: 't',
        Sort: 44,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CancelOnlyETH',
    },
    {
        Group: '',
        Description: 'Late Open ETH',
        added: 'FIX.4.4',
        Value: 'u',
        Sort: 45,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'LateOpenETH',
    },
    {
        Group: '',
        Description: 'Auto Execution ETH',
        added: 'FIX.4.4',
        Value: 'v',
        Sort: 46,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'AutoExecutionETH',
    },
    {
        Group: '',
        Description: 'Reopen',
        added: 'FIX.4.4',
        Value: 'w',
        Sort: 47,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Reopen',
    },
    {
        Group: '',
        Description: 'Reopen ETH',
        added: 'FIX.4.4',
        Value: 'x',
        Sort: 48,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ReopenETH',
    },
    {
        Group: '',
        Description: 'Adjusted',
        added: 'FIX.4.4',
        Value: 'y',
        Sort: 49,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Adjusted',
    },
    {
        Group: '',
        Description: 'Adjusted ETH',
        added: 'FIX.4.4',
        Value: 'z',
        Sort: 50,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'AdjustedETH',
    },
    {
        Group: '',
        Description: 'Spread',
        added: 'FIX.4.4',
        Value: 'AA',
        Sort: 51,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Spread',
    },
    {
        Group: '',
        Description: 'Spread ETH',
        added: 'FIX.4.4',
        Value: 'AB',
        Sort: 52,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'SpreadETH',
    },
    {
        Group: '',
        Description: 'Straddle',
        added: 'FIX.4.4',
        Value: 'AC',
        Sort: 53,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Straddle',
    },
    {
        Group: '',
        Description: 'Straddle ETH',
        added: 'FIX.4.4',
        Value: 'AD',
        Sort: 54,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'StraddleETH',
    },
    {
        Group: '',
        Description: 'Stopped',
        added: 'FIX.4.4',
        Value: 'AE',
        Sort: 55,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Stopped',
    },
    {
        Group: '',
        Description: 'Stopped ETH',
        added: 'FIX.4.4',
        Value: 'AF',
        Sort: 56,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'StoppedETH',
    },
    {
        Group: '',
        Description: 'Regular ETH',
        added: 'FIX.4.4',
        Value: 'AG',
        Sort: 57,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'RegularETH',
    },
    {
        Group: '',
        Description: 'Combo',
        added: 'FIX.4.4',
        Value: 'AH',
        Sort: 58,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Combo',
    },
    {
        Group: '',
        Description: 'Combo ETH',
        added: 'FIX.4.4',
        Value: 'AI',
        Sort: 59,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ComboETH',
    },
    {
        Group: '',
        Description: 'Official Closing Price',
        added: 'FIX.4.4',
        Value: 'AJ',
        Sort: 60,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'OfficialClosingPrice',
    },
    {
        Group: '',
        Description: 'Prior Reference Price',
        added: 'FIX.4.4',
        Value: 'AK',
        Sort: 61,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'PriorReferencePrice',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 62,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Stopped Sold Last',
        added: 'FIX.4.4',
        Value: 'AL',
        Sort: 71,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'StoppedSoldLast',
    },
    {
        Group: '',
        Description: 'Stopped Out of Sequence',
        added: 'FIX.4.4',
        Value: 'AM',
        Sort: 72,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'StoppedOutOfSequence',
    },
    {
        Group: '',
        Description: "Offical Closing Price (duplicate enumeration - use 'AJ' instead)",
        added: 'FIX.4.4',
        Value: 'AN',
        Sort: 73,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'OfficalClosingPrice',
    },
    {
        Group: '',
        Description: "Crossed (duplicate enumeration - use 'X' instead)",
        added: 'FIX.4.4',
        Value: 'AO',
        Sort: 74,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'CrossedOld',
    },
    {
        Group: '',
        Description: 'Fast Market',
        added: 'FIX.4.4',
        Value: 'AP',
        Sort: 75,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'FastMarket',
    },
    {
        Group: '',
        Description: 'Automatic Execution',
        added: 'FIX.4.4',
        Value: 'AQ',
        Sort: 76,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'AutomaticExecution',
    },
    {
        Group: '',
        Description: 'Form T',
        added: 'FIX.4.4',
        Value: 'AR',
        Sort: 77,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'FormT',
    },
    {
        Group: '',
        Description: 'Basket Index',
        added: 'FIX.4.4',
        Value: 'AS',
        Sort: 78,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'BasketIndex',
    },
    {
        Group: '',
        Description: 'Burst Basket',
        added: 'FIX.4.4',
        Value: 'AT',
        Sort: 79,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'BurstBasket',
    },
    {
        Group: '',
        Description: 'Outside Spread',
        added: 'FIX.5.0',
        Value: 'AV',
        Sort: 98,
        addedEP: 47,
        Tag: 277,
        SymbolicName: 'OutsideSpread',
    },
    {
        Group: '',
        Description: 'Implied Trade',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 99,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'ImpliedTrade',
    },
    {
        Group: '',
        Description: 'Marketplace entered trade',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 100,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'MarketplaceEnteredTrade',
    },
    {
        Group: '',
        Description: 'Mult Asset Class Multileg Trade',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 101,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'MultAssetClassMultilegTrade',
    },
    {
        Group: '',
        Description: 'Multileg-to-Multileg Trade',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 102,
        addedEP: 7,
        Tag: 277,
        SymbolicName: 'MultilegToMultilegTrade',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 279,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Change',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 279,
        SymbolicName: 'Change',
    },
    {
        Group: '',
        Description: 'Delete',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 279,
        SymbolicName: 'Delete',
    },
    {
        Group: '',
        Description: 'Delete Thru',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: 7,
        Tag: 279,
        SymbolicName: 'DeleteThru',
    },
    {
        Group: '',
        Description: 'Delete From',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: 7,
        Tag: 279,
        SymbolicName: 'DeleteFrom',
    },
    {
        Group: '',
        Description: 'Overlay',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 10,
        addedEP: 42,
        Tag: 279,
        SymbolicName: 'Overlay',
    },
    {
        Group: '',
        Description: 'Unknown symbol',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 281,
        SymbolicName: 'UnknownSymbol',
    },
    {
        Group: '',
        Description: 'Duplicate MDReqID',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 281,
        SymbolicName: 'DuplicateMDReqID',
    },
    {
        Group: '',
        Description: 'Insufficient Bandwidth',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 281,
        SymbolicName: 'InsufficientBandwidth',
    },
    {
        Group: '',
        Description: 'Insufficient Permissions',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 281,
        SymbolicName: 'InsufficientPermissions',
    },
    {
        Group: '',
        Description: 'Unsupported SubscriptionRequestType',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 281,
        SymbolicName: 'UnsupportedSubscriptionRequestType',
    },
    {
        Group: '',
        Description: 'Unsupported MarketDepth',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 281,
        SymbolicName: 'UnsupportedMarketDepth',
    },
    {
        Group: '',
        Description: 'Unsupported MDUpdateType',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 7,
        Tag: 281,
        SymbolicName: 'UnsupportedMDUpdateType',
    },
    {
        Group: '',
        Description: 'Unsupported AggregatedBook',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 8,
        Tag: 281,
        SymbolicName: 'UnsupportedAggregatedBook',
    },
    {
        Group: '',
        Description: 'Unsupported MDEntryType',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 9,
        Tag: 281,
        SymbolicName: 'UnsupportedMDEntryType',
    },
    {
        Group: '',
        Description: 'Unsupported TradingSessionID',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 10,
        Tag: 281,
        SymbolicName: 'UnsupportedTradingSessionID',
    },
    {
        Group: '',
        Description: 'Unsupported Scope',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 11,
        Tag: 281,
        SymbolicName: 'UnsupportedScope',
    },
    {
        Group: '',
        Description: 'Unsupported OpenCloseSettleFlag',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 12,
        Tag: 281,
        SymbolicName: 'UnsupportedOpenCloseSettleFlag',
    },
    {
        Group: '',
        Description: 'Unsupported MDImplicitDelete',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 13,
        Tag: 281,
        SymbolicName: 'UnsupportedMDImplicitDelete',
    },
    {
        Group: '',
        Description: 'Insufficient credit',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 14,
        addedEP: 21,
        Tag: 281,
        SymbolicName: 'InsufficientCredit',
    },
    {
        Group: '',
        Description: 'Cancellation / Trade Bust',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 285,
        SymbolicName: 'Cancellation',
    },
    {
        Group: '',
        Description: 'Error',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 285,
        SymbolicName: 'Error',
    },
    {
        Group: '',
        Description: 'Daily Open / Close / Settlement entry',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 286,
        SymbolicName: 'DailyOpen',
    },
    {
        Group: '',
        Description: 'Session Open / Close / Settlement entry',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 286,
        SymbolicName: 'SessionOpen',
    },
    {
        Group: '',
        Description: 'Delivery Settlement entry',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 286,
        SymbolicName: 'DeliverySettlementEntry',
    },
    {
        Group: '',
        Description: 'Expected entry',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 4,
        Tag: 286,
        SymbolicName: 'ExpectedEntry',
    },
    {
        Group: '',
        Description: 'Entry from previous business day',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 5,
        Tag: 286,
        SymbolicName: 'EntryFromPreviousBusinessDay',
    },
    {
        Group: '',
        Description: 'Theoretical Price value',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 286,
        SymbolicName: 'TheoreticalPriceValue',
    },
    {
        Group: '',
        Description: 'Bankrupt',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 291,
        SymbolicName: 'Bankrupt',
    },
    {
        Group: '',
        Description: 'Pending delisting',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 291,
        SymbolicName: 'PendingDelisting',
    },
    {
        Group: '',
        Description: 'Restricted',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: 12,
        Tag: 291,
        SymbolicName: 'Restricted',
    },
    {
        Group: '',
        Description: 'Ex-Dividend',
        added: 'FIX.4.2',
        Value: 'A',
        Sort: 1,
        Tag: 292,
        SymbolicName: 'ExDividend',
    },
    {
        Group: '',
        Description: 'Ex-Distribution',
        added: 'FIX.4.2',
        Value: 'B',
        Sort: 2,
        Tag: 292,
        SymbolicName: 'ExDistribution',
    },
    {
        Group: '',
        Description: 'Ex-Rights',
        added: 'FIX.4.2',
        Value: 'C',
        Sort: 3,
        Tag: 292,
        SymbolicName: 'ExRights',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 4,
        Tag: 292,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Ex-Interest',
        added: 'FIX.4.2',
        Value: 'E',
        Sort: 5,
        Tag: 292,
        SymbolicName: 'ExInterest',
    },
    {
        Group: '',
        Description: 'Cash Dividend',
        added: 'FIX.4.4',
        Value: 'F',
        Sort: 6,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'CashDividend',
    },
    {
        Group: '',
        Description: 'Stock Dividend',
        added: 'FIX.4.4',
        Value: 'G',
        Sort: 7,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'StockDividend',
    },
    {
        Group: '',
        Description: 'Non-Integer Stock Split',
        added: 'FIX.4.4',
        Value: 'H',
        Sort: 8,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'NonIntegerStockSplit',
    },
    {
        Group: '',
        Description: 'Reverse Stock Split',
        added: 'FIX.4.4',
        Value: 'I',
        Sort: 9,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'ReverseStockSplit',
    },
    {
        Group: '',
        Description: 'Standard-Integer Stock Split',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 10,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'StandardIntegerStockSplit',
    },
    {
        Group: '',
        Description: 'Position Consolidation',
        added: 'FIX.4.4',
        Value: 'K',
        Sort: 11,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'PositionConsolidation',
    },
    {
        Group: '',
        Description: 'Liquidation Reorganization',
        added: 'FIX.4.4',
        Value: 'L',
        Sort: 12,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'LiquidationReorganization',
    },
    {
        Group: '',
        Description: 'Merger Reorganization',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 13,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'MergerReorganization',
    },
    {
        Group: '',
        Description: 'Rights Offering',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 14,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'RightsOffering',
    },
    {
        Group: '',
        Description: 'Shareholder Meeting',
        added: 'FIX.4.4',
        Value: 'O',
        Sort: 15,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'ShareholderMeeting',
    },
    {
        Group: '',
        Description: 'Spinoff',
        added: 'FIX.4.4',
        Value: 'P',
        Sort: 16,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'Spinoff',
    },
    {
        Group: '',
        Description: 'Tender Offer',
        added: 'FIX.4.4',
        Value: 'Q',
        Sort: 17,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'TenderOffer',
    },
    {
        Group: '',
        Description: 'Warrant',
        added: 'FIX.4.4',
        Value: 'R',
        Sort: 18,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'Warrant',
    },
    {
        Group: '',
        Description: 'Special Action',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 19,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'SpecialAction',
    },
    {
        Group: '',
        Description: 'Symbol Conversion',
        added: 'FIX.4.4',
        Value: 'T',
        Sort: 20,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'SymbolConversion',
    },
    {
        Group: '',
        Description: 'CUSIP / Name Change',
        added: 'FIX.4.4',
        Value: 'U',
        Sort: 21,
        addedEP: 4,
        Tag: 292,
        SymbolicName: 'CUSIP',
    },
    {
        Group: '',
        Description: 'Leap Rollover',
        added: 'FIX.4.4',
        Value: 'V',
        Sort: 22,
        addedEP: 8,
        Tag: 292,
        SymbolicName: 'LeapRollover',
    },
    {
        Group: '',
        Description: 'Succession Event',
        added: 'FIX.5.0',
        Value: 'W',
        Sort: 99,
        addedEP: 42,
        Tag: 292,
        SymbolicName: 'SuccessionEvent',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 0,
        Tag: 297,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Cancel for Symbol(s)',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        Tag: 297,
        SymbolicName: 'CancelForSymbol',
    },
    {
        Group: '',
        Description: 'Canceled for Security Type(s)',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        Tag: 297,
        SymbolicName: 'CanceledForSecurityType',
    },
    {
        Group: '',
        Description: 'Canceled for Underlying',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        Tag: 297,
        SymbolicName: 'CanceledForUnderlying',
    },
    {
        Group: '',
        Description: 'Canceled All',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        Tag: 297,
        SymbolicName: 'CanceledAll',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 297,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Removed from Market',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 297,
        SymbolicName: 'RemovedFromMarket',
    },
    {
        Group: '',
        Description: 'Expired',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 297,
        SymbolicName: 'Expired',
    },
    {
        Group: '',
        Description: 'Query',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 297,
        SymbolicName: 'Query',
    },
    {
        Group: '',
        Description: 'Quote Not Found',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 297,
        SymbolicName: 'QuoteNotFound',
    },
    {
        Group: '',
        Description: 'Pending',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 297,
        SymbolicName: 'Pending',
    },
    {
        Group: '',
        Description: 'Pass',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        Tag: 297,
        SymbolicName: 'Pass',
    },
    {
        Group: '',
        Description: 'Locked Market Warning',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        Tag: 297,
        SymbolicName: 'LockedMarketWarning',
    },
    {
        Group: '',
        Description: 'Cross Market Warning',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        Tag: 297,
        SymbolicName: 'CrossMarketWarning',
    },
    {
        Group: '',
        Description: 'Canceled Due To Lock Market',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 14,
        Tag: 297,
        SymbolicName: 'CanceledDueToLockMarket',
    },
    {
        Group: '',
        Description: 'Canceled Due To Cross Market',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 15,
        Tag: 297,
        SymbolicName: 'CanceledDueToCrossMarket',
    },
    {
        Group: '',
        Description: 'Active',
        added: 'FIX.5.0',
        Value: '16',
        Sort: 17,
        addedEP: 45,
        Tag: 297,
        SymbolicName: 'Active',
    },
    {
        Group: '',
        Description: 'Canceled',
        added: 'FIX.5.0',
        Value: '17',
        Sort: 18,
        addedEP: 45,
        Tag: 297,
        SymbolicName: 'Canceled',
    },
    {
        Group: '',
        Description: 'Unsolicited Quote Replenishment',
        added: 'FIX.5.0',
        Value: '18',
        Sort: 19,
        addedEP: 45,
        Tag: 297,
        SymbolicName: 'UnsolicitedQuoteReplenishment',
    },
    {
        Group: '',
        Description: 'Pending End Trade',
        added: 'FIX.5.0',
        Value: '19',
        Sort: 20,
        addedEP: 68,
        Tag: 297,
        SymbolicName: 'PendingEndTrade',
    },
    {
        Group: '',
        Description: 'Too Late to End',
        added: 'FIX.5.0',
        Value: '20',
        Sort: 21,
        addedEP: 68,
        Tag: 297,
        SymbolicName: 'TooLateToEnd',
    },
    {
        Group: '',
        Description: 'Cancel for one or more securities',
        added: 'FIX.4.2',
        updatedEP: 78,
        Value: '1',
        Sort: 1,
        Tag: 298,
        SymbolicName: 'CancelForOneOrMoreSecurities',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Cancel for Security Type(s)',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 298,
        SymbolicName: 'CancelForSecurityType',
    },
    {
        Group: '',
        Description: 'Cancel for underlying security',
        added: 'FIX.4.2',
        updatedEP: 78,
        Value: '3',
        Sort: 3,
        Tag: 298,
        SymbolicName: 'CancelForUnderlyingSecurity',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Cancel All Quotes',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 298,
        SymbolicName: 'CancelAllQuotes',
    },
    {
        Group: '',
        Description: 'Cancel quote specified in QuoteID',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: 21,
        Tag: 298,
        SymbolicName: 'CancelQuoteSpecifiedInQuoteID',
    },
    {
        Group: '',
        Description: 'Unknown Symbol (security)',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 300,
        SymbolicName: 'UnknownSymbol',
    },
    {
        Group: '',
        Description: 'Exchange (Security) closed',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 300,
        SymbolicName: 'Exchange',
    },
    {
        Group: '',
        Description: 'Quote Request exceeds limit',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 300,
        SymbolicName: 'QuoteRequestExceedsLimit',
    },
    {
        Group: '',
        Description: 'Too late to enter',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 300,
        SymbolicName: 'TooLateToEnter',
    },
    {
        Group: '',
        Description: 'Unknown Quote',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 300,
        SymbolicName: 'UnknownQuote',
    },
    {
        Group: '',
        Description: 'Duplicate Quote',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 6,
        Tag: 300,
        SymbolicName: 'DuplicateQuote',
    },
    {
        Group: '',
        Description: 'Invalid bid/ask spread',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 7,
        Tag: 300,
        SymbolicName: 'InvalidBid',
    },
    {
        Group: '',
        Description: 'Invalid price',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 8,
        Tag: 300,
        SymbolicName: 'InvalidPrice',
    },
    {
        Group: '',
        Description: 'Not authorized to quote security',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 9,
        Tag: 300,
        SymbolicName: 'NotAuthorizedToQuoteSecurity',
    },
    {
        Group: '',
        Description: 'Price exceeds current price band',
        added: 'FIX.5.0',
        Value: '10',
        Sort: 10,
        addedEP: 43,
        Tag: 300,
        SymbolicName: 'PriceExceedsCurrentPriceBand',
    },
    {
        Group: '',
        Description: 'Quote Locked - Unable to Update/Cancel',
        added: 'FIX.5.0',
        Value: '11',
        Sort: 11,
        addedEP: 45,
        Tag: 300,
        SymbolicName: 'QuoteLocked',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 300,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'No Acknowledgement',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 301,
        SymbolicName: 'NoAcknowledgement',
    },
    {
        Group: '',
        Description: 'Acknowledge only negative or erroneous quotes',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 301,
        SymbolicName: 'AcknowledgeOnlyNegativeOrErroneousQuotes',
    },
    {
        Group: '',
        Description: 'Acknowledge each quote message',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '2',
        Sort: 3,
        Tag: 301,
        SymbolicName: 'AcknowledgeEachQuoteMessage',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Summary Acknowledgement',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 45,
        Tag: 301,
        SymbolicName: 'SummaryAcknowledgement',
    },
    {
        Group: '',
        Description: 'Manual',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 303,
        SymbolicName: 'Manual',
    },
    {
        Group: '',
        Description: 'Automatic',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 303,
        SymbolicName: 'Automatic',
    },
    {
        Group: '',
        Description: 'Request Security identity and specifications',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 321,
        SymbolicName: 'RequestSecurityIdentityAndSpecifications',
    },
    {
        Group: '',
        Description: 'Request Security identity for the specifications provided (name of the security is not supplied)',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 321,
        SymbolicName: 'RequestSecurityIdentityForSpecifications',
    },
    {
        Group: '',
        Description: 'Request List Security Types',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0SP1',
        Value: '2',
        Sort: 3,
        Tag: 321,
        SymbolicName: 'RequestListSecurityTypes',
    },
    {
        Group: '',
        Description:
            'Request List Securities (can be qualified with Symbol, SecurityType, TradingSessionID, SecurityExchange. If provided then only list Securities for the specific type.)',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0SP1',
        Value: '3',
        Sort: 4,
        Tag: 321,
        SymbolicName: 'RequestListSecurities',
    },
    {
        Group: '',
        Description: 'Symbol',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'Symbol',
    },
    {
        Group: '',
        Description: 'SecurityType and or CFICode',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'SecurityTypeAndOrCFICode',
    },
    {
        Group: '',
        Description: 'Product',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 7,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'Product',
    },
    {
        Group: '',
        Description: 'TradingSessionID',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 8,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'TradingSessionID',
    },
    {
        Group: '',
        Description: 'All Securities',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'AllSecurities',
    },
    {
        Group: '',
        Description: 'MarketID or MarketID + MarketSegmentID',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 10,
        addedEP: 52,
        Tag: 321,
        SymbolicName: 'MarketIDOrMarketID',
    },
    {
        Group: '',
        Description: 'Accept security proposal as-is',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 323,
        SymbolicName: 'AcceptAsIs',
    },
    {
        Group: '',
        Description: 'Accept security proposal with revisions as indicated in the message',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 323,
        SymbolicName: 'AcceptWithRevisions',
    },
    {
        Group: '',
        Description: 'List of security types returned per request',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        Tag: 323,
        SymbolicName: 'ListOfSecurityTypesReturnedPerRequest',
    },
    {
        Group: '',
        Description: 'List of securities returned per request',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 323,
        SymbolicName: 'ListOfSecuritiesReturnedPerRequest',
    },
    {
        Group: '',
        Description: 'Reject security proposal',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 323,
        SymbolicName: 'RejectSecurityProposal',
    },
    {
        Group: '',
        Description: 'Cannot match selection criteria',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 6,
        Tag: 323,
        SymbolicName: 'CannotMatchSelectionCriteria',
    },
    {
        Group: '',
        Description: 'Message is being sent as a result of a prior request',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 1,
        Tag: 325,
        SymbolicName: 'MessageIsBeingSentAsAResultOfAPriorRequest',
    },
    {
        Group: '',
        Description: 'Message is being sent unsolicited',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: 'Y',
        Sort: 2,
        Tag: 325,
        SymbolicName: 'MessageIsBeingSentUnsolicited',
        updated: 'FIX.5.0SP1',
    },
];

const batch3: ISpecEnums[] = [
    {
        Group: '',
        Description: 'Opening delay',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 0,
        Tag: 326,
        SymbolicName: 'OpeningDelay',
    },
    {
        Group: '',
        Description: 'Trading halt',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 1,
        Tag: 326,
        SymbolicName: 'TradingHalt',
    },
    {
        Group: '',
        Description: 'Resume',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 2,
        Tag: 326,
        SymbolicName: 'Resume',
    },
    {
        Group: '',
        Description: 'No Open / No Resume',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 3,
        Tag: 326,
        SymbolicName: 'NoOpen',
    },
    {
        Group: '',
        Description: 'Price indication',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 4,
        Tag: 326,
        SymbolicName: 'PriceIndication',
    },
    {
        Group: '',
        Description: 'Trading Range Indication',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 5,
        Tag: 326,
        SymbolicName: 'TradingRangeIndication',
    },
    {
        Group: '',
        Description: 'Market Imbalance Buy',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 6,
        Tag: 326,
        SymbolicName: 'MarketImbalanceBuy',
    },
    {
        Group: '',
        Description: 'Market Imbalance Sell',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 7,
        Tag: 326,
        SymbolicName: 'MarketImbalanceSell',
    },
    {
        Group: '',
        Description: 'Market on Close Imbalance Buy',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 8,
        Tag: 326,
        SymbolicName: 'MarketOnCloseImbalanceBuy',
    },
    {
        Group: '',
        Description: 'Market on Close Imbalance Sell',
        added: 'FIX.4.2',
        Value: '10',
        Sort: 9,
        Tag: 326,
        SymbolicName: 'MarketOnCloseImbalanceSell',
    },
    {
        Group: '',
        Description: 'No Market Imbalance',
        added: 'FIX.4.2',
        Value: '12',
        Sort: 11,
        Tag: 326,
        SymbolicName: 'NoMarketImbalance',
    },
    {
        Group: '',
        Description: 'No Market on Close Imbalance',
        added: 'FIX.4.2',
        Value: '13',
        Sort: 12,
        Tag: 326,
        SymbolicName: 'NoMarketOnCloseImbalance',
    },
    {
        Group: '',
        Description: 'ITS Pre-opening',
        added: 'FIX.4.2',
        Value: '14',
        Sort: 13,
        Tag: 326,
        SymbolicName: 'ITSPreOpening',
    },
    {
        Group: '',
        Description: 'New Price Indication',
        added: 'FIX.4.2',
        Value: '15',
        Sort: 14,
        Tag: 326,
        SymbolicName: 'NewPriceIndication',
    },
    {
        Group: '',
        Description: 'Trade Dissemination Time',
        added: 'FIX.4.2',
        Value: '16',
        Sort: 15,
        Tag: 326,
        SymbolicName: 'TradeDisseminationTime',
    },
    {
        Group: '',
        Description: 'Ready to trade (start of session)',
        added: 'FIX.4.2',
        Value: '17',
        Sort: 16,
        Tag: 326,
        SymbolicName: 'ReadyToTrade',
    },
    {
        Group: '',
        Description: 'Not available for trading (end of session)',
        added: 'FIX.4.2',
        Value: '18',
        Sort: 17,
        Tag: 326,
        SymbolicName: 'NotAvailableForTrading',
    },
    {
        Group: '',
        Description: 'Not traded on this market',
        added: 'FIX.4.2',
        Value: '19',
        Sort: 18,
        Tag: 326,
        SymbolicName: 'NotTradedOnThisMarket',
    },
    {
        Group: '',
        Description: 'Unknown or Invalid',
        added: 'FIX.4.2',
        Value: '20',
        Sort: 19,
        Tag: 326,
        SymbolicName: 'UnknownOrInvalid',
    },
    {
        Group: '',
        Description: 'Pre-open',
        added: 'FIX.4.3',
        Value: '21',
        Sort: 20,
        Tag: 326,
        SymbolicName: 'PreOpen',
    },
    {
        Group: '',
        Description: 'Opening Rotation',
        added: 'FIX.4.3',
        Value: '22',
        Sort: 21,
        Tag: 326,
        SymbolicName: 'OpeningRotation',
    },
    {
        Group: '',
        Description: 'Fast Market',
        added: 'FIX.4.3',
        Value: '23',
        Sort: 22,
        Tag: 326,
        SymbolicName: 'FastMarket',
    },
    {
        Group: '',
        Description: 'Pre-Cross - system is in a pre-cross state allowing market to respond to either side of cross',
        added: 'FIX.5.0',
        Value: '24',
        Sort: 98,
        addedEP: 42,
        Tag: 326,
        SymbolicName: 'PreCross',
    },
    {
        Group: '',
        Description:
            'Cross - system has crossed a percentage of the orders and allows market to respond prior to crossing remaining portion',
        added: 'FIX.5.0',
        Value: '25',
        Sort: 99,
        addedEP: 42,
        Tag: 326,
        SymbolicName: 'Cross',
    },
    {
        Group: '',
        Description: 'Halt was not related to a halt of the common stock',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 1,
        Tag: 328,
        SymbolicName: 'HaltWasNotRelatedToAHaltOfTheCommonStock',
    },
    {
        Group: '',
        Description: 'Halt was due to common stock being halted',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: 'Y',
        Sort: 2,
        Tag: 328,
        SymbolicName: 'HaltWasDueToCommonStockBeingHalted',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Halt was not related to a halt of the related security',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 1,
        Tag: 329,
        SymbolicName: 'NotRelatedToSecurityHalt',
    },
    {
        Group: '',
        Description: 'Halt was due to related security being halted',
        added: 'FIX.4.2',
        Value: 'Y',
        Sort: 2,
        Tag: 329,
        SymbolicName: 'RelatedToSecurityHalt',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 334,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Error',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 334,
        SymbolicName: 'Error',
    },
    {
        Group: '',
        Description: 'Correction',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 334,
        SymbolicName: 'Correction',
    },
    {
        Group: '',
        Description: 'Day',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'Day',
    },
    {
        Group: '',
        Description: 'HalfDay',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'HalfDay',
    },
    {
        Group: '',
        Description: 'Morning',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'Morning',
    },
    {
        Group: '',
        Description: 'Afternoon',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'Afternoon',
    },
    {
        Group: '',
        Description: 'Evening',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 5,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'Evening',
    },
    {
        Group: '',
        Description: 'After-hours',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 6,
        addedEP: 58,
        Tag: 336,
        SymbolicName: 'AfterHours',
    },
    {
        Group: '',
        Description: 'Electronic',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 338,
        SymbolicName: 'Electronic',
    },
    {
        Group: '',
        Description: 'Open Outcry',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 338,
        SymbolicName: 'OpenOutcry',
    },
    {
        Group: '',
        Description: 'Two Party',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 338,
        SymbolicName: 'TwoParty',
    },
    {
        Group: '',
        Description: 'Testing',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 339,
        SymbolicName: 'Testing',
    },
    {
        Group: '',
        Description: 'Simulated',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 339,
        SymbolicName: 'Simulated',
    },
    {
        Group: '',
        Description: 'Production',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 339,
        SymbolicName: 'Production',
    },
    {
        Group: '',
        Description: 'Unknown',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 340,
        SymbolicName: 'Unknown',
    },
    {
        Group: '',
        Description: 'Halted',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 340,
        SymbolicName: 'Halted',
    },
    {
        Group: '',
        Description: 'Open',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 340,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Closed',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 340,
        SymbolicName: 'Closed',
    },
    {
        Group: '',
        Description: 'Pre-Open',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 340,
        SymbolicName: 'PreOpen',
    },
    {
        Group: '',
        Description: 'Pre-Close',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 340,
        SymbolicName: 'PreClose',
    },
    {
        Group: '',
        Description: 'Request Rejected',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 7,
        Tag: 340,
        SymbolicName: 'RequestRejected',
    },
    {
        Group: '',
        Description: 'Invalid Tag Number',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 0,
        Tag: 373,
        SymbolicName: 'InvalidTagNumber',
    },
    {
        Group: '',
        Description: 'Required Tag Missing',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 373,
        SymbolicName: 'RequiredTagMissing',
    },
    {
        Group: '',
        Description: 'Tag not defined for this message type',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 373,
        SymbolicName: 'TagNotDefinedForThisMessageType',
    },
    {
        Group: '',
        Description: 'Undefined tag',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 373,
        SymbolicName: 'UndefinedTag',
    },
    {
        Group: '',
        Description: 'Tag specified without a value',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 373,
        SymbolicName: 'TagSpecifiedWithoutAValue',
    },
    {
        Group: '',
        Description: 'Value is incorrect (out of range) for this tag',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 373,
        SymbolicName: 'ValueIsIncorrect',
    },
    {
        Group: '',
        Description: 'Incorrect data format for value',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 6,
        Tag: 373,
        SymbolicName: 'IncorrectDataFormatForValue',
    },
    {
        Group: '',
        Description: 'Decryption problem',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 7,
        Tag: 373,
        SymbolicName: 'DecryptionProblem',
    },
    {
        Group: '',
        Description: 'Signature problem',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 8,
        Tag: 373,
        SymbolicName: 'SignatureProblem',
    },
    {
        Group: '',
        Description: 'CompID problem',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 9,
        Tag: 373,
        SymbolicName: 'CompIDProblem',
    },
    {
        Group: '',
        Description: 'SendingTime Accuracy Problem',
        added: 'FIX.4.2',
        Value: '10',
        Sort: 10,
        Tag: 373,
        SymbolicName: 'SendingTimeAccuracyProblem',
    },
    {
        Group: '',
        Description: 'Invalid MsgType',
        added: 'FIX.4.2',
        Value: '11',
        Sort: 11,
        Tag: 373,
        SymbolicName: 'InvalidMsgType',
    },
    {
        Group: '',
        Description: 'XML Validation Error',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 373,
        SymbolicName: 'XMLValidationError',
    },
    {
        Group: '',
        Description: 'Tag appears more than once',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 373,
        SymbolicName: 'TagAppearsMoreThanOnce',
    },
    {
        Group: '',
        Description: 'Tag specified out of required order',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 373,
        SymbolicName: 'TagSpecifiedOutOfRequiredOrder',
    },
    {
        Group: '',
        Description: 'Repeating group fields out of order',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 373,
        SymbolicName: 'RepeatingGroupFieldsOutOfOrder',
    },
    {
        Group: '',
        Description: 'Incorrect NumInGroup count for repeating group',
        added: 'FIX.4.3',
        Value: '16',
        Sort: 16,
        Tag: 373,
        SymbolicName: 'IncorrectNumInGroupCountForRepeatingGroup',
    },
    {
        Group: '',
        Description: 'Non "Data" value includes field delimiter (<SOH> character)',
        added: 'FIX.4.3',
        Value: '17',
        Sort: 17,
        Tag: 373,
        SymbolicName: 'Non',
    },
    {
        Group: '',
        Description: 'Invalid/Unsupported Application Version',
        added: 'FIX.5.0',
        Value: '18',
        Sort: 19,
        addedEP: 56,
        Tag: 373,
        SymbolicName: 'Invalid',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 373,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.2',
        Value: 'C',
        Sort: 1,
        Tag: 374,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 2,
        Tag: 374,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Was not solicited',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 1,
        Tag: 377,
        SymbolicName: 'WasNotSolicited',
    },
    {
        Group: '',
        Description: 'Was solicited',
        added: 'FIX.4.2',
        Value: 'Y',
        Sort: 2,
        Tag: 377,
        SymbolicName: 'WasSolicited',
    },
    {
        Group: '',
        Description: 'GT corporate action',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 0,
        Tag: 378,
        SymbolicName: 'GTCorporateAction',
    },
    {
        Group: '',
        Description: 'GT renewal / restatement (no corporate action)',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 378,
        SymbolicName: 'GTRenewal',
    },
    {
        Group: '',
        Description: 'Verbal change',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 378,
        SymbolicName: 'VerbalChange',
    },
    {
        Group: '',
        Description: 'Repricing of order',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 378,
        SymbolicName: 'RepricingOfOrder',
    },
    {
        Group: '',
        Description: 'Broker option',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 378,
        SymbolicName: 'BrokerOption',
    },
    {
        Group: '',
        Description: 'Partial decline of OrderQty (e.g. exchange initiated partial cancel)',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 5,
        Tag: 378,
        SymbolicName: 'PartialDeclineOfOrderQty',
    },
    {
        Group: '',
        Description: 'Cancel on Trading Halt',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 378,
        SymbolicName: 'CancelOnTradingHalt',
    },
    {
        Group: '',
        Description: 'Cancel on System Failure',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 378,
        SymbolicName: 'CancelOnSystemFailure',
    },
    {
        Group: '',
        Description: 'Market (Exchange) option',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 378,
        SymbolicName: 'Market',
    },
    {
        Group: '',
        Description: 'Canceled, not best',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        Tag: 378,
        SymbolicName: 'Canceled',
    },
    {
        Group: '',
        Description: 'Warehouse Recap',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 10,
        Tag: 378,
        SymbolicName: 'WarehouseRecap',
    },
    {
        Group: '',
        Description: 'Peg Refresh',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        addedEP: 22,
        Tag: 378,
        SymbolicName: 'PegRefresh',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 378,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 380,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Unknown ID',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 380,
        SymbolicName: 'UnknownID',
    },
    {
        Group: '',
        Description: 'Unknown Security',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 380,
        SymbolicName: 'UnknownSecurity',
    },
    {
        Group: '',
        Description: 'Unsupported Message Type',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '3',
        Sort: 4,
        Tag: 380,
        SymbolicName: 'UnsupportedMessageType',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Application not available',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 380,
        SymbolicName: 'ApplicationNotAvailable',
    },
    {
        Group: '',
        Description: 'Conditionally required field missing',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 380,
        SymbolicName: 'ConditionallyRequiredFieldMissing',
    },
    {
        Group: '',
        Description: 'Not Authorized',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 7,
        Tag: 380,
        SymbolicName: 'NotAuthorized',
    },
    {
        Group: '',
        Description: 'DeliverTo firm not available at this time',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 8,
        Tag: 380,
        SymbolicName: 'DeliverToFirmNotAvailableAtThisTime',
    },
    {
        Group: '',
        Description: 'Invalid price increment',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 9,
        addedEP: 6,
        Tag: 380,
        SymbolicName: 'InvalidPriceIncrement',
    },
    {
        Group: '',
        Description: 'Receive',
        added: 'FIX.4.2',
        Value: 'R',
        Sort: 1,
        Tag: 385,
        SymbolicName: 'Receive',
    },
    {
        Group: '',
        Description: 'Send',
        added: 'FIX.4.2',
        Value: 'S',
        Sort: 2,
        Tag: 385,
        SymbolicName: 'Send',
    },
    {
        Group: '',
        Description: 'Related to displayed price',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 388,
        SymbolicName: 'RelatedToDisplayedPrice',
    },
    {
        Group: '',
        Description: 'Related to market price',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 388,
        SymbolicName: 'RelatedToMarketPrice',
    },
    {
        Group: '',
        Description: 'Related to primary price',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 388,
        SymbolicName: 'RelatedToPrimaryPrice',
    },
    {
        Group: '',
        Description: 'Related to local primary price',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 4,
        Tag: 388,
        SymbolicName: 'RelatedToLocalPrimaryPrice',
    },
    {
        Group: '',
        Description: 'Related to midpoint price',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 5,
        Tag: 388,
        SymbolicName: 'RelatedToMidpointPrice',
    },
    {
        Group: '',
        Description: 'Related to last trade price',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 6,
        Tag: 388,
        SymbolicName: 'RelatedToLastTradePrice',
    },
    {
        Group: '',
        Description: 'Related to VWAP',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        Tag: 388,
        SymbolicName: 'RelatedToVWAP',
    },
    {
        Group: '',
        Description: 'Average Price Guarantee',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        addedEP: 22,
        Tag: 388,
        SymbolicName: 'AveragePriceGuarantee',
    },
    {
        Group: '',
        Description: '"Non Disclosed" style (e.g. US/European)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 394,
        SymbolicName: 'NonDisclosed',
    },
    {
        Group: '',
        Description: '"Disclosed" sytle (e.g. Japanese)',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 394,
        SymbolicName: 'Disclosed',
    },
    {
        Group: '',
        Description: 'No bidding process',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 394,
        SymbolicName: 'NoBiddingProcess',
    },
    {
        Group: '',
        Description: 'Sector',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 399,
        SymbolicName: 'Sector',
    },
    {
        Group: '',
        Description: 'Country',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 399,
        SymbolicName: 'Country',
    },
    {
        Group: '',
        Description: 'Index',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 399,
        SymbolicName: 'Index',
    },
    {
        Group: '',
        Description: 'Side Value 1',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 401,
        SymbolicName: 'SideValue1',
    },
    {
        Group: '',
        Description: 'Side Value 2',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 401,
        SymbolicName: 'SideValue2',
    },
    {
        Group: '',
        Description: '5-day moving average',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 409,
        SymbolicName: 'FiveDayMovingAverage',
    },
    {
        Group: '',
        Description: '20-day moving average',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 409,
        SymbolicName: 'TwentyDayMovingAverage',
    },
    {
        Group: '',
        Description: 'Normal market size',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 409,
        SymbolicName: 'NormalMarketSize',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 409,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'False',
        added: 'FIX.4.2',
        Value: 'N',
        Sort: 1,
        Tag: 411,
        SymbolicName: 'False',
    },
    {
        Group: '',
        Description: 'True',
        added: 'FIX.4.2',
        Value: 'Y',
        Sort: 2,
        Tag: 411,
        SymbolicName: 'True',
    },
    {
        Group: '',
        Description:
            'Buy-side explicitly requests status using Statue Request (default), the sell-side firm can, however, send a DONE status List STatus Response in an unsolicited fashion',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 414,
        SymbolicName: 'BuySideRequests',
    },
    {
        Group: '',
        Description:
            'Sell-side periodically sends status using List Status. Period optionally specified in ProgressPeriod.',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 414,
        SymbolicName: 'SellSideSends',
    },
    {
        Group: '',
        Description: 'Real-time execution reports (to be discourage)',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 414,
        SymbolicName: 'RealTimeExecutionReports',
    },
    {
        Group: '',
        Description: 'Net',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 416,
        SymbolicName: 'Net',
    },
    {
        Group: '',
        Description: 'Gross',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 416,
        SymbolicName: 'Gross',
    },
    {
        Group: '',
        Description: 'Agency',
        added: 'FIX.4.2',
        Value: 'A',
        Sort: 1,
        Tag: 418,
        SymbolicName: 'Agency',
    },
    {
        Group: '',
        Description: 'VWAP Guarantee',
        added: 'FIX.4.2',
        Value: 'G',
        Sort: 2,
        Tag: 418,
        SymbolicName: 'VWAPGuarantee',
    },
    {
        Group: '',
        Description: 'Guaranteed Close',
        added: 'FIX.4.2',
        Value: 'J',
        Sort: 3,
        Tag: 418,
        SymbolicName: 'GuaranteedClose',
    },
    {
        Group: '',
        Description: 'Risk Trade',
        added: 'FIX.4.2',
        Value: 'R',
        Sort: 4,
        Tag: 418,
        SymbolicName: 'RiskTrade',
    },
    {
        Group: '',
        Description: 'Closing price at morning session',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 1,
        Tag: 419,
        SymbolicName: 'ClosingPriceAtMorningSession',
    },
    {
        Group: '',
        Description: 'Closing price',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 2,
        Tag: 419,
        SymbolicName: 'ClosingPrice',
    },
    {
        Group: '',
        Description: 'Current price',
        added: 'FIX.4.2',
        Value: '4',
        Sort: 3,
        Tag: 419,
        SymbolicName: 'CurrentPrice',
    },
    {
        Group: '',
        Description: 'SQ',
        added: 'FIX.4.2',
        Value: '5',
        Sort: 4,
        Tag: 419,
        SymbolicName: 'SQ',
    },
    {
        Group: '',
        Description: 'VWAP through a day',
        added: 'FIX.4.2',
        Value: '6',
        Sort: 5,
        Tag: 419,
        SymbolicName: 'VWAPThroughADay',
    },
    {
        Group: '',
        Description: 'VWAP through a morning session',
        added: 'FIX.4.2',
        Value: '7',
        Sort: 6,
        Tag: 419,
        SymbolicName: 'VWAPThroughAMorningSession',
    },
    {
        Group: '',
        Description: 'VWAP through an afternoon session',
        added: 'FIX.4.2',
        Value: '8',
        Sort: 7,
        Tag: 419,
        SymbolicName: 'VWAPThroughAnAfternoonSession',
    },
    {
        Group: '',
        Description: 'VWAP through a day except "YORI" (an opening auction)',
        added: 'FIX.4.2',
        Value: '9',
        Sort: 8,
        Tag: 419,
        SymbolicName: 'VWAPThroughADayExcept',
    },
    {
        Group: '',
        Description: 'VWAP through a morning session except "YORI" (an opening auction)',
        added: 'FIX.4.2',
        Value: 'A',
        Sort: 9,
        Tag: 419,
        SymbolicName: 'VWAPThroughAMorningSessionExcept',
    },
    {
        Group: '',
        Description: 'VWAP through an afternoon session except "YORI" (an opening auction)',
        added: 'FIX.4.2',
        Value: 'B',
        Sort: 10,
        Tag: 419,
        SymbolicName: 'VWAPThroughAnAfternoonSessionExcept',
    },
    {
        Group: '',
        Description: 'Strike',
        added: 'FIX.4.2',
        Value: 'C',
        Sort: 11,
        Tag: 419,
        SymbolicName: 'Strike',
    },
    {
        Group: '',
        Description: 'Open',
        added: 'FIX.4.2',
        Value: 'D',
        Sort: 12,
        Tag: 419,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Others',
        added: 'FIX.4.2',
        Value: 'Z',
        Sort: 30,
        Tag: 419,
        SymbolicName: 'Others',
    },
    {
        Group: '',
        Description: 'Percentage (i.e. percent of par) (often called "dollar price" for fixed income)',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 0,
        Tag: 423,
        SymbolicName: 'Percentage',
    },
    {
        Group: '',
        Description: 'Per unit (i.e. per share or contract)',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 1,
        Tag: 423,
        SymbolicName: 'PerUnit',
    },
    {
        Group: '',
        Description: 'Fixed amount (absolute value)',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 2,
        Tag: 423,
        SymbolicName: 'FixedAmount',
    },
    {
        Group: '',
        Description: 'Discount - percentage points below par',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 3,
        Tag: 423,
        SymbolicName: 'Discount',
    },
    {
        Group: '',
        Description: 'Premium - percentage points over par',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 4,
        Tag: 423,
        SymbolicName: 'Premium',
    },
    {
        Group: '',
        Description: 'Spread (basis points spread)',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 5,
        Tag: 423,
        SymbolicName: 'Spread',
    },
    {
        Group: '',
        Description: 'TED Price',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 6,
        Tag: 423,
        SymbolicName: 'TEDPrice',
    },
    {
        Group: '',
        Description: 'TED Yield',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 7,
        Tag: 423,
        SymbolicName: 'TEDYield',
    },
    {
        Group: '',
        Description: 'Yield',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 423,
        SymbolicName: 'Yield',
    },
    {
        Group: '',
        Description: 'Fixed cabinet trade price (primarily for listed futures and options)',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 423,
        SymbolicName: 'FixedCabinetTradePrice',
    },
    {
        Group: '',
        Description: 'Variable cabinet trade price (primarily for listed futures and options)',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 10,
        Tag: 423,
        SymbolicName: 'VariableCabinetTradePrice',
    },
    {
        Group: '',
        Description: 'Product ticks in halfs',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 12,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInHalfs',
    },
    {
        Group: '',
        Description: 'Product ticks in fourths',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 13,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInFourths',
    },
    {
        Group: '',
        Description: 'Product ticks in eights',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 14,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInEights',
    },
    {
        Group: '',
        Description: 'Product ticks in sixteenths',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 15,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInSixteenths',
    },
    {
        Group: '',
        Description: 'Product ticks in thirty-seconds',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 16,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInThirtySeconds',
    },
    {
        Group: '',
        Description: 'Product ticks in sixty-forths',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 17,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInSixtyForths',
    },
    {
        Group: '',
        Description: 'Product ticks in one-twenty-eights',
        added: 'FIX.4.4',
        Value: '19',
        Sort: 18,
        addedEP: 19,
        Tag: 423,
        SymbolicName: 'ProductTicksInOneTwentyEights',
    },
    {
        Group: '',
        Description: 'Book out all trades on day of execution',
        issue: 'SPEC-398',
        added: 'FIX.4.2',
        Value: '0',
        Sort: 1,
        Tag: 427,
        SymbolicName: 'BookOutAllTradesOnDayOfExecution',
    },
    {
        Group: '',
        Description: 'Accumulate executions until order is filled or expires',
        issue: 'SPEC-398',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 2,
        Tag: 427,
        SymbolicName: 'AccumulateUntilFilledOrExpired',
    },
    {
        Group: '',
        Description: 'Accumulate until verbally notified otherwise',
        issue: 'SPEC-398',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 3,
        Tag: 427,
        SymbolicName: 'AccumulateUntilVerballyNotifiedOtherwise',
    },
    {
        Group: '',
        Description: 'Ack',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 429,
        SymbolicName: 'Ack',
    },
    {
        Group: '',
        Description: 'Response',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 429,
        SymbolicName: 'Response',
    },
    {
        Group: '',
        Description: 'Timed',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 429,
        SymbolicName: 'Timed',
    },
    {
        Group: '',
        Description: 'Exec Started',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 429,
        SymbolicName: 'ExecStarted',
    },
    {
        Group: '',
        Description: 'All Done',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 429,
        SymbolicName: 'AllDone',
    },
    {
        Group: '',
        Description: 'Alert',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 429,
        SymbolicName: 'Alert',
    },
    {
        Group: '',
        Description: 'Net',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 430,
        SymbolicName: 'Net',
    },
    {
        Group: '',
        Description: 'Gross',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 430,
        SymbolicName: 'Gross',
    },
    {
        Group: '',
        Description: 'In bidding process',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 431,
        SymbolicName: 'InBiddingProcess',
    },
    {
        Group: '',
        Description: 'Received for execution',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 431,
        SymbolicName: 'ReceivedForExecution',
    },
    {
        Group: '',
        Description: 'Executing',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 431,
        SymbolicName: 'Executing',
    },
    {
        Group: '',
        Description: 'Cancelling',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 431,
        SymbolicName: 'Cancelling',
    },
    {
        Group: '',
        Description: 'Alert',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 431,
        SymbolicName: 'Alert',
    },
    {
        Group: '',
        Description: 'All Done',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 431,
        SymbolicName: 'AllDone',
    },
    {
        Group: '',
        Description: 'Reject',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 431,
        SymbolicName: 'Reject',
    },
    {
        Group: '',
        Description: 'Immediate',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 433,
        SymbolicName: 'Immediate',
    },
    {
        Group: '',
        Description:
            'Wait for Execut Instruction (i.e. a List Execut message or phone call before proceeding with execution of the list)',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 433,
        SymbolicName: 'WaitForInstruction',
    },
    {
        Group: '',
        Description: 'Exchange/switch CIV order - Sell driven',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 433,
        SymbolicName: 'SellDriven',
    },
    {
        Group: '',
        Description:
            'Exchange/switch CIV order - Buy driven, cash top-up (i.e. additional cash will be provided to fulfill the order)',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 433,
        SymbolicName: 'BuyDrivenCashTopUp',
    },
    {
        Group: '',
        Description:
            'Exchange/switch CIV order - Buy driven, cash withdraw (i.e. additional cash will not be provided to fulfill the order)',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 433,
        SymbolicName: 'BuyDrivenCashWithdraw',
    },
    {
        Group: '',
        Description: 'Order cancel request',
        added: 'FIX.4.2',
        Value: '1',
        Sort: 1,
        Tag: 434,
        SymbolicName: 'OrderCancelRequest',
    },
    {
        Group: '',
        Description: 'Order cancel/replace request',
        added: 'FIX.4.2',
        Value: '2',
        Sort: 2,
        Tag: 434,
        SymbolicName: 'OrderCancel',
    },
    {
        Group: '',
        Description: 'Single security (default if not specified)',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '1',
        Sort: 1,
        Tag: 442,
        SymbolicName: 'SingleSecurity',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Individual leg of a multi-leg security',
        added: 'FIX.4.2',
        updatedEP: 95,
        Value: '2',
        Sort: 2,
        Tag: 442,
        SymbolicName: 'IndividualLegOfAMultiLegSecurity',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Multi-leg security',
        added: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 442,
        SymbolicName: 'MultiLegSecurity',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for CIV',
        Description: 'UK National Insurance or Pension Number',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 1,
        Tag: 447,
        SymbolicName: 'UKNationalInsuranceOrPensionNumber',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for CIV',
        Description: 'US Social Security Number',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 2,
        Tag: 447,
        SymbolicName: 'USSocialSecurityNumber',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for CIV',
        Description: 'US Employer or Tax ID Number',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 3,
        Tag: 447,
        SymbolicName: 'USEmployerOrTaxIDNumber',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for CIV',
        Description: 'Australian Business Number',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 4,
        Tag: 447,
        SymbolicName: 'AustralianBusinessNumber',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for CIV',
        Description: 'Australian Tax File Number',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 5,
        Tag: 447,
        SymbolicName: 'AustralianTaxFileNumber',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for Equities',
        Description: 'Korean Investor ID',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 447,
        SymbolicName: 'KoreanInvestorID',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for Equities',
        Description: 'Taiwanese Qualified Foreign Investor ID QFII/FID',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 447,
        SymbolicName: 'TaiwaneseForeignInvestorID',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for Equities',
        Description: 'Taiwanese Trading Acct',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 447,
        SymbolicName: 'TaiwaneseTradingAcct',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for Equities',
        Description: 'Malaysian Central Depository (MCD) number',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 447,
        SymbolicName: 'MalaysianCentralDepository',
    },
    {
        Group: 'For PartyRole = "InvestorID" and for Equities',
        Description: 'Chinese Investor ID',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 447,
        SymbolicName: 'ChineseInvestorID',
    },
    {
        Group: 'For PartyRole="Broker of Credit"',
        Description:
            'Directed broker three character acronym as defined in ISITC "ETC Best Practice" guidelines document',
        added: 'FIX.4.4',
        Value: 'I',
        Sort: 1,
        Tag: 447,
        SymbolicName: 'ISITCAcronym',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'BIC (Bank Identification Code - SWIFT managed) code (ISO9362 - See "Appendix 6-B")',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 1,
        Tag: 447,
        SymbolicName: 'BIC',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 2,
        Tag: 447,
        SymbolicName: 'GeneralIdentifier',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'Proprietary / Custom code',
        added: 'FIX.4.3',
        Value: 'D',
        Sort: 3,
        Tag: 447,
        SymbolicName: 'Proprietary',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'ISO Country Code',
        added: 'FIX.4.3',
        Value: 'E',
        Sort: 4,
        Tag: 447,
        SymbolicName: 'ISOCountryCode',
    },
    {
        Group: 'For all PartyRoles',
        Description:
            'Settlement Entity Location (note if Local Market Settlement use "E=ISO Country Code") (see "Appendix 6-G" for valid values)',
        added: 'FIX.4.3',
        Value: 'F',
        Sort: 5,
        Tag: 447,
        SymbolicName: 'SettlementEntityLocation',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'MIC (ISO 10383 - Market Identificer Code) (See "Appendix 6-C")',
        added: 'FIX.4.4',
        Value: 'G',
        Sort: 6,
        Tag: 447,
        SymbolicName: 'MIC',
    },
    {
        Group: 'For all PartyRoles',
        Description: 'CSD participant/member code (e.g.. Euroclear, DTC, CREST or Kassenverein number)',
        added: 'FIX.4.4',
        Value: 'H',
        Sort: 7,
        Tag: 447,
        SymbolicName: 'CSDParticipant',
    },
    {
        Group: '',
        Description: 'Executing Firm (formerly FIX 4.2 ExecBroker)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 452,
        SymbolicName: 'ExecutingFirm',
    },
    {
        Group: '',
        Description: 'Broker of Credit (formerly FIX 4.2 BrokerOfCredit)',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 452,
        SymbolicName: 'BrokerOfCredit',
    },
    {
        Group: '',
        Description: 'Client ID (formerly FIX 4.2 ClientID)',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 452,
        SymbolicName: 'ClientID',
    },
    {
        Group: '',
        Description: 'Clearing Firm (formerly FIX 4.2 ClearingFirm)',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 452,
        SymbolicName: 'ClearingFirm',
    },
    {
        Group: '',
        Description: 'Investor ID',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 452,
        SymbolicName: 'InvestorID',
    },
    {
        Group: '',
        Description: 'Introducing Firm',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 452,
        SymbolicName: 'IntroducingFirm',
    },
    {
        Group: '',
        Description: 'Entering Firm',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 452,
        SymbolicName: 'EnteringFirm',
    },
    {
        Group: '',
        Description: 'Locate / Lending Firm (for short-sales)',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 452,
        SymbolicName: 'Locate',
    },
    {
        Group: '',
        Description: 'Fund Manager Client ID (for CIV)',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 452,
        SymbolicName: 'FundManagerClientID',
    },
    {
        Group: '',
        Description: 'Settlement Location (formerly FIX 4.2 SettlLocation)',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 452,
        SymbolicName: 'SettlementLocation',
    },
    {
        Group: '',
        Description:
            'Order Origination Trader (associated with Order Origination Firm - i.e. trader who initiates/submits the order)',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 452,
        SymbolicName: 'OrderOriginationTrader',
    },
    {
        Group: '',
        Description: 'Executing Trader (associated with Executing Firm - actually executes)',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 452,
        SymbolicName: 'ExecutingTrader',
    },
    {
        Group: '',
        Description: 'Order Origination Firm (e.g. buy-side firm)',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 452,
        SymbolicName: 'OrderOriginationFirm',
    },
    {
        Group: '',
        Description: 'Giveup Clearing Firm (firm to which trade is given up)',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 452,
        SymbolicName: 'GiveupClearingFirm',
    },
    {
        Group: '',
        Description: 'Correspondant Clearing Firm',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 452,
        SymbolicName: 'CorrespondantClearingFirm',
    },
    {
        Group: '',
        Description: 'Executing System',
        added: 'FIX.4.3',
        Value: '16',
        Sort: 16,
        Tag: 452,
        SymbolicName: 'ExecutingSystem',
    },
    {
        Group: '',
        Description: 'Contra Firm',
        added: 'FIX.4.3',
        Value: '17',
        Sort: 17,
        Tag: 452,
        SymbolicName: 'ContraFirm',
    },
    {
        Group: '',
        Description: 'Contra Clearing Firm',
        added: 'FIX.4.3',
        Value: '18',
        Sort: 18,
        Tag: 452,
        SymbolicName: 'ContraClearingFirm',
    },
    {
        Group: '',
        Description: 'Sponsoring Firm',
        added: 'FIX.4.3',
        Value: '19',
        Sort: 19,
        Tag: 452,
        SymbolicName: 'SponsoringFirm',
    },
    {
        Group: '',
        Description: 'Underlying Contra Firm',
        added: 'FIX.4.3',
        Value: '20',
        Sort: 20,
        Tag: 452,
        SymbolicName: 'UnderlyingContraFirm',
    },
    {
        Group: '',
        Description: 'Clearing Organization',
        added: 'FIX.4.4',
        Value: '21',
        Sort: 21,
        Tag: 452,
        SymbolicName: 'ClearingOrganization',
    },
    {
        Group: '',
        Description: 'Exchange',
        added: 'FIX.4.4',
        Value: '22',
        Sort: 22,
        Tag: 452,
        SymbolicName: 'Exchange',
    },
    {
        Group: '',
        Description: 'Customer Account',
        added: 'FIX.4.4',
        Value: '24',
        Sort: 24,
        Tag: 452,
        SymbolicName: 'CustomerAccount',
    },
    {
        Group: '',
        Description: 'Correspondent Clearing Organization',
        added: 'FIX.4.4',
        Value: '25',
        Sort: 25,
        Tag: 452,
        SymbolicName: 'CorrespondentClearingOrganization',
    },
    {
        Group: '',
        Description: 'Correspondent Broker',
        added: 'FIX.4.4',
        Value: '26',
        Sort: 26,
        Tag: 452,
        SymbolicName: 'CorrespondentBroker',
    },
    {
        Group: '',
        Description: 'Buyer/Seller (Receiver/Deliverer)',
        added: 'FIX.4.4',
        Value: '27',
        Sort: 27,
        Tag: 452,
        SymbolicName: 'Buyer',
    },
    {
        Group: '',
        Description: 'Custodian',
        added: 'FIX.4.4',
        Value: '28',
        Sort: 28,
        Tag: 452,
        SymbolicName: 'Custodian',
    },
    {
        Group: '',
        Description: 'Intermediary',
        added: 'FIX.4.4',
        Value: '29',
        Sort: 29,
        Tag: 452,
        SymbolicName: 'Intermediary',
    },
    {
        Group: '',
        Description: 'Agent',
        added: 'FIX.4.4',
        Value: '30',
        Sort: 30,
        Tag: 452,
        SymbolicName: 'Agent',
    },
    {
        Group: '',
        Description: 'Sub-custodian',
        added: 'FIX.4.4',
        Value: '31',
        Sort: 31,
        Tag: 452,
        SymbolicName: 'SubCustodian',
    },
    {
        Group: '',
        Description: 'Beneficiary',
        added: 'FIX.4.4',
        Value: '32',
        Sort: 32,
        Tag: 452,
        SymbolicName: 'Beneficiary',
    },
    {
        Group: '',
        Description: 'Interested party',
        added: 'FIX.4.4',
        Value: '33',
        Sort: 33,
        Tag: 452,
        SymbolicName: 'InterestedParty',
    },
    {
        Group: '',
        Description: 'Regulatory body',
        added: 'FIX.4.4',
        Value: '34',
        Sort: 34,
        Tag: 452,
        SymbolicName: 'RegulatoryBody',
    },
    {
        Group: '',
        Description: 'Liquidity provider',
        added: 'FIX.4.4',
        Value: '35',
        Sort: 35,
        Tag: 452,
        SymbolicName: 'LiquidityProvider',
    },
    {
        Group: '',
        Description: 'Entering trader',
        added: 'FIX.4.4',
        Value: '36',
        Sort: 36,
        Tag: 452,
        SymbolicName: 'EnteringTrader',
    },
    {
        Group: '',
        Description: 'Contra trader',
        added: 'FIX.4.4',
        Value: '37',
        Sort: 37,
        Tag: 452,
        SymbolicName: 'ContraTrader',
    },
    {
        Group: '',
        Description: 'Position account',
        added: 'FIX.4.4',
        Value: '38',
        Sort: 38,
        Tag: 452,
        SymbolicName: 'PositionAccount',
    },
    {
        Group: '',
        Description: 'Contra Investor ID',
        added: 'FIX.4.4',
        Value: '39',
        Sort: 39,
        addedEP: -1,
        Tag: 452,
        SymbolicName: 'ContraInvestorID',
    },
    {
        Group: '',
        Description: 'Transfer to Firm',
        added: 'FIX.4.4',
        Value: '40',
        Sort: 40,
        addedEP: -1,
        Tag: 452,
        SymbolicName: 'TransferToFirm',
    },
    {
        Group: '',
        Description: 'Contra Position Account',
        added: 'FIX.4.4',
        Value: '41',
        Sort: 41,
        addedEP: 5,
        Tag: 452,
        SymbolicName: 'ContraPositionAccount',
    },
    {
        Group: '',
        Description: 'Contra Exchange',
        added: 'FIX.4.4',
        Value: '42',
        Sort: 42,
        addedEP: 5,
        Tag: 452,
        SymbolicName: 'ContraExchange',
    },
    {
        Group: '',
        Description: 'Internal Carry Account',
        added: 'FIX.4.4',
        Value: '43',
        Sort: 43,
        addedEP: 5,
        Tag: 452,
        SymbolicName: 'InternalCarryAccount',
    },
    {
        Group: '',
        Description: 'Order Entry Operator ID',
        added: 'FIX.4.4',
        Value: '44',
        Sort: 44,
        addedEP: 5,
        Tag: 452,
        SymbolicName: 'OrderEntryOperatorID',
    },
    {
        Group: '',
        Description: 'Secondary Account Number',
        added: 'FIX.4.4',
        Value: '45',
        Sort: 45,
        addedEP: 5,
        Tag: 452,
        SymbolicName: 'SecondaryAccountNumber',
    },
    {
        Group: '',
        Description: 'Foreign Firm',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '46',
        Sort: 46,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'ForeignFirm',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Third Party Allocation Firm',
        added: 'FIX.4.4',
        Value: '47',
        Sort: 47,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'ThirdPartyAllocationFirm',
    },
    {
        Group: '',
        Description: 'Claiming Account',
        added: 'FIX.4.4',
        Value: '48',
        Sort: 48,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'ClaimingAccount',
    },
    {
        Group: '',
        Description: 'Asset Manager',
        added: 'FIX.4.4',
        Value: '49',
        Sort: 49,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'AssetManager',
    },
    {
        Group: '',
        Description: 'Pledgor Account',
        added: 'FIX.4.4',
        Value: '50',
        Sort: 50,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'PledgorAccount',
    },
    {
        Group: '',
        Description: 'Pledgee Account',
        added: 'FIX.4.4',
        Value: '51',
        Sort: 51,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'PledgeeAccount',
    },
    {
        Group: '',
        Description: 'Large Trader Reportable Account',
        added: 'FIX.4.4',
        Value: '52',
        Sort: 52,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'LargeTraderReportableAccount',
    },
    {
        Group: '',
        Description: 'Trader mnemonic',
        added: 'FIX.4.4',
        Value: '53',
        Sort: 53,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'TraderMnemonic',
    },
    {
        Group: '',
        Description: 'Sender Location',
        added: 'FIX.4.4',
        Value: '54',
        Sort: 54,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'SenderLocation',
    },
    {
        Group: '',
        Description: 'Session ID',
        added: 'FIX.4.4',
        Value: '55',
        Sort: 55,
        addedEP: 8,
        Tag: 452,
        SymbolicName: 'SessionID',
    },
    {
        Group: '',
        Description: 'Acceptable Counterparty',
        added: 'FIX.4.4',
        Value: '56',
        Sort: 56,
        addedEP: 22,
        Tag: 452,
        SymbolicName: 'AcceptableCounterparty',
    },
    {
        Group: '',
        Description: 'Unacceptable Counterparty',
        added: 'FIX.4.4',
        Value: '57',
        Sort: 57,
        addedEP: 22,
        Tag: 452,
        SymbolicName: 'UnacceptableCounterparty',
    },
    {
        Group: '',
        Description: 'Entering Unit',
        added: 'FIX.4.4',
        Value: '58',
        Sort: 58,
        addedEP: 22,
        Tag: 452,
        SymbolicName: 'EnteringUnit',
    },
    {
        Group: '',
        Description: 'Executing Unit',
        added: 'FIX.4.4',
        Value: '59',
        Sort: 59,
        addedEP: 22,
        Tag: 452,
        SymbolicName: 'ExecutingUnit',
    },
    {
        Group: '',
        Description: 'Introducing Broker',
        added: 'FIX.4.4',
        Value: '60',
        Sort: 60,
        addedEP: 4,
        Tag: 452,
        SymbolicName: 'IntroducingBroker',
    },
    {
        Group: '',
        Description: 'Quote originator',
        added: 'FIX.4.4',
        Value: '61',
        Sort: 61,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'QuoteOriginator',
    },
    {
        Group: '',
        Description: 'Report originator',
        added: 'FIX.4.4',
        Value: '62',
        Sort: 62,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'ReportOriginator',
    },
    {
        Group: '',
        Description: 'Systematic internaliser (SI)',
        added: 'FIX.4.4',
        Value: '63',
        Sort: 63,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'SystematicInternaliser',
    },
    {
        Group: '',
        Description: 'Multilateral Trading Facility (MTF)',
        added: 'FIX.4.4',
        Value: '64',
        Sort: 64,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'MultilateralTradingFacility',
    },
    {
        Group: '',
        Description: 'Regulated Market (RM)',
        added: 'FIX.4.4',
        Value: '65',
        Sort: 65,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'RegulatedMarket',
    },
    {
        Group: '',
        Description: 'Market Maker',
        added: 'FIX.4.4',
        Value: '66',
        Sort: 66,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'MarketMaker',
    },
    {
        Group: '',
        Description: 'Investment Firm',
        added: 'FIX.4.4',
        Value: '67',
        Sort: 67,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'InvestmentFirm',
    },
    {
        Group: '',
        Description: 'Host Competent Authority (Host CA)',
        added: 'FIX.4.4',
        Value: '68',
        Sort: 68,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'HostCompetentAuthority',
    },
    {
        Group: '',
        Description: 'Home Competent Authority (Home CA)',
        added: 'FIX.4.4',
        Value: '69',
        Sort: 69,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'HomeCompetentAuthority',
    },
    {
        Group: '',
        Description: 'Competent Authority of the most relevant market in terms of liquidity (CAL)',
        added: 'FIX.4.4',
        Value: '70',
        Sort: 70,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'CompetentAuthorityLiquidity',
    },
    {
        Group: '',
        Description: 'Competent Authority of the Transaction (Execution) Venue (CATV)',
        added: 'FIX.4.4',
        Value: '71',
        Sort: 71,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'CompetentAuthorityTransactionVenue',
    },
    {
        Group: '',
        Description: 'Reporting intermediary (medium/vendor via which report has been published)',
        added: 'FIX.4.4',
        Value: '72',
        Sort: 72,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'ReportingIntermediary',
    },
    {
        Group: '',
        Description: 'Execution Venue',
        added: 'FIX.4.4',
        Value: '73',
        Sort: 73,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'ExecutionVenue',
    },
    {
        Group: '',
        Description: 'Market data entry originator',
        added: 'FIX.4.4',
        Value: '74',
        Sort: 74,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'MarketDataEntryOriginator',
    },
    {
        Group: '',
        Description: 'Location ID',
        added: 'FIX.4.4',
        Value: '75',
        Sort: 75,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'LocationID',
    },
    {
        Group: '',
        Description: 'Desk ID',
        added: 'FIX.4.4',
        Value: '76',
        Sort: 76,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'DeskID',
    },
    {
        Group: '',
        Description: 'Market data market',
        added: 'FIX.4.4',
        Value: '77',
        Sort: 77,
        addedEP: 26,
        Tag: 452,
        SymbolicName: 'MarketDataMarket',
    },
    {
        Group: '',
        Description: 'Allocation Entity',
        added: 'FIX.4.4',
        Value: '78',
        Sort: 78,
        addedEP: 35,
        Tag: 452,
        SymbolicName: 'AllocationEntity',
    },
    {
        Group: '',
        Description: 'Prime Broker providing General Trade Services',
        added: 'FIX.5.0',
        Value: '79',
        Sort: 79,
        addedEP: 68,
        Tag: 452,
        SymbolicName: 'PrimeBroker',
    },
    {
        Group: '',
        Description: 'Step-Out Firm (Prime Broker)',
        added: 'FIX.5.0',
        Value: '80',
        Sort: 80,
        addedEP: 68,
        Tag: 452,
        SymbolicName: 'StepOutFirm',
    },
    {
        Group: '',
        Description: 'BrokerClearingID',
        added: 'FIX.5.0',
        Value: '81',
        Sort: 81,
        addedEP: 68,
        Tag: 452,
        SymbolicName: 'BrokerClearingID',
    },
    {
        Group: '',
        Description: 'AGENCY',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 460,
        SymbolicName: 'AGENCY',
    },
    {
        Group: '',
        Description: 'COMMODITY',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 460,
        SymbolicName: 'COMMODITY',
    },
    {
        Group: '',
        Description: 'CORPORATE',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 460,
        SymbolicName: 'CORPORATE',
    },
    {
        Group: '',
        Description: 'CURRENCY',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 460,
        SymbolicName: 'CURRENCY',
    },
    {
        Group: '',
        Description: 'EQUITY',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 460,
        SymbolicName: 'EQUITY',
    },
    {
        Group: '',
        Description: 'GOVERNMENT',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 460,
        SymbolicName: 'GOVERNMENT',
    },
    {
        Group: '',
        Description: 'INDEX',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 460,
        SymbolicName: 'INDEX',
    },
    {
        Group: '',
        Description: 'LOAN',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 460,
        SymbolicName: 'LOAN',
    },
    {
        Group: '',
        Description: 'MONEYMARKET',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 460,
        SymbolicName: 'MONEYMARKET',
    },
    {
        Group: '',
        Description: 'MORTGAGE',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 460,
        SymbolicName: 'MORTGAGE',
    },
    {
        Group: '',
        Description: 'MUNICIPAL',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 460,
        SymbolicName: 'MUNICIPAL',
    },
    {
        Group: '',
        Description: 'OTHER',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 460,
        SymbolicName: 'OTHER',
    },
    {
        Group: '',
        Description: 'FINANCING',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        Tag: 460,
        SymbolicName: 'FINANCING',
    },
    {
        Group: '',
        Description: 'Fales (Production)',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 464,
        SymbolicName: 'Fales',
    },
    {
        Group: '',
        Description: 'True (Test)',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 464,
        SymbolicName: 'True',
    },
    {
        Group: '',
        Description: 'SHARES',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 465,
        SymbolicName: 'SHARES',
    },
    {
        Group: '',
        Description: 'BONDS',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 465,
        SymbolicName: 'BONDS',
    },
    {
        Group: '',
        Description: 'CURRENTFACE',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 465,
        SymbolicName: 'CURRENTFACE',
    },
    {
        Group: '',
        Description: 'ORIGINALFACE',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 465,
        SymbolicName: 'ORIGINALFACE',
    },
    {
        Group: '',
        Description: 'CURRENCY',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 465,
        SymbolicName: 'CURRENCY',
    },
    {
        Group: '',
        Description: 'CONTRACTS',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 465,
        SymbolicName: 'CONTRACTS',
    },
    {
        Group: '',
        Description: 'OTHER',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 465,
        SymbolicName: 'OTHER',
    },
    {
        Group: '',
        Description: 'PAR',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 465,
        SymbolicName: 'PAR',
    },
    {
        Group: '',
        Description: 'Round to nearest',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 468,
        SymbolicName: 'RoundToNearest',
    },
    {
        Group: '',
        Description: 'Round down',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 468,
        SymbolicName: 'RoundDown',
    },
    {
        Group: '',
        Description: 'Round up',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 3,
        Tag: 468,
        SymbolicName: 'RoundUp',
    },
    {
        Group: '',
        Description: 'CREST',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 477,
        SymbolicName: 'CREST',
    },
    {
        Group: '',
        Description: 'NSCC',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 477,
        SymbolicName: 'NSCC',
    },
    {
        Group: '',
        Description: 'Euroclear',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 477,
        SymbolicName: 'Euroclear',
    },
    {
        Group: '',
        Description: 'Clearstream',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 477,
        SymbolicName: 'Clearstream',
    },
    {
        Group: '',
        Description: 'Cheque',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 477,
        SymbolicName: 'Cheque',
    },
    {
        Group: '',
        Description: 'Telegraphic Transfer',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        Tag: 477,
        SymbolicName: 'TelegraphicTransfer',
    },
    {
        Group: '',
        Description: 'Fed Wire',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        Tag: 477,
        SymbolicName: 'FedWire',
    },
    {
        Group: '',
        Description: 'Direct Credit (BECS, BACS)',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        Tag: 477,
        SymbolicName: 'DirectCredit',
    },
    {
        Group: '',
        Description: 'ACH Credit',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        Tag: 477,
        SymbolicName: 'ACHCredit',
    },
    {
        Group: '',
        Description: 'BPAY',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 10,
        Tag: 477,
        SymbolicName: 'BPAY',
    },
    {
        Group: '',
        Description: 'High Value Clearing System HVACS',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        Tag: 477,
        SymbolicName: 'HighValueClearingSystemHVACS',
    },
    {
        Group: '',
        Description: 'Reinvest In Fund',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        Tag: 477,
        SymbolicName: 'ReinvestInFund',
    },
    {
        Group: '',
        Description: 'Yes',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 1,
        Tag: 480,
        SymbolicName: 'Yes',
    },
    {
        Group: '',
        Description: 'No - Execution Only',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 2,
        Tag: 480,
        SymbolicName: 'NoExecutionOnly',
    },
    {
        Group: '',
        Description: 'No - Waiver agreement',
        added: 'FIX.4.3',
        Value: 'M',
        Sort: 3,
        Tag: 480,
        SymbolicName: 'NoWaiverAgreement',
    },
    {
        Group: '',
        Description: 'No - Institutional',
        added: 'FIX.4.3',
        Value: 'O',
        Sort: 4,
        Tag: 480,
        SymbolicName: 'NoInstitutional',
    },
    {
        Group: '',
        Description: 'Passed',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 1,
        Tag: 481,
        SymbolicName: 'Passed',
    },
    {
        Group: '',
        Description: 'Not Checked',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 2,
        Tag: 481,
        SymbolicName: 'NotChecked',
    },
    {
        Group: '',
        Description: 'Exempt - Below the Limit',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 3,
        Tag: 481,
        SymbolicName: 'ExemptBelowLimit',
    },
    {
        Group: '',
        Description: 'Exempt - Client Money Type exemption',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 4,
        Tag: 481,
        SymbolicName: 'ExemptMoneyType',
    },
    {
        Group: '',
        Description: 'Exempt - Authorised Credit or financial institution',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 5,
        Tag: 481,
        SymbolicName: 'ExemptAuthorised',
    },
    {
        Group: '',
        Description: 'Bid price',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 1,
        Tag: 484,
        SymbolicName: 'BidPrice',
    },
    {
        Group: '',
        Description: 'Creation price',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 2,
        Tag: 484,
        SymbolicName: 'CreationPrice',
    },
    {
        Group: '',
        Description: 'Creation price plus adjustment percent',
        added: 'FIX.4.3',
        Value: 'D',
        Sort: 3,
        Tag: 484,
        SymbolicName: 'CreationPricePlusAdjustmentPercent',
    },
    {
        Group: '',
        Description: 'Creation price plus adjustment amount',
        added: 'FIX.4.3',
        Value: 'E',
        Sort: 4,
        Tag: 484,
        SymbolicName: 'CreationPricePlusAdjustmentAmount',
    },
    {
        Group: '',
        Description: 'Offer price',
        added: 'FIX.4.3',
        Value: 'O',
        Sort: 5,
        Tag: 484,
        SymbolicName: 'OfferPrice',
    },
    {
        Group: '',
        Description: 'Offer price minus adjustment percent',
        added: 'FIX.4.3',
        Value: 'P',
        Sort: 6,
        Tag: 484,
        SymbolicName: 'OfferPriceMinusAdjustmentPercent',
    },
    {
        Group: '',
        Description: 'Offer price minus adjustment amount',
        added: 'FIX.4.3',
        Value: 'Q',
        Sort: 7,
        Tag: 484,
        SymbolicName: 'OfferPriceMinusAdjustmentAmount',
    },
    {
        Group: '',
        Description: 'Single price',
        added: 'FIX.4.3',
        Value: 'S',
        Sort: 8,
        Tag: 484,
        SymbolicName: 'SinglePrice',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 487,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 487,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 487,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Release',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: -1,
        Tag: 487,
        SymbolicName: 'Release',
    },
    {
        Group: '',
        Description: 'Reverse',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: -1,
        Tag: 487,
        SymbolicName: 'Reverse',
    },
    {
        Group: '',
        Description: 'Cancel Due To Back Out of Trade',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        addedEP: 4,
        Tag: 487,
        SymbolicName: 'CancelDueToBackOutOfTrade',
    },
    {
        Group: '',
        Description: 'CREST',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 492,
        SymbolicName: 'CREST',
    },
    {
        Group: '',
        Description: 'NSCC',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 492,
        SymbolicName: 'NSCC',
    },
    {
        Group: '',
        Description: 'Euroclear',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 492,
        SymbolicName: 'Euroclear',
    },
    {
        Group: '',
        Description: 'Clearstream',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 492,
        SymbolicName: 'Clearstream',
    },
    {
        Group: '',
        Description: 'Cheque',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 492,
        SymbolicName: 'Cheque',
    },
    {
        Group: '',
        Description: 'Telegraphic Transfer',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 492,
        SymbolicName: 'TelegraphicTransfer',
    },
    {
        Group: '',
        Description: 'Fed Wire',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 492,
        SymbolicName: 'FedWire',
    },
    {
        Group: '',
        Description: 'Debit Card',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 492,
        SymbolicName: 'DebitCard',
    },
    {
        Group: '',
        Description: 'Direct Debit (BECS)',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 492,
        SymbolicName: 'DirectDebit',
    },
    {
        Group: '',
        Description: 'Direct Credit (BECS)',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 492,
        SymbolicName: 'DirectCredit',
    },
    {
        Group: '',
        Description: 'Credit Card',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 492,
        SymbolicName: 'CreditCard',
    },
    {
        Group: '',
        Description: 'ACH Debit',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 492,
        SymbolicName: 'ACHDebit',
    },
    {
        Group: '',
        Description: 'ACH Credit',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 492,
        SymbolicName: 'ACHCredit',
    },
    {
        Group: '',
        Description: 'BPAY',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 492,
        SymbolicName: 'BPAY',
    },
    {
        Group: '',
        Description: 'High Value Clearing System (HVACS)',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 492,
        SymbolicName: 'HighValueClearingSystem',
    },
    {
        Group: '',
        Description: 'None/Not Applicable (default)',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 495,
        SymbolicName: 'None',
    },
    {
        Group: '',
        Description: 'Maxi ISA (UK)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 495,
        SymbolicName: 'MaxiISA',
    },
    {
        Group: '',
        Description: 'TESSA (UK)',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 495,
        SymbolicName: 'TESSA',
    },
    {
        Group: '',
        Description: 'Mini Cash ISA (UK)',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 495,
        SymbolicName: 'MiniCashISA',
    },
    {
        Group: '',
        Description: 'Mini Stocks And Shares ISA (UK)',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 495,
        SymbolicName: 'MiniStocksAndSharesISA',
    },
    {
        Group: '',
        Description: 'Mini Insurance ISA (UK)',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 495,
        SymbolicName: 'MiniInsuranceISA',
    },
    {
        Group: '',
        Description: 'Current Year Payment (US)',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 495,
        SymbolicName: 'CurrentYearPayment',
    },
    {
        Group: '',
        Description: 'Prior Year Payment (US)',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 495,
        SymbolicName: 'PriorYearPayment',
    },
    {
        Group: '',
        Description: 'Asset Transfer (US)',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 495,
        SymbolicName: 'AssetTransfer',
    },
    {
        Group: '',
        Description: 'Employee - prior year (US)',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 495,
        SymbolicName: 'EmployeePriorYear',
    },
    {
        Group: '',
        Description: 'Employee - current year (US)',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 495,
        SymbolicName: 'EmployeeCurrentYear',
    },
    {
        Group: '',
        Description: 'Employer - prior year (US)',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 495,
        SymbolicName: 'EmployerPriorYear',
    },
    {
        Group: '',
        Description: 'Employer - current year (US)',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 495,
        SymbolicName: 'EmployerCurrentYear',
    },
    {
        Group: '',
        Description: 'Non-fund prototype IRA (US)',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 495,
        SymbolicName: 'NonFundPrototypeIRA',
    },
    {
        Group: '',
        Description: 'Non-fund qualified plan (US)',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 495,
        SymbolicName: 'NonFundQualifiedPlan',
    },
    {
        Group: '',
        Description: 'Defined contribution plan (US)',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 495,
        SymbolicName: 'DefinedContributionPlan',
    },
    {
        Group: '',
        Description: 'Individual Retirement Account (US)',
        added: 'FIX.4.3',
        Value: '16',
        Sort: 16,
        Tag: 495,
        SymbolicName: 'IRA',
    },
    {
        Group: '',
        Description: 'Individual Retirement Account - Rollover (US)',
        added: 'FIX.4.3',
        Value: '17',
        Sort: 17,
        Tag: 495,
        SymbolicName: 'IRARollover',
    },
    {
        Group: '',
        Description: 'KEOGH (US)',
        added: 'FIX.4.3',
        Value: '18',
        Sort: 18,
        Tag: 495,
        SymbolicName: 'KEOGH',
    },
    {
        Group: '',
        Description: 'Profit Sharing Plan (US)',
        added: 'FIX.4.3',
        Value: '19',
        Sort: 19,
        Tag: 495,
        SymbolicName: 'ProfitSharingPlan',
    },
    {
        Group: '',
        Description: '401(k) (US)',
        added: 'FIX.4.3',
        Value: '20',
        Sort: 20,
        Tag: 495,
        SymbolicName: 'US401K',
    },
    {
        Group: '',
        Description: 'Self-directed IRA (US)',
        added: 'FIX.4.3',
        Value: '21',
        Sort: 21,
        Tag: 495,
        SymbolicName: 'SelfDirectedIRA',
    },
    {
        Group: '',
        Description: '403(b) (US)',
        added: 'FIX.4.3',
        Value: '22',
        Sort: 22,
        Tag: 495,
        SymbolicName: 'US403b',
    },
    {
        Group: '',
        Description: '457 (US)',
        added: 'FIX.4.3',
        Value: '23',
        Sort: 23,
        Tag: 495,
        SymbolicName: 'US457',
    },
    {
        Group: '',
        Description: 'Roth IRA (Fund Prototype) (US)',
        added: 'FIX.4.3',
        Value: '24',
        Sort: 24,
        Tag: 495,
        SymbolicName: 'RothIRAPrototype',
    },
    {
        Group: '',
        Description: 'Roth IRA (Non-prototype) (US)',
        added: 'FIX.4.3',
        Value: '25',
        Sort: 25,
        Tag: 495,
        SymbolicName: 'RothIRANonPrototype',
    },
    {
        Group: '',
        Description: 'Roth Conversion IRA (Fund Prototype) (US)',
        added: 'FIX.4.3',
        Value: '26',
        Sort: 26,
        Tag: 495,
        SymbolicName: 'RothConversionIRAPrototype',
    },
    {
        Group: '',
        Description: 'Roth Conversion IRA (Non-prototype) (US)',
        added: 'FIX.4.3',
        Value: '27',
        Sort: 27,
        Tag: 495,
        SymbolicName: 'RothConversionIRANonPrototype',
    },
    {
        Group: '',
        Description: 'Education IRA (Fund Prototype) (US)',
        added: 'FIX.4.3',
        Value: '28',
        Sort: 28,
        Tag: 495,
        SymbolicName: 'EducationIRAPrototype',
    },
    {
        Group: '',
        Description: 'Education IRA (Non-prototype) (US)',
        added: 'FIX.4.3',
        Value: '29',
        Sort: 29,
        Tag: 495,
        SymbolicName: 'EducationIRANonPrototype',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '999',
        Sort: 99,
        addedEP: -1,
        Tag: 495,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'No',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 497,
        SymbolicName: 'No',
    },
    {
        Group: '',
        Description: 'Yes',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 497,
        SymbolicName: 'Yes',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 1,
        Tag: 506,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.3',
        Value: 'R',
        Sort: 2,
        Tag: 506,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Held',
        added: 'FIX.4.3',
        Value: 'H',
        Sort: 3,
        Tag: 506,
        SymbolicName: 'Held',
    },
    {
        Group: '',
        Description: 'Reminder - i.e. Registration Instructions are still outstanding',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 4,
        Tag: 506,
        SymbolicName: 'Reminder',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Account Type',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 507,
        SymbolicName: 'InvalidAccountType',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Tax Exempt Type',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 507,
        SymbolicName: 'InvalidTaxExemptType',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Ownership Type',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 507,
        SymbolicName: 'InvalidOwnershipType',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable No Reg Details',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 507,
        SymbolicName: 'NoRegDetails',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Reg Seq No',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 507,
        SymbolicName: 'InvalidRegSeqNo',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Reg Details',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 507,
        SymbolicName: 'InvalidRegDetails',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Mailing Details',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 507,
        SymbolicName: 'InvalidMailingDetails',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Mailing Instructions',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 507,
        SymbolicName: 'InvalidMailingInstructions',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Investor ID',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 507,
        SymbolicName: 'InvalidInvestorID',
    },
    {
        Group: '',
        Description: 'Invalid/unaceeptable Investor ID Source',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 507,
        SymbolicName: 'InvalidInvestorIDSource',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Date Of Birth',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 507,
        SymbolicName: 'InvalidDateOfBirth',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Investor Country Of Residence',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 507,
        SymbolicName: 'InvalidCountry',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable No Distrib Instns',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 507,
        SymbolicName: 'InvalidDistribInstns',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Distrib Percentage',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 507,
        SymbolicName: 'InvalidPercentage',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Distrib Payment Method',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 507,
        SymbolicName: 'InvalidPaymentMethod',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Cash Distrib Agent Acct Name',
        added: 'FIX.4.3',
        Value: '16',
        Sort: 16,
        Tag: 507,
        SymbolicName: 'InvalidAccountName',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Cash Distrib Agent Code',
        added: 'FIX.4.3',
        Value: '17',
        Sort: 17,
        Tag: 507,
        SymbolicName: 'InvalidAgentCode',
    },
    {
        Group: '',
        Description: 'Invalid/unacceptable Cash Distrib Agent Acct Num',
        added: 'FIX.4.3',
        Value: '18',
        Sort: 18,
        Tag: 507,
        SymbolicName: 'InvalidAccountNum',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 507,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 514,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 514,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 3,
        Tag: 514,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Joint Investors',
        added: 'FIX.4.4',
        Value: 'J',
        Sort: 1,
        Tag: 517,
        SymbolicName: 'JointInvestors',
    },
    {
        Group: '',
        Description: 'Tenants in Common',
        added: 'FIX.4.4',
        Value: 'T',
        Sort: 2,
        Tag: 517,
        SymbolicName: 'TenantsInCommon',
    },
    {
        Group: '',
        Description: 'Joint Trustees',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 517,
        SymbolicName: 'JointTrustees',
    },
    {
        Group: '',
        Description: 'Commission amount (actual)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 519,
        SymbolicName: 'CommissionAmount',
    },
    {
        Group: '',
        Description: 'Commission percent (actual)',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 519,
        SymbolicName: 'CommissionPercent',
    },
    {
        Group: '',
        Description: 'Initial Charge Amount',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 519,
        SymbolicName: 'InitialChargeAmount',
    },
    {
        Group: '',
        Description: 'Initial Charge Percent',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 519,
        SymbolicName: 'InitialChargePercent',
    },
    {
        Group: '',
        Description: 'Discount Amount',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 519,
        SymbolicName: 'DiscountAmount',
    },
    {
        Group: '',
        Description: 'Discount Percent',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 519,
        SymbolicName: 'DiscountPercent',
    },
    {
        Group: '',
        Description: 'Dilution Levy Amount',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 519,
        SymbolicName: 'DilutionLevyAmount',
    },
    {
        Group: '',
        Description: 'Dilution Levy Percent',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 519,
        SymbolicName: 'DilutionLevyPercent',
    },
    {
        Group: '',
        Description: 'Exit Charge Amount',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 519,
        SymbolicName: 'ExitChargeAmount',
    },
    {
        Group: '',
        Description: 'Exit Charge Percent',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 519,
        SymbolicName: 'ExitChargePercent',
    },
    {
        Group: '',
        Description: 'Fund-Based Renewal Commission Percent (a.k.a. Trail commission)',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 519,
        SymbolicName: 'FundBasedRenewalCommissionPercent',
    },
    {
        Group: '',
        Description:
            'Projected Fund Value (i.e. for investments intended to realise or exceed a specific future value)',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 519,
        SymbolicName: 'ProjectedFundValue',
    },
    {
        Group: '',
        Description: 'Fund-Based Renewal Commission Amount (based on Order value)',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 519,
        SymbolicName: 'FundBasedRenewalCommissionOnOrder',
    },
    {
        Group: '',
        Description: 'Fund-Based Renewal Commission Amount (based on Projected Fund value)',
        added: 'FIX.4.3',
        Value: '14',
        Sort: 14,
        Tag: 519,
        SymbolicName: 'FundBasedRenewalCommissionOnFund',
    },
    {
        Group: '',
        Description: 'Net Settlement Amount',
        added: 'FIX.4.3',
        Value: '15',
        Sort: 15,
        Tag: 519,
        SymbolicName: 'NetSettlementAmount',
    },
    {
        Group: '',
        Description: 'Individual Investor',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 522,
        SymbolicName: 'IndividualInvestor',
    },
    {
        Group: '',
        Description: 'Public Company',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 522,
        SymbolicName: 'PublicCompany',
    },
    {
        Group: '',
        Description: 'Private Company',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 522,
        SymbolicName: 'PrivateCompany',
    },
    {
        Group: '',
        Description: 'Individual Trustee',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 522,
        SymbolicName: 'IndividualTrustee',
    },
    {
        Group: '',
        Description: 'Company Trustee',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 522,
        SymbolicName: 'CompanyTrustee',
    },
    {
        Group: '',
        Description: 'Pension Plan',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 522,
        SymbolicName: 'PensionPlan',
    },
    {
        Group: '',
        Description: 'Custodian Under Gifts to Minors Act',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 522,
        SymbolicName: 'CustodianUnderGiftsToMinorsAct',
    },
    {
        Group: '',
        Description: 'Trusts',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 522,
        SymbolicName: 'Trusts',
    },
    {
        Group: '',
        Description: 'Fiduciaries',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 522,
        SymbolicName: 'Fiduciaries',
    },
    {
        Group: '',
        Description: 'Networking Sub-account',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 522,
        SymbolicName: 'NetworkingSubAccount',
    },
    {
        Group: '',
        Description: 'Non-profit organization',
        added: 'FIX.4.3',
        Value: '11',
        Sort: 11,
        Tag: 522,
        SymbolicName: 'NonProfitOrganization',
    },
    {
        Group: '',
        Description: 'Corporate Body',
        added: 'FIX.4.3',
        Value: '12',
        Sort: 12,
        Tag: 522,
        SymbolicName: 'CorporateBody',
    },
    {
        Group: '',
        Description: 'Nominee',
        added: 'FIX.4.3',
        Value: '13',
        Sort: 13,
        Tag: 522,
        SymbolicName: 'Nominee',
    },
    {
        Group: '',
        Description: 'Agency',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 1,
        Tag: 528,
        SymbolicName: 'Agency',
    },
    {
        Group: '',
        Description: 'Proprietary',
        added: 'FIX.4.3',
        Value: 'G',
        Sort: 2,
        Tag: 528,
        SymbolicName: 'Proprietary',
    },
    {
        Group: '',
        Description: 'Individual',
        added: 'FIX.4.3',
        Value: 'I',
        Sort: 3,
        Tag: 528,
        SymbolicName: 'Individual',
    },
    {
        Group: '',
        Description: 'Principal (Note for CMS purposes, "Principal" includes "Proprietary")',
        added: 'FIX.4.3',
        Value: 'P',
        Sort: 4,
        Tag: 528,
        SymbolicName: 'Principal',
    },
    {
        Group: '',
        Description: 'Riskless Principal',
        added: 'FIX.4.3',
        Value: 'R',
        Sort: 5,
        Tag: 528,
        SymbolicName: 'RisklessPrincipal',
    },
    {
        Group: '',
        Description: 'Agent for Other Member',
        added: 'FIX.4.3',
        Value: 'W',
        Sort: 6,
        Tag: 528,
        SymbolicName: 'AgentForOtherMember',
    },
    {
        Group: '',
        Description: 'Program Trade',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 529,
        SymbolicName: 'ProgramTrade',
    },
    {
        Group: '',
        Description: 'Index Arbitrage',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 529,
        SymbolicName: 'IndexArbitrage',
    },
    {
        Group: '',
        Description: 'Non-Index Arbitrage',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 529,
        SymbolicName: 'NonIndexArbitrage',
    },
    {
        Group: '',
        Description: 'Competing Market Maker',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 529,
        SymbolicName: 'CompetingMarketMaker',
    },
    {
        Group: '',
        Description: 'Acting as Market Maker or Specialist in the security',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 529,
        SymbolicName: 'ActingAsMarketMakerOrSpecialistInSecurity',
    },
    {
        Group: '',
        Description: 'Acting as Market Maker or Specialist in the underlying security of a derivative security',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '6',
        Sort: 6,
        Tag: 529,
        SymbolicName: 'ActingAsMarketMakerOrSpecialistInUnderlying',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Foreign Entity (of foreign government or regulatory jurisdiction)',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 529,
        SymbolicName: 'ForeignEntity',
    },
    {
        Group: '',
        Description: 'External Market Participant',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 529,
        SymbolicName: 'ExternalMarketParticipant',
    },
    {
        Group: '',
        Description: 'External Inter-connected Market Linkage',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '9',
        Sort: 9,
        Tag: 529,
        SymbolicName: 'ExternalInterConnectedMarketLinkage',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Riskless Arbitrage',
        added: 'FIX.4.3',
        Value: 'A',
        Sort: 10,
        Tag: 529,
        SymbolicName: 'RisklessArbitrage',
    },
    {
        Group: '',
        Description: 'Issuer Holding',
        added: 'FIX.5.0',
        Value: 'B',
        Sort: 11,
        addedEP: 61,
        Tag: 529,
        SymbolicName: 'IssuerHolding',
    },
    {
        Group: '',
        Description: 'Issue Price Stabilization',
        added: 'FIX.5.0',
        Value: 'C',
        Sort: 12,
        addedEP: 61,
        Tag: 529,
        SymbolicName: 'IssuePriceStabilization',
    },
    {
        Group: '',
        Description: 'Non-algorithmic',
        added: 'FIX.5.0',
        Value: 'D',
        Sort: 13,
        addedEP: -1,
        Tag: 529,
        SymbolicName: 'NonAlgorithmic',
    },
    {
        Group: '',
        Description: 'Algorithmic',
        added: 'FIX.5.0',
        Value: 'E',
        Sort: 14,
        addedEP: -1,
        Tag: 529,
        SymbolicName: 'Algorithmic',
    },
    {
        Group: '',
        Description: 'Cancel orders for a security',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 530,
        SymbolicName: 'CancelOrdersForASecurity',
    },
    {
        Group: '',
        Description: 'Cancel orders for an underlying security',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 530,
        SymbolicName: 'CancelOrdersForAnUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'Cancel orders for a Product',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 530,
        SymbolicName: 'CancelOrdersForAProduct',
    },
    {
        Group: '',
        Description: 'Cancel orders for a CFICode',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 530,
        SymbolicName: 'CancelOrdersForACFICode',
    },
    {
        Group: '',
        Description: 'Cancel orders for a SecurityType',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 530,
        SymbolicName: 'CancelOrdersForASecurityType',
    },
    {
        Group: '',
        Description: 'Cancel orders for a trading session',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 530,
        SymbolicName: 'CancelOrdersForATradingSession',
    },
    {
        Group: '',
        Description: 'Cancel all orders',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 530,
        SymbolicName: 'CancelAllOrders',
    },
    {
        Group: '',
        Description: 'Cancel orders for a market',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 58,
        Tag: 530,
        SymbolicName: 'CancelOrdersForAMarket',
    },
    {
        Group: '',
        Description: 'Cancel orders for a market segment',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 9,
        addedEP: 58,
        Tag: 530,
        SymbolicName: 'CancelOrdersForAMarketSegment',
    },
    {
        Group: '',
        Description: 'Cancel orders for a security group',
        added: 'FIX.5.0',
        Value: 'A',
        Sort: 10,
        addedEP: 58,
        Tag: 530,
        SymbolicName: 'CancelOrdersForASecurityGroup',
    },
    {
        Group: '',
        Description: 'Cancel Request Rejected - See MassCancelRejectReason (532)',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 531,
        SymbolicName: 'CancelRequestRejected',
    },
    {
        Group: '',
        Description: 'Cancel orders for a security',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 531,
        SymbolicName: 'CancelOrdersForASecurity',
    },
    {
        Group: '',
        Description: 'Cancel orders for an Underlying Security',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 531,
        SymbolicName: 'CancelOrdersForAnUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'Cancel orders for a Product',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 531,
        SymbolicName: 'CancelOrdersForAProduct',
    },
    {
        Group: '',
        Description: 'Cancel orders for a CFICode',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 531,
        SymbolicName: 'CancelOrdersForACFICode',
    },
    {
        Group: '',
        Description: 'Cancel orders for a SecurityType',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 531,
        SymbolicName: 'CancelOrdersForASecurityType',
    },
    {
        Group: '',
        Description: 'Cancel orders for a trading session',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 531,
        SymbolicName: 'CancelOrdersForATradingSession',
    },
    {
        Group: '',
        Description: 'Cancel All Orders',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 531,
        SymbolicName: 'CancelAllOrders',
    },
];

const batch4: ISpecEnums[] = [
    {
        Group: '',
        Description: 'Cancel orders for a market',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 58,
        Tag: 531,
        SymbolicName: 'CancelOrdersForAMarket',
    },
    {
        Group: '',
        Description: 'Cancel orders for a market segment',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 9,
        addedEP: 58,
        Tag: 531,
        SymbolicName: 'CancelOrdersForAMarketSegment',
    },
    {
        Group: '',
        Description: 'Cancel orders for a security group',
        added: 'FIX.5.0',
        Value: 'A',
        Sort: 10,
        addedEP: 58,
        Tag: 531,
        SymbolicName: 'CancelOrdersForASecurityGroup',
    },
    {
        Group: '',
        Description: 'Mass Cancel Not Supported',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 532,
        SymbolicName: 'MassCancelNotSupported',
    },
    {
        Group: '',
        Description: 'Invalid or Unknown Security',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownSecurity',
    },
    {
        Group: '',
        Description: 'Invalid or Unkown Underlying security',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 532,
        SymbolicName: 'InvalidOrUnkownUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'Invalid or Unknown Product',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownProduct',
    },
    {
        Group: '',
        Description: 'Invalid or Unknown CFICode',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownCFICode',
    },
    {
        Group: '',
        Description: 'Invalid or Unknown SecurityType',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownSecurityType',
    },
    {
        Group: '',
        Description: 'Invalid or Unknown Trading Session',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownTradingSession',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Market',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 8,
        addedEP: 58,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownMarket',
    },
    {
        Group: '',
        Description: 'Invalid or unkown Market Segment',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 58,
        Tag: 532,
        SymbolicName: 'InvalidOrUnkownMarketSegment',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Security Group',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 10,
        addedEP: 58,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownSecurityGroup',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 532,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Indicative',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 537,
        SymbolicName: 'Indicative',
    },
    {
        Group: '',
        Description: 'Tradeable',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 537,
        SymbolicName: 'Tradeable',
    },
    {
        Group: '',
        Description: 'Restricted Tradeable',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 3,
        Tag: 537,
        SymbolicName: 'RestrictedTradeable',
    },
    {
        Group: '',
        Description: 'Counter (tradeable)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 537,
        SymbolicName: 'Counter',
    },
    {
        Group: '',
        Description: 'Cash',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 544,
        SymbolicName: 'Cash',
    },
    {
        Group: '',
        Description: 'Margin Open',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 544,
        SymbolicName: 'MarginOpen',
    },
    {
        Group: '',
        Description: 'Margin Close',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 544,
        SymbolicName: 'MarginClose',
    },
    {
        Group: '',
        Description: 'Local Market (Exchange, ECN, ATS)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 546,
        SymbolicName: 'LocalMarket',
    },
    {
        Group: '',
        Description: 'National',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 546,
        SymbolicName: 'National',
    },
    {
        Group: '',
        Description: 'Global',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 546,
        SymbolicName: 'Global',
    },
    {
        Group: '',
        Description:
            'Server must send an explicit delete for bids or offers falling outside the requested MarketDepth of the request',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 547,
        SymbolicName: 'No',
    },
    {
        Group: '',
        Description:
            'Client has responsibility for implicitly deleting bids or offers falling outside the MarketDepth of the request',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 547,
        SymbolicName: 'Yes',
    },
    {
        Group: '',
        Description:
            'Cross AON - cross trade which is executed completely or not. Both sides are treated in the same manner. This is equivalent to an "All or None".',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '1',
        Sort: 1,
        Tag: 549,
        SymbolicName: 'CrossAON',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description:
            'Cross IOC - cross trade which is executed partially and the rest is cancelled. One side is fully executed, the other side is partially executed with the remainder being cancelled. This is equivalent to an IOC on the other side. Note: CrossPrioritization(550) field may be used to indicate which side should fully execute in this scenario.',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '2',
        Sort: 2,
        Tag: 549,
        SymbolicName: 'CrossIOC',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description:
            'Cross One Side - cross trade which is partially executed with the unfilled portions remaining active. One side of the cross is fully executed (as denoted by the CrossPrioritization (550) field), but the unfilled portion remains active.',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '3',
        Sort: 3,
        Tag: 549,
        SymbolicName: 'CrossOneSide',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description:
            'Cross Same Price - cross trade is executed with existing orders with the same price. In this case other orders exist with the same price, the quantity of the Cross is executed against the existing orders and quotes, the remainder of the cross is executed against the other side of the cross. The two sides potentially have different quantities.',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '4',
        Sort: 4,
        Tag: 549,
        SymbolicName: 'CrossSamePrice',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'None',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 550,
        SymbolicName: 'None',
    },
    {
        Group: '',
        Description: 'Buy side is prioritized',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 550,
        SymbolicName: 'BuySideIsPrioritized',
    },
    {
        Group: '',
        Description: 'Sell side is prioritized',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 3,
        Tag: 550,
        SymbolicName: 'SellSideIsPrioritized',
    },
    {
        Group: '',
        Description: 'One Side',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 552,
        SymbolicName: 'OneSide',
    },
    {
        Group: '',
        Description: 'Both Sides',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 552,
        SymbolicName: 'BothSides',
    },
    {
        Group: '',
        Description: 'Symbol',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 559,
        SymbolicName: 'Symbol',
    },
    {
        Group: '',
        Description: 'SecurityType and/or CFICode',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 559,
        SymbolicName: 'SecurityTypeAnd',
    },
    {
        Group: '',
        Description: 'Product',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 559,
        SymbolicName: 'Product',
    },
    {
        Group: '',
        Description: 'TradingSessionID',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 559,
        SymbolicName: 'TradingSessionID',
    },
    {
        Group: '',
        Description: 'All Securities',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 559,
        SymbolicName: 'AllSecurities',
    },
    {
        Group: '',
        Description: 'MarketID or MarketID + MarketSegmentID',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 52,
        Tag: 559,
        SymbolicName: 'MarketIDOrMarketID',
    },
    {
        Group: '',
        Description: 'Valid request',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 560,
        SymbolicName: 'ValidRequest',
    },
    {
        Group: '',
        Description: 'Invalid or unsupported request',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 560,
        SymbolicName: 'InvalidOrUnsupportedRequest',
    },
    {
        Group: '',
        Description: 'No instruments found that match selection criteria',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 560,
        SymbolicName: 'NoInstrumentsFound',
    },
    {
        Group: '',
        Description: 'Not authorized to retrieve instrument data',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 560,
        SymbolicName: 'NotAuthorizedToRetrieveInstrumentData',
    },
    {
        Group: '',
        Description: 'Instrument data temporarily unavailable',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 560,
        SymbolicName: 'InstrumentDataTemporarilyUnavailable',
    },
    {
        Group: '',
        Description: 'Request for instrument data not supported',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 560,
        SymbolicName: 'RequestForInstrumentDataNotSupported',
    },
    {
        Group: '',
        Description: 'Report by mulitleg security only (do not report legs)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 0,
        Tag: 563,
        SymbolicName: 'ReportByMulitlegSecurityOnly',
    },
    {
        Group: '',
        Description: 'Report by multileg security and by instrument legs belonging to the multileg security',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 563,
        SymbolicName: 'ReportByMultilegSecurityAndInstrumentLegs',
    },
    {
        Group: '',
        Description:
            'Report by instrument legs belonging to the multileg security only (do not report status of multileg security)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 563,
        SymbolicName: 'ReportByInstrumentLegsOnly',
    },
    {
        Group: '',
        Description: 'Unknown or invalid TradingSessionID',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 567,
        SymbolicName: 'UnknownOrInvalidTradingSessionID',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 567,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'All Trades',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 569,
        SymbolicName: 'AllTrades',
    },
    {
        Group: '',
        Description:
            'Matched trades matching criteria provided on request (Parties, ExecID, TradeID, OrderID, Instrument, InputSource, etc.)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 569,
        SymbolicName: 'MatchedTradesMatchingCriteria',
    },
    {
        Group: '',
        Description: 'Unmatched trades that match criteria',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 569,
        SymbolicName: 'UnmatchedTradesThatMatchCriteria',
    },
    {
        Group: '',
        Description: 'Unreported trades that match criteria',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 569,
        SymbolicName: 'UnreportedTradesThatMatchCriteria',
    },
    {
        Group: '',
        Description: 'Advisories that match criteria',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 569,
        SymbolicName: 'AdvisoriesThatMatchCriteria',
    },
    {
        Group: '',
        Description: 'Not reported to counterparty',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 570,
        SymbolicName: 'NotReportedToCounterparty',
    },
    {
        Group: '',
        Description: 'Perviously reported to counterparty',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 570,
        SymbolicName: 'PerviouslyReportedToCounterparty',
    },
    {
        Group: '',
        Description: 'Compared, matched or affirmed',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 573,
        SymbolicName: 'Compared',
    },
    {
        Group: '',
        Description: 'Uncompared, unmatched, or unaffirmed',
        added: 'FIX.4.3',
        updatedEP: 95,
        Value: '1',
        Sort: 1,
        Tag: 573,
        SymbolicName: 'Uncompared',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Advisory or alert',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 573,
        SymbolicName: 'AdvisoryOrAlert',
    },
    {
        Group: 'General Purpose',
        Description: 'One-Party Trade Report (privately negotiated trade)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 70,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'OnePartyTradeReport',
    },
    {
        Group: 'General Purpose',
        Description: 'Two-Party Trade Report (privately negotiated trade)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 71,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'TwoPartyTradeReport',
    },
    {
        Group: 'General Purpose',
        Description: 'Confirmed Trade Report (reporting from recognized markets)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 72,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'ConfirmedTradeReport',
    },
    {
        Group: 'General Purpose',
        Description: 'Auto-match',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 73,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'AutoMatch',
    },
    {
        Group: 'General Purpose',
        Description: 'Cross Auction',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 74,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'CrossAuction',
    },
    {
        Group: 'General Purpose',
        Description: 'Counter-Order Selection',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 75,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'CounterOrderSelection',
    },
    {
        Group: 'General Purpose',
        Description: 'Call Auction',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 76,
        addedEP: 22,
        Tag: 574,
        SymbolicName: 'CallAuction',
    },
    {
        Group: 'General Purpose',
        Description: 'Issuing/Buy Back Auction',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 77,
        addedEP: 47,
        Tag: 574,
        SymbolicName: 'Issuing',
    },
    {
        Group: 'NASDAQ',
        Description: 'ACT Accepted Trade',
        added: 'FIX.4.3',
        Value: 'M3',
        Sort: 2,
        Tag: 574,
        SymbolicName: 'ACTAcceptedTrade',
    },
    {
        Group: 'NASDAQ',
        Description: 'ACT Default Trade',
        added: 'FIX.4.3',
        Value: 'M4',
        Sort: 3,
        Tag: 574,
        SymbolicName: 'ACTDefaultTrade',
    },
    {
        Group: 'NASDAQ',
        Description: 'ACT Default After M2',
        added: 'FIX.4.3',
        Value: 'M5',
        Sort: 4,
        Tag: 574,
        SymbolicName: 'ACTDefaultAfterM2',
    },
    {
        Group: 'NASDAQ',
        Description: 'ACT M6 Match',
        added: 'FIX.4.3',
        Value: 'M6',
        Sort: 5,
        Tag: 574,
        SymbolicName: 'ACTM6Match',
    },
    {
        Group: 'NYSE and AMEX',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator plus four badges and execution time (within two-minute window)',
        added: 'FIX.4.3',
        Value: 'A1',
        Sort: 0,
        Tag: 574,
        SymbolicName: 'ExactMatchPlus4BadgesExecTime',
    },
    {
        Group: 'NYSE and AMEX',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus four badges',
        added: 'FIX.4.3',
        Value: 'A2',
        Sort: 1,
        Tag: 574,
        SymbolicName: 'ExactMatchPlus4Badges',
    },
    {
        Group: 'NYSE and AMEX',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges and execution time (within two-minute window)',
        added: 'FIX.4.3',
        Value: 'A3',
        Sort: 2,
        Tag: 574,
        SymbolicName: 'ExactMatchPlus2BadgesExecTime',
    },
    {
        Group: 'NYSE and AMEX',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges',
        added: 'FIX.4.3',
        Value: 'A4',
        Sort: 3,
        Tag: 574,
        SymbolicName: 'ExactMatchPlus2Badges',
    },
    {
        Group: 'NYSE and AMEX',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, TradeType, and Special Trade Indicator plus execution time (within two-minute window)',
        added: 'FIX.4.3',
        Value: 'A5',
        Sort: 4,
        Tag: 574,
        SymbolicName: 'ExactMatchPlusExecTime',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Compared records resulting from stamped advisories or specialist accepts/pair-offs',
        added: 'FIX.4.3',
        Value: 'AQ',
        Sort: 5,
        Tag: 574,
        SymbolicName: 'StampedAdvisoriesOrSpecialistAccepts',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Summarized match using A1 exact match criteria except quantity is summaried',
        added: 'FIX.4.3',
        Value: 'S1',
        Sort: 6,
        Tag: 574,
        SymbolicName: 'A1ExactMatchSummarizedQuantity',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Summarized match using A2 exact match criteria except quantity is summarized',
        added: 'FIX.4.3',
        Value: 'S2',
        Sort: 7,
        Tag: 574,
        SymbolicName: 'A2ExactMatchSummarizedQuantity',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Summarized match using A3 exact match criteria except quantity is summarized',
        added: 'FIX.4.3',
        Value: 'S3',
        Sort: 8,
        Tag: 574,
        SymbolicName: 'A3ExactMatchSummarizedQuantity',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Summarized match using A4 exact match criteria except quantity is summarized',
        added: 'FIX.4.3',
        Value: 'S4',
        Sort: 9,
        Tag: 574,
        SymbolicName: 'A4ExactMatchSummarizedQuantity',
    },
    {
        Group: 'NYSE and AMEX',
        Description: 'Summarized match using A5 exact match criteria except quantity is summarized',
        added: 'FIX.4.3',
        Value: 'S5',
        Sort: 10,
        Tag: 574,
        SymbolicName: 'A5ExactMatchSummarizedQuantity',
    },
    {
        Group: 'NYSE, AMEX and NASDAQ',
        Description:
            'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator minus badges And times: ACT M1 match',
        added: 'FIX.4.3',
        Value: 'M1',
        Sort: 11,
        Tag: 574,
        SymbolicName: 'ExactMatchMinusBadgesTimes',
    },
    {
        Group: 'NYSE, AMEX and NASDAQ',
        Description: 'Summarized match minus badges and times: ACT M2 Match',
        added: 'FIX.4.3',
        Value: 'M2',
        Sort: 12,
        Tag: 574,
        SymbolicName: 'SummarizedMatchMinusBadgesTimes',
    },
    {
        Group: 'NYSE, AMEX and NASDAQ',
        Description: 'OCS Locked In: Non-ACT',
        added: 'FIX.4.3',
        Value: 'MT',
        Sort: 13,
        Tag: 574,
        SymbolicName: 'OCSLockedIn',
    },
    {
        Group: '',
        Description: 'Treat as round lot (default)',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 1,
        Tag: 575,
        SymbolicName: 'TreatAsRoundLot',
    },
    {
        Group: '',
        Description: 'Treat as odd lot',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 2,
        Tag: 575,
        SymbolicName: 'TreatAsOddLot',
    },
    {
        Group: '',
        Description: 'Process normally',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 0,
        Tag: 577,
        SymbolicName: 'ProcessNormally',
    },
    {
        Group: '',
        Description: 'Exclude from all netting',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 577,
        SymbolicName: 'ExcludeFromAllNetting',
    },
    {
        Group: '',
        Description: 'Bilateral netting only',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 577,
        SymbolicName: 'BilateralNettingOnly',
    },
    {
        Group: '',
        Description: 'Ex clearing',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 577,
        SymbolicName: 'ExClearing',
    },
    {
        Group: '',
        Description: 'Special trade',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 577,
        SymbolicName: 'SpecialTrade',
    },
    {
        Group: '',
        Description: 'Multilateral netting',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 577,
        SymbolicName: 'MultilateralNetting',
    },
    {
        Group: '',
        Description: 'Clear against central counterparty',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 577,
        SymbolicName: 'ClearAgainstCentralCounterparty',
    },
    {
        Group: '',
        Description: 'Exclude from central counterparty',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 577,
        SymbolicName: 'ExcludeFromCentralCounterparty',
    },
    {
        Group: '',
        Description: 'Manual mode (pre-posting and/or pre-giveup)',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 577,
        SymbolicName: 'ManualMode',
    },
    {
        Group: '',
        Description: 'Automatic posting mode (trade posting to the position account number specified)',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 9,
        Tag: 577,
        SymbolicName: 'AutomaticPostingMode',
    },
    {
        Group: '',
        Description: 'Automatic give-up mode (trade give-up to the give-up destination number specified)',
        added: 'FIX.4.3',
        Value: '10',
        Sort: 10,
        Tag: 577,
        SymbolicName: 'AutomaticGiveUpMode',
    },
    {
        Group: '',
        Description: 'Qualified Service Representative QSR',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        Tag: 577,
        SymbolicName: 'QualifiedServiceRepresentativeQSR',
    },
    {
        Group: '',
        Description: 'Customer trade',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        Tag: 577,
        SymbolicName: 'CustomerTrade',
    },
    {
        Group: '',
        Description: 'Self clearing',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        Tag: 577,
        SymbolicName: 'SelfClearing',
    },
    {
        Group: '',
        Description: 'Account is carried on customer side of the books',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 581,
        SymbolicName: 'CarriedCustomerSide',
    },
    {
        Group: '',
        Description: 'Account is carried on non-customer side of books',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 581,
        SymbolicName: 'CarriedNonCustomerSide',
    },
    {
        Group: '',
        Description: 'House Trader',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 581,
        SymbolicName: 'HouseTrader',
    },
    {
        Group: '',
        Description: 'Floor Trader',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 581,
        SymbolicName: 'FloorTrader',
    },
    {
        Group: '',
        Description: 'Account is carried on non-customer side of books and is cross margined',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 5,
        Tag: 581,
        SymbolicName: 'CarriedNonCustomerSideCrossMargined',
    },
    {
        Group: '',
        Description: 'Account is house trader and is cross margined',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 6,
        Tag: 581,
        SymbolicName: 'HouseTraderCrossMargined',
    },
    {
        Group: '',
        Description: 'Joint back office account (JBO)',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 7,
        Tag: 581,
        SymbolicName: 'JointBackOfficeAccount',
    },
    {
        Group: '',
        Description: 'Member trading for their own account',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 582,
        SymbolicName: 'MemberTradingForTheirOwnAccount',
    },
    {
        Group: '',
        Description: 'Clearing Firm trading for its proprietary account',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 582,
        SymbolicName: 'ClearingFirmTradingForItsProprietaryAccount',
    },
    {
        Group: '',
        Description: 'Member trading for another member',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 582,
        SymbolicName: 'MemberTradingForAnotherMember',
    },
    {
        Group: '',
        Description: 'All other',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 582,
        SymbolicName: 'AllOther',
    },
    {
        Group: '',
        Description: 'Status for orders for a Security',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForASecurity',
    },
    {
        Group: '',
        Description: 'Status for orders for an Underlying Security',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForAnUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'Status for orders for a Product',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForAProduct',
    },
    {
        Group: '',
        Description: 'Status for orders for a CFICode',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForACFICode',
    },
    {
        Group: '',
        Description: 'Status for orders for a SecurityType',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForASecurityType',
    },
    {
        Group: '',
        Description: 'Status for orders for a trading session',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 6,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForATradingSession',
    },
    {
        Group: '',
        Description: 'Status for all orders',
        added: 'FIX.4.3',
        Value: '7',
        Sort: 7,
        Tag: 585,
        SymbolicName: 'StatusForAllOrders',
    },
    {
        Group: '',
        Description: 'Status for orders for a PartyID',
        added: 'FIX.4.3',
        Value: '8',
        Sort: 8,
        Tag: 585,
        SymbolicName: 'StatusForOrdersForAPartyID',
    },
    {
        Group: '',
        Description: 'Can trigger booking without reference to the order initiator ("auto")',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 589,
        SymbolicName: 'Auto',
    },
    {
        Group: '',
        Description: 'Speak with order initiator before booking ("speak first")',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 589,
        SymbolicName: 'SpeakWithOrderInitiatorBeforeBooking',
    },
    {
        Group: '',
        Description: 'Accumulate',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 589,
        SymbolicName: 'Accumulate',
    },
    {
        Group: '',
        Description: 'Each partial execution is a bookable unit',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 590,
        SymbolicName: 'EachPartialExecutionIsABookableUnit',
    },
    {
        Group: '',
        Description: 'Aggregate partial executions on this order, and book one trade per order',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 590,
        SymbolicName: 'AggregatePartialExecutionsOnThisOrder',
    },
    {
        Group: '',
        Description: 'Aggregate executions for this symbol, side, and settlement date',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 3,
        Tag: 590,
        SymbolicName: 'AggregateExecutionsForThisSymbol',
    },
    {
        Group: '',
        Description: 'Pro rata',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 591,
        SymbolicName: 'ProRata',
    },
    {
        Group: '',
        Description: 'Do not pro-rata - discuss first',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 591,
        SymbolicName: 'DoNotProRata',
    },
    {
        Group: '',
        Description: 'Pre-Trading',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'PreTrading',
    },
    {
        Group: '',
        Description: 'Opening or opening auction',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'OpeningOrOpeningAuction',
    },
    {
        Group: '',
        Description: '(Continuous) Trading',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'Continuous',
    },
    {
        Group: '',
        Description: 'Closing or closing auction',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'ClosingOrClosingAuction',
    },
    {
        Group: '',
        Description: 'Post-Trading',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 5,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'PostTrading',
    },
    {
        Group: '',
        Description: 'Intraday Auction',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 6,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'IntradayAuction',
    },
    {
        Group: '',
        Description: 'Quiescent',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 58,
        Tag: 625,
        SymbolicName: 'Quiescent',
    },
    {
        Group: '',
        Description: 'Calculated (includes MiscFees and NetMoney)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 626,
        SymbolicName: 'Calculated',
    },
    {
        Group: '',
        Description: 'Preliminary (without MiscFees and NetMoney)',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 626,
        SymbolicName: 'Preliminary',
    },
    {
        Group: '',
        Description: 'Sellside Calculated Using Preliminary (includes MiscFees and NetMoney) (Replaced)',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.2',
        Value: '3',
        Sort: 3,
        Tag: 626,
        SymbolicName: 'SellsideCalculatedUsingPreliminary',
    },
    {
        Group: '',
        Description:
            'Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney) (Replaced)',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.2',
        Value: '4',
        Sort: 4,
        Tag: 626,
        SymbolicName: 'SellsideCalculatedWithoutPreliminary',
    },
    {
        Group: '',
        Description: 'Ready-To-Book - Single Order',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 626,
        SymbolicName: 'ReadyToBook',
    },
    {
        Group: '',
        Description: 'Buyside Ready-To-Book - Combined Set of Orders (Replaced)',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.2',
        Value: '6',
        Sort: 6,
        Tag: 626,
        SymbolicName: 'BuysideReadyToBook',
    },
    {
        Group: '',
        Description: 'Warehouse Instruction',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        Tag: 626,
        SymbolicName: 'WarehouseInstruction',
    },
    {
        Group: '',
        Description: 'Request to Intermediary',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        Tag: 626,
        SymbolicName: 'RequestToIntermediary',
    },
    {
        Group: '',
        Description: 'Accept',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'Accept',
    },
    {
        Group: '',
        Description: 'Reject',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 10,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'Reject',
    },
    {
        Group: '',
        Description: 'Accept Pending',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'AcceptPending',
    },
    {
        Group: '',
        Description: 'Incomplete Group',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'IncompleteGroup',
    },
    {
        Group: '',
        Description: 'Complete Group',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'CompleteGroup',
    },
    {
        Group: '',
        Description: 'Reversal Pending',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 14,
        addedEP: 5,
        Tag: 626,
        SymbolicName: 'ReversalPending',
    },
    {
        Group: '',
        Description: '1st year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 1,
        Tag: 635,
        SymbolicName: 'FirstYearDelegate',
    },
    {
        Group: '',
        Description: '2nd year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 2,
        Tag: 635,
        SymbolicName: 'SecondYearDelegate',
    },
    {
        Group: '',
        Description: '3rd year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 3,
        Tag: 635,
        SymbolicName: 'ThirdYearDelegate',
    },
    {
        Group: '',
        Description: '4th year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 4,
        Tag: 635,
        SymbolicName: 'FourthYearDelegate',
    },
    {
        Group: '',
        Description: '5th year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 5,
        Tag: 635,
        SymbolicName: 'FifthYearDelegate',
    },
    {
        Group: '',
        Description: '6th year delegate trading for own account',
        added: 'FIX.4.3',
        Value: '9',
        Sort: 6,
        Tag: 635,
        SymbolicName: 'SixthYearDelegate',
    },
    {
        Group: '',
        Description: 'CBOE Member',
        added: 'FIX.4.3',
        Value: 'B',
        Sort: 7,
        Tag: 635,
        SymbolicName: 'CBOEMember',
    },
    {
        Group: '',
        Description: 'Non-member and Customer',
        added: 'FIX.4.3',
        Value: 'C',
        Sort: 8,
        Tag: 635,
        SymbolicName: 'NonMemberAndCustomer',
    },
    {
        Group: '',
        Description: 'Equity Member and Clearing Member',
        added: 'FIX.4.3',
        Value: 'E',
        Sort: 9,
        Tag: 635,
        SymbolicName: 'EquityMemberAndClearingMember',
    },
    {
        Group: '',
        Description: 'Full and Associate Member trading for own account and as floor brokers',
        added: 'FIX.4.3',
        Value: 'F',
        Sort: 10,
        Tag: 635,
        SymbolicName: 'FullAndAssociateMember',
    },
    {
        Group: '',
        Description: '106.H and 106.J firms',
        added: 'FIX.4.3',
        Value: 'H',
        Sort: 11,
        Tag: 635,
        SymbolicName: 'Firms106HAnd106J',
    },
    {
        Group: '',
        Description: 'GIM, IDEM and COM Membership Interest Holders',
        added: 'FIX.4.3',
        Value: 'I',
        Sort: 12,
        Tag: 635,
        SymbolicName: 'GIM',
    },
    {
        Group: '',
        Description: 'Lessee 106.F Employees',
        added: 'FIX.4.3',
        Value: 'L',
        Sort: 13,
        Tag: 635,
        SymbolicName: 'Lessee106FEmployees',
    },
    {
        Group: '',
        Description: 'All other ownership types',
        added: 'FIX.4.3',
        Value: 'M',
        Sort: 14,
        Tag: 635,
        SymbolicName: 'AllOtherOwnershipTypes',
    },
    {
        Group: '',
        Description: 'Order has been accepted but not yet in a working state',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 636,
        SymbolicName: 'NotWorking',
    },
    {
        Group: '',
        Description: 'Order is currently being worked',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 636,
        SymbolicName: 'Working',
    },
    {
        Group: '',
        Description: 'Priority unchanged',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 638,
        SymbolicName: 'PriorityUnchanged',
    },
    {
        Group: '',
        Description: 'Lost Priority as result of order change',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 638,
        SymbolicName: 'LostPriorityAsResultOfOrderChange',
    },
    {
        Group: '',
        Description: 'Does not consitute a Legal Confirm',
        added: 'FIX.4.3',
        Value: 'N',
        Sort: 1,
        Tag: 650,
        SymbolicName: 'DoesNotConsituteALegalConfirm',
    },
    {
        Group: '',
        Description: 'Legal Confirm',
        added: 'FIX.4.3',
        Value: 'Y',
        Sort: 2,
        Tag: 650,
        SymbolicName: 'LegalConfirm',
    },
    {
        Group: '',
        Description: 'Pending Approval',
        added: 'FIX.4.3',
        Value: '0',
        Sort: 1,
        Tag: 653,
        SymbolicName: 'PendingApproval',
    },
    {
        Group: '',
        Description: 'Approved (Accepted)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 2,
        Tag: 653,
        SymbolicName: 'Approved',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 3,
        Tag: 653,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Unauthorized Request',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 4,
        Tag: 653,
        SymbolicName: 'UnauthorizedRequest',
    },
    {
        Group: '',
        Description: 'Invalid Definition Request',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 5,
        Tag: 653,
        SymbolicName: 'InvalidDefinitionRequest',
    },
    {
        Group: '',
        Description: 'Unknown Symbol (Security)',
        added: 'FIX.4.3',
        Value: '1',
        Sort: 0,
        Tag: 658,
        SymbolicName: 'UnknownSymbol',
    },
    {
        Group: '',
        Description: 'Exchange (Security) Closed',
        added: 'FIX.4.3',
        Value: '2',
        Sort: 1,
        Tag: 658,
        SymbolicName: 'Exchange',
    },
    {
        Group: '',
        Description: 'Quote Request Exceeds Limit',
        added: 'FIX.4.3',
        Value: '3',
        Sort: 2,
        Tag: 658,
        SymbolicName: 'QuoteRequestExceedsLimit',
    },
    {
        Group: '',
        Description: 'Too Late to enter',
        added: 'FIX.4.3',
        Value: '4',
        Sort: 3,
        Tag: 658,
        SymbolicName: 'TooLateToEnter',
    },
    {
        Group: '',
        Description: 'Invalid Price',
        added: 'FIX.4.3',
        Value: '5',
        Sort: 4,
        Tag: 658,
        SymbolicName: 'InvalidPrice',
    },
    {
        Group: '',
        Description: 'Not Authorized To Request Quote',
        added: 'FIX.4.3',
        Value: '6',
        Sort: 5,
        Tag: 658,
        SymbolicName: 'NotAuthorizedToRequestQuote',
    },
    {
        Group: '',
        Description: 'No Match For Inquiry',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 6,
        Tag: 658,
        SymbolicName: 'NoMatchForInquiry',
    },
    {
        Group: '',
        Description: 'No Market For Instrument',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 658,
        SymbolicName: 'NoMarketForInstrument',
    },
    {
        Group: '',
        Description: 'No Inventory',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 658,
        SymbolicName: 'NoInventory',
    },
    {
        Group: '',
        Description: 'Pass',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 658,
        SymbolicName: 'Pass',
    },
    {
        Group: '',
        Description: 'Insufficient credit',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 10,
        addedEP: 21,
        Tag: 658,
        SymbolicName: 'InsufficientCredit',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 658,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'BIC',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 660,
        SymbolicName: 'BIC',
    },
    {
        Group: '',
        Description: 'SID Code',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 660,
        SymbolicName: 'SIDCode',
    },
    {
        Group: '',
        Description: 'TFM (GSPTA)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 660,
        SymbolicName: 'TFM',
    },
    {
        Group: '',
        Description: 'OMGEO (Alert ID)',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 660,
        SymbolicName: 'OMGEO',
    },
    {
        Group: '',
        Description: 'DTCC Code',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 660,
        SymbolicName: 'DTCCCode',
    },
    {
        Group: '',
        Description: 'Other (custom or proprietary)',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 660,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Received',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 665,
        SymbolicName: 'Received',
    },
    {
        Group: '',
        Description: 'Mismatched Account',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 665,
        SymbolicName: 'MismatchedAccount',
    },
    {
        Group: '',
        Description: 'Missing Settlement Instructions',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 665,
        SymbolicName: 'MissingSettlementInstructions',
    },
    {
        Group: '',
        Description: 'Confirmed',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 665,
        SymbolicName: 'Confirmed',
    },
    {
        Group: '',
        Description: 'Request Rejected',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 665,
        SymbolicName: 'RequestRejected',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 666,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 666,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 666,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Book Entry (default)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 668,
        SymbolicName: 'BookEntry',
    },
    {
        Group: '',
        Description: 'Bearer',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 668,
        SymbolicName: 'Bearer',
    },
    {
        Group: '',
        Description: 'Par For Par',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 690,
        SymbolicName: 'ParForPar',
    },
    {
        Group: '',
        Description: 'Modified Duration',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 690,
        SymbolicName: 'ModifiedDuration',
    },
    {
        Group: '',
        Description: 'Risk',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 690,
        SymbolicName: 'Risk',
    },
    {
        Group: '',
        Description: 'Proceeds',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        Tag: 690,
        SymbolicName: 'Proceeds',
    },
    {
        Group: '',
        Description: 'Percent (percent of par)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 0,
        Tag: 692,
        SymbolicName: 'Percent',
    },
    {
        Group: '',
        Description: 'Per Share (e.g. cents per share)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        Tag: 692,
        SymbolicName: 'PerShare',
    },
    {
        Group: '',
        Description: 'Fixed Amount (absolute value)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 2,
        Tag: 692,
        SymbolicName: 'FixedAmount',
    },
    {
        Group: '',
        Description: 'Discount - percentage points below par',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 692,
        SymbolicName: 'Discount',
    },
    {
        Group: '',
        Description: 'Premium - percentage points over par',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        Tag: 692,
        SymbolicName: 'Premium',
    },
    {
        Group: '',
        Description: 'Spread - basis points relative to benchmark',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 5,
        Tag: 692,
        SymbolicName: 'Spread',
    },
    {
        Group: '',
        Description: 'TED Price',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 6,
        Tag: 692,
        SymbolicName: 'TEDPrice',
    },
    {
        Group: '',
        Description: 'TED Yield',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 692,
        SymbolicName: 'TEDYield',
    },
    {
        Group: '',
        Description: 'Yield Spread (swaps)',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 692,
        SymbolicName: 'YieldSpread',
    },
    {
        Group: '',
        Description: 'Yield',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 692,
        SymbolicName: 'Yield',
    },
    {
        Group: '',
        Description: 'Hit/Lift',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 694,
        SymbolicName: 'Hit',
    },
    {
        Group: '',
        Description: 'Counter',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 694,
        SymbolicName: 'Counter',
    },
    {
        Group: '',
        Description: 'Expired',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 694,
        SymbolicName: 'Expired',
    },
    {
        Group: '',
        Description: 'Cover',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 694,
        SymbolicName: 'Cover',
    },
    {
        Group: '',
        Description: 'Done Away',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 694,
        SymbolicName: 'DoneAway',
    },
    {
        Group: '',
        Description: 'Pass',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        Tag: 694,
        SymbolicName: 'Pass',
    },
    {
        Group: '',
        Description: 'End Trade',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 68,
        Tag: 694,
        SymbolicName: 'EndTrade',
    },
    {
        Group: '',
        Description: 'Timed Out',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 68,
        Tag: 694,
        SymbolicName: 'TimedOut',
    },
    {
        Group: '',
        Description: 'Allocation Trade Qty',
        added: 'FIX.4.4',
        Value: 'ALC',
        Sort: 1,
        Tag: 703,
        SymbolicName: 'AllocationTradeQty',
    },
    {
        Group: '',
        Description: 'Option Assignment',
        added: 'FIX.4.4',
        Value: 'AS',
        Sort: 2,
        Tag: 703,
        SymbolicName: 'OptionAssignment',
    },
    {
        Group: '',
        Description: 'As-of Trade Qty',
        added: 'FIX.4.4',
        Value: 'ASF',
        Sort: 3,
        Tag: 703,
        SymbolicName: 'AsOfTradeQty',
    },
    {
        Group: '',
        Description: 'Delivery Qty',
        added: 'FIX.4.4',
        Value: 'DLV',
        Sort: 4,
        Tag: 703,
        SymbolicName: 'DeliveryQty',
    },
    {
        Group: '',
        Description: 'Electronic Trade Qty',
        added: 'FIX.4.4',
        Value: 'ETR',
        Sort: 5,
        Tag: 703,
        SymbolicName: 'ElectronicTradeQty',
    },
    {
        Group: '',
        Description: 'Option Exercise Qty',
        added: 'FIX.4.4',
        Value: 'EX',
        Sort: 6,
        Tag: 703,
        SymbolicName: 'OptionExerciseQty',
    },
    {
        Group: '',
        Description: 'End-of-Day Qty',
        added: 'FIX.4.4',
        Value: 'FIN',
        Sort: 7,
        Tag: 703,
        SymbolicName: 'EndOfDayQty',
    },
    {
        Group: '',
        Description: 'Intra-spread Qty',
        added: 'FIX.4.4',
        Value: 'IAS',
        Sort: 8,
        Tag: 703,
        SymbolicName: 'IntraSpreadQty',
    },
    {
        Group: '',
        Description: 'Inter-spread Qty',
        added: 'FIX.4.4',
        Value: 'IES',
        Sort: 9,
        Tag: 703,
        SymbolicName: 'InterSpreadQty',
    },
    {
        Group: '',
        Description: 'Adjustment Qty',
        added: 'FIX.4.4',
        Value: 'PA',
        Sort: 10,
        Tag: 703,
        SymbolicName: 'AdjustmentQty',
    },
    {
        Group: '',
        Description: 'Pit Trade Qty',
        added: 'FIX.4.4',
        Value: 'PIT',
        Sort: 11,
        Tag: 703,
        SymbolicName: 'PitTradeQty',
    },
    {
        Group: '',
        Description: 'Start-of-Day Qty',
        added: 'FIX.4.4',
        Value: 'SOD',
        Sort: 12,
        Tag: 703,
        SymbolicName: 'StartOfDayQty',
    },
    {
        Group: '',
        Description: 'Integral Split',
        added: 'FIX.4.4',
        Value: 'SPL',
        Sort: 13,
        Tag: 703,
        SymbolicName: 'IntegralSplit',
    },
    {
        Group: '',
        Description: 'Transaction from Assignment',
        added: 'FIX.4.4',
        Value: 'TA',
        Sort: 14,
        Tag: 703,
        SymbolicName: 'TransactionFromAssignment',
    },
    {
        Group: '',
        Description: 'Total Transaction Qty',
        added: 'FIX.4.4',
        Value: 'TOT',
        Sort: 15,
        Tag: 703,
        SymbolicName: 'TotalTransactionQty',
    },
    {
        Group: '',
        Description: 'Transaction Quantity',
        added: 'FIX.4.4',
        Value: 'TQ',
        Sort: 16,
        Tag: 703,
        SymbolicName: 'TransactionQuantity',
    },
    {
        Group: '',
        Description: 'Transfer Trade Qty',
        added: 'FIX.4.4',
        Value: 'TRF',
        Sort: 17,
        Tag: 703,
        SymbolicName: 'TransferTradeQty',
    },
    {
        Group: '',
        Description: 'Transaction from Exercise',
        added: 'FIX.4.4',
        Value: 'TX',
        Sort: 18,
        Tag: 703,
        SymbolicName: 'TransactionFromExercise',
    },
    {
        Group: '',
        Description: 'Cross Margin Qty',
        added: 'FIX.4.4',
        Value: 'XM',
        Sort: 19,
        Tag: 703,
        SymbolicName: 'CrossMarginQty',
    },
    {
        Group: '',
        Description: 'Receive Quantity',
        added: 'FIX.4.4',
        Value: 'RCV',
        Sort: 20,
        addedEP: 4,
        Tag: 703,
        SymbolicName: 'ReceiveQuantity',
    },
    {
        Group: '',
        Description: 'Corporate Action Adjustment',
        added: 'FIX.4.4',
        Value: 'CAA',
        Sort: 21,
        addedEP: 4,
        Tag: 703,
        SymbolicName: 'CorporateActionAdjustment',
    },
    {
        Group: '',
        Description: 'Delivery Notice Qty',
        added: 'FIX.4.4',
        Value: 'DN',
        Sort: 22,
        addedEP: 13,
        Tag: 703,
        SymbolicName: 'DeliveryNoticeQty',
    },
    {
        Group: '',
        Description: 'Exchange for Physical Qty',
        added: 'FIX.4.4',
        Value: 'EP',
        Sort: 23,
        addedEP: 13,
        Tag: 703,
        SymbolicName: 'ExchangeForPhysicalQty',
    },
    {
        Group: '',
        Description: 'Privately negotiated Trade Qty (Non-regulated)',
        added: 'FIX.5.0',
        Value: 'PNTN',
        Sort: 24,
        addedEP: 55,
        Tag: 703,
        SymbolicName: 'PrivatelyNegotiatedTradeQty',
    },
    {
        Group: '',
        Description: 'Submitted',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 706,
        SymbolicName: 'Submitted',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 706,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 706,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Cash Amount (Corporate Event)',
        added: 'FIX.4.4',
        Value: 'CASH',
        Sort: 0,
        Tag: 707,
        SymbolicName: 'CashAmount',
    },
    {
        Group: '',
        Description: 'Cash Residual Amount',
        added: 'FIX.4.4',
        Value: 'CRES',
        Sort: 1,
        Tag: 707,
        SymbolicName: 'CashResidualAmount',
    },
    {
        Group: '',
        Description: 'Final Mark-to-Market Amount',
        added: 'FIX.4.4',
        Value: 'FMTM',
        Sort: 2,
        Tag: 707,
        SymbolicName: 'FinalMarkToMarketAmount',
    },
    {
        Group: '',
        Description: 'Incremental Mark-to-Market Amount',
        added: 'FIX.4.4',
        Value: 'IMTM',
        Sort: 3,
        Tag: 707,
        SymbolicName: 'IncrementalMarkToMarketAmount',
    },
    {
        Group: '',
        Description: 'Premium Amount',
        added: 'FIX.4.4',
        Value: 'PREM',
        Sort: 4,
        Tag: 707,
        SymbolicName: 'PremiumAmount',
    },
    {
        Group: '',
        Description: 'Start-of-Day Mark-to-Market Amount',
        added: 'FIX.4.4',
        Value: 'SMTM',
        Sort: 5,
        Tag: 707,
        SymbolicName: 'StartOfDayMarkToMarketAmount',
    },
    {
        Group: '',
        Description: 'Trade Variation Amount',
        added: 'FIX.4.4',
        Value: 'TVAR',
        Sort: 6,
        Tag: 707,
        SymbolicName: 'TradeVariationAmount',
    },
    {
        Group: '',
        Description: 'Value Adjusted Amount',
        added: 'FIX.4.4',
        Value: 'VADJ',
        Sort: 7,
        Tag: 707,
        SymbolicName: 'ValueAdjustedAmount',
    },
    {
        Group: '',
        Description: 'Settlement Value',
        added: 'FIX.4.4',
        Value: 'SETL',
        Sort: 8,
        addedEP: 4,
        Tag: 707,
        SymbolicName: 'SettlementValue',
    },
    {
        Group: '',
        Description: 'Exercise',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 709,
        SymbolicName: 'Exercise',
    },
    {
        Group: '',
        Description: 'Do Not Exercise',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 709,
        SymbolicName: 'DoNotExercise',
    },
    {
        Group: '',
        Description: 'Position Adjustment',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 709,
        SymbolicName: 'PositionAdjustment',
    },
    {
        Group: '',
        Description: 'Position Change Submission/Margin Disposition',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 709,
        SymbolicName: 'PositionChangeSubmission',
    },
    {
        Group: '',
        Description: 'Pledge',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 709,
        SymbolicName: 'Pledge',
    },
    {
        Group: '',
        Description: 'Large Trader Submission',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        addedEP: 13,
        Tag: 709,
        SymbolicName: 'LargeTraderSubmission',
    },
    {
        Group: '',
        Description: 'New - used to increment the overall transaction quantity',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 712,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description:
            'Replace - used to override the overall transaction quantity or specifi add messages based on the reference ID',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 712,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Cancel - used to remove the overall transaction or specific add messages based on reference ID',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 712,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Reverse - used to completelly back-out the transaction such that the transaction never existed',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: 4,
        Tag: 712,
        SymbolicName: 'Reverse',
    },
    {
        Group: '',
        Description: 'Intraday',
        added: 'FIX.4.4',
        Value: 'ITD',
        Sort: 1,
        addedEP: 1,
        Tag: 716,
        SymbolicName: 'Intraday',
    },
    {
        Group: '',
        Description: 'Regular Trading Hours',
        added: 'FIX.4.4',
        Value: 'RTH',
        Sort: 2,
        addedEP: 1,
        Tag: 716,
        SymbolicName: 'RegularTradingHours',
    },
    {
        Group: '',
        Description: 'Electronic Trading Hours',
        added: 'FIX.4.4',
        Value: 'ETH',
        Sort: 3,
        addedEP: 1,
        Tag: 716,
        SymbolicName: 'ElectronicTradingHours',
    },
    {
        Group: '',
        Description: 'End Of Day',
        added: 'FIX.4.4',
        Value: 'EOD',
        Sort: 4,
        addedEP: 4,
        Tag: 716,
        SymbolicName: 'EndOfDay',
    },
    {
        Group: '',
        Description: 'Process Request As Margin Disposition',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 718,
        SymbolicName: 'ProcessRequestAsMarginDisposition',
    },
    {
        Group: '',
        Description: 'Delta Plus',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 718,
        SymbolicName: 'DeltaPlus',
    },
    {
        Group: '',
        Description: 'Delta Minus',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 718,
        SymbolicName: 'DeltaMinus',
    },
    {
        Group: '',
        Description: 'Final',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 718,
        SymbolicName: 'Final',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 722,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Accepted With Warnings',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 722,
        SymbolicName: 'AcceptedWithWarnings',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 722,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Completed',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 722,
        SymbolicName: 'Completed',
    },
    {
        Group: '',
        Description: 'Completed With Warnings',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 722,
        SymbolicName: 'CompletedWithWarnings',
    },
    {
        Group: '',
        Description: 'Successful Completion - no warnings or errors',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 723,
        SymbolicName: 'SuccessfulCompletion',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 723,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 723,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Positions',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 724,
        SymbolicName: 'Positions',
    },
    {
        Group: '',
        Description: 'Trades',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 724,
        SymbolicName: 'Trades',
    },
    {
        Group: '',
        Description: 'Exercises',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 724,
        SymbolicName: 'Exercises',
    },
    {
        Group: '',
        Description: 'Assignments',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 724,
        SymbolicName: 'Assignments',
    },
    {
        Group: '',
        Description: 'Settlement Activity',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: 4,
        Tag: 724,
        SymbolicName: 'SettlementActivity',
    },
    {
        Group: '',
        Description: 'Backout Message',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        addedEP: 4,
        Tag: 724,
        SymbolicName: 'BackoutMessage',
    },
    {
        Group: '',
        Description: 'Inband - transport the request was sent over (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 725,
        SymbolicName: 'Inband',
    },
    {
        Group: '',
        Description:
            'Out of Band - pre-arranged out-of-band delivery mechanizm (i.e. FTP, HTTP, NDM, etc.) between counterparties. Details specified via ResponseDestination (726).',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 725,
        SymbolicName: 'OutOfBand',
    },
    {
        Group: '',
        Description: 'Valid request',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 728,
        SymbolicName: 'ValidRequest',
    },
    {
        Group: '',
        Description: 'Invalid or unsupported request',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 728,
        SymbolicName: 'InvalidOrUnsupportedRequest',
    },
    {
        Group: '',
        Description: 'No positions found that match criteria',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 728,
        SymbolicName: 'NoPositionsFoundThatMatchCriteria',
    },
    {
        Group: '',
        Description: 'Not authorized to request positions',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 728,
        SymbolicName: 'NotAuthorizedToRequestPositions',
    },
    {
        Group: '',
        Description: 'Request for position not supported',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 728,
        SymbolicName: 'RequestForPositionNotSupported',
    },
    {
        Group: '',
        Description: 'Other (use Text (58) in conjunction with this code for an explaination)',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 728,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Completed',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 729,
        SymbolicName: 'Completed',
    },
    {
        Group: '',
        Description: 'Completed With Warnings',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 729,
        SymbolicName: 'CompletedWithWarnings',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 729,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Final',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 731,
        SymbolicName: 'Final',
    },
    {
        Group: '',
        Description: 'Theoretical',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 731,
        SymbolicName: 'Theoretical',
    },
    {
        Group: '',
        Description: 'Pro rata',
        added: 'FIX.4.4',
        Value: 'P',
        Sort: 1,
        Tag: 744,
        SymbolicName: 'ProRata',
    },
    {
        Group: '',
        Description: 'Random',
        added: 'FIX.4.4',
        Value: 'R',
        Sort: 2,
        Tag: 744,
        SymbolicName: 'Random',
    },
    {
        Group: '',
        Description: 'Automatic',
        added: 'FIX.4.4',
        Value: 'A',
        Sort: 1,
        Tag: 747,
        SymbolicName: 'Automatic',
    },
    {
        Group: '',
        Description: 'Manual',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 2,
        Tag: 747,
        SymbolicName: 'Manual',
    },
    {
        Group: '',
        Description: 'Successful (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 749,
        SymbolicName: 'Successful',
    },
    {
        Group: '',
        Description: 'Invalid or unknown instrument',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 749,
        SymbolicName: 'InvalidOrUnknownInstrument',
    },
    {
        Group: '',
        Description: 'Invalid type of trade requested',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 749,
        SymbolicName: 'InvalidTypeOfTradeRequested',
    },
    {
        Group: '',
        Description: 'Invalid parties',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 749,
        SymbolicName: 'InvalidParties',
    },
    {
        Group: '',
        Description: 'Invalid transport type requested',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 749,
        SymbolicName: 'InvalidTransportTypeRequested',
    },
    {
        Group: '',
        Description: 'Invalid destination requested',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 749,
        SymbolicName: 'InvalidDestinationRequested',
    },
    {
        Group: '',
        Description: 'TradeRequestType not supported',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 749,
        SymbolicName: 'TradeRequestTypeNotSupported',
    },
    {
        Group: '',
        Description: 'Not authorized',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 749,
        SymbolicName: 'NotAuthorized',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 749,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 750,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Completed',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 750,
        SymbolicName: 'Completed',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 750,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Successful (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 751,
        SymbolicName: 'Successful',
    },
    {
        Group: '',
        Description: 'Invalid party onformation',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 751,
        SymbolicName: 'InvalidPartyOnformation',
    },
    {
        Group: '',
        Description: 'Unknown instrument',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 751,
        SymbolicName: 'UnknownInstrument',
    },
    {
        Group: '',
        Description: 'Unauthorized to report trades',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 751,
        SymbolicName: 'UnauthorizedToReportTrades',
    },
    {
        Group: '',
        Description: 'Invalid trade type',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 751,
        SymbolicName: 'InvalidTradeType',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 751,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Single Security (default if not specified)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 752,
        SymbolicName: 'SingleSecurity',
    },
    {
        Group: '',
        Description: 'Individual leg of a multileg security',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 752,
        SymbolicName: 'IndividualLegOfAMultilegSecurity',
    },
    {
        Group: '',
        Description: 'Multileg Security',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 752,
        SymbolicName: 'MultilegSecurity',
    },
    {
        Group: '',
        Description: 'Execution Time',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 770,
        SymbolicName: 'ExecutionTime',
    },
    {
        Group: '',
        Description: 'Time In',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 770,
        SymbolicName: 'TimeIn',
    },
    {
        Group: '',
        Description: 'Time Out',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 770,
        SymbolicName: 'TimeOut',
    },
    {
        Group: '',
        Description: 'Broker Receipt',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 770,
        SymbolicName: 'BrokerReceipt',
    },
    {
        Group: '',
        Description: 'Broker Execution',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 770,
        SymbolicName: 'BrokerExecution',
    },
    {
        Group: '',
        Description: 'Desk Receipt',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        addedEP: 9,
        Tag: 770,
        SymbolicName: 'DeskReceipt',
    },
    {
        Group: '',
        Description: 'Status',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 773,
        SymbolicName: 'Status',
    },
    {
        Group: '',
        Description: 'Confirmation',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 773,
        SymbolicName: 'Confirmation',
    },
    {
        Group: '',
        Description: 'Confirmation Request Rejected (reason can be stated in Text (58) field)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 773,
        SymbolicName: 'ConfirmationRequestRejected',
    },
    {
        Group: '',
        Description: 'Mismatched account',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 774,
        SymbolicName: 'MismatchedAccount',
    },
    {
        Group: '',
        Description: 'Missing settlement instructions',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 774,
        SymbolicName: 'MissingSettlementInstructions',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 774,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Regular booking',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 775,
        SymbolicName: 'RegularBooking',
    },
    {
        Group: '',
        Description: 'CFD (Contract for difference)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 775,
        SymbolicName: 'CFD',
    },
    {
        Group: '',
        Description: 'Total Return Swap',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 775,
        SymbolicName: 'TotalReturnSwap',
    },
    {
        Group: '',
        Description: 'Use default instructions',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 780,
        SymbolicName: 'UseDefaultInstructions',
    },
    {
        Group: '',
        Description: 'Derive from parameters provided',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 780,
        SymbolicName: 'DeriveFromParametersProvided',
    },
    {
        Group: '',
        Description: 'Full details provided',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 780,
        SymbolicName: 'FullDetailsProvided',
    },
    {
        Group: '',
        Description: 'SSI DB IDs provided',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 780,
        SymbolicName: 'SSIDBIDsProvided',
    },
    {
        Group: '',
        Description: 'Phone for instructions',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 780,
        SymbolicName: 'PhoneForInstructions',
    },
    {
        Group: '',
        Description: 'Cash',
        added: 'FIX.4.4',
        Value: 'C',
        Sort: 1,
        Tag: 787,
        SymbolicName: 'Cash',
    },
    {
        Group: '',
        Description: 'Securities',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 2,
        Tag: 787,
        SymbolicName: 'Securities',
    },
    {
        Group: '',
        Description: 'Overnight',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 788,
        SymbolicName: 'Overnight',
    },
    {
        Group: '',
        Description: 'Term',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 788,
        SymbolicName: 'Term',
    },
    {
        Group: '',
        Description: 'Flexible',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 788,
        SymbolicName: 'Flexible',
    },
    {
        Group: '',
        Description: 'Open',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 788,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Unable to process request',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 792,
        SymbolicName: 'UnableToProcessRequest',
    },
    {
        Group: '',
        Description: 'Unknown account',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 792,
        SymbolicName: 'UnknownAccount',
    },
    {
        Group: '',
        Description: 'No matching settlement instructions found',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 792,
        SymbolicName: 'NoMatchingSettlementInstructionsFound',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 792,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Preliminary Request to Intermediary',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'PreliminaryRequestToIntermediary',
    },
    {
        Group: '',
        Description: 'Sellside Calculated Using Preliminary (includes MiscFees and NetMoney)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 2,
        Tag: 794,
        SymbolicName: 'SellsideCalculatedUsingPreliminary',
    },
    {
        Group: '',
        Description:
            'Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney)',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 794,
        SymbolicName: 'SellsideCalculatedWithoutPreliminary',
    },
    {
        Group: '',
        Description: 'Warehouse Recap',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        Tag: 794,
        SymbolicName: 'WarehouseRecap',
    },
    {
        Group: '',
        Description: 'Request to Intermediary',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 5,
        Tag: 794,
        SymbolicName: 'RequestToIntermediary',
    },
    {
        Group: '',
        Description: 'Accept',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 6,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'Accept',
    },
    {
        Group: '',
        Description: 'Reject',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 7,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'Reject',
    },
    {
        Group: '',
        Description: 'Accept Pending',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 8,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'AcceptPending',
    },
    {
        Group: '',
        Description: 'Complete',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 9,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'Complete',
    },
    {
        Group: '',
        Description: 'Reverse Pending',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 10,
        addedEP: 5,
        Tag: 794,
        SymbolicName: 'ReversePending',
    },
    {
        Group: '',
        Description: 'Original details incomplete/incorrect',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 796,
        SymbolicName: 'OriginalDetailsIncomplete',
    },
    {
        Group: '',
        Description: 'Change in underlying order details',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 796,
        SymbolicName: 'ChangeInUnderlyingOrderDetails',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 796,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Account is carried pn customer side of books',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 798,
        SymbolicName: 'CarriedCustomerSide',
    },
    {
        Group: '',
        Description: 'Account is carried on non-customer side of books',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 798,
        SymbolicName: 'CarriedNonCustomerSide',
    },
    {
        Group: '',
        Description: 'House trader',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 798,
        SymbolicName: 'HouseTrader',
    },
    {
        Group: '',
        Description: 'Floor trader',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 798,
        SymbolicName: 'FloorTrader',
    },
    {
        Group: '',
        Description: 'Account is carried on non-customer side of books and is cross margined',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 5,
        Tag: 798,
        SymbolicName: 'CarriedNonCustomerSideCrossMargined',
    },
    {
        Group: '',
        Description: 'Account is house trader and is cross margined',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 6,
        Tag: 798,
        SymbolicName: 'HouseTraderCrossMargined',
    },
    {
        Group: '',
        Description: 'Joint back office account (JBO)',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 798,
        SymbolicName: 'JointBackOfficeAccount',
    },
    {
        Group: '',
        Description: 'Firm',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 0,
        Tag: 803,
        SymbolicName: 'Firm',
    },
    {
        Group: '',
        Description: 'Person',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        Tag: 803,
        SymbolicName: 'Person',
    },
    {
        Group: '',
        Description: 'System',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 2,
        Tag: 803,
        SymbolicName: 'System',
    },
    {
        Group: '',
        Description: 'Application',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 803,
        SymbolicName: 'Application',
    },
    {
        Group: '',
        Description: 'Full legal name of firm',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        Tag: 803,
        SymbolicName: 'FullLegalNameOfFirm',
    },
    {
        Group: '',
        Description: 'Postal address',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 5,
        Tag: 803,
        SymbolicName: 'PostalAddress',
    },
    {
        Group: '',
        Description: 'Phone number',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 6,
        Tag: 803,
        SymbolicName: 'PhoneNumber',
    },
    {
        Group: '',
        Description: 'Email address',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 803,
        SymbolicName: 'EmailAddress',
    },
    {
        Group: '',
        Description: 'Contact name',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 803,
        SymbolicName: 'ContactName',
    },
    {
        Group: '',
        Description: 'Securities account number (for settlement instructions)',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 803,
        SymbolicName: 'SecuritiesAccountNumber',
    },
    {
        Group: '',
        Description: 'Registration number (for settlement instructions and confirmations)',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 10,
        Tag: 803,
        SymbolicName: 'RegistrationNumber',
    },
    {
        Group: '',
        Description: 'Registered address (for confirmation purposes)',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 11,
        Tag: 803,
        SymbolicName: 'RegisteredAddressForConfirmation',
    },
    {
        Group: '',
        Description: 'Regulatory status (for confirmation purposes)',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 12,
        Tag: 803,
        SymbolicName: 'RegulatoryStatus',
    },
    {
        Group: '',
        Description: 'Registration name (for settlement instructions)',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 13,
        Tag: 803,
        SymbolicName: 'RegistrationName',
    },
    {
        Group: '',
        Description: 'Cash account number (for settlement instructions)',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 14,
        Tag: 803,
        SymbolicName: 'CashAccountNumber',
    },
    {
        Group: '',
        Description: 'BIC',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 15,
        Tag: 803,
        SymbolicName: 'BIC',
    },
    {
        Group: '',
        Description: 'CSD participant member code',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 16,
        Tag: 803,
        SymbolicName: 'CSDParticipantMemberCode',
    },
    {
        Group: '',
        Description: 'Registered address',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 17,
        Tag: 803,
        SymbolicName: 'RegisteredAddress',
    },
    {
        Group: '',
        Description: 'Fund account name',
        added: 'FIX.4.4',
        Value: '19',
        Sort: 18,
        Tag: 803,
        SymbolicName: 'FundAccountName',
    },
    {
        Group: '',
        Description: 'Telex number',
        added: 'FIX.4.4',
        Value: '20',
        Sort: 19,
        Tag: 803,
        SymbolicName: 'TelexNumber',
    },
    {
        Group: '',
        Description: 'Fax number',
        added: 'FIX.4.4',
        Value: '21',
        Sort: 20,
        Tag: 803,
        SymbolicName: 'FaxNumber',
    },
    {
        Group: '',
        Description: 'Securities account name',
        added: 'FIX.4.4',
        Value: '22',
        Sort: 21,
        Tag: 803,
        SymbolicName: 'SecuritiesAccountName',
    },
    {
        Group: '',
        Description: 'Cash account name',
        added: 'FIX.4.4',
        Value: '23',
        Sort: 22,
        Tag: 803,
        SymbolicName: 'CashAccountName',
    },
    {
        Group: '',
        Description: 'Department',
        added: 'FIX.4.4',
        Value: '24',
        Sort: 23,
        Tag: 803,
        SymbolicName: 'Department',
    },
    {
        Group: '',
        Description: 'Location desk',
        added: 'FIX.4.4',
        Value: '25',
        Sort: 24,
        Tag: 803,
        SymbolicName: 'LocationDesk',
    },
    {
        Group: '',
        Description: 'Position account type',
        added: 'FIX.4.4',
        Value: '26',
        Sort: 25,
        Tag: 803,
        SymbolicName: 'PositionAccountType',
    },
    {
        Group: '',
        Description: 'Security locate ID',
        added: 'FIX.4.4',
        Value: '27',
        Sort: 26,
        addedEP: 1,
        Tag: 803,
        SymbolicName: 'SecurityLocateID',
    },
    {
        Group: '',
        Description: 'Market maker',
        added: 'FIX.4.4',
        Value: '28',
        Sort: 27,
        addedEP: 26,
        Tag: 803,
        SymbolicName: 'MarketMaker',
    },
    {
        Group: '',
        Description: 'Eligible counterparty',
        added: 'FIX.4.4',
        Value: '29',
        Sort: 28,
        addedEP: 26,
        Tag: 803,
        SymbolicName: 'EligibleCounterparty',
    },
    {
        Group: '',
        Description: 'Professional client',
        added: 'FIX.4.4',
        Value: '30',
        Sort: 29,
        addedEP: 26,
        Tag: 803,
        SymbolicName: 'ProfessionalClient',
    },
    {
        Group: '',
        Description: 'Location',
        added: 'FIX.4.4',
        Value: '31',
        Sort: 30,
        addedEP: 26,
        Tag: 803,
        SymbolicName: 'Location',
    },
    {
        Group: '',
        Description: 'Execution venue',
        added: 'FIX.4.4',
        Value: '32',
        Sort: 31,
        addedEP: 26,
        Tag: 803,
        SymbolicName: 'ExecutionVenue',
    },
    {
        Group: '',
        Description: 'Currency delivery identifier',
        added: 'FIX.5.0',
        Value: '33',
        Sort: 99,
        addedEP: 44,
        Tag: 803,
        SymbolicName: 'CurrencyDeliveryIdentifier',
    },
    {
        Group: '',
        Description: 'Pending Accept',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 808,
        SymbolicName: 'PendingAccept',
    },
    {
        Group: '',
        Description: 'Pending Release',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 808,
        SymbolicName: 'PendingRelease',
    },
    {
        Group: '',
        Description: 'Pending Reversal',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 808,
        SymbolicName: 'PendingReversal',
    },
    {
        Group: '',
        Description: 'Accept',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 808,
        SymbolicName: 'Accept',
    },
    {
        Group: '',
        Description: 'Block Level Reject',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 808,
        SymbolicName: 'BlockLevelReject',
    },
    {
        Group: '',
        Description: 'Account Level Reject',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        Tag: 808,
        SymbolicName: 'AccountLevelReject',
    },
    {
        Group: '',
        Description: 'No Action Taken',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 814,
        SymbolicName: 'NoActionTaken',
    },
    {
        Group: '',
        Description: 'Queue Flushed',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 814,
        SymbolicName: 'QueueFlushed',
    },
    {
        Group: '',
        Description: 'Overlay Last',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 814,
        SymbolicName: 'OverlayLast',
    },
    {
        Group: '',
        Description: 'End Session',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 814,
        SymbolicName: 'EndSession',
    },
    {
        Group: '',
        Description: 'No Action Taken',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 815,
        SymbolicName: 'NoActionTaken',
    },
    {
        Group: '',
        Description: 'Queue Flushed',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 815,
        SymbolicName: 'QueueFlushed',
    },
    {
        Group: '',
        Description: 'Overlay Last',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 815,
        SymbolicName: 'OverlayLast',
    },
    {
        Group: '',
        Description: 'End Session',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 815,
        SymbolicName: 'EndSession',
    },
    {
        Group: '',
        Description: 'No Average Pricing',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 819,
        SymbolicName: 'NoAveragePricing',
    },
    {
        Group: '',
        Description: 'Trade is part of an average price group identified by the TradeLinkID (820)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 819,
        SymbolicName: 'Trade',
    },
    {
        Group: '',
        Description: 'Last trade is the average price group identified by the TradeLinkID (820)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 819,
        SymbolicName: 'LastTrade',
    },
    {
        Group: '',
        Description: 'Allocation not required',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 826,
        SymbolicName: 'AllocationNotRequired',
    },
    {
        Group: '',
        Description: 'Allocation required (give-up trade) allocation information not provided (incomplete)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 826,
        SymbolicName: 'AllocationRequired',
    },
    {
        Group: '',
        Description: 'Use allocation provided with the trade',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 826,
        SymbolicName: 'UseAllocationProvidedWithTheTrade',
    },
    {
        Group: '',
        Description: 'Allocation give-up executor',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: 4,
        Tag: 826,
        SymbolicName: 'AllocationGiveUpExecutor',
    },
    {
        Group: '',
        Description: 'Allocation from executor',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: 4,
        Tag: 826,
        SymbolicName: 'AllocationFromExecutor',
    },
    {
        Group: '',
        Description: 'Allocation to claim account',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        addedEP: 4,
        Tag: 826,
        SymbolicName: 'AllocationToClaimAccount',
    },
    {
        Group: '',
        Description: 'Expire on trading session close (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 827,
        SymbolicName: 'ExpireOnTradingSessionClose',
    },
    {
        Group: '',
        Description: 'Expire on trading session open',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 827,
        SymbolicName: 'ExpireOnTradingSessionOpen',
    },
    {
        Group: '',
        Description:
            'Trading eligibility expiration specified in the date and time fields [EventDate(866) and EventTime(1145)] associated with EventType(865)=7(Last Eligible Trade Date)',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 42,
        Tag: 827,
        SymbolicName: 'SpecifiedExpiration',
    },
    {
        Group: '',
        Description: 'Regular Trade',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 0,
        Tag: 828,
        SymbolicName: 'RegularTrade',
    },
    {
        Group: '',
        Description: 'Block Trade',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 828,
        SymbolicName: 'BlockTrade',
    },
    {
        Group: '',
        Description: 'EFP (Exchange for physical)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 828,
        SymbolicName: 'EFP',
    },
    {
        Group: '',
        Description: 'Transfer',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 828,
        SymbolicName: 'Transfer',
    },
    {
        Group: '',
        Description: 'Late Trade',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 828,
        SymbolicName: 'LateTrade',
    },
    {
        Group: '',
        Description: 'T Trade',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 828,
        SymbolicName: 'TTrade',
    },
    {
        Group: '',
        Description: 'Weighted Average Price Trade',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        Tag: 828,
        SymbolicName: 'WeightedAveragePriceTrade',
    },
    {
        Group: '',
        Description: 'Bunched Trade',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        Tag: 828,
        SymbolicName: 'BunchedTrade',
    },
    {
        Group: '',
        Description: 'Late Bunched Trade',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        Tag: 828,
        SymbolicName: 'LateBunchedTrade',
    },
    {
        Group: '',
        Description: 'Prior Reference Price Trade',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        Tag: 828,
        SymbolicName: 'PriorReferencePriceTrade',
    },
    {
        Group: '',
        Description: 'After Hours Trade',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 10,
        Tag: 828,
        SymbolicName: 'AfterHoursTrade',
    },
    {
        Group: '',
        Description: 'Exchange for Risk (EFR)',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'ExchangeForRisk',
    },
    {
        Group: '',
        Description: 'Exchange for Swap (EFS )',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'ExchangeForSwap',
    },
    {
        Group: '',
        Description: 'Exchange of Futures for (in Market) Futures (EFM ) (e,g, full sized for mini)',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'ExchangeOfFuturesFor',
    },
    {
        Group: '',
        Description: 'Exchange of Options for Options (EOO)',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 14,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'ExchangeOfOptionsForOptions',
    },
    {
        Group: '',
        Description: 'Trading at Settlement',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 15,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'TradingAtSettlement',
    },
    {
        Group: '',
        Description: 'All or None',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 16,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'AllOrNone',
    },
    {
        Group: '',
        Description: 'Futures Large Order Execution',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 17,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'FuturesLargeOrderExecution',
    },
    {
        Group: '',
        Description: 'Exchange of Futures for Futures (external market) (EFF)',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 18,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'ExchangeOfFuturesForFutures',
    },
    {
        Group: '',
        Description: 'Option Interim Trade',
        added: 'FIX.4.4',
        Value: '19',
        Sort: 19,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'OptionInterimTrade',
    },
    {
        Group: '',
        Description: 'Option Cabinet Trade',
        added: 'FIX.4.4',
        Value: '20',
        Sort: 20,
        addedEP: 5,
        Tag: 828,
        SymbolicName: 'OptionCabinetTrade',
    },
    {
        Group: '',
        Description: 'Privately Negotiated Trades',
        added: 'FIX.4.4',
        Value: '22',
        Sort: 21,
        addedEP: 19,
        Tag: 828,
        SymbolicName: 'PrivatelyNegotiatedTrades',
    },
    {
        Group: '',
        Description: 'Substitution of Futures for Forwards',
        added: 'FIX.4.4',
        Value: '23',
        Sort: 22,
        addedEP: 19,
        Tag: 828,
        SymbolicName: 'SubstitutionOfFuturesForForwards',
    },
    {
        Group: '',
        Description: 'Non-standard settlement',
        added: 'FIX.5.0',
        Value: '48',
        Sort: 48,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'NonStandardSettlement',
    },
    {
        Group: '',
        Description: 'Derivative Related Transaction',
        added: 'FIX.5.0',
        Value: '49',
        Sort: 49,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'DerivativeRelatedTransaction',
    },
    {
        Group: '',
        Description: 'Portfolio Trade',
        added: 'FIX.5.0',
        Value: '50',
        Sort: 50,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'PortfolioTrade',
    },
    {
        Group: '',
        Description: 'Volume Weighted Average Trade',
        added: 'FIX.5.0',
        Value: '51',
        Sort: 51,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'VolumeWeightedAverageTrade',
    },
    {
        Group: '',
        Description: 'Exchange Granted Trade',
        added: 'FIX.5.0',
        Value: '52',
        Sort: 52,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'ExchangeGrantedTrade',
    },
    {
        Group: '',
        Description: 'Repurchase Agreement',
        added: 'FIX.5.0',
        Value: '53',
        Sort: 53,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'RepurchaseAgreement',
    },
    {
        Group: '',
        Description: 'OTC',
        added: 'FIX.5.0',
        Value: '54',
        Sort: 54,
        addedEP: 47,
        Tag: 828,
        SymbolicName: 'OTC',
    },
    {
        Group: '',
        Description: 'Exchange Basis Facility (EBF)',
        added: 'FIX.5.0',
        Value: '55',
        Sort: 55,
        addedEP: 55,
        Tag: 828,
        SymbolicName: 'ExchangeBasisFacility',
    },
    {
        Group: 'MiFID Values',
        Description: 'Error trade',
        added: 'FIX.4.4',
        Value: '24',
        Sort: 24,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'ErrorTrade',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special cum dividend (CD)',
        added: 'FIX.4.4',
        Value: '25',
        Sort: 25,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialCumDividend',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special ex dividend (XD)',
        added: 'FIX.4.4',
        Value: '26',
        Sort: 26,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialExDividend',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special cum coupon (CC)',
        added: 'FIX.4.4',
        Value: '27',
        Sort: 27,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialCumCoupon',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special ex coupon (XC)',
        added: 'FIX.4.4',
        Value: '28',
        Sort: 28,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialExCoupon',
    },
    {
        Group: 'MiFID Values',
        Description: 'Cash settlement (CS)',
        added: 'FIX.4.4',
        Value: '29',
        Sort: 29,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'CashSettlement',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special price (usually net- or all-in price) (SP)',
        added: 'FIX.4.4',
        Value: '30',
        Sort: 30,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialPrice',
    },
    {
        Group: 'MiFID Values',
        Description: 'Guaranteed delivery (GD)',
        added: 'FIX.4.4',
        Value: '31',
        Sort: 31,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'GuaranteedDelivery',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special cum rights (CR)',
        added: 'FIX.4.4',
        Value: '32',
        Sort: 32,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialCumRights',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special ex rights (XR)',
        added: 'FIX.4.4',
        Value: '33',
        Sort: 33,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialExRights',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special cum capital repayments (CP)',
        added: 'FIX.4.4',
        Value: '34',
        Sort: 34,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialCumCapitalRepayments',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special ex capital repayments (XP)',
        added: 'FIX.4.4',
        Value: '35',
        Sort: 35,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialExCapitalRepayments',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special cum bonus (CB)',
        added: 'FIX.4.4',
        Value: '36',
        Sort: 36,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialCumBonus',
    },
    {
        Group: 'MiFID Values',
        Description: 'Special ex bonus (XB)',
        added: 'FIX.4.4',
        Value: '37',
        Sort: 37,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'SpecialExBonus',
    },
    {
        Group: 'MiFID Values',
        Description: 'Block trade (same as large trade)',
        added: 'FIX.4.4',
        Value: '38',
        Sort: 38,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'LargeTrade',
    },
];

const batch5: ISpecEnums[] = [
    {
        Group: 'MiFID Values',
        Description: 'Worked principal trade (UK-specific)',
        added: 'FIX.4.4',
        Value: '39',
        Sort: 39,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'WorkedPrincipalTrade',
    },
    {
        Group: 'MiFID Values',
        Description: 'Block Trades - after market',
        added: 'FIX.4.4',
        Value: '40',
        Sort: 40,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'BlockTrades',
    },
    {
        Group: 'MiFID Values',
        Description: 'Name change',
        added: 'FIX.4.4',
        Value: '41',
        Sort: 41,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'NameChange',
    },
    {
        Group: 'MiFID Values',
        Description: 'Portfolio transfer',
        added: 'FIX.4.4',
        Value: '42',
        Sort: 42,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'PortfolioTransfer',
    },
    {
        Group: 'MiFID Values',
        Description:
            'Prorogation buy - Euronext Paris only. Is used to defer settlement under French SRD (deferred settlement system) . Trades must be reported as crosses at zero price',
        added: 'FIX.4.4',
        Value: '43',
        Sort: 43,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'ProrogationBuy',
    },
    {
        Group: 'MiFID Values',
        Description: 'Prorogation sell - see prorogation buy',
        added: 'FIX.4.4',
        Value: '44',
        Sort: 44,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'ProrogationSell',
    },
    {
        Group: 'MiFID Values',
        Description: 'Option exercise',
        added: 'FIX.4.4',
        Value: '45',
        Sort: 45,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'OptionExercise',
    },
    {
        Group: 'MiFID Values',
        Description: 'Delta neutral transaction',
        added: 'FIX.4.4',
        Value: '46',
        Sort: 46,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'DeltaNeutralTransaction',
    },
    {
        Group: 'MiFID Values',
        Description: 'Financing transaction (includes repo and stock lending)',
        added: 'FIX.4.4',
        Value: '47',
        Sort: 47,
        addedEP: 26,
        Tag: 828,
        SymbolicName: 'FinancingTransaction',
    },
    {
        Group: '',
        Description: 'CMTA',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: 4,
        Tag: 829,
        SymbolicName: 'CMTA',
    },
    {
        Group: '',
        Description: 'Internal transfer or adjustment',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: 4,
        Tag: 829,
        SymbolicName: 'InternalTransferOrAdjustment',
    },
    {
        Group: '',
        Description: 'External transfer or transfer of account',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: 4,
        Tag: 829,
        SymbolicName: 'ExternalTransferOrTransferOfAccount',
    },
    {
        Group: '',
        Description: 'Reject for submitting side',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: 4,
        Tag: 829,
        SymbolicName: 'RejectForSubmittingSide',
    },
    {
        Group: '',
        Description: 'Advisory for contra side',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: 4,
        Tag: 829,
        SymbolicName: 'AdvisoryForContraSide',
    },
    {
        Group: '',
        Description: 'Offset due to an allocation',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'OffsetDueToAnAllocation',
    },
    {
        Group: '',
        Description: 'Onset due to an allocation',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '6',
        Sort: 7,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'OnsetDueToAnAllocation',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Differential spread',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'DifferentialSpread',
    },
    {
        Group: '',
        Description: 'Implied spread leg executed against an outright',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 9,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'ImpliedSpreadLegExecutedAgainstAnOutright',
    },
    {
        Group: '',
        Description: 'Transaction from exercise',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 10,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'TransactionFromExercise',
    },
    {
        Group: '',
        Description: 'Transaction from assignment',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 11,
        addedEP: 5,
        Tag: 829,
        SymbolicName: 'TransactionFromAssignment',
    },
    {
        Group: '',
        Description: 'ACATS',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 12,
        addedEP: 8,
        Tag: 829,
        SymbolicName: 'ACATS',
    },
    {
        Group: '',
        Description: 'Off Hours Trade',
        added: 'FIX.5.0',
        Value: '33',
        Sort: 32,
        addedEP: 61,
        Tag: 829,
        SymbolicName: 'OffHoursTrade',
    },
    {
        Group: '',
        Description: 'On Hours Trade',
        added: 'FIX.5.0',
        Value: '34',
        Sort: 33,
        addedEP: 61,
        Tag: 829,
        SymbolicName: 'OnHoursTrade',
    },
    {
        Group: '',
        Description: 'OTC Quote',
        added: 'FIX.5.0',
        Value: '35',
        Sort: 34,
        addedEP: 61,
        Tag: 829,
        SymbolicName: 'OTCQuote',
    },
    {
        Group: '',
        Description: 'Converted SWAP',
        added: 'FIX.5.0',
        Value: '36',
        Sort: 36,
        addedEP: -1,
        Tag: 829,
        SymbolicName: 'ConvertedSWAP',
    },
    {
        Group: 'MiFID Values',
        Description: 'AI (Automated input facility disabled in response to an exchange request.)',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 13,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'AI',
    },
    {
        Group: 'MiFID Values',
        Description:
            'B (Transaction between two member firms where neither member firm is registered as a market maker in the security in question and neither is a designated fund manager. Also used by broker dealers when dealing with another broker which is not a member firm. Non-order book securities only.)',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 14,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'B',
    },
    {
        Group: 'MiFID Values',
        Description: 'K (Transaction using block trade facility.)',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 15,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'K',
    },
    {
        Group: 'MiFID Values',
        Description: 'LC (Correction submitted more than three days after publication of the original trade report.)',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 16,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'LC',
    },
    {
        Group: 'MiFID Values',
        Description:
            'M (Transaction, other than a transaction resulting from a stock swap or stock switch, between two market makers registered in that security including IDB or a public display system trades. Non-order book securities only.)',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 17,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'M',
    },
    {
        Group: 'MiFID Values',
        Description: 'N (Non-protected portfolio transaction or a fully disclosed portfolio transaction)',
        added: 'FIX.4.4',
        Value: '19',
        Sort: 18,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'N',
    },
    {
        Group: 'MiFID Values',
        Description:
            'NM ( i) transaction where Exchange has granted permission for non-publication\nii)IDB is reporting as seller\niii) submitting a transaction report to the Exchange, where the transaction report is not also a trade report.)',
        added: 'FIX.4.4',
        Value: '20',
        Sort: 19,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'NM',
    },
    {
        Group: 'MiFID Values',
        Description: 'NR (Non-risk transaction in a SEATS security other than an AIM security)',
        added: 'FIX.4.4',
        Value: '21',
        Sort: 20,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'NR',
    },
    {
        Group: 'MiFID Values',
        Description:
            'P (Protected portfolio transaction or a worked principal agreement to effect a portfolio transaction which includes order book securities)',
        added: 'FIX.4.4',
        Value: '22',
        Sort: 21,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'P',
    },
    {
        Group: 'MiFID Values',
        Description: 'PA (Protected transaction notification)',
        added: 'FIX.4.4',
        Value: '23',
        Sort: 22,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'PA',
    },
    {
        Group: 'MiFID Values',
        Description:
            'PC (Contra trade for transaction which took place on a previous day and which was automatically executed on the Exchange trading system)',
        added: 'FIX.4.4',
        Value: '24',
        Sort: 23,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'PC',
    },
    {
        Group: 'MiFID Values',
        Description:
            'PN (Worked principal notification for a portfolio transaction which includes order book securities)',
        added: 'FIX.4.4',
        Value: '25',
        Sort: 24,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'PN',
    },
    {
        Group: 'MiFID Values',
        Description:
            'R ( (i) riskless principal transaction between non-members where the buying and selling transactions are executed at different prices or on different terms (requires a trade report with trade type indicator R for each transaction)\n(ii) market maker is reporting all the legs of a riskless principal transaction where the buying and selling transactions are executed at different prices (requires a trade report with trade type indicator R for each transaction)or\n(iii) market maker is reporting the onward leg of a riskless principal transaction where the legs are executed at different prices, and another market maker has submitted a trade report using trade type indicator M for the first leg (this requires a single trade report with trade type indicator R).)',
        added: 'FIX.4.4',
        Value: '26',
        Sort: 25,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'R',
    },
    {
        Group: 'MiFID Values',
        Description:
            'RO (Transaction which resulted from the exercise of a traditional option or a stock-settled covered warrant)',
        added: 'FIX.4.4',
        Value: '27',
        Sort: 26,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'RO',
    },
    {
        Group: 'MiFID Values',
        Description:
            'RT (Risk transaction in a SEATS security, (excluding AIM security) reported by a market maker registered in that security)',
        added: 'FIX.4.4',
        Value: '28',
        Sort: 27,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'RT',
    },
    {
        Group: 'MiFID Values',
        Description:
            'SW (Transactions resulting from stock swap or a stock switch (one report is required for each line of stock))',
        added: 'FIX.4.4',
        Value: '29',
        Sort: 28,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'SW',
    },
    {
        Group: 'MiFID Values',
        Description: 'T (If reporting a single protected transaction)',
        added: 'FIX.4.4',
        Value: '30',
        Sort: 29,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'T',
    },
    {
        Group: 'MiFID Values',
        Description: 'WN (Worked principal notification for a single order book security)',
        added: 'FIX.4.4',
        Value: '31',
        Sort: 30,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'WN',
    },
    {
        Group: 'MiFID Values',
        Description: 'WT (Worked principal transaction (other than a portfolio transaction))',
        added: 'FIX.4.4',
        Value: '32',
        Sort: 31,
        addedEP: 26,
        Tag: 829,
        SymbolicName: 'WT',
    },
    {
        Group: 'MiFID Values',
        Description: 'Crossed Trade (X)',
        added: 'FIX.5.0',
        Value: '37',
        Sort: 37,
        addedEP: -1,
        Tag: 829,
        SymbolicName: 'CrossedTrade',
    },
    {
        Group: 'MiFID Values',
        Description: 'Interim Protected Trade (I)',
        added: 'FIX.5.0',
        Value: '38',
        Sort: 38,
        addedEP: -1,
        Tag: 829,
        SymbolicName: 'InterimProtectedTrade',
    },
    {
        Group: 'MiFID Values',
        Description: 'Large in Scale (L)',
        added: 'FIX.5.0',
        Value: '39',
        Sort: 39,
        addedEP: -1,
        Tag: 829,
        SymbolicName: 'LargeInScale',
    },
    {
        Group: '',
        Description: 'Floating (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 835,
        SymbolicName: 'Floating',
    },
    {
        Group: '',
        Description: 'Fixed',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 835,
        SymbolicName: 'Fixed',
    },
    {
        Group: '',
        Description: 'Price (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 836,
        SymbolicName: 'Price',
    },
    {
        Group: '',
        Description: 'Basis Points',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 836,
        SymbolicName: 'BasisPoints',
    },
    {
        Group: '',
        Description: 'Ticks',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 836,
        SymbolicName: 'Ticks',
    },
    {
        Group: '',
        Description: 'Price Tier / Level',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 836,
        SymbolicName: 'PriceTier',
    },
    {
        Group: '',
        Description: 'Or better (default) - price improvement allowed',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 837,
        SymbolicName: 'OrBetter',
    },
    {
        Group: '',
        Description: 'Strict - limit is a strict limit',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 837,
        SymbolicName: 'Strict',
    },
    {
        Group: '',
        Description:
            'Or worse - for a buy the peg limit is a minimum and for a sell the peg limit is a maximum (for use for orders which have a price range)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 837,
        SymbolicName: 'OrWorse',
    },
    {
        Group: '',
        Description:
            'More aggressive - on a buy order round the price up to the nearest tick; on a sell order round down to the nearest tick',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 838,
        SymbolicName: 'MoreAggressive',
    },
    {
        Group: '',
        Description:
            'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 838,
        SymbolicName: 'MorePassive',
    },
    {
        Group: '',
        Description: 'Local (Exchange, ECN, ATS)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 840,
        SymbolicName: 'Local',
    },
    {
        Group: '',
        Description: 'National',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 840,
        SymbolicName: 'National',
    },
    {
        Group: '',
        Description: 'Global',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 840,
        SymbolicName: 'Global',
    },
    {
        Group: '',
        Description: 'National excluding local',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 840,
        SymbolicName: 'NationalExcludingLocal',
    },
    {
        Group: '',
        Description: 'Floating (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 841,
        SymbolicName: 'Floating',
    },
    {
        Group: '',
        Description: 'Fixed',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 841,
        SymbolicName: 'Fixed',
    },
    {
        Group: '',
        Description: 'Price (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 842,
        SymbolicName: 'Price',
    },
    {
        Group: '',
        Description: 'Basis Points',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 842,
        SymbolicName: 'BasisPoints',
    },
    {
        Group: '',
        Description: 'Ticks',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 842,
        SymbolicName: 'Ticks',
    },
    {
        Group: '',
        Description: 'Price Tier / Level',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 842,
        SymbolicName: 'PriceTier',
    },
    {
        Group: '',
        Description: 'Or better (default) - price improvement allowed',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 843,
        SymbolicName: 'OrBetter',
    },
    {
        Group: '',
        Description: 'Strict - limit is a strict limit',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 843,
        SymbolicName: 'Strict',
    },
    {
        Group: '',
        Description:
            'Or worse - for a buy the discretion price is a minimum and for a sell the discretion price is a maximum (for use for orders which have a price range)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 843,
        SymbolicName: 'OrWorse',
    },
    {
        Group: '',
        Description:
            'More aggressive - on a buy order round the price up to the nearest tick; on a sell round down to the nearest tick',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 844,
        SymbolicName: 'MoreAggressive',
    },
    {
        Group: '',
        Description:
            'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 844,
        SymbolicName: 'MorePassive',
    },
    {
        Group: '',
        Description: 'Local (Exchange, ECN, ATS)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 846,
        SymbolicName: 'Local',
    },
    {
        Group: '',
        Description: 'National',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 846,
        SymbolicName: 'National',
    },
    {
        Group: '',
        Description: 'Global',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 846,
        SymbolicName: 'Global',
    },
    {
        Group: '',
        Description: 'National excluding local',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 846,
        SymbolicName: 'NationalExcludingLocal',
    },
    {
        Group: '',
        Description: 'VWAP',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 847,
        SymbolicName: 'VWAP',
    },
    {
        Group: '',
        Description: 'Participate (i.e. aim to be x percent of the market volume)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 847,
        SymbolicName: 'Participate',
    },
    {
        Group: '',
        Description: 'Mininize market impact',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 847,
        SymbolicName: 'MininizeMarketImpact',
    },
    {
        Group: '',
        Description: 'Added Liquidity',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 851,
        SymbolicName: 'AddedLiquidity',
    },
    {
        Group: '',
        Description: 'Removed Liquidity',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 851,
        SymbolicName: 'RemovedLiquidity',
    },
    {
        Group: '',
        Description: 'Liquidity Routed Out',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 851,
        SymbolicName: 'LiquidityRoutedOut',
    },
    {
        Group: '',
        Description: 'Auction',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 57,
        Tag: 851,
        SymbolicName: 'Auction',
    },
    {
        Group: '',
        Description: 'Do Not Report Trade',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 1,
        Tag: 852,
        SymbolicName: 'DoNotReportTrade',
    },
    {
        Group: '',
        Description: 'Report Trade',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 2,
        Tag: 852,
        SymbolicName: 'ReportTrade',
    },
    {
        Group: '',
        Description: 'Dealer Sold Short',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 853,
        SymbolicName: 'DealerSoldShort',
    },
    {
        Group: '',
        Description: 'Dealer Sold Short Exempt',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 853,
        SymbolicName: 'DealerSoldShortExempt',
    },
    {
        Group: '',
        Description: 'Selling Customer Sold Short',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 853,
        SymbolicName: 'SellingCustomerSoldShort',
    },
    {
        Group: '',
        Description: 'Selling Customer Sold Short Exempt',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 853,
        SymbolicName: 'SellingCustomerSoldShortExempt',
    },
    {
        Group: '',
        Description: 'Qualified Service Representative (QSR) or Automatic Give-up (AGU) Contra Side Sold Short',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 853,
        SymbolicName: 'QualifiedServiceRepresentative',
    },
    {
        Group: '',
        Description: 'QSR or AGU Contra Side Sold Short Exempt',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 853,
        SymbolicName: 'QSROrAGUContraSideSoldShortExempt',
    },
    {
        Group: '',
        Description: 'Units (shares, par, currency)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 854,
        SymbolicName: 'Units',
    },
    {
        Group: '',
        Description: 'Contracts (if used - must specify ContractMultiplier (tag 231))',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 854,
        SymbolicName: 'Contracts',
    },
    {
        Group: '',
        Description:
            'Units of Measure per Time Unit (if used - must specify UnitofMeasure (tag 996) and TimeUnit (tag 997))',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: 5,
        Tag: 854,
        SymbolicName: 'UnitsOfMeasurePerTimeUnit',
    },
    {
        Group: '',
        Description: 'Submit',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 856,
        SymbolicName: 'Submit',
    },
    {
        Group: '',
        Description: 'Alleged',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 856,
        SymbolicName: 'Alleged',
    },
    {
        Group: '',
        Description: 'Accept',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 856,
        SymbolicName: 'Accept',
    },
    {
        Group: '',
        Description: 'Decline',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 856,
        SymbolicName: 'Decline',
    },
    {
        Group: '',
        Description: 'Addendum',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 856,
        SymbolicName: 'Addendum',
    },
    {
        Group: '',
        Description: 'No/Was',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 856,
        SymbolicName: 'No',
    },
    {
        Group: '',
        Description: 'Trade Report Cancel',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        Tag: 856,
        SymbolicName: 'TradeReportCancel',
    },
    {
        Group: '',
        Description: '(Locked-In) Trade Break',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        Tag: 856,
        SymbolicName: 'LockedIn',
    },
    {
        Group: '',
        Description: 'Defaulted',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 9,
        addedEP: 4,
        Tag: 856,
        SymbolicName: 'Defaulted',
    },
    {
        Group: '',
        Description: 'Invalid CMTA',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 10,
        addedEP: 8,
        Tag: 856,
        SymbolicName: 'InvalidCMTA',
    },
    {
        Group: '',
        Description: 'Pended',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 11,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'Pended',
    },
    {
        Group: '',
        Description: 'Alleged New',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 12,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'AllegedNew',
    },
    {
        Group: '',
        Description: 'Alleged Addendum',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 13,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'AllegedAddendum',
    },
    {
        Group: '',
        Description: 'Alleged No/Was',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 14,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'AllegedNo',
    },
    {
        Group: '',
        Description: 'Alleged Trade Report Cancel',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 15,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'AllegedTradeReportCancel',
    },
    {
        Group: '',
        Description: 'Alleged (Locked-In) Trade Break',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 16,
        addedEP: 23,
        Tag: 856,
        SymbolicName: 'AllegedTradeBreak',
    },
    {
        Group: '',
        Description: 'Not Specified',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 857,
        SymbolicName: 'NotSpecified',
    },
    {
        Group: '',
        Description: 'Explicit List Provided',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 857,
        SymbolicName: 'ExplicitListProvided',
    },
    {
        Group: '',
        Description: 'Put',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 0,
        Tag: 865,
        SymbolicName: 'Put',
    },
    {
        Group: '',
        Description: 'Call',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        Tag: 865,
        SymbolicName: 'Call',
    },
    {
        Group: '',
        Description: 'Tender',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 2,
        Tag: 865,
        SymbolicName: 'Tender',
    },
    {
        Group: '',
        Description: 'Sinking Fund Call',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 865,
        SymbolicName: 'SinkingFundCall',
    },
    {
        Group: '',
        Description: 'Activation',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        addedEP: 8,
        Tag: 865,
        SymbolicName: 'Activation',
    },
    {
        Group: '',
        Description: 'Inactiviation',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 5,
        addedEP: 8,
        Tag: 865,
        SymbolicName: 'Inactiviation',
    },
    {
        Group: '',
        Description: 'Last Eligible Trade Date',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 6,
        addedEP: 42,
        Tag: 865,
        SymbolicName: 'LastEligibleTradeDate',
    },
    {
        Group: '',
        Description: 'Swap Start Date',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 7,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'SwapStartDate',
    },
    {
        Group: '',
        Description: 'Swap End Date',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 8,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'SwapEndDate',
    },
    {
        Group: '',
        Description: 'Swap Roll Date',
        added: 'FIX.5.0',
        Value: '10',
        Sort: 9,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'SwapRollDate',
    },
    {
        Group: '',
        Description: 'Swap Next Start Date',
        added: 'FIX.5.0',
        Value: '11',
        Sort: 10,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'SwapNextStartDate',
    },
    {
        Group: '',
        Description: 'Swap Next Roll Date',
        added: 'FIX.5.0',
        Value: '12',
        Sort: 11,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'SwapNextRollDate',
    },
    {
        Group: '',
        Description: 'First Delivery Date',
        added: 'FIX.5.0',
        Value: '13',
        Sort: 12,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'FirstDeliveryDate',
    },
    {
        Group: '',
        Description: 'Last Delivery Date',
        added: 'FIX.5.0',
        Value: '14',
        Sort: 13,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'LastDeliveryDate',
    },
    {
        Group: '',
        Description: 'Initial Inventory Due Date',
        added: 'FIX.5.0',
        Value: '15',
        Sort: 14,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'InitialInventoryDueDate',
    },
    {
        Group: '',
        Description: 'Final Inventory Due Date',
        added: 'FIX.5.0',
        Value: '16',
        Sort: 15,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'FinalInventoryDueDate',
    },
    {
        Group: '',
        Description: 'First Intent Date',
        added: 'FIX.5.0',
        Value: '17',
        Sort: 16,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'FirstIntentDate',
    },
    {
        Group: '',
        Description: 'Last Intent Date',
        added: 'FIX.5.0',
        Value: '18',
        Sort: 17,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'LastIntentDate',
    },
    {
        Group: '',
        Description: 'Position Removal Date',
        added: 'FIX.5.0',
        Value: '19',
        Sort: 18,
        addedEP: 52,
        Tag: 865,
        SymbolicName: 'PositionRemovalDate',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 865,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Flat (securities pay interest on a current basis but are traded without interest)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 0,
        Tag: 871,
        SymbolicName: 'Flat',
    },
    {
        Group: '',
        Description: 'Zero coupon',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        Tag: 871,
        SymbolicName: 'ZeroCoupon',
    },
    {
        Group: '',
        Description: 'Interest bearing (for Euro commercial paper when not issued at discount)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 2,
        Tag: 871,
        SymbolicName: 'InterestBearing',
    },
    {
        Group: '',
        Description: 'No periodic payments',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 871,
        SymbolicName: 'NoPeriodicPayments',
    },
    {
        Group: '',
        Description: 'Variable rate',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 4,
        Tag: 871,
        SymbolicName: 'VariableRate',
    },
    {
        Group: '',
        Description: 'Less fee for put',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 5,
        Tag: 871,
        SymbolicName: 'LessFeeForPut',
    },
    {
        Group: '',
        Description: 'Stepped coupon',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 6,
        Tag: 871,
        SymbolicName: 'SteppedCoupon',
    },
    {
        Group: '',
        Description: 'Coupon period (if not semi-annual). Supply redemption date in the InstrAttribValue (872) field.',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 7,
        Tag: 871,
        SymbolicName: 'CouponPeriod',
    },
    {
        Group: '',
        Description: 'When [and if] issued',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 8,
        Tag: 871,
        SymbolicName: 'When',
    },
    {
        Group: '',
        Description: 'Original issue discount',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 9,
        Tag: 871,
        SymbolicName: 'OriginalIssueDiscount',
    },
    {
        Group: '',
        Description: 'Callable, puttable',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 10,
        Tag: 871,
        SymbolicName: 'Callable',
    },
    {
        Group: '',
        Description: 'Escrowed to Maturity',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 11,
        Tag: 871,
        SymbolicName: 'EscrowedToMaturity',
    },
    {
        Group: '',
        Description:
            'Escrowed to redemption date - callable. Supply redemption date in the InstrAttribValue (872) field',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 12,
        Tag: 871,
        SymbolicName: 'EscrowedToRedemptionDate',
    },
    {
        Group: '',
        Description: 'Pre-refunded',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 13,
        Tag: 871,
        SymbolicName: 'PreRefunded',
    },
    {
        Group: '',
        Description: 'In default',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 14,
        Tag: 871,
        SymbolicName: 'InDefault',
    },
    {
        Group: '',
        Description: 'Unrated',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 15,
        Tag: 871,
        SymbolicName: 'Unrated',
    },
    {
        Group: '',
        Description: 'Taxable',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 16,
        Tag: 871,
        SymbolicName: 'Taxable',
    },
    {
        Group: '',
        Description: 'Indexed',
        added: 'FIX.4.4',
        Value: '18',
        Sort: 17,
        Tag: 871,
        SymbolicName: 'Indexed',
    },
    {
        Group: '',
        Description: 'Subject To Alternative Minimum Tax',
        added: 'FIX.4.4',
        Value: '19',
        Sort: 18,
        Tag: 871,
        SymbolicName: 'SubjectToAlternativeMinimumTax',
    },
    {
        Group: '',
        Description: 'Original issue discount price. Supply price in the InstrAttribValue (872) field',
        added: 'FIX.4.4',
        Value: '20',
        Sort: 19,
        Tag: 871,
        SymbolicName: 'OriginalIssueDiscountPrice',
    },
    {
        Group: '',
        Description: 'Callable below maturity value',
        added: 'FIX.4.4',
        Value: '21',
        Sort: 20,
        Tag: 871,
        SymbolicName: 'CallableBelowMaturityValue',
    },
    {
        Group: '',
        Description: 'Callable without notice by mail to holder unless registered',
        added: 'FIX.4.4',
        Value: '22',
        Sort: 21,
        Tag: 871,
        SymbolicName: 'CallableWithoutNotice',
    },
    {
        Group: '',
        Description: 'Price tick rules for security.',
        added: 'FIX.5.0',
        Value: '23',
        Sort: 22,
        addedEP: 42,
        Tag: 871,
        SymbolicName: 'PriceTickRulesForSecurity',
    },
    {
        Group: '',
        Description: 'Trade type eligibility details for security.',
        added: 'FIX.5.0',
        Value: '24',
        Sort: 23,
        addedEP: 42,
        Tag: 871,
        SymbolicName: 'TradeTypeEligibilityDetailsForSecurity',
    },
    {
        Group: '',
        Description: 'Instrument Denominator',
        added: 'FIX.5.0',
        Value: '25',
        Sort: 26,
        addedEP: 52,
        Tag: 871,
        SymbolicName: 'InstrumentDenominator',
    },
    {
        Group: '',
        Description: 'Instrument Numerator',
        added: 'FIX.5.0',
        Value: '26',
        Sort: 27,
        addedEP: 52,
        Tag: 871,
        SymbolicName: 'InstrumentNumerator',
    },
    {
        Group: '',
        Description: 'Instrument Price Precision',
        added: 'FIX.5.0',
        Value: '27',
        Sort: 28,
        addedEP: 52,
        Tag: 871,
        SymbolicName: 'InstrumentPricePrecision',
    },
    {
        Group: '',
        Description: 'Instrument Strike Price',
        added: 'FIX.5.0',
        Value: '28',
        Sort: 29,
        addedEP: 52,
        Tag: 871,
        SymbolicName: 'InstrumentStrikePrice',
    },
    {
        Group: '',
        Description: 'Tradeable Indicator',
        added: 'FIX.5.0',
        Value: '29',
        Sort: 30,
        addedEP: 52,
        Tag: 871,
        SymbolicName: 'TradeableIndicator',
    },
    {
        Group: '',
        Description: 'Text. Supply the text of the attribute or disclaimer in the InstrAttribValue (872) field.',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 871,
        SymbolicName: 'Text',
    },
    {
        Group: '',
        Description: '3(a)(3)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 875,
        SymbolicName: 'Program3a3',
    },
    {
        Group: '',
        Description: '4(2)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 875,
        SymbolicName: 'Program42',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 875,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Absolute',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 891,
        SymbolicName: 'Absolute',
    },
    {
        Group: '',
        Description: 'Per Unit',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 891,
        SymbolicName: 'PerUnit',
    },
    {
        Group: '',
        Description: 'Percentage',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 891,
        SymbolicName: 'Percentage',
    },
    {
        Group: '',
        Description: 'Not Last Message',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 1,
        Tag: 893,
        SymbolicName: 'NotLastMessage',
    },
    {
        Group: '',
        Description: 'Last Message',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 2,
        Tag: 893,
        SymbolicName: 'LastMessage',
    },
    {
        Group: '',
        Description: 'Initial',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 895,
        SymbolicName: 'Initial',
    },
    {
        Group: '',
        Description: 'Scheduled',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 895,
        SymbolicName: 'Scheduled',
    },
    {
        Group: '',
        Description: 'Time Warning',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 895,
        SymbolicName: 'TimeWarning',
    },
    {
        Group: '',
        Description: 'Margin Deficiency',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 895,
        SymbolicName: 'MarginDeficiency',
    },
    {
        Group: '',
        Description: 'Margin Excess',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 895,
        SymbolicName: 'MarginExcess',
    },
    {
        Group: '',
        Description: 'Forward Collateral Demand',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 895,
        SymbolicName: 'ForwardCollateralDemand',
    },
    {
        Group: '',
        Description: 'Event of default',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        Tag: 895,
        SymbolicName: 'EventOfDefault',
    },
    {
        Group: '',
        Description: 'Adverse tax event',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        Tag: 895,
        SymbolicName: 'AdverseTaxEvent',
    },
    {
        Group: '',
        Description: 'Trade Date',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 896,
        SymbolicName: 'TradeDate',
    },
    {
        Group: '',
        Description: 'GC Instrument',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 896,
        SymbolicName: 'GCInstrument',
    },
    {
        Group: '',
        Description: 'Collateral Instrument',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 896,
        SymbolicName: 'CollateralInstrument',
    },
    {
        Group: '',
        Description: 'Substitution Eligible',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 896,
        SymbolicName: 'SubstitutionEligible',
    },
    {
        Group: '',
        Description: 'Not Assigned',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 896,
        SymbolicName: 'NotAssigned',
    },
    {
        Group: '',
        Description: 'Partially Assigned',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 896,
        SymbolicName: 'PartiallyAssigned',
    },
    {
        Group: '',
        Description: 'Fully Assigned',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        Tag: 896,
        SymbolicName: 'FullyAssigned',
    },
    {
        Group: '',
        Description: 'Outstanding Trades (Today < end date)',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        Tag: 896,
        SymbolicName: 'OutstandingTrades',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 903,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 903,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 903,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Release',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 903,
        SymbolicName: 'Release',
    },
    {
        Group: '',
        Description: 'Reverse',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 903,
        SymbolicName: 'Reverse',
    },
    {
        Group: '',
        Description: 'Received',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 905,
        SymbolicName: 'Received',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 905,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Declined',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 905,
        SymbolicName: 'Declined',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 905,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Unknown deal (order / trade)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 906,
        SymbolicName: 'UnknownDeal',
    },
    {
        Group: '',
        Description: 'Unknown or invalid instrument',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 906,
        SymbolicName: 'UnknownOrInvalidInstrument',
    },
    {
        Group: '',
        Description: 'Unauthorized transaction',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 906,
        SymbolicName: 'UnauthorizedTransaction',
    },
    {
        Group: '',
        Description: 'Insufficient collateral',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 906,
        SymbolicName: 'InsufficientCollateral',
    },
    {
        Group: '',
        Description: 'Invalid type of collateral',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 906,
        SymbolicName: 'InvalidTypeOfCollateral',
    },
    {
        Group: '',
        Description: 'Excessive substitution',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 906,
        SymbolicName: 'ExcessiveSubstitution',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 906,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Unassigned',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 910,
        SymbolicName: 'Unassigned',
    },
    {
        Group: '',
        Description: 'Partially Assigned',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 910,
        SymbolicName: 'PartiallyAssigned',
    },
    {
        Group: '',
        Description: 'Assignment Proposed',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 910,
        SymbolicName: 'AssignmentProposed',
    },
    {
        Group: '',
        Description: 'Assigned (Accepted)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 910,
        SymbolicName: 'Assigned',
    },
    {
        Group: '',
        Description: 'Challenged',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 910,
        SymbolicName: 'Challenged',
    },
    {
        Group: '',
        Description: 'Not last message',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 1,
        addedEP: -1,
        Tag: 912,
        SymbolicName: 'NotLastMessage',
    },
    {
        Group: '',
        Description: 'Last message',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 2,
        addedEP: -1,
        Tag: 912,
        SymbolicName: 'LastMessage',
    },
    {
        Group: '',
        Description: '"Versus Payment": Deliver (if sell) or Receive (if buy) vs. (against) Payment',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 919,
        SymbolicName: 'VersusPayment',
    },
    {
        Group: '',
        Description: '"Free": Deliver (if sell) or Receive (if buy) Free',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 919,
        SymbolicName: 'Free',
    },
    {
        Group: '',
        Description: 'Tri-Party',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 919,
        SymbolicName: 'TriParty',
    },
    {
        Group: '',
        Description: 'Hold In Custody',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 919,
        SymbolicName: 'HoldInCustody',
    },
    {
        Group: '',
        Description: 'Log On User',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 924,
        SymbolicName: 'LogOnUser',
    },
    {
        Group: '',
        Description: 'Log Off User',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 924,
        SymbolicName: 'LogOffUser',
    },
    {
        Group: '',
        Description: 'Change Password For User',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 924,
        SymbolicName: 'ChangePasswordForUser',
    },
    {
        Group: '',
        Description: 'Request Individual User Status',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 924,
        SymbolicName: 'RequestIndividualUserStatus',
    },
    {
        Group: '',
        Description: 'Logged In',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 926,
        SymbolicName: 'LoggedIn',
    },
    {
        Group: '',
        Description: 'Not Logged In',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 926,
        SymbolicName: 'NotLoggedIn',
    },
    {
        Group: '',
        Description: 'User Not Recognised',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 926,
        SymbolicName: 'UserNotRecognised',
    },
    {
        Group: '',
        Description: 'Password Incorrect',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 926,
        SymbolicName: 'PasswordIncorrect',
    },
    {
        Group: '',
        Description: 'Password Changed',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        Tag: 926,
        SymbolicName: 'PasswordChanged',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        Tag: 926,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Forced user logout by Exchange',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 56,
        Tag: 926,
        SymbolicName: 'ForcedUserLogoutByExchange',
    },
    {
        Group: '',
        Description: 'Session shutdown warning',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 56,
        Tag: 926,
        SymbolicName: 'SessionShutdownWarning',
    },
    {
        Group: '',
        Description: 'Connected',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 928,
        SymbolicName: 'Connected',
    },
    {
        Group: '',
        Description: 'Not Connected - down expected up',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 928,
        SymbolicName: 'NotConnectedUnexpected',
    },
    {
        Group: '',
        Description: 'Not Connected - down expected down',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 928,
        SymbolicName: 'NotConnectedExpected',
    },
    {
        Group: '',
        Description: 'In Process',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        Tag: 928,
        SymbolicName: 'InProcess',
    },
    {
        Group: '',
        Description: 'Snapshot',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 935,
        SymbolicName: 'Snapshot',
    },
    {
        Group: '',
        Description: 'Subscribe',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 935,
        SymbolicName: 'Subscribe',
    },
    {
        Group: '',
        Description: 'Stop Subscribing',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 3,
        Tag: 935,
        SymbolicName: 'StopSubscribing',
    },
    {
        Group: '',
        Description: "Level of Detail, then NoCompID's becomes required",
        added: 'FIX.4.4',
        Value: '8',
        Sort: 4,
        Tag: 935,
        SymbolicName: 'LevelOfDetail',
    },
    {
        Group: '',
        Description: 'Full',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 937,
        SymbolicName: 'Full',
    },
    {
        Group: '',
        Description: 'Incremental Update',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 937,
        SymbolicName: 'IncrementalUpdate',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 939,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 939,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Accepted with errors',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: 13,
        Tag: 939,
        SymbolicName: 'AcceptedWithErrors',
    },
    {
        Group: '',
        Description: 'Received',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        Tag: 940,
        SymbolicName: 'Received',
    },
    {
        Group: '',
        Description: 'Confirm rejected, i.e. not affirmed',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        Tag: 940,
        SymbolicName: 'ConfirmRejected',
    },
    {
        Group: '',
        Description: 'Affirmed',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        Tag: 940,
        SymbolicName: 'Affirmed',
    },
    {
        Group: '',
        Description: 'Retain',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 944,
        SymbolicName: 'Retain',
    },
    {
        Group: '',
        Description: 'Add',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 944,
        SymbolicName: 'Add',
    },
    {
        Group: '',
        Description: 'Remove',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 944,
        SymbolicName: 'Remove',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 945,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Accepted With Warnings',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 945,
        SymbolicName: 'AcceptedWithWarnings',
    },
    {
        Group: '',
        Description: 'Completed',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 945,
        SymbolicName: 'Completed',
    },
    {
        Group: '',
        Description: 'Completed With Warnings',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 945,
        SymbolicName: 'CompletedWithWarnings',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 945,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Successful (default)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        Tag: 946,
        SymbolicName: 'Successful',
    },
    {
        Group: '',
        Description: 'Invalid or unknown instrument',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        Tag: 946,
        SymbolicName: 'InvalidOrUnknownInstrument',
    },
    {
        Group: '',
        Description: 'Invalid or unknown collateral type',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        Tag: 946,
        SymbolicName: 'InvalidOrUnknownCollateralType',
    },
    {
        Group: '',
        Description: 'Invalid Parties',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        Tag: 946,
        SymbolicName: 'InvalidParties',
    },
    {
        Group: '',
        Description: 'Invalid Transport Type requested',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        Tag: 946,
        SymbolicName: 'InvalidTransportTypeRequested',
    },
    {
        Group: '',
        Description: 'Invalid Destination requested',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 6,
        Tag: 946,
        SymbolicName: 'InvalidDestinationRequested',
    },
    {
        Group: '',
        Description: 'No collateral found for the trade specified',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 7,
        Tag: 946,
        SymbolicName: 'NoCollateralFoundForTheTradeSpecified',
    },
    {
        Group: '',
        Description: 'No collateral found for the order specified',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 8,
        Tag: 946,
        SymbolicName: 'NoCollateralFoundForTheOrderSpecified',
    },
    {
        Group: '',
        Description: 'Collateral inquiry type not supported',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 9,
        Tag: 946,
        SymbolicName: 'CollateralInquiryTypeNotSupported',
    },
    {
        Group: '',
        Description: 'Unauthorized for collateral inquiry',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 10,
        Tag: 946,
        SymbolicName: 'UnauthorizedForCollateralInquiry',
    },
    {
        Group: '',
        Description: 'Other (further information in Text (58) field)',
        added: 'FIX.4.4',
        Value: '99',
        Sort: 99,
        Tag: 946,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Int',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Int',
    },
    {
        Group: '',
        Description: 'Length',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Length',
    },
    {
        Group: '',
        Description: 'NumInGroup',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'NumInGroup',
    },
    {
        Group: '',
        Description: 'SeqNum',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'SeqNum',
    },
    {
        Group: '',
        Description: 'TagNum',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'TagNum',
    },
    {
        Group: '',
        Description: 'float',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '6',
        Sort: 6,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Float',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Qty',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Qty',
    },
    {
        Group: '',
        Description: 'Price',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Price',
    },
    {
        Group: '',
        Description: 'PriceOffset',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'PriceOffset',
    },
    {
        Group: '',
        Description: 'Amt',
        added: 'FIX.4.4',
        Value: '10',
        Sort: 10,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Amt',
    },
    {
        Group: '',
        Description: 'Percentage',
        added: 'FIX.4.4',
        Value: '11',
        Sort: 11,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Percentage',
    },
    {
        Group: '',
        Description: 'Char',
        added: 'FIX.4.4',
        Value: '12',
        Sort: 12,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Char',
    },
    {
        Group: '',
        Description: 'Boolean',
        added: 'FIX.4.4',
        Value: '13',
        Sort: 13,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Boolean',
    },
    {
        Group: '',
        Description: 'String',
        added: 'FIX.4.4',
        Value: '14',
        Sort: 14,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'String',
    },
    {
        Group: '',
        Description: 'MultipleCharValue',
        added: 'FIX.4.4',
        Value: '15',
        Sort: 15,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'MultipleCharValue',
    },
    {
        Group: '',
        Description: 'Currency',
        added: 'FIX.4.4',
        Value: '16',
        Sort: 16,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Currency',
    },
    {
        Group: '',
        Description: 'Exchange',
        added: 'FIX.4.4',
        Value: '17',
        Sort: 17,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Exchange',
    },
    {
        Group: '',
        Description: 'MonthYear',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '18',
        Sort: 18,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'MonthYear',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'UTCTimestamp',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '19',
        Sort: 19,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'UTCTimestamp',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'UTCTimeOnly',
        added: 'FIX.4.4',
        Value: '20',
        Sort: 20,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'UTCTimeOnly',
    },
    {
        Group: '',
        Description: 'LocalMktDate',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '21',
        Sort: 21,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'LocalMktDate',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'UTCDateOnly',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '22',
        Sort: 22,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'UTCDateOnly',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'data',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: '23',
        Sort: 23,
        addedEP: -1,
        Tag: 959,
        SymbolicName: 'Data',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'MultipleStringValue',
        added: 'FIX.4.4',
        Value: '24',
        Sort: 24,
        addedEP: 34,
        Tag: 959,
        SymbolicName: 'MultipleStringValue',
    },
    {
        Group: '',
        Description: 'Active',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 965,
        SymbolicName: 'Active',
    },
    {
        Group: '',
        Description: 'Inactive',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 965,
        SymbolicName: 'Inactive',
    },
    {
        Group: '',
        Description: 'FIXED',
        added: 'FIX.4.4',
        Value: 'FIXED',
        Sort: 1,
        addedEP: -1,
        Tag: 974,
        SymbolicName: 'FIXED',
    },
    {
        Group: '',
        Description: 'DIFF',
        added: 'FIX.4.4',
        Value: 'DIFF',
        Sort: 2,
        addedEP: -1,
        Tag: 974,
        SymbolicName: 'DIFF',
    },
    {
        Group: '',
        Description: 'T+1',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 1,
        addedEP: -1,
        Tag: 975,
        SymbolicName: 'TPlus1',
    },
    {
        Group: '',
        Description: 'T+3',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 2,
        addedEP: -1,
        Tag: 975,
        SymbolicName: 'TPlus3',
    },
    {
        Group: '',
        Description: 'T+4',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 3,
        addedEP: -1,
        Tag: 975,
        SymbolicName: 'TPlus4',
    },
    {
        Group: '',
        Description: 'Add',
        added: 'FIX.4.4',
        Value: 'A',
        Sort: 1,
        addedEP: 8,
        Tag: 980,
        SymbolicName: 'Add',
    },
    {
        Group: '',
        Description: 'Delete',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 2,
        addedEP: 8,
        Tag: 980,
        SymbolicName: 'Delete',
    },
    {
        Group: '',
        Description: 'Modify',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 3,
        addedEP: 8,
        Tag: 980,
        SymbolicName: 'Modify',
    },
    {
        Group: '',
        Description: 'Auto Exercise',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 982,
        SymbolicName: 'AutoExercise',
    },
    {
        Group: '',
        Description: 'Non Auto Exercise',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 982,
        SymbolicName: 'NonAutoExercise',
    },
    {
        Group: '',
        Description: 'Final Will Be Exercised',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 982,
        SymbolicName: 'FinalWillBeExercised',
    },
    {
        Group: '',
        Description: 'Contrary Intention',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 982,
        SymbolicName: 'ContraryIntention',
    },
    {
        Group: '',
        Description: 'Difference',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 982,
        SymbolicName: 'Difference',
    },
    {
        Group: '',
        Description: 'Sub Allocate',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 992,
        SymbolicName: 'SubAllocate',
    },
    {
        Group: '',
        Description: 'Third Party Allocation',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 992,
        SymbolicName: 'ThirdPartyAllocation',
    },
    {
        Group: 'Fixed Magnitude UOM',
        Description: 'Billion cubic feet',
        added: 'FIX.4.4',
        Value: 'Bcf',
        Sort: 1,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'BillionCubicFeet',
    },
    {
        Group: 'Fixed Magnitude UOM',
        Description: 'Million Barrels',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0SP1',
        Value: 'MMbbl',
        Sort: 5,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'MillionBarrels',
    },
    {
        Group: 'Fixed Magnitude UOM',
        Description: 'One Million BTU',
        added: 'FIX.4.4',
        Value: 'MMBtu',
        Sort: 6,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'OneMillionBTU',
    },
    {
        Group: 'Fixed Magnitude UOM',
        Description: 'Megawatt hours',
        added: 'FIX.4.4',
        Value: 'MWh',
        Sort: 7,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'MegawattHours',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Barrels',
        added: 'FIX.4.4',
        Value: 'Bbl',
        Sort: 0,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'Barrels',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Bushels',
        added: 'FIX.4.4',
        Value: 'Bu',
        Sort: 2,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'Bushels',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'pounds',
        added: 'FIX.4.4',
        Value: 'lbs',
        Sort: 3,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'Pounds',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Gallons',
        added: 'FIX.4.4',
        Value: 'Gal',
        Sort: 4,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'Gallons',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Troy Ounces',
        added: 'FIX.4.4',
        Value: 'oz_tr',
        Sort: 8,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'TroyOunces',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Metric Tons (aka Tonne)',
        added: 'FIX.4.4',
        Value: 't',
        Sort: 9,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'MetricTons',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Tons (US)',
        added: 'FIX.4.4',
        Value: 'tn',
        Sort: 10,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'Tons',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'US Dollars',
        added: 'FIX.4.4',
        Value: 'USD',
        Sort: 11,
        addedEP: -1,
        Tag: 996,
        SymbolicName: 'USDollars',
    },
    {
        Group: '',
        Description: 'Hour',
        added: 'FIX.4.4',
        Value: 'H',
        Sort: 0,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Hour',
    },
    {
        Group: '',
        Description: 'Minute',
        added: 'FIX.4.4',
        Value: 'Min',
        Sort: 1,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Minute',
    },
    {
        Group: '',
        Description: 'Second',
        added: 'FIX.4.4',
        Value: 'S',
        Sort: 2,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Second',
    },
    {
        Group: '',
        Description: 'Day',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 3,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Day',
    },
    {
        Group: '',
        Description: 'Week',
        added: 'FIX.4.4',
        Value: 'Wk',
        Sort: 4,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Week',
    },
    {
        Group: '',
        Description: 'Month',
        added: 'FIX.4.4',
        Value: 'Mo',
        Sort: 5,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Month',
    },
    {
        Group: '',
        Description: 'Year',
        added: 'FIX.4.4',
        Value: 'Yr',
        Sort: 6,
        addedEP: -1,
        Tag: 997,
        SymbolicName: 'Year',
    },
    {
        Group: '',
        Description: 'Automatic',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1002,
        SymbolicName: 'Automatic',
    },
    {
        Group: '',
        Description: 'Guarantor',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1002,
        SymbolicName: 'Guarantor',
    },
    {
        Group: '',
        Description: 'Manual',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1002,
        SymbolicName: 'Manual',
    },
    {
        Group: '',
        Description: 'false - trade is not an AsOf trade',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1015,
        SymbolicName: 'False',
    },
    {
        Group: '',
        Description: 'true - trade is an AsOf trade',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1015,
        SymbolicName: 'True',
    },
    {
        Group: '',
        Description: 'Top of Book',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1021,
        SymbolicName: 'TopOfBook',
    },
    {
        Group: '',
        Description: 'Price Depth',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1021,
        SymbolicName: 'PriceDepth',
    },
    {
        Group: '',
        Description: 'Order Depth',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1021,
        SymbolicName: 'OrderDepth',
    },
    {
        Group: '',
        Description: 'Book',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1024,
        SymbolicName: 'Book',
    },
    {
        Group: '',
        Description: 'Off-Book',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1024,
        SymbolicName: 'OffBook',
    },
    {
        Group: '',
        Description: 'Cross',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1024,
        SymbolicName: 'Cross',
    },
    {
        Group: 'NASD OATS',
        Description: 'Add-on Order',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'ADD',
        Sort: 1,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'AddOnOrder',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'All or None',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'AON',
        Sort: 2,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'AllOrNone',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Cash Not Held',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'CNH',
        Sort: 3,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'CashNotHeld',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Directed Order',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'DIR',
        Sort: 4,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'DirectedOrder',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Exchange for Physical Transaction',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'E.W',
        Sort: 5,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'ExchangeForPhysicalTransaction',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Fill or Kill',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'FOK',
        Sort: 6,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'FillOrKill',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Imbalance Only',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'IO',
        Sort: 7,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'ImbalanceOnly',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Immediate or Cancel',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'IOC',
        Sort: 8,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'ImmediateOrCancel',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Limit On Open',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'LOO',
        Sort: 9,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'LimitOnOpen',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Limit on Close',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'LOC',
        Sort: 10,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'LimitOnClose',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Market at Open',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'MAO',
        Sort: 11,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'MarketAtOpen',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Market at Close',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'MAC',
        Sort: 12,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'MarketAtClose',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Market on Open',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'MOO',
        Sort: 13,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'MarketOnOpen',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Market On Close',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'MOC',
        Sort: 14,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'MarketOnClose',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Minimum Quantity',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'MQT',
        Sort: 15,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'MinimumQuantity',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Not Held',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'NH',
        Sort: 16,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'NotHeld',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Over the Day',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'OVD',
        Sort: 17,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'OverTheDay',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Pegged',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'PEG',
        Sort: 18,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'Pegged',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Reserve Size Order',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'RSV',
        Sort: 19,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'ReserveSizeOrder',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Stop Stock Transaction',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'S.W',
        Sort: 20,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'StopStockTransaction',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Scale',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'SCL',
        Sort: 21,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'Scale',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Time Order',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'TMO',
        Sort: 22,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'TimeOrder',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Trailing Stop',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'TS',
        Sort: 23,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'TrailingStop',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Work',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'WRK',
        Sort: 24,
        addedEP: -1,
        Tag: 1031,
        SymbolicName: 'Work',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'NASD OATS',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1032,
        SymbolicName: 'NASDOATS',
    },
    {
        Group: 'NASD OATS',
        Description: 'Agency',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'A',
        Sort: 1,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Agency',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Arbitrage',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'AR',
        Sort: 2,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Arbitrage',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Derivatives',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'D',
        Sort: 3,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Derivatives',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'International',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'IN',
        Sort: 4,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'International',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Institutional',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'IS',
        Sort: 5,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Institutional',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Other',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'O',
        Sort: 6,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Other',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Preferred Trading',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'PF',
        Sort: 7,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'PreferredTrading',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Proprietary',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'PR',
        Sort: 8,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Proprietary',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Program Trading',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'PT',
        Sort: 9,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'ProgramTrading',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Sales',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'S',
        Sort: 10,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Sales',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: 'NASD OATS',
        Description: 'Trading',
        added: 'FIX.4.4',
        updatedEP: 95,
        Value: 'T',
        Sort: 11,
        addedEP: -1,
        Tag: 1033,
        SymbolicName: 'Trading',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'NASD OATS',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1034,
        SymbolicName: 'NASDOATS',
    },
    {
        Group: '',
        Description: 'Add-on Order',
        added: 'FIX.4.4',
        Value: 'ADD',
        Sort: 1,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'AddOnOrder',
    },
    {
        Group: '',
        Description: 'All or None',
        added: 'FIX.4.4',
        Value: 'AON',
        Sort: 2,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'AllOrNone',
    },
    {
        Group: '',
        Description: 'Cash Not Held',
        added: 'FIX.4.4',
        Value: 'CNH',
        Sort: 3,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'CashNotHeld',
    },
    {
        Group: '',
        Description: 'Directed Order',
        added: 'FIX.4.4',
        Value: 'DIR',
        Sort: 4,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'DirectedOrder',
    },
    {
        Group: '',
        Description: 'Exchange for Physical Transaction',
        added: 'FIX.4.4',
        Value: 'E.W',
        Sort: 5,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'ExchangeForPhysicalTransaction',
    },
    {
        Group: '',
        Description: 'Fill or Kill',
        added: 'FIX.4.4',
        Value: 'FOK',
        Sort: 6,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'FillOrKill',
    },
    {
        Group: '',
        Description: 'Imbalance Only',
        added: 'FIX.4.4',
        Value: 'IO',
        Sort: 7,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'ImbalanceOnly',
    },
    {
        Group: '',
        Description: 'Immediate or Cancel',
        added: 'FIX.4.4',
        Value: 'IOC',
        Sort: 8,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'ImmediateOrCancel',
    },
    {
        Group: '',
        Description: 'Limit On Open',
        added: 'FIX.4.4',
        Value: 'LOO',
        Sort: 9,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'LimitOnOpen',
    },
    {
        Group: '',
        Description: 'Limit on Close',
        added: 'FIX.4.4',
        Value: 'LOC',
        Sort: 10,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'LimitOnClose',
    },
    {
        Group: '',
        Description: 'Market at Open',
        added: 'FIX.4.4',
        Value: 'MAO',
        Sort: 11,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'MarketAtOpen',
    },
    {
        Group: '',
        Description: 'Market at Close',
        added: 'FIX.4.4',
        Value: 'MAC',
        Sort: 12,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'MarketAtClose',
    },
    {
        Group: '',
        Description: 'Market on Open',
        added: 'FIX.4.4',
        Value: 'MOO',
        Sort: 13,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'MarketOnOpen',
    },
    {
        Group: '',
        Description: 'Market On Close',
        added: 'FIX.4.4',
        Value: 'MOC',
        Sort: 14,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'MarketOnClose',
    },
    {
        Group: '',
        Description: 'Minimum Quantity',
        added: 'FIX.4.4',
        Value: 'MQT',
        Sort: 15,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'MinimumQuantity',
    },
    {
        Group: '',
        Description: 'Not Held',
        added: 'FIX.4.4',
        Value: 'NH',
        Sort: 16,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'NotHeld',
    },
    {
        Group: '',
        Description: 'Over the Day',
        added: 'FIX.4.4',
        Value: 'OVD',
        Sort: 17,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'OverTheDay',
    },
    {
        Group: '',
        Description: 'Pegged',
        added: 'FIX.4.4',
        Value: 'PEG',
        Sort: 18,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'Pegged',
    },
    {
        Group: '',
        Description: 'Reserve Size Order',
        added: 'FIX.4.4',
        Value: 'RSV',
        Sort: 19,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'ReserveSizeOrder',
    },
    {
        Group: '',
        Description: 'Stop Stock Transaction',
        added: 'FIX.4.4',
        Value: 'S.W',
        Sort: 20,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'StopStockTransaction',
    },
    {
        Group: '',
        Description: 'Scale',
        added: 'FIX.4.4',
        Value: 'SCL',
        Sort: 21,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'Scale',
    },
    {
        Group: '',
        Description: 'Time Order',
        added: 'FIX.4.4',
        Value: 'TMO',
        Sort: 22,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'TimeOrder',
    },
    {
        Group: '',
        Description: 'Trailing Stop',
        added: 'FIX.4.4',
        Value: 'TS',
        Sort: 23,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'TrailingStop',
    },
    {
        Group: '',
        Description: 'Work',
        added: 'FIX.4.4',
        Value: 'WRK',
        Sort: 24,
        addedEP: -1,
        Tag: 1035,
        SymbolicName: 'Work',
    },
    {
        Group: '',
        Description: 'Received, not yet processed',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1036,
        SymbolicName: 'Received',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1036,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: "Don't know / Rejected",
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1036,
        SymbolicName: 'Don',
    },
    {
        Group: '',
        Description: 'Specific Deposit',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1043,
        SymbolicName: 'SpecificDeposit',
    },
    {
        Group: '',
        Description: 'General',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1043,
        SymbolicName: 'General',
    },
    {
        Group: '',
        Description: 'Divide',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 0,
        addedEP: -1,
        Tag: 1046,
        SymbolicName: 'Divide',
    },
    {
        Group: '',
        Description: 'Multiply',
        added: 'FIX.4.4',
        Value: 'M',
        Sort: 1,
        addedEP: -1,
        Tag: 1046,
        SymbolicName: 'Multiply',
    },
    {
        Group: '',
        Description: 'Open',
        added: 'FIX.4.4',
        Value: 'O',
        Sort: 1,
        addedEP: -1,
        Tag: 1047,
        SymbolicName: 'Open',
    },
    {
        Group: '',
        Description: 'Close',
        added: 'FIX.4.4',
        Value: 'C',
        Sort: 2,
        addedEP: -1,
        Tag: 1047,
        SymbolicName: 'Close',
    },
    {
        Group: '',
        Description: 'Rolled',
        added: 'FIX.4.4',
        Value: 'R',
        Sort: 3,
        addedEP: -1,
        Tag: 1047,
        SymbolicName: 'Rolled',
    },
    {
        Group: '',
        Description: 'FIFO',
        added: 'FIX.4.4',
        Value: 'F',
        Sort: 4,
        addedEP: -1,
        Tag: 1047,
        SymbolicName: 'FIFO',
    },
    {
        Group: '',
        Description: 'Order initiator is aggressor',
        added: 'FIX.4.4',
        Value: 'Y',
        Sort: 1,
        addedEP: -1,
        Tag: 1057,
        SymbolicName: 'OrderInitiatorIsAggressor',
    },
    {
        Group: '',
        Description: 'Order initiator is passive',
        added: 'FIX.4.4',
        Value: 'N',
        Sort: 2,
        addedEP: -1,
        Tag: 1057,
        SymbolicName: 'OrderInitiatorIsPassive',
    },
    {
        Group: '',
        Description: 'Indicative',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: 32,
        Tag: 1070,
        SymbolicName: 'Indicative',
    },
    {
        Group: '',
        Description: 'Tradeable',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 3,
        addedEP: 32,
        Tag: 1070,
        SymbolicName: 'Tradeable',
    },
    {
        Group: '',
        Description: 'Restricted Tradeable',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 4,
        addedEP: 32,
        Tag: 1070,
        SymbolicName: 'RestrictedTradeable',
    },
    {
        Group: '',
        Description: 'Counter',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 5,
        addedEP: 32,
        Tag: 1070,
        SymbolicName: 'Counter',
    },
    {
        Group: '',
        Description: 'Indicative and Tradeable',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 6,
        addedEP: 32,
        Tag: 1070,
        SymbolicName: 'IndicativeAndTradeable',
    },
    {
        Group: '',
        Description: 'SecondaryOrderID(198)',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1081,
        SymbolicName: 'SecondaryOrderID',
    },
    {
        Group: '',
        Description: 'OrderID(37)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1081,
        SymbolicName: 'OrderID',
    },
    {
        Group: '',
        Description: 'MDEntryID(278)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1081,
        SymbolicName: 'MDEntryID',
    },
    {
        Group: '',
        Description: 'QuoteEntryID(299)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: -1,
        Tag: 1081,
        SymbolicName: 'QuoteEntryID',
    },
    {
        Group: '',
        Description: 'Immediate (after each fill)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1083,
        SymbolicName: 'Immediate',
    },
    {
        Group: '',
        Description: 'Exhaust (when DisplayQty = 0)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1083,
        SymbolicName: 'Exhaust',
    },
    {
        Group: '',
        Description: 'Initial (use original DisplayQty)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1084,
        SymbolicName: 'Initial',
    },
    {
        Group: '',
        Description: 'New (use RefreshQty)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1084,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Random (randomize value)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1084,
        SymbolicName: 'Random',
    },
    {
        Group: '',
        Description: 'None',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1092,
        SymbolicName: 'None',
    },
    {
        Group: '',
        Description: 'Local (Exchange, ECN, ATS)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1092,
        SymbolicName: 'Local',
    },
    {
        Group: '',
        Description: 'National (Across all national markets)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1092,
        SymbolicName: 'National',
    },
    {
        Group: '',
        Description: 'Global (Across all markets)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: -1,
        Tag: 1092,
        SymbolicName: 'Global',
    },
    {
        Group: '',
        Description: 'Odd Lot',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1093,
        SymbolicName: 'OddLot',
    },
    {
        Group: '',
        Description: 'Round Lot',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1093,
        SymbolicName: 'RoundLot',
    },
    {
        Group: '',
        Description: 'Block Lot',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1093,
        SymbolicName: 'BlockLot',
    },
    {
        Group: '',
        Description: 'Last peg (last sale)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'LastPeg',
    },
    {
        Group: '',
        Description: 'Mid-price peg (midprice of inside quote)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'MidPricePeg',
    },
    {
        Group: '',
        Description: 'Opening peg',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'OpeningPeg',
    },
    {
        Group: '',
        Description: 'Market peg',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'MarketPeg',
    },
    {
        Group: '',
        Description: 'Primary peg (primary market - buy at bid or sell at offer)',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'PrimaryPeg',
    },
    {
        Group: '',
        Description: 'Peg to VWAP',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'PegToVWAP',
    },
    {
        Group: '',
        Description: 'Trailing Stop Peg',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'TrailingStopPeg',
    },
    {
        Group: '',
        Description: 'Peg to Limit Price',
        added: 'FIX.4.4',
        Value: '9',
        Sort: 9,
        addedEP: -1,
        Tag: 1094,
        SymbolicName: 'PegToLimitPrice',
    },
    {
        Group: '',
        Description: 'Partial Execution',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1100,
        SymbolicName: 'PartialExecution',
    },
    {
        Group: '',
        Description: 'Specified Trading Session',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1100,
        SymbolicName: 'SpecifiedTradingSession',
    },
    {
        Group: '',
        Description: 'Next Auction',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1100,
        SymbolicName: 'NextAuction',
    },
    {
        Group: '',
        Description: 'Price Movement',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 1100,
        SymbolicName: 'PriceMovement',
    },
    {
        Group: '',
        Description: 'Activate',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1101,
        SymbolicName: 'Activate',
    },
    {
        Group: '',
        Description: 'Modify',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1101,
        SymbolicName: 'Modify',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1101,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'Best Offer',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'BestOffer',
    },
    {
        Group: '',
        Description: 'Last Trade',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'LastTrade',
    },
    {
        Group: '',
        Description: 'Best Bid',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'BestBid',
    },
    {
        Group: '',
        Description: 'Best Bid or Last Trade',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'BestBidOrLastTrade',
    },
    {
        Group: '',
        Description: 'Best Offer or Last Trade',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'BestOfferOrLastTrade',
    },
    {
        Group: '',
        Description: 'Best Mid',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        addedEP: -1,
        Tag: 1107,
        SymbolicName: 'BestMid',
    },
    {
        Group: '',
        Description: 'None',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1108,
        SymbolicName: 'None',
    },
    {
        Group: '',
        Description: 'Local (Exchange, ECN, ATS)',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1108,
        SymbolicName: 'Local',
    },
    {
        Group: '',
        Description: 'National (Across all national markets)',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1108,
        SymbolicName: 'National',
    },
    {
        Group: '',
        Description: 'Global (Across all markets)',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: -1,
        Tag: 1108,
        SymbolicName: 'Global',
    },
    {
        Group: '',
        Description: 'Trigger if the price of the specified type goes UP to or through the specified Trigger Price.',
        added: 'FIX.4.4',
        Value: 'U',
        Sort: 1,
        addedEP: -1,
        Tag: 1109,
        SymbolicName: 'Up',
    },
    {
        Group: '',
        Description: 'Trigger if the price of the specified type goes DOWN to or through the specified Trigger Price.',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 2,
        addedEP: -1,
        Tag: 1109,
        SymbolicName: 'Down',
    },
    {
        Group: '',
        Description: 'Market',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: 35,
        Tag: 1111,
        SymbolicName: 'Market',
    },
    {
        Group: '',
        Description: 'Limit',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: 35,
        Tag: 1111,
        SymbolicName: 'Limit',
    },
    {
        Group: '',
        Description: 'Order',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'Order',
    },
    {
        Group: '',
        Description: 'Quote',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'Quote',
    },
    {
        Group: '',
        Description: 'Privately Negotiated Trade',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'PrivatelyNegotiatedTrade',
    },
];

const batch6: ISpecEnums[] = [
    {
        Group: '',
        Description: 'Multileg order',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'MultilegOrder',
    },
    {
        Group: '',
        Description: 'Linked order',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'LinkedOrder',
    },
    {
        Group: '',
        Description: 'Quote Request',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'QuoteRequest',
    },
    {
        Group: '',
        Description: 'Implied Order',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'ImpliedOrder',
    },
    {
        Group: '',
        Description: 'Cross Order',
        added: 'FIX.4.4',
        Value: '8',
        Sort: 8,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'CrossOrder',
    },
    {
        Group: '',
        Description: 'Streaming price (quote)',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 9,
        addedEP: -1,
        Tag: 1115,
        SymbolicName: 'StreamingPrice',
    },
    {
        Group: '',
        Description: 'Trade Confirmation',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 1,
        addedEP: -1,
        Tag: 1123,
        SymbolicName: 'TradeConfirmation',
    },
    {
        Group: '',
        Description: 'Two-Party Report',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 2,
        addedEP: -1,
        Tag: 1123,
        SymbolicName: 'TwoPartyReport',
    },
    {
        Group: '',
        Description: 'One-Party Report for Matching',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 3,
        addedEP: -1,
        Tag: 1123,
        SymbolicName: 'OnePartyReportForMatching',
    },
    {
        Group: '',
        Description: 'One-Party Report for Pass Through',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 4,
        addedEP: -1,
        Tag: 1123,
        SymbolicName: 'OnePartyReportForPassThrough',
    },
    {
        Group: '',
        Description: 'Automated Floor Order Routing',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 5,
        addedEP: -1,
        Tag: 1123,
        SymbolicName: 'AutomatedFloorOrderRouting',
    },
    {
        Group: '',
        Description: 'Two Party Report for Claim',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 55,
        Tag: 1123,
        SymbolicName: 'TwoPartyReportForClaim',
    },
    {
        Group: '',
        Description: 'FIX27',
        added: 'FIX.4.4',
        Value: '0',
        Sort: 0,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX27',
    },
    {
        Group: '',
        Description: 'FIX30',
        added: 'FIX.4.4',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX30',
    },
    {
        Group: '',
        Description: 'FIX40',
        added: 'FIX.4.4',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX40',
    },
    {
        Group: '',
        Description: 'FIX41',
        added: 'FIX.4.4',
        Value: '3',
        Sort: 3,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX41',
    },
    {
        Group: '',
        Description: 'FIX42',
        added: 'FIX.4.4',
        Value: '4',
        Sort: 4,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX42',
    },
    {
        Group: '',
        Description: 'FIX43',
        added: 'FIX.4.4',
        Value: '5',
        Sort: 5,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX43',
    },
    {
        Group: '',
        Description: 'FIX44',
        added: 'FIX.4.4',
        Value: '6',
        Sort: 6,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX44',
    },
    {
        Group: '',
        Description: 'FIX50',
        added: 'FIX.4.4',
        Value: '7',
        Sort: 7,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX50',
    },
    {
        Group: '',
        Description: 'FIX50SP1',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: -1,
        Tag: 1128,
        SymbolicName: 'FIX50SP1',
    },
    {
        Group: '',
        Description: 'BIC (Bank Identification Code) (ISO 9362)',
        added: 'FIX.4.4',
        Value: 'B',
        Sort: 1,
        addedEP: -1,
        Tag: 1133,
        SymbolicName: 'BIC',
    },
    {
        Group: '',
        Description: 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
        added: 'FIX.4.4',
        Value: 'C',
        Sort: 2,
        addedEP: -1,
        Tag: 1133,
        SymbolicName: 'GeneralIdentifier',
    },
    {
        Group: '',
        Description: 'Proprietary / Custom code',
        added: 'FIX.4.4',
        Value: 'D',
        Sort: 3,
        addedEP: -1,
        Tag: 1133,
        SymbolicName: 'Proprietary',
    },
    {
        Group: '',
        Description: 'ISO Country Code',
        added: 'FIX.4.4',
        Value: 'E',
        Sort: 4,
        addedEP: -1,
        Tag: 1133,
        SymbolicName: 'ISOCountryCode',
    },
    {
        Group: '',
        Description: 'MIC (ISO 10383 - Market Identifier Code)',
        added: 'FIX.4.4',
        Value: 'G',
        Sort: 5,
        addedEP: -1,
        Tag: 1133,
        SymbolicName: 'MIC',
    },
    {
        Group: '',
        Description: 'Not implied',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 42,
        Tag: 1144,
        SymbolicName: 'NotImplied',
    },
    {
        Group: '',
        Description: 'Implied-in - The existence of a multi-leg instrument is implied by the legs of that instrument',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 42,
        Tag: 1144,
        SymbolicName: 'ImpliedIn',
    },
    {
        Group: '',
        Description: 'Implied-out - The existence of the underlying legs are implied by the multi-leg instrument',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 42,
        Tag: 1144,
        SymbolicName: 'ImpliedOut',
    },
    {
        Group: '',
        Description: 'Both Implied-in and Implied-out',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 42,
        Tag: 1144,
        SymbolicName: 'BothImpliedInAndImpliedOut',
    },
    {
        Group: '',
        Description: 'Preliminary',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 44,
        Tag: 1159,
        SymbolicName: 'Preliminary',
    },
    {
        Group: '',
        Description: 'Final',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 44,
        Tag: 1159,
        SymbolicName: 'Final',
    },
    {
        Group: '',
        Description: 'Cancel',
        added: 'FIX.5.0',
        Value: 'C',
        Sort: 1,
        addedEP: 44,
        Tag: 1162,
        SymbolicName: 'Cancel',
    },
    {
        Group: '',
        Description: 'New',
        added: 'FIX.5.0',
        Value: 'N',
        Sort: 2,
        addedEP: 44,
        Tag: 1162,
        SymbolicName: 'New',
    },
    {
        Group: '',
        Description: 'Replace',
        added: 'FIX.5.0',
        Value: 'R',
        Sort: 3,
        addedEP: 44,
        Tag: 1162,
        SymbolicName: 'Replace',
    },
    {
        Group: '',
        Description: 'Restate',
        added: 'FIX.5.0',
        Value: 'T',
        Sort: 4,
        addedEP: 44,
        Tag: 1162,
        SymbolicName: 'Restate',
    },
    {
        Group: '',
        Description: 'Instructions of Broker',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 44,
        Tag: 1164,
        SymbolicName: 'InstructionsOfBroker',
    },
    {
        Group: '',
        Description: 'Instructions for Institution',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 44,
        Tag: 1164,
        SymbolicName: 'InstructionsForInstitution',
    },
    {
        Group: '',
        Description: 'Investor',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 44,
        Tag: 1164,
        SymbolicName: 'Investor',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Rejected',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 2,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Removed from Market',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 3,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'RemovedFromMarket',
    },
    {
        Group: '',
        Description: 'Expired',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 4,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'Expired',
    },
    {
        Group: '',
        Description: 'Locked Market Warning',
        added: 'FIX.5.0',
        Value: '12',
        Sort: 5,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'LockedMarketWarning',
    },
    {
        Group: '',
        Description: 'Cross Market Warning',
        added: 'FIX.5.0',
        Value: '13',
        Sort: 6,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'CrossMarketWarning',
    },
    {
        Group: '',
        Description: 'Canceled due to Lock Market',
        added: 'FIX.5.0',
        Value: '14',
        Sort: 7,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'CanceledDueToLockMarket',
    },
    {
        Group: '',
        Description: 'Canceled due to Cross Market',
        added: 'FIX.5.0',
        Value: '15',
        Sort: 8,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'CanceledDueToCrossMarket',
    },
    {
        Group: '',
        Description: 'Active',
        added: 'FIX.5.0',
        Value: '16',
        Sort: 9,
        addedEP: 45,
        Tag: 1167,
        SymbolicName: 'Active',
    },
    {
        Group: '',
        Description: 'Private Quote',
        added: 'FIX.5.0',
        Value: 'Y',
        Sort: 1,
        addedEP: 46,
        Tag: 1171,
        SymbolicName: 'PrivateQuote',
    },
    {
        Group: '',
        Description: 'Public Quote',
        added: 'FIX.5.0',
        Value: 'N',
        Sort: 2,
        addedEP: 46,
        Tag: 1171,
        SymbolicName: 'PublicQuote',
    },
    {
        Group: '',
        Description: 'All market participants',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 46,
        Tag: 1172,
        SymbolicName: 'AllMarketParticipants',
    },
    {
        Group: '',
        Description: 'Specified market participants',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 46,
        Tag: 1172,
        SymbolicName: 'SpecifiedMarketParticipants',
    },
    {
        Group: '',
        Description: 'All Market Makers',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 46,
        Tag: 1172,
        SymbolicName: 'AllMarketMakers',
    },
    {
        Group: '',
        Description: 'Primary Market Maker(s)',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 46,
        Tag: 1172,
        SymbolicName: 'PrimaryMarketMaker',
    },
    {
        Group: '',
        Description: 'Order imbalance, auction is extended',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'OrderImbalance',
    },
    {
        Group: '',
        Description: 'Trading resumes (after Halt)',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'TradingResumes',
    },
    {
        Group: '',
        Description: 'Price Volatility Interruption',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'PriceVolatilityInterruption',
    },
    {
        Group: '',
        Description: 'Change of Trading Session',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'ChangeOfTradingSession',
    },
    {
        Group: '',
        Description: 'Change of Trading Subsession',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 5,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'ChangeOfTradingSubsession',
    },
    {
        Group: '',
        Description: 'Change of Security Trading Status',
        added: 'FIX.5.0',
        updatedEP: 95,
        Value: '6',
        Sort: 6,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'ChangeOfSecurityTradingStatus',
        updated: 'FIX.5.0SP1',
    },
    {
        Group: '',
        Description: 'Change of Book Type',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'ChangeOfBookType',
    },
    {
        Group: '',
        Description: 'Change of Market Depth',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 47,
        Tag: 1174,
        SymbolicName: 'ChangeOfMarketDepth',
    },
    {
        Group: '',
        Description: 'Exchange Last',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 47,
        Tag: 1176,
        SymbolicName: 'ExchangeLast',
    },
    {
        Group: '',
        Description: 'High / Low Price',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 47,
        Tag: 1176,
        SymbolicName: 'High',
    },
    {
        Group: '',
        Description: 'Average Price (VWAP, TWAP ... )',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 47,
        Tag: 1176,
        SymbolicName: 'AveragePrice',
    },
    {
        Group: '',
        Description: 'Turnover (Price * Qty)',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 47,
        Tag: 1176,
        SymbolicName: 'Turnover',
    },
    {
        Group: '',
        Description: 'Customer',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 47,
        Tag: 1178,
        SymbolicName: 'Customer',
    },
    {
        Group: '',
        Description: 'Cash settlement required',
        added: 'FIX.5.0',
        Value: 'C',
        Sort: 1,
        addedEP: 52,
        Tag: 1193,
        SymbolicName: 'CashSettlementRequired',
    },
    {
        Group: '',
        Description: 'Physical settlement required',
        added: 'FIX.5.0',
        Value: 'P',
        Sort: 2,
        addedEP: 52,
        Tag: 1193,
        SymbolicName: 'PhysicalSettlementRequired',
    },
    {
        Group: '',
        Description: 'European',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1194,
        SymbolicName: 'European',
    },
    {
        Group: '',
        Description: 'American',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1194,
        SymbolicName: 'American',
    },
    {
        Group: '',
        Description: 'Bermuda',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1194,
        SymbolicName: 'Bermuda',
    },
    {
        Group: '',
        Description: 'Standard, money per unit of a physical',
        added: 'FIX.5.0',
        Value: 'STD',
        Sort: 1,
        addedEP: 52,
        Tag: 1196,
        SymbolicName: 'Standard',
    },
    {
        Group: '',
        Description: 'Index',
        added: 'FIX.5.0',
        Value: 'INX',
        Sort: 2,
        addedEP: 52,
        Tag: 1196,
        SymbolicName: 'Index',
    },
    {
        Group: '',
        Description: 'Interest rate Index',
        added: 'FIX.5.0',
        Value: 'INT',
        Sort: 3,
        addedEP: 52,
        Tag: 1196,
        SymbolicName: 'InterestRateIndex',
    },
    {
        Group: '',
        Description: 'premium style',
        added: 'FIX.5.0',
        Value: 'EQTY',
        Sort: 1,
        addedEP: 52,
        Tag: 1197,
        SymbolicName: 'PremiumStyle',
    },
    {
        Group: '',
        Description: 'futures style mark-to-market',
        added: 'FIX.5.0',
        Value: 'FUT',
        Sort: 2,
        addedEP: 52,
        Tag: 1197,
        SymbolicName: 'FuturesStyleMarkToMarket',
    },
    {
        Group: '',
        Description: 'futures style with an attached cash adjustment',
        added: 'FIX.5.0',
        Value: 'FUTDA',
        Sort: 3,
        addedEP: 52,
        Tag: 1197,
        SymbolicName: 'FuturesStyleWithAnAttachedCashAdjustment',
    },
    {
        Group: '',
        Description: 'pre-listed only',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1198,
        SymbolicName: 'PreListedOnly',
    },
    {
        Group: '',
        Description: 'user requested',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1198,
        SymbolicName: 'UserRequested',
    },
    {
        Group: '',
        Description: 'Regular',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1209,
        SymbolicName: 'Regular',
    },
    {
        Group: '',
        Description: 'Variable',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1209,
        SymbolicName: 'Variable',
    },
    {
        Group: '',
        Description: 'Fixed',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1209,
        SymbolicName: 'Fixed',
    },
    {
        Group: '',
        Description: 'Traded as a spread leg',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 52,
        Tag: 1209,
        SymbolicName: 'TradedAsASpreadLeg',
    },
    {
        Group: '',
        Description: 'Settled as a spread leg',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 52,
        Tag: 1209,
        SymbolicName: 'SettledAsASpreadLeg',
    },
    {
        Group: '',
        Description: 'Months',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1302,
        SymbolicName: 'Months',
    },
    {
        Group: '',
        Description: 'Days',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1302,
        SymbolicName: 'Days',
    },
    {
        Group: '',
        Description: 'Weeks',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1302,
        SymbolicName: 'Weeks',
    },
    {
        Group: '',
        Description: 'Years',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 52,
        Tag: 1302,
        SymbolicName: 'Years',
    },
    {
        Group: '',
        Description: 'YearMonth Only (default)',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1303,
        SymbolicName: 'YearMonthOnly',
    },
    {
        Group: '',
        Description: 'YearMonthDay',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1303,
        SymbolicName: 'YearMonthDay',
    },
    {
        Group: '',
        Description: 'YearMonthWeek',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1303,
        SymbolicName: 'YearMonthWeek',
    },
    {
        Group: '',
        Description: 'Price',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1306,
        SymbolicName: 'Price',
    },
    {
        Group: '',
        Description: 'Ticks',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1306,
        SymbolicName: 'Ticks',
    },
    {
        Group: '',
        Description: 'Percentage',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1306,
        SymbolicName: 'Percentage',
    },
    {
        Group: '',
        Description: 'Symbol',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'Symbol',
    },
    {
        Group: '',
        Description: 'SecurityType and or CFICode',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'SecurityTypeAndOrCFICode',
    },
    {
        Group: '',
        Description: 'Product',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'Product',
    },
    {
        Group: '',
        Description: 'TradingSessionID',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'TradingSessionID',
    },
    {
        Group: '',
        Description: 'All Securities',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'AllSecurities',
    },
    {
        Group: '',
        Description: 'UndelyingSymbol',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'UndelyingSymbol',
    },
    {
        Group: '',
        Description: 'Underlying SecurityType and or CFICode',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 7,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'UnderlyingSecurityTypeAndOrCFICode',
    },
    {
        Group: '',
        Description: 'Underlying Product',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 8,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'UnderlyingProduct',
    },
    {
        Group: '',
        Description: 'MarketID or MarketID + MarketSegmentID',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 52,
        Tag: 1307,
        SymbolicName: 'MarketIDOrMarketID',
    },
    {
        Group: '',
        Description: 'Add',
        added: 'FIX.5.0',
        Value: 'A',
        Sort: 1,
        addedEP: 53,
        Tag: 1395,
        SymbolicName: 'Add',
    },
    {
        Group: '',
        Description: 'Delete',
        added: 'FIX.5.0',
        Value: 'D',
        Sort: 2,
        addedEP: 53,
        Tag: 1395,
        SymbolicName: 'Delete',
    },
    {
        Group: '',
        Description: 'Modify',
        added: 'FIX.5.0',
        Value: 'M',
        Sort: 3,
        addedEP: 53,
        Tag: 1395,
        SymbolicName: 'Modify',
    },
    {
        Group: '',
        Description: 'Session active',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'SessionActive',
    },
    {
        Group: '',
        Description: 'Session password changed',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'SessionPasswordChanged',
    },
    {
        Group: '',
        Description: 'Session password due to expire',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'SessionPasswordDueToExpire',
    },
    {
        Group: '',
        Description: 'New session password does not comply with policy',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'NewSessionPasswordDoesNotComplyWithPolicy',
    },
    {
        Group: '',
        Description: 'Session logout complete',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'SessionLogoutComplete',
    },
    {
        Group: '',
        Description: 'Invalid username or password',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'InvalidUsernameOrPassword',
    },
    {
        Group: '',
        Description: 'Account locked',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 7,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'AccountLocked',
    },
    {
        Group: '',
        Description: 'Logons are not allowed at this time',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 8,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'LogonsAreNotAllowedAtThisTime',
    },
    {
        Group: '',
        Description: 'Password expired',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 9,
        addedEP: 56,
        Tag: 1409,
        SymbolicName: 'PasswordExpired',
    },
    {
        Group: '',
        Description: 'Trading resumes (after Halt)',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 58,
        Tag: 1368,
        SymbolicName: 'TradingResumes',
    },
    {
        Group: '',
        Description: 'Change of Trading Session',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 58,
        Tag: 1368,
        SymbolicName: 'ChangeOfTradingSession',
    },
    {
        Group: '',
        Description: 'Change of Trading Subsession',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 58,
        Tag: 1368,
        SymbolicName: 'ChangeOfTradingSubsession',
    },
    {
        Group: '',
        Description: 'Change of Trading Status',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 58,
        Tag: 1368,
        SymbolicName: 'ChangeOfTradingStatus',
    },
    {
        Group: '',
        Description: 'Suspend orders',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 1373,
        SymbolicName: 'SuspendOrders',
    },
    {
        Group: '',
        Description: 'Release orders from suspension',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 58,
        Tag: 1373,
        SymbolicName: 'ReleaseOrdersFromSuspension',
    },
    {
        Group: '',
        Description: 'Cancel orders',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 58,
        Tag: 1373,
        SymbolicName: 'CancelOrders',
    },
    {
        Group: '',
        Description: 'All orders for a security',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForASecurity',
    },
    {
        Group: '',
        Description: 'All orders for an underlying security',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForAnUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'All orders for a Product',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForAProduct',
    },
    {
        Group: '',
        Description: 'All orders for a CFICode',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForACFICode',
    },
    {
        Group: '',
        Description: 'All orders for a SecurityType',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 5,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForASecurityType',
    },
    {
        Group: '',
        Description: 'All orders for a trading session',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 6,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForATradingSession',
    },
    {
        Group: '',
        Description: 'All orders',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrders',
    },
    {
        Group: '',
        Description: 'All orders for a Market',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForAMarket',
    },
    {
        Group: '',
        Description: 'All orders for a Market Segment',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 9,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForAMarketSegment',
    },
    {
        Group: '',
        Description: 'All orders for a Security Group',
        added: 'FIX.5.0',
        Value: '10',
        Sort: 10,
        addedEP: 58,
        Tag: 1374,
        SymbolicName: 'AllOrdersForASecurityGroup',
    },
    {
        Group: '',
        Description: 'Rejected - See MassActionRejectReason(1376)',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 0,
        addedEP: 58,
        Tag: 1375,
        SymbolicName: 'Rejected',
    },
    {
        Group: '',
        Description: 'Accepted',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 1375,
        SymbolicName: 'Accepted',
    },
    {
        Group: '',
        Description: 'Mass Action Not Supported',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 0,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'MassActionNotSupported',
    },
    {
        Group: '',
        Description: 'Invalid or unknown security',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownSecurity',
    },
    {
        Group: '',
        Description: 'Invalid or unknown underlying security',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownUnderlyingSecurity',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Product',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownProduct',
    },
    {
        Group: '',
        Description: 'Invalid or unknown CFICode',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownCFICode',
    },
    {
        Group: '',
        Description: 'Invalid or unknown SecurityType',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 5,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownSecurityType',
    },
    {
        Group: '',
        Description: 'Invalid or unknown trading session',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 6,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownTradingSession',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Market',
        added: 'FIX.5.0',
        Value: '7',
        Sort: 7,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownMarket',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Market Segment',
        added: 'FIX.5.0',
        Value: '8',
        Sort: 8,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownMarketSegment',
    },
    {
        Group: '',
        Description: 'Invalid or unknown Security Group',
        added: 'FIX.5.0',
        Value: '9',
        Sort: 9,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownSecurityGroup',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.5.0',
        Value: '99',
        Sort: 99,
        addedEP: 58,
        Tag: 1376,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Predefined Multileg Security',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 59,
        Tag: 1377,
        SymbolicName: 'PredefinedMultilegSecurity',
    },
    {
        Group: '',
        Description: 'User-defined Multleg Security',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 59,
        Tag: 1377,
        SymbolicName: 'UserDefinedMultilegSecurity',
    },
    {
        Group: '',
        Description: 'User-defined, Non-Securitized, Multileg',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 59,
        Tag: 1377,
        SymbolicName: 'UserDefined',
    },
    {
        Group: '',
        Description: 'Net Price',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'NetPrice',
    },
    {
        Group: '',
        Description: 'Reversed Net Price',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'ReversedNetPrice',
    },
    {
        Group: '',
        Description: 'Yield Difference',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'YieldDifference',
    },
    {
        Group: '',
        Description: 'Individual',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'Individual',
    },
    {
        Group: '',
        Description: 'Contract Weighted Average Price',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'ContractWeightedAveragePrice',
    },
    {
        Group: '',
        Description: 'Multiplied Price',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 6,
        addedEP: 59,
        Tag: 1378,
        SymbolicName: 'MultipliedPrice',
    },
    {
        Group: '',
        Description: 'One Cancels the Other (OCO)',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: 60,
        Tag: 1385,
        SymbolicName: 'OneCancelsTheOther',
    },
    {
        Group: '',
        Description: 'One Triggers the Other (OTO)',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 60,
        Tag: 1385,
        SymbolicName: 'OneTriggersTheOther',
    },
    {
        Group: '',
        Description: 'One Updates the Other (OUO) - Absolute Quantity Reduction',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 3,
        addedEP: 60,
        Tag: 1385,
        SymbolicName: 'OneUpdatesTheOtherAbsolute',
    },
    {
        Group: '',
        Description: 'One Updates the Other (OUO) - Proportional Quantity Reduction',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 4,
        addedEP: 60,
        Tag: 1385,
        SymbolicName: 'OneUpdatesTheOtherProportional',
    },
    {
        Group: '',
        Description: 'Broker / Exchange option',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'BrokerCredit',
    },
    {
        Group: '',
        Description: 'Exchange closed',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'ExchangeClosed',
    },
    {
        Group: '',
        Description: 'Too late to enter',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 3,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'TooLateToEnter',
    },
    {
        Group: '',
        Description: 'Unknown order',
        added: 'FIX.5.0',
        Value: '5',
        Sort: 4,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'UnknownOrder',
    },
    {
        Group: '',
        Description: 'Duplicate Order (e.g. dupe ClOrdID)',
        added: 'FIX.5.0',
        Value: '6',
        Sort: 5,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'DuplicateOrder',
    },
    {
        Group: '',
        Description: 'Unsupported order characteristic',
        added: 'FIX.5.0',
        Value: '11',
        Sort: 6,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'UnsupportedOrderCharacteristic',
    },
    {
        Group: '',
        Description: 'Other',
        added: 'FIX.5.0',
        Value: '99',
        Sort: 7,
        addedEP: 60,
        Tag: 1386,
        SymbolicName: 'Other',
    },
    {
        Group: '',
        Description: 'Do Not Publish Trade',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 61,
        Tag: 1390,
        SymbolicName: 'DoNotPublishTrade',
    },
    {
        Group: '',
        Description: 'Publish Trade',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 61,
        Tag: 1390,
        SymbolicName: 'PublishTrade',
    },
    {
        Group: '',
        Description: 'Deferred Publication',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 61,
        Tag: 1390,
        SymbolicName: 'DeferredPublication',
    },
    {
        Group: '',
        Description: 'Retransmission of application messages for the specified Applications',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 63,
        Tag: 1347,
        SymbolicName: 'Retransmission',
    },
    {
        Group: '',
        Description: 'Subscription to the specified Applications',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 63,
        Tag: 1347,
        SymbolicName: 'Subscription',
    },
    {
        Group: '',
        Description: 'Request for the last ApplLastSeqNum published for the specified Applications',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 63,
        Tag: 1347,
        SymbolicName: 'RequestLastSeqNum',
    },
    {
        Group: '',
        Description: 'Request valid set of Applications',
        added: 'FIX.5.0',
        Value: '3',
        Sort: 4,
        addedEP: 63,
        Tag: 1347,
        SymbolicName: 'RequestApplications',
    },
    {
        Group: '',
        Description: 'Unsubscribe to the specified Applications',
        added: 'FIX.5.0',
        Value: '4',
        Sort: 5,
        addedEP: 63,
        Tag: 1347,
        SymbolicName: 'Unsubscribe',
    },
    {
        Group: '',
        Description: 'Request successfully processed',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 63,
        Tag: 1348,
        SymbolicName: 'RequestSuccessfullyProcessed',
    },
    {
        Group: '',
        Description: 'Application does not exist',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 63,
        Tag: 1348,
        SymbolicName: 'ApplicationDoesNotExist',
    },
    {
        Group: '',
        Description: 'Messages not available',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 63,
        Tag: 1348,
        SymbolicName: 'MessagesNotAvailable',
    },
    {
        Group: '',
        Description: 'Application does not exist',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 1,
        addedEP: 63,
        Tag: 1354,
        SymbolicName: 'ApplicationDoesNotExist',
    },
    {
        Group: '',
        Description: 'Messages requested are not available',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 2,
        addedEP: 63,
        Tag: 1354,
        SymbolicName: 'MessagesRequestedAreNotAvailable',
    },
    {
        Group: '',
        Description: 'User not authorized for application',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 3,
        addedEP: 63,
        Tag: 1354,
        SymbolicName: 'UserNotAuthorizedForApplication',
    },
    {
        Group: '',
        Description: 'Reset ApplSeqNum to new value specified in ApplNewSeqNum(1399)',
        added: 'FIX.5.0',
        Value: '0',
        Sort: 0,
        addedEP: -1,
        Tag: 1426,
        SymbolicName: 'ApplSeqNumReset',
    },
    {
        Group: '',
        Description:
            'Reports that the last message has been sent for the ApplIDs Refer to RefApplLastSeqNum(1357) for the application sequence number of the last message.',
        added: 'FIX.5.0',
        Value: '1',
        Sort: 1,
        addedEP: -1,
        Tag: 1426,
        SymbolicName: 'LastMessageSent',
    },
    {
        Group: '',
        Description:
            'Heartbeat message indicating that Application identified by RefApplID(1355) is still alive. Refer to RefApplLastSeqNum(1357) for the application sequence number of the previous message.',
        added: 'FIX.5.0',
        Value: '2',
        Sort: 2,
        addedEP: -1,
        Tag: 1426,
        SymbolicName: 'ApplicationAlive',
    },
    {
        Description: 'Seconds (default if not specified)',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Seconds',
    },
    {
        Description: 'Tenths of a second',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'TenthsOfASecond',
    },
    {
        Description: 'Hundredths of a second',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'HundredthsOfASecond',
    },
    {
        Description: 'milliseconds',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Milliseconds',
    },
    {
        Description: 'microseconds',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Microseconds',
    },
    {
        Description: 'nanoseconds',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 5,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Nanoseconds',
    },
    {
        Description: 'minutes',
        added: 'FIX.5.0SP1',
        Value: '10',
        Sort: 10,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Minutes',
    },
    {
        Description: 'hours',
        added: 'FIX.5.0SP1',
        Value: '11',
        Sort: 11,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Hours',
    },
    {
        Description: 'days',
        added: 'FIX.5.0SP1',
        Value: '12',
        Sort: 12,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Days',
    },
    {
        Description: 'weeks',
        added: 'FIX.5.0SP1',
        Value: '13',
        Sort: 13,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Weeks',
    },
    {
        Description: 'months',
        added: 'FIX.5.0SP1',
        Value: '14',
        Sort: 14,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Months',
    },
    {
        Description: 'years',
        added: 'FIX.5.0SP1',
        Value: '15',
        Sort: 15,
        addedEP: 77,
        Tag: 1429,
        SymbolicName: 'Years',
    },
    {
        Description: 'Electronic',
        added: 'FIX.5.0SP1',
        Value: 'E',
        Sort: 0,
        addedEP: 77,
        Tag: 1430,
        SymbolicName: 'Electronic',
    },
    {
        Description: 'Pit',
        added: 'FIX.5.0SP1',
        Value: 'P',
        Sort: 1,
        addedEP: 77,
        Tag: 1430,
        SymbolicName: 'Pit',
    },
    {
        Description: 'Ex-Pit',
        added: 'FIX.5.0SP1',
        Value: 'X',
        Sort: 2,
        addedEP: 77,
        Tag: 1430,
        SymbolicName: 'ExPit',
    },
    {
        Description: 'GTC from previous day',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 77,
        Tag: 1431,
        SymbolicName: 'GTCFromPreviousDay',
    },
    {
        Description: 'Partial Fill Remaining',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 77,
        Tag: 1431,
        SymbolicName: 'PartialFillRemaining',
    },
    {
        Description: 'Order Changed',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 77,
        Tag: 1431,
        SymbolicName: 'OrderChanged',
    },
    {
        Description: 'Member trading for their own account',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 77,
        Tag: 1432,
        SymbolicName: 'MemberTradingForTheirOwnAccount',
    },
    {
        Description: 'Clearing Firm trading for its proprietary account',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 77,
        Tag: 1432,
        SymbolicName: 'ClearingFirmTradingForItsProprietaryAccount',
    },
    {
        Description: 'Member trading for another member',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 77,
        Tag: 1432,
        SymbolicName: 'MemberTradingForAnotherMember',
    },
    {
        Description: 'All other',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 77,
        Tag: 1432,
        SymbolicName: 'AllOther',
    },
    {
        Description: 'Submission to Clearing',
        added: 'FIX.5.0SP1',
        Value: '7',
        Sort: 7,
        addedEP: 77,
        Tag: 770,
        SymbolicName: 'SubmissionToClearing',
    },
    {
        Description: 'Original order ID',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 77,
        Tag: 1081,
        SymbolicName: 'OriginalOrderID',
    },
    {
        Description: 'Cross',
        added: 'FIX.5.0SP1',
        Value: 'F',
        Sort: 15,
        addedEP: 78,
        Tag: 529,
        SymbolicName: 'Cross',
    },
    {
        Description: 'Cancel retransmission',
        issue: 'SPEC-674',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 6,
        addedEP: 78,
        Tag: 1347,
        SymbolicName: 'CancelRetransmission',
    },
    {
        Description: 'Cancel retransmission and unsubscribe to the specified applications',
        added: 'FIX.5.0SP1',
        Value: '6',
        Sort: 7,
        addedEP: 78,
        Tag: 1347,
        SymbolicName: 'CancelRetransmissionUnsubscribe',
    },
    {
        Description: 'Cancel by QuoteType(537)',
        added: 'FIX.5.0SP1',
        Value: '6',
        Sort: 6,
        addedEP: 78,
        Tag: 298,
        SymbolicName: 'CancelByQuoteType',
    },
    {
        Description: 'Undisclosed (invisible order)',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 78,
        Tag: 1084,
        SymbolicName: 'Undisclosed',
    },
    {
        Description: 'Delta Positions',
        added: 'FIX.5.0SP1',
        Value: '6',
        Sort: 7,
        addedEP: 79,
        Tag: 724,
        SymbolicName: 'DeltaPositions',
    },
    {
        Description: 'Central Registration Depository (CRD)',
        added: 'FIX.5.0SP1',
        Value: '82',
        Sort: 82,
        addedEP: 79,
        Tag: 452,
        SymbolicName: 'CentralRegistrationDepository',
    },
    {
        Description: 'Utility provided standard model',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 79,
        Tag: 1434,
        SymbolicName: 'UtilityProvidedStandardModel',
    },
    {
        Description: 'Proprietary (user supplied) model',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 79,
        Tag: 1434,
        SymbolicName: 'ProprietaryModel',
    },
    {
        Description: 'Net Delta Qty',
        added: 'FIX.5.0SP1',
        Value: 'DLT',
        Sort: 25,
        addedEP: 79,
        Tag: 703,
        SymbolicName: 'NetDeltaQty',
    },
    {
        Group: '',
        Description: 'Round lot based upon UnitOfMeasure(996)',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 80,
        Tag: 1093,
        SymbolicName: 'RoundLotBasedUpon',
    },
    {
        Group: '',
        Description: 'Shares',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 80,
        Tag: 1435,
        SymbolicName: 'Shares',
    },
    {
        Group: '',
        Description: 'Hours',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 80,
        Tag: 1435,
        SymbolicName: 'Hours',
    },
    {
        Group: '',
        Description: 'Days',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 80,
        Tag: 1435,
        SymbolicName: 'Days',
    },
    {
        Group: '',
        Description: 'NERC Eastern Off-Peak',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 80,
        Tag: 1439,
        SymbolicName: 'NERCEasternOffPeak',
    },
    {
        Group: '',
        Description: 'NERC Western Off-Peak',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 80,
        Tag: 1439,
        SymbolicName: 'NERCWesternOffPeak',
    },
    {
        Group: '',
        Description: 'NERC Calendar-All Days in month',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 80,
        Tag: 1439,
        SymbolicName: 'NERCCalendarAllDaysInMonth',
    },
    {
        Group: '',
        Description: 'NERC Eastern Peak',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 80,
        Tag: 1439,
        SymbolicName: 'NERCEasternPeak',
    },
    {
        Group: '',
        Description: 'NERC Western Peak',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 80,
        Tag: 1439,
        SymbolicName: 'NERCWesternPeak',
    },
    {
        Description: 'Bloomberg',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 82,
        Tag: 1446,
        SymbolicName: 'Bloomberg',
    },
    {
        Description: 'Reuters',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 82,
        Tag: 1446,
        SymbolicName: 'Reuters',
    },
    {
        Description: 'Telerate',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 82,
        Tag: 1446,
        SymbolicName: 'Telerate',
    },
    {
        Description: 'Other',
        added: 'FIX.5.0SP1',
        Value: '99',
        Sort: 99,
        addedEP: 82,
        Tag: 1446,
        SymbolicName: 'Other',
    },
    {
        Description: 'Primary',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 82,
        Tag: 1447,
        SymbolicName: 'Primary',
    },
    {
        Description: 'Secondary',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 82,
        Tag: 1447,
        SymbolicName: 'Secondary',
    },
    {
        Group: 'Currency',
        Description: 'Non-deliverable forward',
        added: 'FIX.5.0SP1',
        Value: 'FXNDF',
        Sort: 1,
        addedEP: 82,
        Tag: 167,
        SymbolicName: 'NonDeliverableForward',
    },
    {
        Group: 'Currency',
        Description: 'FX Spot',
        added: 'FIX.5.0SP1',
        Value: 'FXSPOT',
        Sort: 2,
        addedEP: 82,
        Tag: 167,
        SymbolicName: 'FXSpot',
    },
    {
        Group: 'Currency',
        Description: 'FX Forward',
        added: 'FIX.5.0SP1',
        Value: 'FXFWD',
        Sort: 3,
        addedEP: 82,
        Tag: 167,
        SymbolicName: 'FXForward',
    },
    {
        Group: 'Currency',
        Description: 'FX Swap',
        added: 'FIX.5.0SP1',
        Value: 'FXSWAP',
        Sort: 4,
        addedEP: 82,
        Tag: 167,
        SymbolicName: 'FXSwap',
    },
    {
        Description: 'Full Restructuring',
        added: 'FIX.5.0SP1',
        Value: 'FR',
        Sort: 0,
        addedEP: 83,
        Tag: 1449,
        SymbolicName: 'FullRestructuring',
    },
    {
        Description: 'Modified Restructuring',
        added: 'FIX.5.0SP1',
        Value: 'MR',
        Sort: 1,
        addedEP: 83,
        Tag: 1449,
        SymbolicName: 'ModifiedRestructuring',
    },
    {
        Description: 'Modified Mod Restructuring',
        added: 'FIX.5.0SP1',
        Value: 'MM',
        Sort: 2,
        addedEP: 83,
        Tag: 1449,
        SymbolicName: 'ModifiedModRestructuring',
    },
    {
        Description: 'No Restructuring specified',
        added: 'FIX.5.0SP1',
        Value: 'XR',
        Sort: 3,
        addedEP: 83,
        Tag: 1449,
        SymbolicName: 'NoRestructuringSpecified',
    },
    {
        Description: 'Senior Secured',
        added: 'FIX.5.0SP1',
        Value: 'SD',
        Sort: 0,
        addedEP: 83,
        Tag: 1450,
        SymbolicName: 'SeniorSecured',
    },
    {
        Description: 'Senior',
        added: 'FIX.5.0SP1',
        Value: 'SR',
        Sort: 1,
        addedEP: 83,
        Tag: 1450,
        SymbolicName: 'Senior',
    },
    {
        Description: 'Subordinated',
        added: 'FIX.5.0SP1',
        Value: 'SB',
        Sort: 2,
        addedEP: 83,
        Tag: 1450,
        SymbolicName: 'Subordinated',
    },
    {
        Description: 'Percent of Par',
        added: 'FIX.5.0SP1',
        Value: 'PCTPAR',
        Sort: 4,
        addedEP: 83,
        Tag: 1196,
        SymbolicName: 'PercentOfPar',
    },
    {
        Description: 'CDS style collateralization of market to market and coupon',
        added: 'FIX.5.0SP1',
        Value: 'CDS',
        Sort: 4,
        addedEP: 83,
        Tag: 1197,
        SymbolicName: 'CDSStyleCollateralization',
    },
    {
        Description: 'CDS in delivery - use recovery rate to calculate obligation',
        added: 'FIX.5.0SP1',
        Value: 'CDSD',
        Sort: 5,
        addedEP: 83,
        Tag: 1197,
        SymbolicName: 'CDSInDeliveryUseRecoveryRateToCalculate',
    },
    {
        Description: 'Initial Trade Coupon Amount',
        added: 'FIX.5.0SP1',
        Value: 'ICPN',
        Sort: 9,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'InitialTradeCouponAmount',
    },
    {
        Description: 'Accrued Coupon Amount',
        added: 'FIX.5.0SP1',
        Value: 'ACPN',
        Sort: 10,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'AccruedCouponAmount',
    },
    {
        Description: 'Coupon Amount',
        added: 'FIX.5.0SP1',
        Value: 'CPN',
        Sort: 11,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'CouponAmount',
    },
    {
        Description: 'Incremental Accrued Coupon',
        added: 'FIX.5.0SP1',
        Value: 'IACPN',
        Sort: 12,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'IncrementalAccruedCoupon',
    },
    {
        Description: 'Collateralized Mark to Market',
        added: 'FIX.5.0SP1',
        Value: 'CMTM',
        Sort: 13,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'CollateralizedMarkToMarket',
    },
    {
        Description: 'Incremental Collateralized Mark to market',
        added: 'FIX.5.0SP1',
        Value: 'ICMTM',
        Sort: 14,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'IncrementalCollateralizedMarkToMarket',
    },
    {
        Description: 'Compensation Amount',
        added: 'FIX.5.0SP1',
        Value: 'DLV',
        Sort: 15,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'CompensationAmount',
    },
    {
        Description: 'Total Banked Amount',
        added: 'FIX.5.0SP1',
        Value: 'BANK',
        Sort: 16,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'TotalBankedAmount',
    },
    {
        Description: 'Total Collateralized Amount',
        added: 'FIX.5.0SP1',
        Value: 'COLAT',
        Sort: 17,
        addedEP: 83,
        Tag: 707,
        SymbolicName: 'TotalCollateralizedAmount',
    },
    {
        Description: 'Credit Event Adjustment',
        added: 'FIX.5.0SP1',
        Value: 'CEA',
        Sort: 25,
        addedEP: 83,
        Tag: 703,
        SymbolicName: 'CreditEventAdjustment',
    },
    {
        Description: 'Succession Event Adjustment',
        added: 'FIX.5.0SP1',
        Value: 'SEA',
        Sort: 26,
        addedEP: 83,
        Tag: 703,
        SymbolicName: 'SuccessionEventAdjustment',
    },
    {
        Description: 'Recovery Rate',
        added: 'FIX.5.0SP1',
        Value: 'Y',
        Sort: 34,
        addedEP: 83,
        Tag: 269,
        SymbolicName: 'RecoveryRate',
    },
    {
        Description: 'Recovery Rate for Long',
        added: 'FIX.5.0SP1',
        Value: 'Z',
        Sort: 35,
        addedEP: 83,
        Tag: 269,
        SymbolicName: 'RecoveryRateForLong',
    },
    {
        Description: 'Recovery Rate for Short',
        added: 'FIX.5.0SP1',
        Value: 'a',
        Sort: 36,
        addedEP: 83,
        Tag: 269,
        SymbolicName: 'RecoveryRateForShort',
    },
    {
        Description: 'Full Curve',
        added: 'FIX.5.0SP1',
        Value: '6',
        Sort: 59,
        addedEP: 83,
        Tag: 276,
        SymbolicName: 'FullCurve',
    },
    {
        Description: 'Flat Curve',
        added: 'FIX.5.0SP1',
        Value: '7',
        Sort: 60,
        addedEP: 83,
        Tag: 276,
        SymbolicName: 'FlatCurve',
    },
    {
        Description: 'Fixing Price',
        added: 'FIX.5.0SP1',
        Value: 'W',
        Sort: 32,
        addedEP: 84,
        Tag: 269,
        SymbolicName: 'FixingPrice',
    },
    {
        Description: 'Cash Rate',
        added: 'FIX.5.0SP1',
        Value: 'X',
        Sort: 33,
        addedEP: 84,
        Tag: 269,
        SymbolicName: 'CashRate',
    },
    {
        Description: 'Post-close',
        added: 'FIX.5.0SP1',
        Value: '26',
        Sort: 100,
        addedEP: 84,
        Tag: 326,
        SymbolicName: 'PostClose',
    },
    {
        Description: 'Cancel for Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '7',
        Sort: 7,
        addedEP: 85,
        Tag: 298,
        SymbolicName: 'CancelForSecurityIssuer',
    },
    {
        Description: 'Cancel for Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '8',
        Sort: 8,
        addedEP: 85,
        Tag: 298,
        SymbolicName: 'CancelForIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Invalid or unknown Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '12',
        Sort: 12,
        addedEP: 85,
        Tag: 300,
        SymbolicName: 'InvalidOrUnknownSecurityIssuer',
    },
    {
        Description: 'Invalid or unknown Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '13',
        Sort: 13,
        addedEP: 85,
        Tag: 300,
        SymbolicName: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Cancel for Security Issuer',
        issue: 'SPEC-673',
        added: 'FIX.5.0SP1',
        Value: 'B',
        Sort: 11,
        addedEP: 85,
        Tag: 530,
        SymbolicName: 'CancelOrdersForSecurityIssuer',
    },
    {
        Description: 'Cancel for Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: 'C',
        Sort: 12,
        addedEP: 85,
        Tag: 530,
        SymbolicName: 'CancelForIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Cancel Orders for a Securities Issuer',
        added: 'FIX.5.0SP1',
        Value: 'B',
        Sort: 11,
        addedEP: 85,
        Tag: 531,
        SymbolicName: 'CancelOrdersForASecuritiesIssuer',
    },
    {
        Description: 'Cancel Orders for Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: 'C',
        Sort: 12,
        addedEP: 85,
        Tag: 531,
        SymbolicName: 'CancelOrdersForIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Invalid or unknown Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '10',
        Sort: 11,
        addedEP: 85,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownSecurityIssuer',
    },
    {
        Description: 'Invalid or unknown Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '11',
        Sort: 12,
        addedEP: 85,
        Tag: 532,
        SymbolicName: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Status for Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '9',
        Sort: 9,
        addedEP: 85,
        Tag: 585,
        SymbolicName: 'StatusForSecurityIssuer',
    },
    {
        Description: 'Status for Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '10',
        Sort: 10,
        addedEP: 85,
        Tag: 585,
        SymbolicName: 'StatusForIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Cancel for Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '11',
        Sort: 11,
        addedEP: 85,
        Tag: 1374,
        SymbolicName: 'CancelForSecurityIssuer',
    },
    {
        Description: 'Cancel for Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '12',
        Sort: 12,
        addedEP: 85,
        Tag: 1374,
        SymbolicName: 'CancelForIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'Invalid or unknown Security Issuer',
        added: 'FIX.5.0SP1',
        Value: '10',
        Sort: 10,
        addedEP: 85,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownSecurityIssuer',
    },
    {
        Description: 'Invalid or unknown Issuer of Underlying Security',
        added: 'FIX.5.0SP1',
        Value: '11',
        Sort: 11,
        addedEP: 85,
        Tag: 1376,
        SymbolicName: 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    },
    {
        Description: 'News Dissemination',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'NewsDissemination',
    },
    {
        Description: 'Order Influx',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'OrderInflux',
    },
    {
        Description: 'Order Imbalance',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'OrderImbalance',
    },
    {
        Description: 'Additional Information',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'AdditionalInformation',
    },
    {
        Description: 'News Pending',
        added: 'FIX.5.0SP1',
        updatedEP: 95,
        Value: '4',
        Sort: 4,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'NewsPending',
        updated: 'FIX.5.0SP1',
    },
    {
        Description: 'Equipment Changeover',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 5,
        addedEP: 86,
        Tag: 327,
        SymbolicName: 'EquipmentChangeover',
    },
    {
        Description: 'Industry Classification',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 87,
        Tag: 1470,
        SymbolicName: 'IndustryClassification',
    },
    {
        Description: 'Trading List',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 87,
        Tag: 1470,
        SymbolicName: 'TradingList',
    },
    {
        Description: 'Market / Market Segment List',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 87,
        Tag: 1470,
        SymbolicName: 'Market',
    },
    {
        Description: 'Newspaper List',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 87,
        Tag: 1470,
        SymbolicName: 'NewspaperList',
    },
    {
        Description: 'ICB (Industry Classification Benchmark) published by Dow Jones and FTSE - www.icbenchmark.com',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 87,
        Tag: 1471,
        SymbolicName: 'ICB',
    },
    {
        Description:
            'NAICS (North American Industry Classification System). Replaced SIC (Standard Industry Classification) www.census.gov/naics or  www.naics.com.',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 87,
        Tag: 1471,
        SymbolicName: 'NAICS',
    },
    {
        Description: 'GICS (Global Industry Classification Standard) published by Standards & Poor',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 87,
        Tag: 1471,
        SymbolicName: 'GICS',
    },
    {
        Group: 'Variable Quantity UOM',
        Description: 'Allowances',
        added: 'FIX.5.0SP1',
        Value: 'Alw',
        Sort: 13,
        addedEP: 89,
        Tag: 996,
        SymbolicName: 'Allowances',
    },
    {
        Description: 'Company News',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 90,
        Tag: 1473,
        SymbolicName: 'CompanyNews',
    },
    {
        Description: 'Marketplace News',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 90,
        Tag: 1473,
        SymbolicName: 'MarketplaceNews',
    },
    {
        Description: 'Financial Market News',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 90,
        Tag: 1473,
        SymbolicName: 'FinancialMarketNews',
    },
    {
        Description: 'Technical News',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 90,
        Tag: 1473,
        SymbolicName: 'TechnicalNews',
    },
    {
        Description: 'Other News',
        added: 'FIX.5.0SP1',
        Value: '99',
        Sort: 99,
        addedEP: 90,
        Tag: 1473,
        SymbolicName: 'OtherNews',
    },
    {
        Description: 'Replacement',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 90,
        Tag: 1477,
        SymbolicName: 'Replacement',
    },
    {
        Description: 'Other Language',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 90,
        Tag: 1477,
        SymbolicName: 'OtherLanguage',
    },
    {
        Description: 'Complimentary',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 90,
        Tag: 1477,
        SymbolicName: 'Complimentary',
    },
    {
        Description: 'Application message re-send completed.',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 91,
        Tag: 1426,
        SymbolicName: 'ResendComplete',
    },
    {
        Description: 'Fixed Strike',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1478,
        SymbolicName: 'FixedStrike',
    },
    {
        Description: 'Strike set at expiration to underlying or other value (lookback floating)',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1478,
        SymbolicName: 'StrikeSetAtExpiration',
    },
    {
        Description: 'Strike set to average of underlying settlement price across the life of the option',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1478,
        SymbolicName: 'StrikeSetToAverageAcrossLife',
    },
    {
        Description: 'Strike set to optimal value',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 92,
        Tag: 1478,
        SymbolicName: 'StrikeSetToOptimalValue',
    },
    {
        Description: 'Less than underlying price is in-the-money (ITM)',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1479,
        SymbolicName: 'LessThan',
    },
    {
        Description: 'Less than or equal to the underlying price is in-the-money(ITM)',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1479,
        SymbolicName: 'LessThanOrEqual',
    },
    {
        Description: 'Equal to the underlying price is in-the-money(ITM)',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1479,
        SymbolicName: 'Equal',
    },
    {
        Description: 'Greater than or equal to underlying price is in-the-money(ITM)',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 92,
        Tag: 1479,
        SymbolicName: 'GreaterThanOrEqual',
    },
    {
        Description: 'Greater than underlying is in-the-money(ITM)',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 5,
        addedEP: 92,
        Tag: 1479,
        SymbolicName: 'GreaterThan',
    },
    {
        Description: 'Regular',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1481,
        SymbolicName: 'Regular',
    },
    {
        Description: 'Special reference',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1481,
        SymbolicName: 'SpecialReference',
    },
    {
        Description: 'Optimal value (Lookback)',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1481,
        SymbolicName: 'OptimalValue',
    },
    {
        Description: 'Average value (Asian option)',
        issue: 'SPEC-672',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 92,
        Tag: 1481,
        SymbolicName: 'AverageValue',
    },
    {
        Description: 'Vanilla',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1482,
        SymbolicName: 'Vanilla',
    },
    {
        Description: 'Capped',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1482,
        SymbolicName: 'Capped',
    },
    {
        Description: 'Binary',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1482,
        SymbolicName: 'Binary',
    },
    {
        Description: 'Capped',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'Capped',
    },
    {
        Description: 'Trigger',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'Trigger',
    },
    {
        Description: 'Knock-in up',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'KnockInUp',
    },
    {
        Description: 'Kock-in down',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'KockInDown',
    },
    {
        Description: 'Knock-out up',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 5,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'KnockOutUp',
    },
    {
        Description: 'Knock-out down',
        added: 'FIX.5.0SP1',
        Value: '6',
        Sort: 6,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'KnockOutDown',
    },
    {
        Description: 'Underlying',
        added: 'FIX.5.0SP1',
        Value: '7',
        Sort: 7,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'Underlying',
    },
    {
        Description: 'Reset Barrier',
        added: 'FIX.5.0SP1',
        Value: '8',
        Sort: 8,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'ResetBarrier',
    },
    {
        Description: 'Rolling Barrier',
        added: 'FIX.5.0SP1',
        Value: '9',
        Sort: 9,
        addedEP: 92,
        Tag: 1484,
        SymbolicName: 'RollingBarrier',
    },
    {
        Description: 'Less than ComplexEventPrice(1486)',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1487,
        SymbolicName: 'LessThanComplexEventPrice',
    },
    {
        Description: 'Less than or equal to ComplexEventPrice(1486)',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1487,
        SymbolicName: 'LessThanOrEqualToComplexEventPrice',
    },
    {
        Description: 'Equal to ComplexEventPrice(1486)',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1487,
        SymbolicName: 'EqualToComplexEventPrice',
    },
    {
        Description: 'Greater than or equal to ComplexEventPrice(1486)',
        added: 'FIX.5.0SP1',
        Value: '4',
        Sort: 4,
        addedEP: 92,
        Tag: 1487,
        SymbolicName: 'GreaterThanOrEqualToComplexEventPrice',
    },
    {
        Description: 'Greater than ComplexEventPrice(1486)',
        added: 'FIX.5.0SP1',
        Value: '5',
        Sort: 5,
        addedEP: 92,
        Tag: 1487,
        SymbolicName: 'GreaterThanComplexEventPrice',
    },
    {
        Description: 'Expiration',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1489,
        SymbolicName: 'Expiration',
    },
    {
        Description: 'Immediate (At Any Time)',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1489,
        SymbolicName: 'Immediate',
    },
    {
        Description: 'Specified Date/Time',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 92,
        Tag: 1489,
        SymbolicName: 'SpecifiedDate',
    },
    {
        Description: 'And',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 92,
        Tag: 1490,
        SymbolicName: 'And',
    },
    {
        Description: 'Or',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 92,
        Tag: 1490,
        SymbolicName: 'Or',
    },
    {
        Description: 'Stream assignment for new customer(s)',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 93,
        Tag: 1498,
        SymbolicName: 'StreamAssignmentForNewCustomer',
    },
    {
        Description: 'Stream assignment for existing customer(s)',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 93,
        Tag: 1498,
        SymbolicName: 'StreamAssignmentForExistingCustomer',
    },
    {
        Description: 'Unknown client',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 93,
        Tag: 1502,
        SymbolicName: 'UnknownClient',
    },
    {
        Description: 'Exceeds maximum size',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 93,
        Tag: 1502,
        SymbolicName: 'ExceedsMaximumSize',
    },
    {
        Description: 'Unknown or Invalid currency pair',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 93,
        Tag: 1502,
        SymbolicName: 'UnknownOrInvalidCurrencyPair',
    },
    {
        Description: 'No available stream',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 93,
        Tag: 1502,
        SymbolicName: 'NoAvailableStream',
    },
    {
        Description: 'Other',
        added: 'FIX.5.0SP1',
        Value: '99',
        Sort: 99,
        addedEP: 93,
        Tag: 1502,
        SymbolicName: 'Other',
    },
    {
        Description: 'Assignment Accepted',
        added: 'FIX.5.0SP1',
        Value: '0',
        Sort: 0,
        addedEP: 93,
        Tag: 1503,
        SymbolicName: 'AssignmentAccepted',
    },
    {
        Description: 'Assignment Rejected',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 93,
        Tag: 1503,
        SymbolicName: 'AssignmentRejected',
    },
    {
        Description: 'Assignment',
        added: 'FIX.5.0SP1',
        Value: '1',
        Sort: 1,
        addedEP: 93,
        Tag: 1617,
        SymbolicName: 'Assignment',
    },
    {
        Description: 'Rejected',
        added: 'FIX.5.0SP1',
        Value: '2',
        Sort: 2,
        addedEP: 93,
        Tag: 1617,
        SymbolicName: 'Rejected',
    },
    {
        Description: 'Terminate/Unassign',
        added: 'FIX.5.0SP1',
        Value: '3',
        Sort: 3,
        addedEP: 93,
        Tag: 1617,
        SymbolicName: 'Terminate',
    },
    {
        Description: 'Agent',
        added: 'FIX.5.0SP1',
        Value: 'A',
        Sort: 0,
        addedEP: 95,
        Tag: 1048,
        SymbolicName: 'Agent',
    },
    {
        Description: 'Principal',
        added: 'FIX.5.0SP1',
        Value: 'P',
        Sort: 1,
        addedEP: 95,
        Tag: 1048,
        SymbolicName: 'Principal',
    },
    {
        Description: 'Riskless Principal',
        added: 'FIX.5.0SP1',
        Value: 'R',
        Sort: 2,
        addedEP: 95,
        Tag: 1048,
        SymbolicName: 'RisklessPrincipal',
    },
    {
        Description: 'Pro rata',
        issue: 'SPEC-384',
        added: 'FIX.4.4',
        Value: 'P',
        Sort: 1,
        addedEP: 4,
        Tag: 1049,
        SymbolicName: 'ProRata',
    },
    {
        Description: 'Random',
        issue: 'SPEC-384',
        added: 'FIX.4.4',
        Value: 'R',
        Sort: 2,
        addedEP: 4,
        Tag: 1049,
        SymbolicName: 'Random',
    },
    {
        Description: 'Other',
        added: 'FIX.5.0SP1',
        Value: '99',
        Sort: 99,
        addedEP: 95,
        Tag: 88,
        SymbolicName: 'Other',
    },
    {
        Description: 'Country',
        added: 'FIX.5.0SP1',
        Value: '25',
        Sort: 25,
        addedEP: 95,
        Tag: 959,
        SymbolicName: 'Country',
    },
    {
        Description: 'Language',
        added: 'FIX.5.0SP1',
        Value: '26',
        Sort: 26,
        addedEP: 95,
        Tag: 959,
        SymbolicName: 'Language',
    },
    {
        Description: 'TZTimeOnly',
        added: 'FIX.5.0SP1',
        Value: '27',
        Sort: 27,
        addedEP: 95,
        Tag: 959,
        SymbolicName: 'TZTimeOnly',
    },
    {
        Description: 'TZTimestamp',
        added: 'FIX.5.0SP1',
        Value: '28',
        Sort: 28,
        addedEP: 95,
        Tag: 959,
        SymbolicName: 'TZTimestamp',
    },
    {
        Description: 'Tenor',
        added: 'FIX.5.0SP1',
        Value: '29',
        Sort: 29,
        addedEP: 95,
        Tag: 959,
        SymbolicName: 'Tenor',
    },
    {
        Description: 'Clearing Account',
        added: 'FIX.5.0SP1',
        Value: '83',
        Sort: 83,
        addedEP: 96,
        Tag: 452,
        SymbolicName: 'ClearingAccount',
    },
    {
        Description: 'Acceptable Settling Counterparty',
        added: 'FIX.5.0SP1',
        Value: '84',
        Sort: 84,
        addedEP: 96,
        Tag: 452,
        SymbolicName: 'AcceptableSettlingCounterparty',
    },
    {
        Description: 'Unacceptable Settling Counterparty',
        added: 'FIX.5.0SP1',
        Value: '85',
        Sort: 85,
        addedEP: 96,
        Tag: 452,
        SymbolicName: 'UnacceptableSettlingCounterparty',
    },
    {
        Description: 'FIX50SP2',
        added: 'FIX.5.0SP1',
        Value: '9',
        Sort: 9,
        addedEP: 97,
        Tag: 1128,
        SymbolicName: 'FIX50SP2',
    },
    {
        Elaboration:
            'The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received.',
        Group: '',
        Description: 'Heartbeat',
        Value: '0',
        Sort: 0,
        Tag: 35,
        SymbolicName: 'Heartbeat',
    },
    {
        Elaboration:
            'The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID.',
        Group: '',
        Description: 'TestRequest',
        Value: '1',
        Sort: 1,
        Tag: 35,
        SymbolicName: 'TestRequest',
    },
    {
        Elaboration:
            'The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process.',
        Group: '',
        Description: 'ResendRequest',
        Value: '2',
        Sort: 2,
        Tag: 35,
        SymbolicName: 'ResendRequest',
    },
    {
        Elaboration:
            'The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks.',
        Group: '',
        Description: 'Reject',
        Value: '3',
        Sort: 3,
        Tag: 35,
        SymbolicName: 'Reject',
    },
    {
        Elaboration:
            'The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side.',
        Group: '',
        Description: 'SequenceReset',
        Value: '4',
        Sort: 4,
        Tag: 35,
        SymbolicName: 'SequenceReset',
    },
    {
        Elaboration:
            'The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition.',
        Group: '',
        Description: 'Logout',
        Value: '5',
        Sort: 5,
        Tag: 35,
        SymbolicName: 'Logout',
    },
    {
        Elaboration:
            'Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID.',
        Group: '',
        Description: 'IOI',
        Value: '6',
        Sort: 6,
        Tag: 35,
        SymbolicName: 'IOI',
    },
    {
        Elaboration:
            'Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID.',
        Group: '',
        Description: 'Advertisement',
        Value: '7',
        Sort: 7,
        Tag: 35,
        SymbolicName: 'Advertisement',
    },
    {
        Elaboration:
            'The execution report message is used to:\n1. confirm the receipt of an order\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n3. relay order status information\n4. relay fill information on working orders\n5. relay fill information on tradeable or restricted tradeable quotes\n6. reject orders\n7. report post-trade fees calculations associated with a trade',
        Group: '',
        Description: 'ExecutionReport',
        Value: '8',
        Sort: 8,
        Tag: 35,
        SymbolicName: 'ExecutionReport',
    },
    {
        Elaboration:
            'The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored.',
        Group: '',
        Description: 'OrderCancelReject',
        Value: '9',
        Sort: 9,
        Tag: 35,
        SymbolicName: 'OrderCancelReject',
    },
    {
        Elaboration:
            'The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session.',
        Group: '',
        Description: 'Logon',
        Value: 'A',
        Sort: 10,
        Tag: 35,
        SymbolicName: 'Logon',
    },
    {
        Elaboration:
            'The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request.',
        Group: '',
        Description: 'DerivativeSecurityList',
        Value: 'AA',
        Sort: 11,
        Tag: 35,
        SymbolicName: 'DerivativeSecurityList',
    },
    {
        Elaboration:
            'The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs.',
        Group: '',
        Description: 'NewOrderMultileg',
        Value: 'AB',
        Sort: 12,
        Tag: 35,
        SymbolicName: 'NewOrderMultileg',
    },
    {
        Elaboration:
            'Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage.',
        Group: '',
        Description: 'MultilegOrderCancelReplace',
        Value: 'AC',
        Sort: 13,
        Tag: 35,
        SymbolicName: 'MultilegOrderCancelReplace',
    },
    {
        Elaboration:
            'The Trade Capture Report Request can be used to:\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request.',
        Group: '',
        Description: 'TradeCaptureReportRequest',
        Value: 'AD',
        Sort: 14,
        Tag: 35,
        SymbolicName: 'TradeCaptureReportRequest',
    },
    {
        Elaboration:
            'The Trade Capture Report message can be:\n• Used to report trades between counterparties.\n• Used to report trades to a trade matching system\n• Can be sent unsolicited between counterparties.\n• Sent as a reply to a Trade Capture Report Request.\n• Can be used to report unmatched and matched trades.',
        Group: '',
        Description: 'TradeCaptureReport',
        Value: 'AE',
        Sort: 15,
        Tag: 35,
        SymbolicName: 'TradeCaptureReport',
    },
    {
        Elaboration:
            'The order mass status request message requests the status for orders matching criteria specified within the request.',
        Group: '',
        Description: 'OrderMassStatusRequest',
        Value: 'AF',
        Sort: 16,
        Tag: 35,
        SymbolicName: 'OrderMassStatusRequest',
    },
    {
        Elaboration:
            'The Quote Request Reject message is used to reject Quote Request messages for all quoting models.',
        Group: '',
        Description: 'QuoteRequestReject',
        Value: 'AG',
        Sort: 17,
        Tag: 35,
        SymbolicName: 'QuoteRequestReject',
    },
    {
        Elaboration:
            'In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments',
        Group: '',
        Description: 'RFQRequest',
        Value: 'AH',
        Sort: 18,
        Tag: 35,
        SymbolicName: 'RFQRequest',
    },
    {
        Elaboration:
            'The quote status report message is used:\n• as the response to a Quote Status Request message\n• as a response to a Quote Cancel message\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)',
        Group: '',
        Description: 'QuoteStatusReport',
        Value: 'AI',
        Sort: 19,
        Tag: 35,
        SymbolicName: 'QuoteStatusReport',
    },
    {
        Elaboration:
            'The Quote Response message is used to respond to a IOI message or Quote message. It is also used to counter a Quote or end a negotiation dialog.',
        Group: '',
        Description: 'QuoteResponse',
        Value: 'AJ',
        Sort: 20,
        Tag: 35,
        SymbolicName: 'QuoteResponse',
    },
    {
        Elaboration:
            'The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations.',
        Group: '',
        Description: 'Confirmation',
        Value: 'AK',
        Sort: 21,
        Tag: 35,
        SymbolicName: 'Confirmation',
    },
    {
        Elaboration:
            'The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services.',
        Group: '',
        Description: 'PositionMaintenanceRequest',
        Value: 'AL',
        Sort: 22,
        Tag: 35,
        SymbolicName: 'PositionMaintenanceRequest',
    },
    {
        Elaboration:
            'The Position Maintenance Report message is sent by the holder of a positon in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected.',
        Group: '',
        Description: 'PositionMaintenanceReport',
        Value: 'AM',
        Sort: 23,
        Tag: 35,
        SymbolicName: 'PositionMaintenanceReport',
    },
    {
        Elaboration:
            'The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity.',
        Group: '',
        Description: 'RequestForPositions',
        Value: 'AN',
        Sort: 24,
        Tag: 35,
        SymbolicName: 'RequestForPositions',
    },
    {
        Elaboration:
            'The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed.',
        Group: '',
        Description: 'RequestForPositionsAck',
        Value: 'AO',
        Sort: 25,
        Tag: 35,
        SymbolicName: 'RequestForPositionsAck',
    },
    {
        Elaboration:
            'The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner.',
        Group: '',
        Description: 'PositionReport',
        Value: 'AP',
        Sort: 26,
        Tag: 35,
        SymbolicName: 'PositionReport',
    },
    {
        Elaboration:
            'The Trade Capture Request Ack message is used to:\n• Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n• Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n• Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request\n• The Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc.',
        Group: '',
        Description: 'TradeCaptureReportRequestAck',
        Value: 'AQ',
        Sort: 27,
        Tag: 35,
        SymbolicName: 'TradeCaptureReportRequestAck',
    },
    {
        Elaboration:
            'The Trade Capture Report Ack message can be:\n• Used to acknowledge trade capture reports received from a counterparty\n• Used to reject a trade capture report received from a counterparty',
        Group: '',
        Description: 'TradeCaptureReportAck',
        Value: 'AR',
        Sort: 28,
        Tag: 35,
        SymbolicName: 'TradeCaptureReportAck',
    },
    {
        Elaboration:
            'Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the Allocation Report (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase. In versions of FIX prior to version 4.4, this functionality was provided through the Allocation message. Depending on the needs of the market and the timing of "confirmed" status, the role of Allocation Report can be taken over in whole or in part by the Confirmation message.',
        Group: '',
        Description: 'AllocationReport',
        Value: 'AS',
        Sort: 29,
        Tag: 35,
        SymbolicName: 'AllocationReport',
    },
    {
        Elaboration:
            'The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message.',
        Group: '',
        Description: 'AllocationReportAck',
        Value: 'AT',
        Sort: 30,
        Tag: 35,
        SymbolicName: 'AllocationReportAck',
    },
    {
        Elaboration: 'The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message.',
        Group: '',
        Description: 'ConfirmationAck',
        Value: 'AU',
        Sort: 31,
        Tag: 35,
        SymbolicName: 'ConfirmationAck',
    },
    {
        Elaboration:
            'The Settlement Instruction Request message is used to request standing settlement instructions from another party.',
        Group: '',
        Description: 'SettlementInstructionRequest',
        Value: 'AV',
        Sort: 32,
        Tag: 35,
        SymbolicName: 'SettlementInstructionRequest',
    },
    {
        Elaboration:
            'Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process.',
        Group: '',
        Description: 'AssignmentReport',
        Value: 'AW',
        Sort: 33,
        Tag: 35,
        SymbolicName: 'AssignmentReport',
    },
    {
        Elaboration:
            'An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral.',
        Group: '',
        Description: 'CollateralRequest',
        Value: 'AX',
        Sort: 34,
        Tag: 35,
        SymbolicName: 'CollateralRequest',
    },
    {
        Elaboration:
            'Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message.',
        Group: '',
        Description: 'CollateralAssignment',
        Value: 'AY',
        Sort: 35,
        Tag: 35,
        SymbolicName: 'CollateralAssignment',
    },
    {
        Elaboration: 'Used to respond to a Collateral Assignment message.',
        Group: '',
        Description: 'CollateralResponse',
        Value: 'AZ',
        Sort: 36,
        Tag: 35,
        SymbolicName: 'CollateralResponse',
    },
    {
        Elaboration:
            "The news message is a general free format message between the broker and institution. The message contains flags to identify the news item's urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues.",
        Group: '',
        Description: 'News',
        Value: 'B',
        Sort: 37,
        Tag: 35,
        SymbolicName: 'News',
    },
    {
        Elaboration: 'Used to report collateral status when responding to a Collateral Inquiry message.',
        Group: '',
        Description: 'CollateralReport',
        Value: 'BA',
        Sort: 38,
        Tag: 35,
        SymbolicName: 'CollateralReport',
    },
    {
        Elaboration: 'Used to inquire for collateral status.',
        Group: '',
        Description: 'CollateralInquiry',
        Value: 'BB',
        Sort: 39,
        Tag: 35,
        SymbolicName: 'CollateralInquiry',
    },
    {
        Elaboration:
            'This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing.',
        Group: '',
        Description: 'NetworkCounterpartySystemStatusRequest',
        Value: 'BC',
        Sort: 40,
        Tag: 35,
        SymbolicName: 'NetworkCounterpartySystemStatusRequest',
    },
    {
        Elaboration: 'This message is sent in response to a Network (Counterparty System) Status Request Message.',
        Group: '',
        Description: 'NetworkCounterpartySystemStatusResponse',
        Value: 'BD',
        Sort: 41,
        Tag: 35,
        SymbolicName: 'NetworkCounterpartySystemStatusResponse',
    },
    {
        Elaboration:
            "This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user's status.",
        Group: '',
        Description: 'UserRequest',
        Value: 'BE',
        Sort: 42,
        Tag: 35,
        SymbolicName: 'UserRequest',
    },
    {
        Elaboration:
            'This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message.',
        Group: '',
        Description: 'UserResponse',
        Value: 'BF',
        Sort: 43,
        Tag: 35,
        SymbolicName: 'UserResponse',
    },
    {
        Elaboration:
            'Used to respond to a Collateral Inquiry in the following situations:\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty.',
        Group: '',
        Description: 'CollateralInquiryAck',
        Value: 'BG',
        Sort: 44,
        Tag: 35,
        SymbolicName: 'CollateralInquiryAck',
    },
    {
        Elaboration: 'The Confirmation Request message is used to request a Confirmation message.',
        Group: '',
        Description: 'ConfirmationRequest',
        Value: 'BH',
        Sort: 45,
        Tag: 35,
        SymbolicName: 'ConfirmationRequest',
    },
    {
        Elaboration:
            'The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions.',
        Group: '',
        Description: 'TradingSessionListRequest',
        Value: 'BI',
        Sort: 46,
        Tag: 35,
        SymbolicName: 'TradingSessionListRequest',
    },
    {
        Elaboration:
            'The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session.',
        Group: '',
        Description: 'TradingSessionList',
        Value: 'BJ',
        Sort: 47,
        Tag: 35,
        SymbolicName: 'TradingSessionList',
    },
    {
        Elaboration:
            'The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions.',
        Group: '',
        Description: 'SecurityListUpdateReport',
        Value: 'BK',
        Sort: 48,
        Tag: 35,
        SymbolicName: 'SecurityListUpdateReport',
    },
    {
        Elaboration:
            'Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions',
        Group: '',
        Description: 'AdjustedPositionReport',
        Value: 'BL',
        Sort: 49,
        Tag: 35,
        SymbolicName: 'AdjustedPositionReport',
    },
    {
        Elaboration:
            'This message is used in a 3-party allocation model where notification of group creation and group updates to counterparties is needed. The mssage will also carry trade information that comprised the group to the counterparties.',
        Group: '',
        Description: 'AllocationInstructionAlert',
        Value: 'BM',
        Sort: 50,
        Tag: 35,
        SymbolicName: 'AllocationInstructionAlert',
    },
    {
        Elaboration:
            "The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK'd).",
        Group: '',
        Description: 'ExecutionAcknowledgement',
        Value: 'BN',
        Sort: 51,
        Tag: 35,
        SymbolicName: 'ExecutionAcknowledgement',
    },
    {
        Elaboration:
            'The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes.',
        Group: '',
        Description: 'ContraryIntentionReport',
        Value: 'BO',
        Sort: 52,
        Tag: 35,
        SymbolicName: 'ContraryIntentionReport',
    },
    {
        Elaboration:
            'This message is used for reporting updates to a Product Security Masterfile. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions.',
        Group: '',
        Description: 'SecurityDefinitionUpdateReport',
        Value: 'BP',
        Sort: 53,
        Tag: 35,
        SymbolicName: 'SecurityDefinitionUpdateReport',
    },
    {
        Elaboration:
            'The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation.',
        Group: '',
        Description: 'SettlementObligationReport',
        Value: 'BQ',
        Sort: 54,
        Tag: 35,
        SymbolicName: 'SettlementObligationReport',
    },
    {
        Elaboration:
            'The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family.',
        Group: '',
        Description: 'DerivativeSecurityListUpdateReport',
        Value: 'BR',
        Sort: 55,
        Tag: 35,
        SymbolicName: 'DerivativeSecurityListUpdateReport',
    },
    {
        Elaboration:
            'The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions.',
        Group: '',
        Description: 'TradingSessionListUpdateReport',
        Value: 'BS',
        Sort: 56,
        Tag: 35,
        SymbolicName: 'TradingSessionListUpdateReport',
    },
    {
        Elaboration:
            'The Market Definition Request message is used to request for market structure information from the Respondent that receives this request.',
        Group: '',
        Description: 'MarketDefinitionRequest',
        Value: 'BT',
        Sort: 57,
        Tag: 35,
        SymbolicName: 'MarketDefinitionRequest',
    },
    {
        Elaboration:
            'The Market Definition message is used to respond to Market Definition Request. In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the Market Definition Update Report.',
        Group: '',
        Description: 'MarketDefinition',
        Value: 'BU',
        Sort: 58,
        Tag: 35,
        SymbolicName: 'MarketDefinition',
    },
    {
        Elaboration:
            'In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the Market Definition message.',
        Group: '',
        Description: 'MarketDefinitionUpdateReport',
        Value: 'BV',
        Sort: 59,
        Tag: 35,
        SymbolicName: 'MarketDefinitionUpdateReport',
    },
    {
        Elaboration:
            'This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355).',
        Group: '',
        Description: 'ApplicationMessageRequest',
        Value: 'BW',
        Sort: 60,
        Tag: 35,
        SymbolicName: 'ApplicationMessageRequest',
    },
    {
        Elaboration:
            'This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent.',
        Group: '',
        Description: 'ApplicationMessageRequestAck',
        Value: 'BX',
        Sort: 61,
        Tag: 35,
        SymbolicName: 'ApplicationMessageRequestAck',
    },
    {
        Elaboration:
            'This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic.',
        Group: '',
        Description: 'ApplicationMessageReport',
        Value: 'BY',
        Sort: 62,
        Tag: 35,
        SymbolicName: 'ApplicationMessageReport',
    },
    {
        Elaboration:
            'The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order.',
        Group: '',
        Description: 'OrderMassActionReport',
        Value: 'BZ',
        Sort: 63,
        Tag: 35,
        SymbolicName: 'OrderMassActionReport',
    },
    {
        Elaboration:
            'The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties.',
        Group: '',
        Description: 'Email',
        Value: 'C',
        Sort: 64,
        Tag: 35,
        SymbolicName: 'Email',
    },
    {
        Elaboration:
            'The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding "S" to the ExecInst values. It can also be used for mass order cancellation.',
        Group: '',
        Description: 'OrderMassActionRequest',
        Value: 'CA',
        Sort: 65,
        Tag: 35,
        SymbolicName: 'OrderMassActionRequest',
    },
    {
        Elaboration:
            'The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant.',
        Group: '',
        Description: 'UserNotification',
        Value: 'CB',
        Sort: 66,
        Tag: 35,
        SymbolicName: 'UserNotification',
    },
    {
        Elaboration:
            'In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs.',
        Group: '',
        Description: 'StreamAssignmentRequest',
        Value: 'CC',
        Sort: 67,
        Tag: 35,
        SymbolicName: 'StreamAssignmentRequest',
    },
    {
        Elaboration:
            'he StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker.',
        Group: '',
        Description: 'StreamAssignmentReport',
        Value: 'CD',
        Sort: 68,
        Tag: 35,
        SymbolicName: 'StreamAssignmentReport',
    },
    {
        Elaboration:
            'This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment.',
        Group: '',
        Description: 'StreamAssignmentReportACK',
        Value: 'CE',
        Sort: 69,
        Tag: 35,
        SymbolicName: 'StreamAssignmentReportACK',
    },
    {
        Elaboration:
            'The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution.',
        Group: '',
        Description: 'NewOrderSingle',
        Value: 'D',
        Sort: 70,
        Tag: 35,
        SymbolicName: 'NewOrderSingle',
    },
    {
        Elaboration:
            'The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed.',
        Group: '',
        Description: 'NewOrderList',
        Value: 'E',
        Sort: 71,
        Tag: 35,
        SymbolicName: 'NewOrderList',
    },
    {
        Elaboration:
            'The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order).',
        Group: '',
        Description: 'OrderCancelRequest',
        Value: 'F',
        Sort: 72,
        Tag: 35,
        SymbolicName: 'OrderCancelRequest',
    },
    {
        Elaboration:
            'The order cancel/replace request is used to change the parameters of an existing order.\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose.',
        Group: '',
        Description: 'OrderCancelReplaceRequest',
        Value: 'G',
        Sort: 73,
        Tag: 35,
        SymbolicName: 'OrderCancelReplaceRequest',
    },
    {
        Elaboration:
            'The order status request message is used by the institution to generate an order status message back from the broker.',
        Group: '',
        Description: 'OrderStatusRequest',
        Value: 'H',
        Sort: 74,
        Tag: 35,
        SymbolicName: 'OrderStatusRequest',
    },
    {
        Elaboration:
            'The Allocation Instruction message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts. In versions of FIX prior to version 4.4, this same message was known as the Allocation message. Note in versions of FIX prior to version 4.4, the allocation message was also used to communicate fee and expense details from the Sellside to the Buyside. This role has now been removed from the Allocation Instruction and is now performed by the new (to version 4.4) Allocation Report and Confirmation messages.,The Allocation Report message should be used for the Sell-side Initiated Allocation role as defined in previous versions of the protocol.',
        Group: '',
        Description: 'AllocationInstruction',
        Value: 'J',
        Sort: 75,
        Tag: 35,
        SymbolicName: 'AllocationInstruction',
    },
    {
        Elaboration:
            'The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution.',
        Group: '',
        Description: 'ListCancelRequest',
        Value: 'K',
        Sort: 76,
        Tag: 35,
        SymbolicName: 'ListCancelRequest',
    },
    {
        Elaboration:
            'The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation.',
        Group: '',
        Description: 'ListExecute',
        Value: 'L',
        Sort: 77,
        Tag: 35,
        SymbolicName: 'ListExecute',
    },
    {
        Elaboration:
            'The list status request message type is used by institutions to instruct the broker to generate status messages for a list.',
        Group: '',
        Description: 'ListStatusRequest',
        Value: 'M',
        Sort: 78,
        Tag: 35,
        SymbolicName: 'ListStatusRequest',
    },
    {
        Elaboration:
            "The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker's site. This message may also be used to respond to the List Cancel Request.",
        Group: '',
        Description: 'ListStatus',
        Value: 'N',
        Sort: 79,
        Tag: 35,
        SymbolicName: 'ListStatus',
    },
    {
        Elaboration:
            'In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message.',
        Group: '',
        Description: 'AllocationInstructionAck',
        Value: 'P',
        Sort: 80,
        Tag: 35,
        SymbolicName: 'AllocationInstructionAck',
    },
    {
        Elaboration:
            'The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message.',
        Group: '',
        Description: 'DontKnowTrade',
        Value: 'Q',
        Sort: 81,
        Tag: 35,
        SymbolicName: 'DontKnowTrade',
    },
    {
        Elaboration:
            'In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)',
        Group: '',
        Description: 'QuoteRequest',
        Value: 'R',
        Sort: 82,
        Tag: 35,
        SymbolicName: 'QuoteRequest',
    },
    {
        Elaboration:
            'The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets.',
        Group: '',
        Description: 'Quote',
        Value: 'S',
        Sort: 83,
        Tag: 35,
        SymbolicName: 'Quote',
    },
    {
        Elaboration:
            'The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent "standing instructions" database or matching system or, for CIV, from an intermediary to a fund manager.',
        Group: '',
        Description: 'SettlementInstructions',
        Value: 'T',
        Sort: 84,
        Tag: 35,
        SymbolicName: 'SettlementInstructions',
    },
    {
        Elaboration:
            'Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A Market Data Request is a general request for market data on specific securities or forex quotes.',
        Group: '',
        Description: 'MarketDataRequest',
        Value: 'V',
        Sort: 85,
        Tag: 35,
        SymbolicName: 'MarketDataRequest',
    },
    {
        Elaboration:
            'The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these.',
        Group: '',
        Description: 'MarketDataSnapshotFullRefresh',
        Value: 'W',
        Sort: 86,
        Tag: 35,
        SymbolicName: 'MarketDataSnapshotFullRefresh',
    },
    {
        Elaboration:
            'The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted.',
        Group: '',
        Description: 'MarketDataIncrementalRefresh',
        Value: 'X',
        Sort: 87,
        Tag: 35,
        SymbolicName: 'MarketDataIncrementalRefresh',
    },
    {
        Elaboration:
            'The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used.',
        Group: '',
        Description: 'MarketDataRequestReject',
        Value: 'Y',
        Sort: 88,
        Tag: 35,
        SymbolicName: 'MarketDataRequestReject',
    },
    {
        Elaboration:
            'The Quote Cancel message is used by an originator of quotes to cancel quotes.\nThe Quote Cancel message supports cancellation of:\n• All quotes\n• Quotes for a specific symbol or security ID\n• All quotes for a security type\n• All quotes for an underlying',
        Group: '',
        Description: 'QuoteCancel',
        Value: 'Z',
        Sort: 89,
        Tag: 35,
        SymbolicName: 'QuoteCancel',
    },
    {
        Elaboration:
            'The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities.',
        Group: '',
        Description: 'QuoteStatusRequest',
        Value: 'a',
        Sort: 90,
        Tag: 35,
        SymbolicName: 'QuoteStatusRequest',
    },
    {
        Elaboration: 'Mass Quote Acknowledgement is used as the application level response to a Mass Quote message.',
        Group: '',
        Description: 'MassQuoteAcknowledgement',
        Value: 'b',
        Sort: 91,
        Tag: 35,
        SymbolicName: 'MassQuoteAcknowledgement',
    },
    {
        Elaboration:
            'The Security Definition Request message is used for the following:\n1. Request a specific Security to be traded with the second party. The request security can be defined as a multileg security made up of one or more instrument legs.\n2. Request a set of individual securities for a single market segment.\n3. Request all securities, independent of market segment.',
        Group: '',
        Description: 'SecurityDefinitionRequest',
        Value: 'c',
        Sort: 92,
        Tag: 35,
        SymbolicName: 'SecurityDefinitionRequest',
    },
    {
        Elaboration:
            "The Security Definition message is used for the following:\n1. Accept the security defined in a Security Definition message.\n2. Accept the security defined in a Security Definition message with changes to the definition and/or identity of the security.\n3. Reject the security requested in a Security Definition message.\n4. Respond to a request for securities within a specified market segment.\n5. Convey comprehensive security definition for all market segments that the security participates in.\n6. Convey the security's trading rules that differ from default rules for the market segment.",
        Group: '',
        Description: 'SecurityDefinition',
        Value: 'd',
        Sort: 93,
        Tag: 35,
        SymbolicName: 'SecurityDefinition',
    },
    {
        Elaboration:
            'The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message.',
        Group: '',
        Description: 'SecurityStatusRequest',
        Value: 'e',
        Sort: 94,
        Tag: 35,
        SymbolicName: 'SecurityStatusRequest',
    },
    {
        Elaboration:
            'The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security.',
        Group: '',
        Description: 'SecurityStatus',
        Value: 'f',
        Sort: 95,
        Tag: 35,
        SymbolicName: 'SecurityStatus',
    },
    {
        Elaboration:
            'The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market.',
        Group: '',
        Description: 'TradingSessionStatusRequest',
        Value: 'g',
        Sort: 96,
        Tag: 35,
        SymbolicName: 'TradingSessionStatusRequest',
    },
    {
        Elaboration:
            'The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session.',
        Group: '',
        Description: 'TradingSessionStatus',
        Value: 'h',
        Sort: 97,
        Tag: 35,
        SymbolicName: 'TradingSessionStatus',
    },
    {
        Elaboration:
            'The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM).',
        Group: '',
        Description: 'MassQuote',
        Value: 'i',
        Sort: 98,
        Tag: 35,
        SymbolicName: 'MassQuote',
    },
    {
        Elaboration:
            'The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued.',
        Group: '',
        Description: 'BusinessMessageReject',
        Value: 'j',
        Sort: 99,
        Tag: 35,
        SymbolicName: 'BusinessMessageReject',
    },
    {
        Elaboration:
            'The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n      In the "Non disclosed" convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the "Non disclosed" convention the entry repeating group is used to define liquidity of the program. See " Program/Basket/List Trading"  for an example.\n      In the "Disclosed" convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the "Disclosed" convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids.',
        Group: '',
        Description: 'BidRequest',
        Value: 'k',
        Sort: 100,
        Tag: 35,
        SymbolicName: 'BidRequest',
    },
    {
        Elaboration:
            'The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n      In the "Non disclosed" convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See "Program/Basket/List Trading"  for an example.\n      In the "Disclosed" convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message.',
        Group: '',
        Description: 'BidResponse',
        Value: 'l',
        Sort: 101,
        Tag: 35,
        SymbolicName: 'BidResponse',
    },
    {
        Elaboration:
            'The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades.',
        Group: '',
        Description: 'ListStrikePrice',
        Value: 'm',
        Sort: 102,
        Tag: 35,
        SymbolicName: 'ListStrikePrice',
    },
    {
        Elaboration: '',
        Group: '',
        Description: 'XMLnonFIX',
        Value: 'n',
        Sort: 103,
        Tag: 35,
        SymbolicName: 'XMLnonFIX',
    },
    {
        Elaboration:
            'The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation.',
        Group: '',
        Description: 'RegistrationInstructions',
        Value: 'o',
        Sort: 104,
        Tag: 35,
        SymbolicName: 'RegistrationInstructions',
    },
    {
        Elaboration:
            'The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation.',
        Group: '',
        Description: 'RegistrationInstructionsResponse',
        Value: 'p',
        Sort: 105,
        Tag: 35,
        SymbolicName: 'RegistrationInstructionsResponse',
    },
    {
        Elaboration:
            'The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity).',
        Group: '',
        Description: 'OrderMassCancelRequest',
        Value: 'q',
        Sort: 106,
        Tag: 35,
        SymbolicName: 'OrderMassCancelRequest',
    },
    {
        Elaboration:
            'The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message.',
        Group: '',
        Description: 'OrderMassCancelReport',
        Value: 'r',
        Sort: 107,
        Tag: 35,
        SymbolicName: 'OrderMassCancelReport',
    },
    {
        Elaboration:
            'Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID.',
        Group: '',
        Description: 'NewOrderCross',
        Value: 's',
        Sort: 108,
        Tag: 35,
        SymbolicName: 'NewOrderCross',
    },
    {
        Elaboration:
            'Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage.',
        Group: '',
        Description: 'CrossOrderCancelReplaceRequest',
        Value: 't',
        Sort: 109,
        Tag: 35,
        SymbolicName: 'CrossOrderCancelReplaceRequest',
    },
    {
        Elaboration: 'Used to fully cancel the remaining open quantity of a cross order.',
        Group: '',
        Description: 'CrossOrderCancelRequest',
        Value: 'u',
        Sort: 110,
        Tag: 35,
        SymbolicName: 'CrossOrderCancelRequest',
    },
    {
        Elaboration:
            'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
        Group: '',
        Description: 'SecurityTypeRequest',
        Value: 'v',
        Sort: 111,
        Tag: 35,
        SymbolicName: 'SecurityTypeRequest',
    },
    {
        Elaboration:
            'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
        Group: '',
        Description: 'SecurityTypes',
        Value: 'w',
        Sort: 112,
        Tag: 35,
        SymbolicName: 'SecurityTypes',
    },
    {
        Elaboration:
            'The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
        Group: '',
        Description: 'SecurityListRequest',
        Value: 'x',
        Sort: 113,
        Tag: 35,
        SymbolicName: 'SecurityListRequest',
    },
    {
        Elaboration:
            'The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request.',
        Group: '',
        Description: 'SecurityList',
        Value: 'y',
        Sort: 114,
        Tag: 35,
        SymbolicName: 'SecurityList',
    },
    {
        Elaboration:
            'The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
        Group: '',
        Description: 'DerivativeSecurityListRequest',
        Value: 'z',
        Sort: 115,
        Tag: 35,
        SymbolicName: 'DerivativeSecurityListRequest',
    },
];

export const ENUMS: ISpecEnums[] = batch1.concat(batch2).concat(batch3).concat(batch4).concat(batch5).concat(batch6);
